// src/components/CrashCourse/FinalExam/finalExamData.js
//
// Full 50-state Final Certification Exam bank — 50 questions per state,
// auto-generated from the live per-state facts in courseData.js (see
// scripts/generate-exam-bank.js) so every answer is traceable back to the
// exact numbers, names, and rules already shown to students in the course
// modules. 15 questions per state are state-specific (authority, cert
// name, signage, lighting, dimension thresholds, night travel, insurance,
// compliance group, state red-flag rule); the remaining 35 are shared,
// state-agnostic PEVO/escort knowledge questions used across all 50 banks.
//
// Shape matches quizzes.ExamQuestion 1:1 — course_id, question_text,
// option_a..d, correct_answer (A|B|C|D), explanation. See README.md.

export const FINAL_EXAM_BANK = {
  "AL_PEVO_PREP": [
    {
      "id": "AL_PEVO_PREP_1",
      "course_id": "AL_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Alabama?",
      "option_a": "NC DOT Oversize Permits",
      "option_b": "Wisconsin DOT Permit Office",
      "option_c": "Arizona DOT Permit Office",
      "option_d": "Alabama DOT Permit Office",
      "correct_answer": "D",
      "explanation": "Per Alabama's current course data: Alabama DOT Permit Office"
    },
    {
      "id": "AL_PEVO_PREP_2",
      "course_id": "AL_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Alabama require to legally operate as an escort vehicle operator?",
      "option_a": "PPCA Required",
      "option_b": "PEVO Cert",
      "option_c": "State Specific",
      "option_d": "NY Standalone ONLY",
      "correct_answer": "B",
      "explanation": "Per Alabama's current course data: PEVO Cert"
    },
    {
      "id": "AL_PEVO_PREP_3",
      "course_id": "AL_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Alabama?",
      "option_a": "OVERSIZE LOAD - fluorescent yellow, 5ft x 12in",
      "option_b": "OVERSIZE LOAD - yellow background, 6-inch black letters",
      "option_c": "OVERSIZE LOAD - 5ft x 12in yellow",
      "option_d": "OVERSIZE LOAD - yellow, black letters, standard",
      "correct_answer": "C",
      "explanation": "Per Alabama's current course data: OVERSIZE LOAD - 5ft x 12in yellow"
    },
    {
      "id": "AL_PEVO_PREP_4",
      "course_id": "AL_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Alabama?",
      "option_a": "Amber strobe, Class 1 rated, mounted highest point of vehicle",
      "option_b": "Class 1 amber strobe - must be visible 500 ft",
      "option_c": "SAE Class 1 amber, front and rear required",
      "option_d": "SAE Class 1 amber, front and rear",
      "correct_answer": "B",
      "explanation": "Per Alabama's current course data: Class 1 amber strobe - must be visible 500 ft"
    },
    {
      "id": "AL_PEVO_PREP_5",
      "course_id": "AL_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Alabama?",
      "option_a": "18-inch stop/slow paddle, 3 lb 2-A:10-B:C fire extinguisher, safety cones",
      "option_b": "Paddle, 3 lb extinguisher, vest",
      "option_c": "Paddle, extinguisher, flares, emergency triangles",
      "option_d": "18-inch stop/slow paddle, 3 lb fire extinguisher",
      "correct_answer": "D",
      "explanation": "Per Alabama's current course data: 18-inch stop/slow paddle, 3 lb fire extinguisher"
    },
    {
      "id": "AL_PEVO_PREP_6",
      "course_id": "AL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Alabama, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 14'0\" triggers mandatory P/EVO escort",
      "option_b": "Any load exceeding 8'6\" width, 13'6\" height, or 80,000 lbs GVW",
      "option_c": "ANY load over 8'6\" width or 13'6\" height - ZERO tolerance",
      "option_d": "Loads exceeding 8'6\" width or 13'6\" height require escort",
      "correct_answer": "B",
      "explanation": "Per Alabama's current course data: Any load exceeding 8'6\" width, 13'6\" height, or 80,000 lbs GVW"
    },
    {
      "id": "AL_PEVO_PREP_7",
      "course_id": "AL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Alabama?",
      "option_a": "12'0\"",
      "option_b": "14'6\"",
      "option_c": "14'0\"",
      "option_d": "16'0\"",
      "correct_answer": "C",
      "explanation": "Per Alabama's current course data: 14'0\""
    },
    {
      "id": "AL_PEVO_PREP_8",
      "course_id": "AL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Alabama?",
      "option_a": "14'0\"",
      "option_b": "16'0\"",
      "option_c": "15'0\"",
      "option_d": "18'0\"",
      "correct_answer": "A",
      "explanation": "Per Alabama's current course data: 14'0\""
    },
    {
      "id": "AL_PEVO_PREP_9",
      "course_id": "AL_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Alabama's night travel status for oversize permitted moves?",
      "option_a": "w/ lighting",
      "option_b": "Allowed",
      "option_c": "Always fully prohibited, no exceptions",
      "option_d": "Restricted",
      "correct_answer": "B",
      "explanation": "Per Alabama's current course data: Allowed"
    },
    {
      "id": "AL_PEVO_PREP_10",
      "course_id": "AL_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Alabama?",
      "option_a": "Same as standard minimum — no separate night-ops tier specified",
      "option_b": "$500K CSL minimum",
      "option_c": "$750K CSL minimum",
      "option_d": "$1M CSL minimum",
      "correct_answer": "C",
      "explanation": "Per Alabama's current course data: $750K CSL minimum"
    },
    {
      "id": "AL_PEVO_PREP_11",
      "course_id": "AL_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Alabama?",
      "option_a": "$500K CSL",
      "option_b": "$1M CSL",
      "option_c": "$750K CSL",
      "option_d": "$10,000 liability",
      "correct_answer": "C",
      "explanation": "Per Alabama's current course data: $750K CSL"
    },
    {
      "id": "AL_PEVO_PREP_12",
      "course_id": "AL_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Alabama belong to for escort operator requirements?",
      "option_a": "Standalone",
      "option_b": "14 PEVO",
      "option_c": "Remaining",
      "option_d": "Stand-Alone",
      "correct_answer": "B",
      "explanation": "Per Alabama's current course data: 14 PEVO"
    },
    {
      "id": "AL_PEVO_PREP_13",
      "course_id": "AL_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Alabama-specific rule or red flag operators must know?",
      "option_a": "Mountain routes require additional permits. I-70 mountain corridor has weight and escort restrictions year-round.",
      "option_b": "Alabama participates in the 14-state PEVO reciprocity group. One PPCA cert covers all PEVO states.",
      "option_c": "Connecticut restricts night moves on state routes. Permit office must pre-approve routes over bridges. Hartford metro restricted 7am-9am and 4pm-7pm.",
      "option_d": "PEVO reciprocity state. Appalachian mountain routes have additional permit requirements.",
      "correct_answer": "B",
      "explanation": "Per Alabama's current course data: Alabama participates in the 14-state PEVO reciprocity group. One PPCA cert covers all PEVO states."
    },
    {
      "id": "AL_PEVO_PREP_14",
      "course_id": "AL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Alabama?",
      "option_a": "6'0\"",
      "option_b": "8'6\" (standard)",
      "option_c": "There is no standard width threshold",
      "option_d": "10'0\"",
      "correct_answer": "B",
      "explanation": "Per Alabama's current course data: 8'6\" (standard)"
    },
    {
      "id": "AL_PEVO_PREP_15",
      "course_id": "AL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Alabama?",
      "option_a": "13'6\" (standard)",
      "option_b": "There is no standard height threshold",
      "option_c": "10'0\"",
      "option_d": "15'0\"",
      "correct_answer": "A",
      "explanation": "Per Alabama's current course data: 13'6\" (standard)"
    },
    {
      "id": "AL_PEVO_PREP_16",
      "course_id": "AL_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_17",
      "course_id": "AL_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_18",
      "course_id": "AL_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_19",
      "course_id": "AL_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_20",
      "course_id": "AL_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_21",
      "course_id": "AL_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_22",
      "course_id": "AL_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_23",
      "course_id": "AL_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_24",
      "course_id": "AL_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_25",
      "course_id": "AL_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_26",
      "course_id": "AL_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_27",
      "course_id": "AL_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_28",
      "course_id": "AL_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_29",
      "course_id": "AL_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_30",
      "course_id": "AL_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_31",
      "course_id": "AL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_32",
      "course_id": "AL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_33",
      "course_id": "AL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_34",
      "course_id": "AL_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_35",
      "course_id": "AL_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_36",
      "course_id": "AL_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_37",
      "course_id": "AL_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_38",
      "course_id": "AL_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_39",
      "course_id": "AL_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_40",
      "course_id": "AL_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_41",
      "course_id": "AL_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_42",
      "course_id": "AL_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_43",
      "course_id": "AL_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_44",
      "course_id": "AL_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_45",
      "course_id": "AL_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_46",
      "course_id": "AL_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_47",
      "course_id": "AL_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_48",
      "course_id": "AL_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_49",
      "course_id": "AL_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AL_PEVO_PREP_50",
      "course_id": "AL_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "AK_PEVO_PREP": [
    {
      "id": "AK_PEVO_PREP_1",
      "course_id": "AK_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Alaska?",
      "option_a": "Mississippi DOT Permits",
      "option_b": "Alaska DOT Permit Section",
      "option_c": "Virginia DOT Oversize Permits",
      "option_d": "Oregon DOT Permits Unit",
      "correct_answer": "B",
      "explanation": "Per Alaska's current course data: Alaska DOT Permit Section"
    },
    {
      "id": "AK_PEVO_PREP_2",
      "course_id": "AK_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Alaska require to legally operate as an escort vehicle operator?",
      "option_a": "NY Standalone ONLY",
      "option_b": "PPCA Required",
      "option_c": "State Specific",
      "option_d": "PEVO Cert",
      "correct_answer": "C",
      "explanation": "Per Alaska's current course data: State Specific"
    },
    {
      "id": "AK_PEVO_PREP_3",
      "course_id": "AK_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Alaska?",
      "option_a": "OVERSIZE LOAD - 5ft x 12in, fluorescent yellow, reflective lettering",
      "option_b": "OVERSIZE LOAD - yellow background, 6-inch black letters",
      "option_c": "OVERSIZE LOAD - standard yellow spec",
      "option_d": "OVERSIZE LOAD - 5ft x 12in yellow",
      "correct_answer": "B",
      "explanation": "Per Alaska's current course data: OVERSIZE LOAD - yellow background, 6-inch black letters"
    },
    {
      "id": "AK_PEVO_PREP_4",
      "course_id": "AK_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Alaska?",
      "option_a": "SAE Class 1 amber - 360 degree visibility required",
      "option_b": "Amber strobe - front and rear mandatory",
      "option_c": "Amber Class 1 or 2 - front and rear required",
      "option_d": "Amber Class 1, front and rear",
      "correct_answer": "C",
      "explanation": "Per Alaska's current course data: Amber Class 1 or 2 - front and rear required"
    },
    {
      "id": "AK_PEVO_PREP_5",
      "course_id": "AK_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Alaska?",
      "option_a": "Paddle, 3 lb extinguisher, cones",
      "option_b": "Paddle, extinguisher, safety triangles",
      "option_c": "Paddle, extinguisher, emergency kit",
      "option_d": "Fire extinguisher, emergency flares, safety vest",
      "correct_answer": "D",
      "explanation": "Per Alaska's current course data: Fire extinguisher, emergency flares, safety vest"
    },
    {
      "id": "AK_PEVO_PREP_6",
      "course_id": "AK_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Alaska, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 14'0\"",
      "option_b": "Width over 8'6\" or height over 13'0\" requires escort",
      "option_c": "Width over 8'6\" or height over 14'0\" triggers mandatory P/EVO escort",
      "option_d": "Any load over 8'6\" width or 14'0\" height on state highways",
      "correct_answer": "D",
      "explanation": "Per Alaska's current course data: Any load over 8'6\" width or 14'0\" height on state highways"
    },
    {
      "id": "AK_PEVO_PREP_7",
      "course_id": "AK_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Alaska?",
      "option_a": "12'0\"",
      "option_b": "16'0\"",
      "option_c": "14'0\"",
      "option_d": "14'6\"",
      "correct_answer": "C",
      "explanation": "Per Alaska's current course data: 14'0\""
    },
    {
      "id": "AK_PEVO_PREP_8",
      "course_id": "AK_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Alaska?",
      "option_a": "13'6\"",
      "option_b": "15'6\"",
      "option_c": "15'0\"",
      "option_d": "14'6\"",
      "correct_answer": "C",
      "explanation": "Per Alaska's current course data: 15'0\""
    },
    {
      "id": "AK_PEVO_PREP_9",
      "course_id": "AK_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Alaska's night travel status for oversize permitted moves?",
      "option_a": "Restricted",
      "option_b": "Always fully prohibited, no exceptions",
      "option_c": "Allowed",
      "option_d": "w/ lighting",
      "correct_answer": "A",
      "explanation": "Per Alaska's current course data: Restricted"
    },
    {
      "id": "AK_PEVO_PREP_10",
      "course_id": "AK_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Alaska?",
      "option_a": "$1M CSL minimum",
      "option_b": "Same as standard minimum — no separate night-ops tier specified",
      "option_c": "$500K CSL minimum",
      "option_d": "$750K CSL minimum",
      "correct_answer": "A",
      "explanation": "Per Alaska's current course data: $1M CSL minimum"
    },
    {
      "id": "AK_PEVO_PREP_11",
      "course_id": "AK_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Alaska?",
      "option_a": "$500K CSL",
      "option_b": "$10,000 liability",
      "option_c": "$1M CSL",
      "option_d": "$750K CSL",
      "correct_answer": "C",
      "explanation": "Per Alaska's current course data: $1M CSL"
    },
    {
      "id": "AK_PEVO_PREP_12",
      "course_id": "AK_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Alaska belong to for escort operator requirements?",
      "option_a": "NY Standalone",
      "option_b": "Standalone",
      "option_c": "8-State",
      "option_d": "14 PEVO",
      "correct_answer": "B",
      "explanation": "Per Alaska's current course data: Standalone"
    },
    {
      "id": "AK_PEVO_PREP_13",
      "course_id": "AK_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Alaska-specific rule or red flag operators must know?",
      "option_a": "Ohio does not participate in PEVO reciprocity. Own state cert required. Columbus and Cleveland metros have restricted hours.",
      "option_b": "Nebraska is in the 8-State group. Flat terrain and minimal bridge restrictions make this a straightforward escort state.",
      "option_c": "Arizona is in the 8-State uniform equipment group. One properly-equipped vehicle covers AZ, ID, IA, KS, MO, NE, NV, UT.",
      "option_d": "Alaska has no reciprocity. Extreme weather rules apply Oct-Apr. Daylight-only travel required Nov-Feb.",
      "correct_answer": "D",
      "explanation": "Per Alaska's current course data: Alaska has no reciprocity. Extreme weather rules apply Oct-Apr. Daylight-only travel required Nov-Feb."
    },
    {
      "id": "AK_PEVO_PREP_14",
      "course_id": "AK_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Alaska?",
      "option_a": "There is no standard width threshold",
      "option_b": "6'0\"",
      "option_c": "8'6\" (standard)",
      "option_d": "10'0\"",
      "correct_answer": "C",
      "explanation": "Per Alaska's current course data: 8'6\" (standard)"
    },
    {
      "id": "AK_PEVO_PREP_15",
      "course_id": "AK_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Alaska?",
      "option_a": "13'6\" (standard)",
      "option_b": "There is no standard height threshold",
      "option_c": "10'0\"",
      "option_d": "15'0\"",
      "correct_answer": "A",
      "explanation": "Per Alaska's current course data: 13'6\" (standard)"
    },
    {
      "id": "AK_PEVO_PREP_16",
      "course_id": "AK_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_17",
      "course_id": "AK_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_18",
      "course_id": "AK_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_19",
      "course_id": "AK_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_20",
      "course_id": "AK_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_21",
      "course_id": "AK_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_22",
      "course_id": "AK_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_23",
      "course_id": "AK_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_24",
      "course_id": "AK_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_25",
      "course_id": "AK_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_26",
      "course_id": "AK_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_27",
      "course_id": "AK_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_28",
      "course_id": "AK_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_29",
      "course_id": "AK_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_30",
      "course_id": "AK_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_31",
      "course_id": "AK_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_32",
      "course_id": "AK_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_33",
      "course_id": "AK_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_34",
      "course_id": "AK_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_35",
      "course_id": "AK_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_36",
      "course_id": "AK_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_37",
      "course_id": "AK_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_38",
      "course_id": "AK_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_39",
      "course_id": "AK_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_40",
      "course_id": "AK_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_41",
      "course_id": "AK_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_42",
      "course_id": "AK_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_43",
      "course_id": "AK_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_44",
      "course_id": "AK_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_45",
      "course_id": "AK_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_46",
      "course_id": "AK_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_47",
      "course_id": "AK_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_48",
      "course_id": "AK_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_49",
      "course_id": "AK_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AK_PEVO_PREP_50",
      "course_id": "AK_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "AZ_PEVO_PREP": [
    {
      "id": "AZ_PEVO_PREP_1",
      "course_id": "AZ_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Arizona?",
      "option_a": "NJ DOT Oversize Permit Unit",
      "option_b": "Arizona DOT Permit Office",
      "option_c": "Georgia DOT Oversize Unit",
      "option_d": "Delaware DOT Permit Office",
      "correct_answer": "B",
      "explanation": "Per Arizona's current course data: Arizona DOT Permit Office"
    },
    {
      "id": "AZ_PEVO_PREP_2",
      "course_id": "AZ_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Arizona require to legally operate as an escort vehicle operator?",
      "option_a": "8-State Uniform",
      "option_b": "PPCA Required",
      "option_c": "PEVO Cert",
      "option_d": "State Specific",
      "correct_answer": "A",
      "explanation": "Per Arizona's current course data: 8-State Uniform"
    },
    {
      "id": "AZ_PEVO_PREP_3",
      "course_id": "AZ_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Arizona?",
      "option_a": "OVERSIZE LOAD - 5ft x 12in, yellow, black letters",
      "option_b": "OVERSIZE LOAD - yellow, SAE spec",
      "option_c": "OVERSIZE LOAD - standard 5ft x 12in",
      "option_d": "OVERSIZE LOAD - 5ft wide x 10in high, yellow, black letters",
      "correct_answer": "D",
      "explanation": "Per Arizona's current course data: OVERSIZE LOAD - 5ft wide x 10in high, yellow, black letters"
    },
    {
      "id": "AZ_PEVO_PREP_4",
      "course_id": "AZ_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Arizona?",
      "option_a": "Amber Class 1 strobe",
      "option_b": "SAE Class 1 amber - 360 degree visibility required",
      "option_c": "Amber Class 1 strobe front and rear",
      "option_d": "SAE Class 1 amber strobe - front and rear",
      "correct_answer": "B",
      "explanation": "Per Arizona's current course data: SAE Class 1 amber - 360 degree visibility required"
    },
    {
      "id": "AZ_PEVO_PREP_5",
      "course_id": "AZ_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Arizona?",
      "option_a": "Stop/slow paddle, 2.5 lb fire extinguisher, flares",
      "option_b": "Paddle, 5 lb extinguisher, 3 road flares, safety vest",
      "option_c": "Paddle, 5 lb extinguisher, flares, safety vest",
      "option_d": "Paddle, 5 lb extinguisher, flares, cones, first aid kit",
      "correct_answer": "A",
      "explanation": "Per Arizona's current course data: Stop/slow paddle, 2.5 lb fire extinguisher, flares"
    },
    {
      "id": "AZ_PEVO_PREP_6",
      "course_id": "AZ_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Arizona, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 13'6\" requires escort",
      "option_b": "Width exceeding 8'6\" requires lead escort; height over 15'0\" requires height pole",
      "option_c": "Width over 8'6\", height over 13'6\", or length over 65 ft",
      "option_d": "Loads exceeding 8'6\" width or 13'6\" height require escort",
      "correct_answer": "D",
      "explanation": "Per Arizona's current course data: Loads exceeding 8'6\" width or 13'6\" height require escort"
    },
    {
      "id": "AZ_PEVO_PREP_7",
      "course_id": "AZ_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Arizona?",
      "option_a": "12'0\"",
      "option_b": "14'0\"",
      "option_c": "14'6\"",
      "option_d": "16'0\"",
      "correct_answer": "C",
      "explanation": "Per Arizona's current course data: 14'6\""
    },
    {
      "id": "AZ_PEVO_PREP_8",
      "course_id": "AZ_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Arizona?",
      "option_a": "13'6\"",
      "option_b": "15'6\"",
      "option_c": "16'0\"",
      "option_d": "14'6\"",
      "correct_answer": "D",
      "explanation": "Per Arizona's current course data: 14'6\""
    },
    {
      "id": "AZ_PEVO_PREP_9",
      "course_id": "AZ_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Arizona's night travel status for oversize permitted moves?",
      "option_a": "Restricted",
      "option_b": "Allowed",
      "option_c": "Always fully prohibited, no exceptions",
      "option_d": "w/ lighting",
      "correct_answer": "D",
      "explanation": "Per Arizona's current course data: w/ lighting"
    },
    {
      "id": "AZ_PEVO_PREP_10",
      "course_id": "AZ_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Arizona?",
      "option_a": "$1M CSL minimum",
      "option_b": "$500K CSL minimum",
      "option_c": "Same as standard minimum — no separate night-ops tier specified",
      "option_d": "$750K CSL minimum",
      "correct_answer": "D",
      "explanation": "Per Arizona's current course data: $750K CSL minimum"
    },
    {
      "id": "AZ_PEVO_PREP_11",
      "course_id": "AZ_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Arizona?",
      "option_a": "$500K CSL",
      "option_b": "$750K CSL",
      "option_c": "$10,000 liability",
      "option_d": "$1M CSL",
      "correct_answer": "B",
      "explanation": "Per Arizona's current course data: $750K CSL"
    },
    {
      "id": "AZ_PEVO_PREP_12",
      "course_id": "AZ_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Arizona belong to for escort operator requirements?",
      "option_a": "14 PEVO",
      "option_b": "Stand-Alone",
      "option_c": "8-State",
      "option_d": "Standalone",
      "correct_answer": "C",
      "explanation": "Per Arizona's current course data: 8-State"
    },
    {
      "id": "AZ_PEVO_PREP_13",
      "course_id": "AZ_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Arizona-specific rule or red flag operators must know?",
      "option_a": "Arizona is in the 8-State uniform equipment group. One properly-equipped vehicle covers AZ, ID, IA, KS, MO, NE, NV, UT.",
      "option_b": "California requires its own state-specific certification — NO reciprocity accepted. Caltrans has 15 district offices with different route procedures. SR-99 and I-5 corridors have strict permit windows. Bay Area and LA metro have rush-hour bans 7am-9am and 4pm-7pm.",
      "option_c": "Texas has one of the highest height allowances at 18'0\". Texas requires state-specific certification (no PEVO reciprocity). TxDMV handles permit issuance. Super loads over 20' wide require Texas DPS escort. Houston, Dallas, and Austin metros have restricted windows. Oversize signs must be 7ft wide — larger than most states.",
      "option_d": "Mountain routes require additional permits. I-70 mountain corridor has weight and escort restrictions year-round.",
      "correct_answer": "A",
      "explanation": "Per Arizona's current course data: Arizona is in the 8-State uniform equipment group. One properly-equipped vehicle covers AZ, ID, IA, KS, MO, NE, NV, UT."
    },
    {
      "id": "AZ_PEVO_PREP_14",
      "course_id": "AZ_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Arizona?",
      "option_a": "There is no standard width threshold",
      "option_b": "8'6\" (standard)",
      "option_c": "6'0\"",
      "option_d": "10'0\"",
      "correct_answer": "B",
      "explanation": "Per Arizona's current course data: 8'6\" (standard)"
    },
    {
      "id": "AZ_PEVO_PREP_15",
      "course_id": "AZ_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Arizona?",
      "option_a": "10'0\"",
      "option_b": "There is no standard height threshold",
      "option_c": "13'6\" (standard)",
      "option_d": "15'0\"",
      "correct_answer": "C",
      "explanation": "Per Arizona's current course data: 13'6\" (standard)"
    },
    {
      "id": "AZ_PEVO_PREP_16",
      "course_id": "AZ_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_17",
      "course_id": "AZ_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_18",
      "course_id": "AZ_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_19",
      "course_id": "AZ_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_20",
      "course_id": "AZ_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_21",
      "course_id": "AZ_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_22",
      "course_id": "AZ_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_23",
      "course_id": "AZ_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_24",
      "course_id": "AZ_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_25",
      "course_id": "AZ_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_26",
      "course_id": "AZ_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_27",
      "course_id": "AZ_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_28",
      "course_id": "AZ_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_29",
      "course_id": "AZ_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_30",
      "course_id": "AZ_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_31",
      "course_id": "AZ_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_32",
      "course_id": "AZ_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_33",
      "course_id": "AZ_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_34",
      "course_id": "AZ_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_35",
      "course_id": "AZ_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_36",
      "course_id": "AZ_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_37",
      "course_id": "AZ_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_38",
      "course_id": "AZ_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_39",
      "course_id": "AZ_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_40",
      "course_id": "AZ_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_41",
      "course_id": "AZ_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_42",
      "course_id": "AZ_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_43",
      "course_id": "AZ_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_44",
      "course_id": "AZ_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_45",
      "course_id": "AZ_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_46",
      "course_id": "AZ_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_47",
      "course_id": "AZ_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_48",
      "course_id": "AZ_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_49",
      "course_id": "AZ_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AZ_PEVO_PREP_50",
      "course_id": "AZ_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "AR_PEVO_PREP": [
    {
      "id": "AR_PEVO_PREP_1",
      "course_id": "AR_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Arkansas?",
      "option_a": "Maryland SHA Permit Office",
      "option_b": "MA DOT Permit Office",
      "option_c": "Arkansas DOT Oversize Permits",
      "option_d": "WV DOT Permit Office",
      "correct_answer": "C",
      "explanation": "Per Arkansas's current course data: Arkansas DOT Oversize Permits"
    },
    {
      "id": "AR_PEVO_PREP_2",
      "course_id": "AR_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Arkansas require to legally operate as an escort vehicle operator?",
      "option_a": "PEVO Cert",
      "option_b": "PPCA Required",
      "option_c": "NY Standalone ONLY",
      "option_d": "State Specific",
      "correct_answer": "A",
      "explanation": "Per Arkansas's current course data: PEVO Cert"
    },
    {
      "id": "AR_PEVO_PREP_3",
      "course_id": "AR_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Arkansas?",
      "option_a": "OVERSIZE LOAD - yellow, 5ft x 12in, 8-inch letters",
      "option_b": "OVERSIZE LOAD - 96in x 12in, fluorescent yellow-green, black letters",
      "option_c": "OVERSIZE LOAD - yellow, black letters, 5ft x 12in",
      "option_d": "OVERSIZE LOAD - must be removed when not actively escorting",
      "correct_answer": "A",
      "explanation": "Per Arkansas's current course data: OVERSIZE LOAD - yellow, 5ft x 12in, 8-inch letters"
    },
    {
      "id": "AR_PEVO_PREP_4",
      "course_id": "AR_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Arkansas?",
      "option_a": "SAE Class 1 amber, police-grade brightness",
      "option_b": "SAE Class 1 amber AND rear-facing amber required",
      "option_c": "Amber strobe, Class 1 rated, mounted highest point of vehicle",
      "option_d": "Amber SAE Class 1 strobe visible from all sides",
      "correct_answer": "C",
      "explanation": "Per Arkansas's current course data: Amber strobe, Class 1 rated, mounted highest point of vehicle"
    },
    {
      "id": "AR_PEVO_PREP_5",
      "course_id": "AR_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Arkansas?",
      "option_a": "Paddle, 5 lb extinguisher, flares, safety vest",
      "option_b": "Paddle, extinguisher, cones",
      "option_c": "Paddle, 3 lb extinguisher, flares",
      "option_d": "18-inch stop/slow paddle, fire extinguisher",
      "correct_answer": "D",
      "explanation": "Per Arkansas's current course data: 18-inch stop/slow paddle, fire extinguisher"
    },
    {
      "id": "AR_PEVO_PREP_6",
      "course_id": "AR_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Arkansas, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 13'6\" requires escort",
      "option_b": "Loads exceeding 8'6\" width or 13'6\" height require escort",
      "option_c": "Width over 8'6\", height over 13'6\", or length over 65 ft",
      "option_d": "Any load exceeding 8'6\" width, 13'6\" height, or 80,000 lbs GVW",
      "correct_answer": "C",
      "explanation": "Per Arkansas's current course data: Width over 8'6\", height over 13'6\", or length over 65 ft"
    },
    {
      "id": "AR_PEVO_PREP_7",
      "course_id": "AR_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Arkansas?",
      "option_a": "14'6\"",
      "option_b": "14'0\"",
      "option_c": "16'0\"",
      "option_d": "12'0\"",
      "correct_answer": "B",
      "explanation": "Per Arkansas's current course data: 14'0\""
    },
    {
      "id": "AR_PEVO_PREP_8",
      "course_id": "AR_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Arkansas?",
      "option_a": "14'6\"",
      "option_b": "14'0\"",
      "option_c": "13'6\"",
      "option_d": "18'0\"",
      "correct_answer": "B",
      "explanation": "Per Arkansas's current course data: 14'0\""
    },
    {
      "id": "AR_PEVO_PREP_9",
      "course_id": "AR_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Arkansas's night travel status for oversize permitted moves?",
      "option_a": "Restricted",
      "option_b": "Always fully prohibited, no exceptions",
      "option_c": "w/ lighting",
      "option_d": "Allowed",
      "correct_answer": "D",
      "explanation": "Per Arkansas's current course data: Allowed"
    },
    {
      "id": "AR_PEVO_PREP_10",
      "course_id": "AR_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Arkansas?",
      "option_a": "$500K CSL minimum",
      "option_b": "$1M CSL minimum",
      "option_c": "Same as standard minimum — no separate night-ops tier specified",
      "option_d": "$750K CSL minimum",
      "correct_answer": "D",
      "explanation": "Per Arkansas's current course data: $750K CSL minimum"
    },
    {
      "id": "AR_PEVO_PREP_11",
      "course_id": "AR_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Arkansas?",
      "option_a": "$500K CSL",
      "option_b": "$1M CSL",
      "option_c": "$10,000 liability",
      "option_d": "$750K CSL",
      "correct_answer": "D",
      "explanation": "Per Arkansas's current course data: $750K CSL"
    },
    {
      "id": "AR_PEVO_PREP_12",
      "course_id": "AR_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Arkansas belong to for escort operator requirements?",
      "option_a": "8-State",
      "option_b": "Standalone",
      "option_c": "14 PEVO",
      "option_d": "Stand-Alone",
      "correct_answer": "C",
      "explanation": "Per Arkansas's current course data: 14 PEVO"
    },
    {
      "id": "AR_PEVO_PREP_13",
      "course_id": "AR_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Arkansas-specific rule or red flag operators must know?",
      "option_a": "Night travel prohibited without variance. White Mountain routes have seasonal weight restrictions and bridge limits.",
      "option_b": "Nebraska is in the 8-State group. Flat terrain and minimal bridge restrictions make this a straightforward escort state.",
      "option_c": "PEVO reciprocity state. PPCA cert accepted. Carry original cert plus trip permit at all times.",
      "option_d": "Louisiana has one of the highest height allowances at 15'0\". Bayou and river crossings require bridge clearance verification.",
      "correct_answer": "C",
      "explanation": "Per Arkansas's current course data: PEVO reciprocity state. PPCA cert accepted. Carry original cert plus trip permit at all times."
    },
    {
      "id": "AR_PEVO_PREP_14",
      "course_id": "AR_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Arkansas?",
      "option_a": "6'0\"",
      "option_b": "8'6\" (standard)",
      "option_c": "10'0\"",
      "option_d": "There is no standard width threshold",
      "correct_answer": "B",
      "explanation": "Per Arkansas's current course data: 8'6\" (standard)"
    },
    {
      "id": "AR_PEVO_PREP_15",
      "course_id": "AR_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Arkansas?",
      "option_a": "13'6\" (standard)",
      "option_b": "10'0\"",
      "option_c": "15'0\"",
      "option_d": "There is no standard height threshold",
      "correct_answer": "A",
      "explanation": "Per Arkansas's current course data: 13'6\" (standard)"
    },
    {
      "id": "AR_PEVO_PREP_16",
      "course_id": "AR_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_17",
      "course_id": "AR_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_18",
      "course_id": "AR_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_19",
      "course_id": "AR_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_20",
      "course_id": "AR_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_21",
      "course_id": "AR_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_22",
      "course_id": "AR_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_23",
      "course_id": "AR_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_24",
      "course_id": "AR_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_25",
      "course_id": "AR_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_26",
      "course_id": "AR_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_27",
      "course_id": "AR_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_28",
      "course_id": "AR_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_29",
      "course_id": "AR_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_30",
      "course_id": "AR_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_31",
      "course_id": "AR_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_32",
      "course_id": "AR_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_33",
      "course_id": "AR_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_34",
      "course_id": "AR_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_35",
      "course_id": "AR_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_36",
      "course_id": "AR_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_37",
      "course_id": "AR_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_38",
      "course_id": "AR_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_39",
      "course_id": "AR_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_40",
      "course_id": "AR_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_41",
      "course_id": "AR_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_42",
      "course_id": "AR_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_43",
      "course_id": "AR_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_44",
      "course_id": "AR_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_45",
      "course_id": "AR_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_46",
      "course_id": "AR_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_47",
      "course_id": "AR_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_48",
      "course_id": "AR_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_49",
      "course_id": "AR_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "AR_PEVO_PREP_50",
      "course_id": "AR_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "CO_PEVO_PREP": [
    {
      "id": "CO_PEVO_PREP_1",
      "course_id": "CO_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Colorado?",
      "option_a": "Colorado DOT Oversize Permits",
      "option_b": "Washington State DOT Permit Office",
      "option_c": "TxDOT Oversize/Overweight Permits",
      "option_d": "Idaho Transportation Dept Permits",
      "correct_answer": "A",
      "explanation": "Per Colorado's current course data: Colorado DOT Oversize Permits"
    },
    {
      "id": "CO_PEVO_PREP_2",
      "course_id": "CO_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Colorado require to legally operate as an escort vehicle operator?",
      "option_a": "NY Standalone ONLY",
      "option_b": "State Specific",
      "option_c": "8-State Uniform",
      "option_d": "PEVO Cert",
      "correct_answer": "D",
      "explanation": "Per Colorado's current course data: PEVO Cert"
    },
    {
      "id": "CO_PEVO_PREP_3",
      "course_id": "CO_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Colorado?",
      "option_a": "OVERSIZE LOAD - 5ft x 12in, fluorescent yellow-green, black reflective letters",
      "option_b": "OVERSIZE LOAD - standard yellow, 5ft x 10in",
      "option_c": "OVERSIZED LOAD - required on front and rear",
      "option_d": "OVERSIZE LOAD - 5ft x 10in, reflective yellow, black letters",
      "correct_answer": "D",
      "explanation": "Per Colorado's current course data: OVERSIZE LOAD - 5ft x 10in, reflective yellow, black letters"
    },
    {
      "id": "CO_PEVO_PREP_4",
      "course_id": "CO_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Colorado?",
      "option_a": "SAE Class 1 amber strobe",
      "option_b": "Amber Class 1 strobe required",
      "option_c": "Amber Class 1 strobe, visible 1000 ft each direction",
      "option_d": "SAE Class 1 amber 360-degree strobe, plus headlights on",
      "correct_answer": "D",
      "explanation": "Per Colorado's current course data: SAE Class 1 amber 360-degree strobe, plus headlights on"
    },
    {
      "id": "CO_PEVO_PREP_5",
      "course_id": "CO_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Colorado?",
      "option_a": "Paddle, 3 lb extinguisher, flares",
      "option_b": "18-inch stop/slow paddle, 3 lb fire extinguisher",
      "option_c": "Paddle, 3 lb extinguisher",
      "option_d": "Stop/slow paddle min 18in, 3 lb fire extinguisher, orange cones",
      "correct_answer": "D",
      "explanation": "Per Colorado's current course data: Stop/slow paddle min 18in, 3 lb fire extinguisher, orange cones"
    },
    {
      "id": "CO_PEVO_PREP_6",
      "course_id": "CO_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Colorado, when is an escort legally REQUIRED?",
      "option_a": "Width over 9'0\" or height over 13'6\" triggers escort requirement",
      "option_b": "Width over 8'6\" or height over 14'0\" triggers mandatory escort",
      "option_c": "Width over 8'6\" OR height over 14'0\" on most highways",
      "option_d": "Any load exceeding 8'0\" width or 13'6\" height",
      "correct_answer": "B",
      "explanation": "Per Colorado's current course data: Width over 8'6\" or height over 14'0\" triggers mandatory escort"
    },
    {
      "id": "CO_PEVO_PREP_7",
      "course_id": "CO_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Colorado?",
      "option_a": "14'6\"",
      "option_b": "14'0\"",
      "option_c": "16'0\"",
      "option_d": "12'0\"",
      "correct_answer": "A",
      "explanation": "Per Colorado's current course data: 14'6\""
    },
    {
      "id": "CO_PEVO_PREP_8",
      "course_id": "CO_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Colorado?",
      "option_a": "15'6\"",
      "option_b": "15'0\"",
      "option_c": "14'6\"",
      "option_d": "18'0\"",
      "correct_answer": "C",
      "explanation": "Per Colorado's current course data: 14'6\""
    },
    {
      "id": "CO_PEVO_PREP_9",
      "course_id": "CO_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Colorado's night travel status for oversize permitted moves?",
      "option_a": "Restricted",
      "option_b": "Always fully prohibited, no exceptions",
      "option_c": "Allowed",
      "option_d": "w/ lighting",
      "correct_answer": "D",
      "explanation": "Per Colorado's current course data: w/ lighting"
    },
    {
      "id": "CO_PEVO_PREP_10",
      "course_id": "CO_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Colorado?",
      "option_a": "$750K CSL minimum",
      "option_b": "$1M CSL minimum",
      "option_c": "Same as standard minimum — no separate night-ops tier specified",
      "option_d": "$500K CSL minimum",
      "correct_answer": "A",
      "explanation": "Per Colorado's current course data: $750K CSL minimum"
    },
    {
      "id": "CO_PEVO_PREP_11",
      "course_id": "CO_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Colorado?",
      "option_a": "$1M CSL",
      "option_b": "$10,000 liability",
      "option_c": "$750K CSL",
      "option_d": "$500K CSL",
      "correct_answer": "C",
      "explanation": "Per Colorado's current course data: $750K CSL"
    },
    {
      "id": "CO_PEVO_PREP_12",
      "course_id": "CO_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Colorado belong to for escort operator requirements?",
      "option_a": "NY Standalone",
      "option_b": "8-State",
      "option_c": "14 PEVO",
      "option_d": "Standalone",
      "correct_answer": "C",
      "explanation": "Per Colorado's current course data: 14 PEVO"
    },
    {
      "id": "CO_PEVO_PREP_13",
      "course_id": "CO_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Colorado-specific rule or red flag operators must know?",
      "option_a": "Tennessee does not participate in PEVO reciprocity. Nashville metro has restricted permit windows. Mountain routes require special permits.",
      "option_b": "Oklahoma has high wind conditions on open highways. Tornado season (April-June) may result in permit holds.",
      "option_c": "Mountain routes require additional permits. I-70 mountain corridor has weight and escort restrictions year-round.",
      "option_d": "Minnesota allows 15'0\" height clearance. Spring weight restrictions apply March-May on all state and county roads.",
      "correct_answer": "C",
      "explanation": "Per Colorado's current course data: Mountain routes require additional permits. I-70 mountain corridor has weight and escort restrictions year-round."
    },
    {
      "id": "CO_PEVO_PREP_14",
      "course_id": "CO_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Colorado?",
      "option_a": "10'0\"",
      "option_b": "There is no standard width threshold",
      "option_c": "6'0\"",
      "option_d": "8'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per Colorado's current course data: 8'6\" (standard)"
    },
    {
      "id": "CO_PEVO_PREP_15",
      "course_id": "CO_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Colorado?",
      "option_a": "There is no standard height threshold",
      "option_b": "15'0\"",
      "option_c": "13'6\" (standard)",
      "option_d": "10'0\"",
      "correct_answer": "C",
      "explanation": "Per Colorado's current course data: 13'6\" (standard)"
    },
    {
      "id": "CO_PEVO_PREP_16",
      "course_id": "CO_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_17",
      "course_id": "CO_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_18",
      "course_id": "CO_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_19",
      "course_id": "CO_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_20",
      "course_id": "CO_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_21",
      "course_id": "CO_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_22",
      "course_id": "CO_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_23",
      "course_id": "CO_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_24",
      "course_id": "CO_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_25",
      "course_id": "CO_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_26",
      "course_id": "CO_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_27",
      "course_id": "CO_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_28",
      "course_id": "CO_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_29",
      "course_id": "CO_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_30",
      "course_id": "CO_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_31",
      "course_id": "CO_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_32",
      "course_id": "CO_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_33",
      "course_id": "CO_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_34",
      "course_id": "CO_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_35",
      "course_id": "CO_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_36",
      "course_id": "CO_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_37",
      "course_id": "CO_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_38",
      "course_id": "CO_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_39",
      "course_id": "CO_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_40",
      "course_id": "CO_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_41",
      "course_id": "CO_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_42",
      "course_id": "CO_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_43",
      "course_id": "CO_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_44",
      "course_id": "CO_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_45",
      "course_id": "CO_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_46",
      "course_id": "CO_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_47",
      "course_id": "CO_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_48",
      "course_id": "CO_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_49",
      "course_id": "CO_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CO_PEVO_PREP_50",
      "course_id": "CO_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "CT_PEVO_PREP": [
    {
      "id": "CT_PEVO_PREP_1",
      "course_id": "CT_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Connecticut?",
      "option_a": "CT DOT Permit Unit",
      "option_b": "SC DOT Oversize Permits",
      "option_c": "NM DOT Permits Office",
      "option_d": "TxDOT Oversize/Overweight Permits",
      "correct_answer": "A",
      "explanation": "Per Connecticut's current course data: CT DOT Permit Unit"
    },
    {
      "id": "CT_PEVO_PREP_2",
      "course_id": "CT_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Connecticut require to legally operate as an escort vehicle operator?",
      "option_a": "PEVO Cert",
      "option_b": "NY Standalone ONLY",
      "option_c": "PPCA Required",
      "option_d": "8-State Uniform",
      "correct_answer": "A",
      "explanation": "Per Connecticut's current course data: PEVO Cert"
    },
    {
      "id": "CT_PEVO_PREP_3",
      "course_id": "CT_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Connecticut?",
      "option_a": "OVERSIZE LOAD - 5ft x 12in, yellow, black 8-inch letters",
      "option_b": "OVERSIZE LOAD - 5ft x 12in, fluorescent yellow, reflective lettering",
      "option_c": "OVERSIZE LOAD - 5ft x 12in, bright yellow, 8-inch black letters, 1-inch brush stroke",
      "option_d": "OVERSIZE LOAD - standard 5ft x 12in",
      "correct_answer": "A",
      "explanation": "Per Connecticut's current course data: OVERSIZE LOAD - 5ft x 12in, yellow, black 8-inch letters"
    },
    {
      "id": "CT_PEVO_PREP_4",
      "course_id": "CT_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Connecticut?",
      "option_a": "Amber Class 1 strobe front and rear",
      "option_b": "SAE Class 1 amber 360-degree strobe, plus headlights on",
      "option_c": "Amber SAE Class 1 strobe, front and rear",
      "option_d": "Amber SAE Class 1, front and rear",
      "correct_answer": "A",
      "explanation": "Per Connecticut's current course data: Amber Class 1 strobe front and rear"
    },
    {
      "id": "CT_PEVO_PREP_5",
      "course_id": "CT_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Connecticut?",
      "option_a": "Paddle, 5 lb extinguisher, flares, safety vest",
      "option_b": "Paddle, extinguisher, 6 road flares",
      "option_c": "18-inch stop/slow paddle, 3 lb (2-A:10-B:C) fire extinguisher, orange safety vest",
      "option_d": "Paddle, extinguisher, flares, emergency triangles",
      "correct_answer": "B",
      "explanation": "Per Connecticut's current course data: Paddle, extinguisher, 6 road flares"
    },
    {
      "id": "CT_PEVO_PREP_6",
      "course_id": "CT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Connecticut, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\", height over 13'6\", or length over 65 ft",
      "option_b": "Width over 8'6\" or height over 13'0\" requires escort",
      "option_c": "Width over 9'0\" or height over 14'0\"",
      "option_d": "Width over 8'6\" or height over 13'0\"",
      "correct_answer": "B",
      "explanation": "Per Connecticut's current course data: Width over 8'6\" or height over 13'0\" requires escort"
    },
    {
      "id": "CT_PEVO_PREP_7",
      "course_id": "CT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Connecticut?",
      "option_a": "12'0\"",
      "option_b": "16'0\"",
      "option_c": "14'0\"",
      "option_d": "14'6\"",
      "correct_answer": "C",
      "explanation": "Per Connecticut's current course data: 14'0\""
    },
    {
      "id": "CT_PEVO_PREP_8",
      "course_id": "CT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Connecticut?",
      "option_a": "15'0\"",
      "option_b": "15'6\"",
      "option_c": "14'6\"",
      "option_d": "13'6\"",
      "correct_answer": "D",
      "explanation": "Per Connecticut's current course data: 13'6\""
    },
    {
      "id": "CT_PEVO_PREP_9",
      "course_id": "CT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Connecticut's night travel status for oversize permitted moves?",
      "option_a": "Always fully prohibited, no exceptions",
      "option_b": "w/ lighting",
      "option_c": "Allowed",
      "option_d": "Restricted",
      "correct_answer": "D",
      "explanation": "Per Connecticut's current course data: Restricted"
    },
    {
      "id": "CT_PEVO_PREP_10",
      "course_id": "CT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Connecticut?",
      "option_a": "$750K CSL minimum",
      "option_b": "$1M CSL minimum",
      "option_c": "$500K CSL minimum",
      "option_d": "Same as standard minimum — no separate night-ops tier specified",
      "correct_answer": "A",
      "explanation": "Per Connecticut's current course data: $750K CSL minimum"
    },
    {
      "id": "CT_PEVO_PREP_11",
      "course_id": "CT_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Connecticut?",
      "option_a": "$500K CSL",
      "option_b": "$1M CSL",
      "option_c": "$10,000 liability",
      "option_d": "$750K CSL",
      "correct_answer": "D",
      "explanation": "Per Connecticut's current course data: $750K CSL"
    },
    {
      "id": "CT_PEVO_PREP_12",
      "course_id": "CT_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Connecticut belong to for escort operator requirements?",
      "option_a": "Standalone",
      "option_b": "8-State",
      "option_c": "Stand-Alone",
      "option_d": "14 PEVO",
      "correct_answer": "D",
      "explanation": "Per Connecticut's current course data: 14 PEVO"
    },
    {
      "id": "CT_PEVO_PREP_13",
      "course_id": "CT_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Connecticut-specific rule or red flag operators must know?",
      "option_a": "Nebraska is in the 8-State group. Flat terrain and minimal bridge restrictions make this a straightforward escort state.",
      "option_b": "Connecticut restricts night moves on state routes. Permit office must pre-approve routes over bridges. Hartford metro restricted 7am-9am and 4pm-7pm.",
      "option_c": "Kansas is part of the 8-State uniform group. Flat terrain allows consistent escort patterns with few route restrictions.",
      "option_d": "High wind and blizzard conditions common Oct-April. Wind farm equipment moves are a major market in SD.",
      "correct_answer": "B",
      "explanation": "Per Connecticut's current course data: Connecticut restricts night moves on state routes. Permit office must pre-approve routes over bridges. Hartford metro restricted 7am-9am and 4pm-7pm."
    },
    {
      "id": "CT_PEVO_PREP_14",
      "course_id": "CT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Connecticut?",
      "option_a": "6'0\"",
      "option_b": "10'0\"",
      "option_c": "There is no standard width threshold",
      "option_d": "8'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per Connecticut's current course data: 8'6\" (standard)"
    },
    {
      "id": "CT_PEVO_PREP_15",
      "course_id": "CT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Connecticut?",
      "option_a": "10'0\"",
      "option_b": "13'6\" (standard)",
      "option_c": "There is no standard height threshold",
      "option_d": "15'0\"",
      "correct_answer": "B",
      "explanation": "Per Connecticut's current course data: 13'6\" (standard)"
    },
    {
      "id": "CT_PEVO_PREP_16",
      "course_id": "CT_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_17",
      "course_id": "CT_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_18",
      "course_id": "CT_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_19",
      "course_id": "CT_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_20",
      "course_id": "CT_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_21",
      "course_id": "CT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_22",
      "course_id": "CT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_23",
      "course_id": "CT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_24",
      "course_id": "CT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_25",
      "course_id": "CT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_26",
      "course_id": "CT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_27",
      "course_id": "CT_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_28",
      "course_id": "CT_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_29",
      "course_id": "CT_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_30",
      "course_id": "CT_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_31",
      "course_id": "CT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_32",
      "course_id": "CT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_33",
      "course_id": "CT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_34",
      "course_id": "CT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_35",
      "course_id": "CT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_36",
      "course_id": "CT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_37",
      "course_id": "CT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_38",
      "course_id": "CT_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_39",
      "course_id": "CT_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_40",
      "course_id": "CT_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_41",
      "course_id": "CT_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_42",
      "course_id": "CT_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_43",
      "course_id": "CT_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_44",
      "course_id": "CT_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_45",
      "course_id": "CT_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_46",
      "course_id": "CT_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_47",
      "course_id": "CT_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_48",
      "course_id": "CT_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_49",
      "course_id": "CT_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CT_PEVO_PREP_50",
      "course_id": "CT_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "DE_PEVO_PREP": [
    {
      "id": "DE_PEVO_PREP_1",
      "course_id": "DE_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Delaware?",
      "option_a": "Vermont Agency of Transportation",
      "option_b": "Delaware DOT Permit Office",
      "option_c": "Michigan DOT Permit Office",
      "option_d": "NM DOT Permits Office",
      "correct_answer": "B",
      "explanation": "Per Delaware's current course data: Delaware DOT Permit Office"
    },
    {
      "id": "DE_PEVO_PREP_2",
      "course_id": "DE_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Delaware require to legally operate as an escort vehicle operator?",
      "option_a": "PPCA Required",
      "option_b": "State Specific",
      "option_c": "PEVO Cert",
      "option_d": "8-State Uniform",
      "correct_answer": "C",
      "explanation": "Per Delaware's current course data: PEVO Cert"
    },
    {
      "id": "DE_PEVO_PREP_3",
      "course_id": "DE_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Delaware?",
      "option_a": "OVERSIZE LOAD - 5ft wide x 10in high, yellow, black letters",
      "option_b": "OVERSIZE LOAD - 5ft x 10in, reflective yellow, black letters",
      "option_c": "OVERSIZE LOAD - 5ft x 12in yellow, reflective",
      "option_d": "OVERSIZE LOAD - standard 5ft x 12in yellow sign",
      "correct_answer": "D",
      "explanation": "Per Delaware's current course data: OVERSIZE LOAD - standard 5ft x 12in yellow sign"
    },
    {
      "id": "DE_PEVO_PREP_4",
      "course_id": "DE_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Delaware?",
      "option_a": "Amber Class 1, front and rear",
      "option_b": "Amber SAE Class 1 strobe visible from all sides",
      "option_c": "SAE Class 1 amber strobe - front and rear",
      "option_d": "SAE Class 1 amber, front and rear required",
      "correct_answer": "B",
      "explanation": "Per Delaware's current course data: Amber SAE Class 1 strobe visible from all sides"
    },
    {
      "id": "DE_PEVO_PREP_5",
      "course_id": "DE_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Delaware?",
      "option_a": "Fire extinguisher, emergency flares, safety vest",
      "option_b": "18-inch stop/slow paddle, 3 lb fire extinguisher",
      "option_c": "18-inch stop/slow paddle, 3 lb 2-A:10-B:C fire extinguisher, safety cones",
      "option_d": "Paddle, fire extinguisher, safety vest",
      "correct_answer": "D",
      "explanation": "Per Delaware's current course data: Paddle, fire extinguisher, safety vest"
    },
    {
      "id": "DE_PEVO_PREP_6",
      "course_id": "DE_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Delaware, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\", height over 13'6\", or length over 65 ft",
      "option_b": "Width over 8'6\" or height over 13'6\"",
      "option_c": "Width over 8'6\" or height over 13'0\" requires escort",
      "option_d": "Width over 9'0\" or height over 15'0\"",
      "correct_answer": "B",
      "explanation": "Per Delaware's current course data: Width over 8'6\" or height over 13'6\""
    },
    {
      "id": "DE_PEVO_PREP_7",
      "course_id": "DE_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Delaware?",
      "option_a": "16'0\"",
      "option_b": "12'0\"",
      "option_c": "14'6\"",
      "option_d": "14'0\"",
      "correct_answer": "D",
      "explanation": "Per Delaware's current course data: 14'0\""
    },
    {
      "id": "DE_PEVO_PREP_8",
      "course_id": "DE_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Delaware?",
      "option_a": "16'0\"",
      "option_b": "13'6\"",
      "option_c": "18'0\"",
      "option_d": "15'0\"",
      "correct_answer": "B",
      "explanation": "Per Delaware's current course data: 13'6\""
    },
    {
      "id": "DE_PEVO_PREP_9",
      "course_id": "DE_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Delaware's night travel status for oversize permitted moves?",
      "option_a": "Allowed",
      "option_b": "w/ lighting",
      "option_c": "Restricted",
      "option_d": "Always fully prohibited, no exceptions",
      "correct_answer": "B",
      "explanation": "Per Delaware's current course data: w/ lighting"
    },
    {
      "id": "DE_PEVO_PREP_10",
      "course_id": "DE_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Delaware?",
      "option_a": "Same as standard minimum — no separate night-ops tier specified",
      "option_b": "$750K CSL minimum",
      "option_c": "$1M CSL minimum",
      "option_d": "$500K CSL minimum",
      "correct_answer": "B",
      "explanation": "Per Delaware's current course data: $750K CSL minimum"
    },
    {
      "id": "DE_PEVO_PREP_11",
      "course_id": "DE_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Delaware?",
      "option_a": "$10,000 liability",
      "option_b": "$1M CSL",
      "option_c": "$750K CSL",
      "option_d": "$500K CSL",
      "correct_answer": "C",
      "explanation": "Per Delaware's current course data: $750K CSL"
    },
    {
      "id": "DE_PEVO_PREP_12",
      "course_id": "DE_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Delaware belong to for escort operator requirements?",
      "option_a": "14 PEVO",
      "option_b": "Standalone",
      "option_c": "8-State",
      "option_d": "NY Standalone",
      "correct_answer": "A",
      "explanation": "Per Delaware's current course data: 14 PEVO"
    },
    {
      "id": "DE_PEVO_PREP_13",
      "course_id": "DE_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Delaware-specific rule or red flag operators must know?",
      "option_a": "California requires its own state-specific certification — NO reciprocity accepted. Caltrans has 15 district offices with different route procedures. SR-99 and I-5 corridors have strict permit windows. Bay Area and LA metro have rush-hour bans 7am-9am and 4pm-7pm.",
      "option_b": "Delaware is a small state with high bridge density. Bridge strike liability is strictly enforced under state code.",
      "option_c": "Connecticut restricts night moves on state routes. Permit office must pre-approve routes over bridges. Hartford metro restricted 7am-9am and 4pm-7pm.",
      "option_d": "Oregon requires state-specific cert AND $1M insurance. Portland metro restricted windows. Coast routes have severe weather seasonal restrictions Oct-Mar.",
      "correct_answer": "B",
      "explanation": "Per Delaware's current course data: Delaware is a small state with high bridge density. Bridge strike liability is strictly enforced under state code."
    },
    {
      "id": "DE_PEVO_PREP_14",
      "course_id": "DE_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Delaware?",
      "option_a": "8'6\" (standard)",
      "option_b": "There is no standard width threshold",
      "option_c": "6'0\"",
      "option_d": "10'0\"",
      "correct_answer": "A",
      "explanation": "Per Delaware's current course data: 8'6\" (standard)"
    },
    {
      "id": "DE_PEVO_PREP_15",
      "course_id": "DE_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Delaware?",
      "option_a": "15'0\"",
      "option_b": "13'6\" (standard)",
      "option_c": "10'0\"",
      "option_d": "There is no standard height threshold",
      "correct_answer": "B",
      "explanation": "Per Delaware's current course data: 13'6\" (standard)"
    },
    {
      "id": "DE_PEVO_PREP_16",
      "course_id": "DE_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_17",
      "course_id": "DE_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_18",
      "course_id": "DE_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_19",
      "course_id": "DE_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_20",
      "course_id": "DE_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_21",
      "course_id": "DE_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_22",
      "course_id": "DE_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_23",
      "course_id": "DE_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_24",
      "course_id": "DE_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_25",
      "course_id": "DE_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_26",
      "course_id": "DE_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_27",
      "course_id": "DE_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_28",
      "course_id": "DE_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_29",
      "course_id": "DE_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_30",
      "course_id": "DE_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_31",
      "course_id": "DE_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_32",
      "course_id": "DE_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_33",
      "course_id": "DE_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_34",
      "course_id": "DE_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_35",
      "course_id": "DE_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_36",
      "course_id": "DE_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_37",
      "course_id": "DE_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_38",
      "course_id": "DE_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_39",
      "course_id": "DE_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_40",
      "course_id": "DE_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_41",
      "course_id": "DE_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_42",
      "course_id": "DE_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_43",
      "course_id": "DE_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_44",
      "course_id": "DE_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_45",
      "course_id": "DE_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_46",
      "course_id": "DE_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_47",
      "course_id": "DE_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_48",
      "course_id": "DE_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_49",
      "course_id": "DE_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "DE_PEVO_PREP_50",
      "course_id": "DE_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "GA_PEVO_PREP": [
    {
      "id": "GA_PEVO_PREP_1",
      "course_id": "GA_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Georgia?",
      "option_a": "Montana DOT Permit Office",
      "option_b": "Georgia DOT Oversize Unit",
      "option_c": "Colorado DOT Oversize Permits",
      "option_d": "Oklahoma DOT Permits",
      "correct_answer": "B",
      "explanation": "Per Georgia's current course data: Georgia DOT Oversize Unit"
    },
    {
      "id": "GA_PEVO_PREP_2",
      "course_id": "GA_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Georgia require to legally operate as an escort vehicle operator?",
      "option_a": "State Specific",
      "option_b": "PEVO Cert",
      "option_c": "PPCA Required",
      "option_d": "NY Standalone ONLY",
      "correct_answer": "B",
      "explanation": "Per Georgia's current course data: PEVO Cert"
    },
    {
      "id": "GA_PEVO_PREP_3",
      "course_id": "GA_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Georgia?",
      "option_a": "OVERSIZE LOAD - must be removed when not actively escorting",
      "option_b": "OVERSIZED LOAD - required on front and rear",
      "option_c": "OVERSIZE LOAD - 5ft x 12in, fluorescent yellow, reflective lettering",
      "option_d": "OVERSIZE LOAD - 7ft x 18in, fluorescent yellow-orange, 10-inch black letters",
      "correct_answer": "C",
      "explanation": "Per Georgia's current course data: OVERSIZE LOAD - 5ft x 12in, fluorescent yellow, reflective lettering"
    },
    {
      "id": "GA_PEVO_PREP_4",
      "course_id": "GA_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Georgia?",
      "option_a": "Amber Class 1 strobe, front and rear",
      "option_b": "SAE Class 1 amber strobe, 360-degree visibility, minimum 35W",
      "option_c": "Amber Class 1 strobe - 360 visibility at 500 ft",
      "option_d": "Amber Class 1 strobe, visible from 500 ft",
      "correct_answer": "B",
      "explanation": "Per Georgia's current course data: SAE Class 1 amber strobe, 360-degree visibility, minimum 35W"
    },
    {
      "id": "GA_PEVO_PREP_5",
      "course_id": "GA_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Georgia?",
      "option_a": "Stop/slow paddle, 2.5 lb fire extinguisher, flares",
      "option_b": "18-inch stop/slow paddle, 3 lb extinguisher, cones",
      "option_c": "Paddle, 2.5 lb extinguisher, flares",
      "option_d": "Paddle, extinguisher, 6 road flares",
      "correct_answer": "B",
      "explanation": "Per Georgia's current course data: 18-inch stop/slow paddle, 3 lb extinguisher, cones"
    },
    {
      "id": "GA_PEVO_PREP_6",
      "course_id": "GA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Georgia, when is an escort legally REQUIRED?",
      "option_a": "Width over 9'0\" or height over 15'0\"",
      "option_b": "Width over 8'6\", height over 13'6\", or length over 65 ft",
      "option_c": "Width exceeding 8'6\" requires lead escort; height over 15'0\" requires height pole",
      "option_d": "Loads exceeding 8'6\" width or 13'6\" height require licensed escort",
      "correct_answer": "C",
      "explanation": "Per Georgia's current course data: Width exceeding 8'6\" requires lead escort; height over 15'0\" requires height pole"
    },
    {
      "id": "GA_PEVO_PREP_7",
      "course_id": "GA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Georgia?",
      "option_a": "14'6\"",
      "option_b": "16'0\"",
      "option_c": "14'0\"",
      "option_d": "12'0\"",
      "correct_answer": "C",
      "explanation": "Per Georgia's current course data: 14'0\""
    },
    {
      "id": "GA_PEVO_PREP_8",
      "course_id": "GA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Georgia?",
      "option_a": "15'6\"",
      "option_b": "13'6\"",
      "option_c": "15'0\"",
      "option_d": "16'0\"",
      "correct_answer": "C",
      "explanation": "Per Georgia's current course data: 15'0\""
    },
    {
      "id": "GA_PEVO_PREP_9",
      "course_id": "GA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Georgia's night travel status for oversize permitted moves?",
      "option_a": "Restricted",
      "option_b": "Allowed",
      "option_c": "w/ lighting",
      "option_d": "Always fully prohibited, no exceptions",
      "correct_answer": "C",
      "explanation": "Per Georgia's current course data: w/ lighting"
    },
    {
      "id": "GA_PEVO_PREP_10",
      "course_id": "GA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Georgia?",
      "option_a": "Same as standard minimum — no separate night-ops tier specified",
      "option_b": "$750K CSL minimum",
      "option_c": "$500K CSL minimum",
      "option_d": "$1M CSL minimum",
      "correct_answer": "B",
      "explanation": "Per Georgia's current course data: $750K CSL minimum"
    },
    {
      "id": "GA_PEVO_PREP_11",
      "course_id": "GA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Georgia?",
      "option_a": "$750K CSL",
      "option_b": "$500K CSL",
      "option_c": "$10,000 liability",
      "option_d": "$1M CSL",
      "correct_answer": "A",
      "explanation": "Per Georgia's current course data: $750K CSL"
    },
    {
      "id": "GA_PEVO_PREP_12",
      "course_id": "GA_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Georgia belong to for escort operator requirements?",
      "option_a": "Standalone",
      "option_b": "14 PEVO",
      "option_c": "NY Standalone",
      "option_d": "Remaining",
      "correct_answer": "B",
      "explanation": "Per Georgia's current course data: 14 PEVO"
    },
    {
      "id": "GA_PEVO_PREP_13",
      "course_id": "GA_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Georgia-specific rule or red flag operators must know?",
      "option_a": "Georgia has one of the highest height limits at 15'0\". Atlanta metro has significant restricted travel times.",
      "option_b": "Ohio does not participate in PEVO reciprocity. Own state cert required. Columbus and Cleveland metros have restricted hours.",
      "option_c": "Wisconsin allows 15'0\" height. Spring weight restrictions apply March-May. Wind energy equipment moves are a growing market.",
      "option_d": "Large agricultural equipment moves are common. Spring weight restrictions apply on all secondary roads.",
      "correct_answer": "A",
      "explanation": "Per Georgia's current course data: Georgia has one of the highest height limits at 15'0\". Atlanta metro has significant restricted travel times."
    },
    {
      "id": "GA_PEVO_PREP_14",
      "course_id": "GA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Georgia?",
      "option_a": "8'6\" (standard)",
      "option_b": "10'0\"",
      "option_c": "There is no standard width threshold",
      "option_d": "6'0\"",
      "correct_answer": "A",
      "explanation": "Per Georgia's current course data: 8'6\" (standard)"
    },
    {
      "id": "GA_PEVO_PREP_15",
      "course_id": "GA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Georgia?",
      "option_a": "15'0\"",
      "option_b": "13'6\" (standard)",
      "option_c": "There is no standard height threshold",
      "option_d": "10'0\"",
      "correct_answer": "B",
      "explanation": "Per Georgia's current course data: 13'6\" (standard)"
    },
    {
      "id": "GA_PEVO_PREP_16",
      "course_id": "GA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_17",
      "course_id": "GA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_18",
      "course_id": "GA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_19",
      "course_id": "GA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_20",
      "course_id": "GA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_21",
      "course_id": "GA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_22",
      "course_id": "GA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_23",
      "course_id": "GA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_24",
      "course_id": "GA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_25",
      "course_id": "GA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_26",
      "course_id": "GA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_27",
      "course_id": "GA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_28",
      "course_id": "GA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_29",
      "course_id": "GA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_30",
      "course_id": "GA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_31",
      "course_id": "GA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_32",
      "course_id": "GA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_33",
      "course_id": "GA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_34",
      "course_id": "GA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_35",
      "course_id": "GA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_36",
      "course_id": "GA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_37",
      "course_id": "GA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_38",
      "course_id": "GA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_39",
      "course_id": "GA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_40",
      "course_id": "GA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_41",
      "course_id": "GA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_42",
      "course_id": "GA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_43",
      "course_id": "GA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_44",
      "course_id": "GA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_45",
      "course_id": "GA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_46",
      "course_id": "GA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_47",
      "course_id": "GA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_48",
      "course_id": "GA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_49",
      "course_id": "GA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "GA_PEVO_PREP_50",
      "course_id": "GA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "HI_PEVO_PREP": [
    {
      "id": "HI_PEVO_PREP_1",
      "course_id": "HI_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Hawaii?",
      "option_a": "Missouri DOT Permit Center",
      "option_b": "Oregon DOT Permits Unit",
      "option_c": "Georgia DOT Oversize Unit",
      "option_d": "Hawaii DOT Highways Division",
      "correct_answer": "D",
      "explanation": "Per Hawaii's current course data: Hawaii DOT Highways Division"
    },
    {
      "id": "HI_PEVO_PREP_2",
      "course_id": "HI_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Hawaii require to legally operate as an escort vehicle operator?",
      "option_a": "PEVO Cert",
      "option_b": "NY Standalone ONLY",
      "option_c": "State Specific",
      "option_d": "8-State Uniform",
      "correct_answer": "C",
      "explanation": "Per Hawaii's current course data: State Specific"
    },
    {
      "id": "HI_PEVO_PREP_3",
      "course_id": "HI_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Hawaii?",
      "option_a": "OVERSIZE LOAD - standard 5ft x 12in",
      "option_b": "OVERSIZE LOAD - 5ft x 12in, yellow, black 8-inch letters",
      "option_c": "OVERSIZE LOAD - 5ft x 12in yellow",
      "option_d": "OVERSIZED LOAD - required on front and rear",
      "correct_answer": "D",
      "explanation": "Per Hawaii's current course data: OVERSIZED LOAD - required on front and rear"
    },
    {
      "id": "HI_PEVO_PREP_4",
      "course_id": "HI_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Hawaii?",
      "option_a": "Amber Class 1 strobe front and rear",
      "option_b": "Amber strobe - front and rear mandatory",
      "option_c": "Amber Class 1 front and rear",
      "option_d": "SAE Class 1 amber front and rear",
      "correct_answer": "B",
      "explanation": "Per Hawaii's current course data: Amber strobe - front and rear mandatory"
    },
    {
      "id": "HI_PEVO_PREP_5",
      "course_id": "HI_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Hawaii?",
      "option_a": "18-inch stop/slow paddle, fire extinguisher",
      "option_b": "Stop/slow paddle, 2.5 lb fire extinguisher, flares",
      "option_c": "Paddle, extinguisher, 6 flares",
      "option_d": "Fire extinguisher, safety triangles, vest",
      "correct_answer": "D",
      "explanation": "Per Hawaii's current course data: Fire extinguisher, safety triangles, vest"
    },
    {
      "id": "HI_PEVO_PREP_6",
      "course_id": "HI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Hawaii, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 13'6\"",
      "option_b": "Any load exceeding 8'0\" width or 13'6\" height",
      "option_c": "Width over 8'6\" or height over 14'0\" triggers mandatory P/EVO escort",
      "option_d": "Width over 8'6\" or height over 13'0\"",
      "correct_answer": "B",
      "explanation": "Per Hawaii's current course data: Any load exceeding 8'0\" width or 13'6\" height"
    },
    {
      "id": "HI_PEVO_PREP_7",
      "course_id": "HI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Hawaii?",
      "option_a": "14'0\"",
      "option_b": "14'6\"",
      "option_c": "16'0\"",
      "option_d": "12'0\"",
      "correct_answer": "D",
      "explanation": "Per Hawaii's current course data: 12'0\""
    },
    {
      "id": "HI_PEVO_PREP_8",
      "course_id": "HI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Hawaii?",
      "option_a": "14'6\"",
      "option_b": "18'0\"",
      "option_c": "14'0\"",
      "option_d": "13'6\"",
      "correct_answer": "C",
      "explanation": "Per Hawaii's current course data: 14'0\""
    },
    {
      "id": "HI_PEVO_PREP_9",
      "course_id": "HI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Hawaii's night travel status for oversize permitted moves?",
      "option_a": "Restricted",
      "option_b": "Allowed",
      "option_c": "Always fully prohibited, no exceptions",
      "option_d": "w/ lighting",
      "correct_answer": "A",
      "explanation": "Per Hawaii's current course data: Restricted"
    },
    {
      "id": "HI_PEVO_PREP_10",
      "course_id": "HI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Hawaii?",
      "option_a": "Same as standard minimum — no separate night-ops tier specified",
      "option_b": "$750K CSL minimum",
      "option_c": "$500K CSL minimum",
      "option_d": "$1M CSL minimum",
      "correct_answer": "C",
      "explanation": "Per Hawaii's current course data: $500K CSL minimum"
    },
    {
      "id": "HI_PEVO_PREP_11",
      "course_id": "HI_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Hawaii?",
      "option_a": "$750K CSL",
      "option_b": "$500K CSL",
      "option_c": "$1M CSL",
      "option_d": "$10,000 liability",
      "correct_answer": "B",
      "explanation": "Per Hawaii's current course data: $500K CSL"
    },
    {
      "id": "HI_PEVO_PREP_12",
      "course_id": "HI_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Hawaii belong to for escort operator requirements?",
      "option_a": "Standalone",
      "option_b": "8-State",
      "option_c": "Remaining",
      "option_d": "NY Standalone",
      "correct_answer": "A",
      "explanation": "Per Hawaii's current course data: Standalone"
    },
    {
      "id": "HI_PEVO_PREP_13",
      "course_id": "HI_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Hawaii-specific rule or red flag operators must know?",
      "option_a": "NJ requires $1M insurance. NJ Turnpike and Garden State Parkway have separate permit procedures. Path and Lincoln tunnel approaches have height restrictions.",
      "option_b": "Hawaii has the narrowest width allowance at 12'0\". Island-specific routes and weight restrictions apply on all four major islands.",
      "option_c": "Northern Virginia (NOVA) has some of the most restrictive permit windows in the country. I-95 and I-66 corridors are heavily managed.",
      "option_d": "Delaware is a small state with high bridge density. Bridge strike liability is strictly enforced under state code.",
      "correct_answer": "B",
      "explanation": "Per Hawaii's current course data: Hawaii has the narrowest width allowance at 12'0\". Island-specific routes and weight restrictions apply on all four major islands."
    },
    {
      "id": "HI_PEVO_PREP_14",
      "course_id": "HI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Hawaii?",
      "option_a": "8'6\" (standard)",
      "option_b": "There is no standard width threshold",
      "option_c": "10'0\"",
      "option_d": "6'0\"",
      "correct_answer": "A",
      "explanation": "Per Hawaii's current course data: 8'6\" (standard)"
    },
    {
      "id": "HI_PEVO_PREP_15",
      "course_id": "HI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Hawaii?",
      "option_a": "There is no standard height threshold",
      "option_b": "13'6\" (standard)",
      "option_c": "10'0\"",
      "option_d": "15'0\"",
      "correct_answer": "B",
      "explanation": "Per Hawaii's current course data: 13'6\" (standard)"
    },
    {
      "id": "HI_PEVO_PREP_16",
      "course_id": "HI_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_17",
      "course_id": "HI_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_18",
      "course_id": "HI_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_19",
      "course_id": "HI_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_20",
      "course_id": "HI_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_21",
      "course_id": "HI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_22",
      "course_id": "HI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_23",
      "course_id": "HI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_24",
      "course_id": "HI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_25",
      "course_id": "HI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_26",
      "course_id": "HI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_27",
      "course_id": "HI_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_28",
      "course_id": "HI_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_29",
      "course_id": "HI_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_30",
      "course_id": "HI_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_31",
      "course_id": "HI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_32",
      "course_id": "HI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_33",
      "course_id": "HI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_34",
      "course_id": "HI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_35",
      "course_id": "HI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_36",
      "course_id": "HI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_37",
      "course_id": "HI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_38",
      "course_id": "HI_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_39",
      "course_id": "HI_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_40",
      "course_id": "HI_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_41",
      "course_id": "HI_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_42",
      "course_id": "HI_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_43",
      "course_id": "HI_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_44",
      "course_id": "HI_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_45",
      "course_id": "HI_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_46",
      "course_id": "HI_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_47",
      "course_id": "HI_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_48",
      "course_id": "HI_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_49",
      "course_id": "HI_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "HI_PEVO_PREP_50",
      "course_id": "HI_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "ID_PEVO_PREP": [
    {
      "id": "ID_PEVO_PREP_1",
      "course_id": "ID_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Idaho?",
      "option_a": "NM DOT Permits Office",
      "option_b": "NC DOT Oversize Permits",
      "option_c": "NH DOT Permit Office",
      "option_d": "Idaho Transportation Dept Permits",
      "correct_answer": "D",
      "explanation": "Per Idaho's current course data: Idaho Transportation Dept Permits"
    },
    {
      "id": "ID_PEVO_PREP_2",
      "course_id": "ID_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Idaho require to legally operate as an escort vehicle operator?",
      "option_a": "PEVO Cert",
      "option_b": "NY Standalone ONLY",
      "option_c": "8-State Uniform",
      "option_d": "PPCA Required",
      "correct_answer": "C",
      "explanation": "Per Idaho's current course data: 8-State Uniform"
    },
    {
      "id": "ID_PEVO_PREP_3",
      "course_id": "ID_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Idaho?",
      "option_a": "OVERSIZE LOAD - 7ft x 18in, fluorescent yellow-orange, 10-inch black letters",
      "option_b": "OVERSIZE LOAD - yellow, black letters, standard",
      "option_c": "OVERSIZE LOAD - 5ft wide x 10in high, yellow, black letters",
      "option_d": "OVERSIZE LOAD - 5ft x 10in, yellow, SAE spec",
      "correct_answer": "D",
      "explanation": "Per Idaho's current course data: OVERSIZE LOAD - 5ft x 10in, yellow, SAE spec"
    },
    {
      "id": "ID_PEVO_PREP_4",
      "course_id": "ID_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Idaho?",
      "option_a": "SAE Class 1 amber strobe, 360-degree visibility, minimum 35W",
      "option_b": "Amber Class 1 strobe - 360 visibility at 500 ft",
      "option_c": "Amber Class 1 strobe required",
      "option_d": "SAE Class 1 amber strobe - front and rear",
      "correct_answer": "B",
      "explanation": "Per Idaho's current course data: Amber Class 1 strobe - 360 visibility at 500 ft"
    },
    {
      "id": "ID_PEVO_PREP_5",
      "course_id": "ID_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Idaho?",
      "option_a": "Paddle, 2.5 lb extinguisher, flares",
      "option_b": "Paddle, 3 lb extinguisher, vest",
      "option_c": "18-inch paddle, 3 lb extinguisher",
      "option_d": "Paddle, 5 lb extinguisher, flares, safety vest",
      "correct_answer": "A",
      "explanation": "Per Idaho's current course data: Paddle, 2.5 lb extinguisher, flares"
    },
    {
      "id": "ID_PEVO_PREP_6",
      "course_id": "ID_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Idaho, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\", height over 13'6\", or length over 65 ft",
      "option_b": "Loads exceeding 8'6\" width or 13'6\" height require licensed escort",
      "option_c": "Width over 9'0\" or height over 13'6\" triggers escort requirement",
      "option_d": "ANY load over 8'6\" width or 13'6\" height - ZERO tolerance",
      "correct_answer": "B",
      "explanation": "Per Idaho's current course data: Loads exceeding 8'6\" width or 13'6\" height require licensed escort"
    },
    {
      "id": "ID_PEVO_PREP_7",
      "course_id": "ID_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Idaho?",
      "option_a": "14'6\"",
      "option_b": "12'0\"",
      "option_c": "16'0\"",
      "option_d": "14'0\"",
      "correct_answer": "A",
      "explanation": "Per Idaho's current course data: 14'6\""
    },
    {
      "id": "ID_PEVO_PREP_8",
      "course_id": "ID_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Idaho?",
      "option_a": "13'6\"",
      "option_b": "18'0\"",
      "option_c": "15'0\"",
      "option_d": "14'6\"",
      "correct_answer": "D",
      "explanation": "Per Idaho's current course data: 14'6\""
    },
    {
      "id": "ID_PEVO_PREP_9",
      "course_id": "ID_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Idaho's night travel status for oversize permitted moves?",
      "option_a": "Restricted",
      "option_b": "w/ lighting",
      "option_c": "Always fully prohibited, no exceptions",
      "option_d": "Allowed",
      "correct_answer": "B",
      "explanation": "Per Idaho's current course data: w/ lighting"
    },
    {
      "id": "ID_PEVO_PREP_10",
      "course_id": "ID_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Idaho?",
      "option_a": "Same as standard minimum — no separate night-ops tier specified",
      "option_b": "$1M CSL minimum",
      "option_c": "$750K CSL minimum",
      "option_d": "$500K CSL minimum",
      "correct_answer": "C",
      "explanation": "Per Idaho's current course data: $750K CSL minimum"
    },
    {
      "id": "ID_PEVO_PREP_11",
      "course_id": "ID_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Idaho?",
      "option_a": "$750K CSL",
      "option_b": "$500K CSL",
      "option_c": "$1M CSL",
      "option_d": "$10,000 liability",
      "correct_answer": "A",
      "explanation": "Per Idaho's current course data: $750K CSL"
    },
    {
      "id": "ID_PEVO_PREP_12",
      "course_id": "ID_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Idaho belong to for escort operator requirements?",
      "option_a": "14 PEVO",
      "option_b": "8-State",
      "option_c": "Stand-Alone",
      "option_d": "Remaining",
      "correct_answer": "B",
      "explanation": "Per Idaho's current course data: 8-State"
    },
    {
      "id": "ID_PEVO_PREP_13",
      "course_id": "ID_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Idaho-specific rule or red flag operators must know?",
      "option_a": "Baltimore metro and Chesapeake Bay Bridge have special permit procedures. Bay Bridge requires advance notice of 48 hours.",
      "option_b": "Idaho is part of the 8-State uniform equipment group. Mountain corridors US-95 and I-84 have seasonal restrictions.",
      "option_c": "Vermont spring thaw laws (Feb-April) severely restrict movements. Green Mountain routes have height clearance issues.",
      "option_d": "Louisiana has one of the highest height allowances at 15'0\". Bayou and river crossings require bridge clearance verification.",
      "correct_answer": "B",
      "explanation": "Per Idaho's current course data: Idaho is part of the 8-State uniform equipment group. Mountain corridors US-95 and I-84 have seasonal restrictions."
    },
    {
      "id": "ID_PEVO_PREP_14",
      "course_id": "ID_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Idaho?",
      "option_a": "There is no standard width threshold",
      "option_b": "6'0\"",
      "option_c": "10'0\"",
      "option_d": "8'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per Idaho's current course data: 8'6\" (standard)"
    },
    {
      "id": "ID_PEVO_PREP_15",
      "course_id": "ID_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Idaho?",
      "option_a": "10'0\"",
      "option_b": "13'6\" (standard)",
      "option_c": "15'0\"",
      "option_d": "There is no standard height threshold",
      "correct_answer": "B",
      "explanation": "Per Idaho's current course data: 13'6\" (standard)"
    },
    {
      "id": "ID_PEVO_PREP_16",
      "course_id": "ID_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_17",
      "course_id": "ID_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_18",
      "course_id": "ID_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_19",
      "course_id": "ID_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_20",
      "course_id": "ID_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_21",
      "course_id": "ID_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_22",
      "course_id": "ID_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_23",
      "course_id": "ID_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_24",
      "course_id": "ID_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_25",
      "course_id": "ID_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_26",
      "course_id": "ID_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_27",
      "course_id": "ID_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_28",
      "course_id": "ID_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_29",
      "course_id": "ID_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_30",
      "course_id": "ID_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_31",
      "course_id": "ID_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_32",
      "course_id": "ID_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_33",
      "course_id": "ID_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_34",
      "course_id": "ID_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_35",
      "course_id": "ID_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_36",
      "course_id": "ID_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_37",
      "course_id": "ID_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_38",
      "course_id": "ID_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_39",
      "course_id": "ID_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_40",
      "course_id": "ID_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_41",
      "course_id": "ID_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_42",
      "course_id": "ID_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_43",
      "course_id": "ID_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_44",
      "course_id": "ID_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_45",
      "course_id": "ID_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_46",
      "course_id": "ID_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_47",
      "course_id": "ID_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_48",
      "course_id": "ID_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_49",
      "course_id": "ID_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ID_PEVO_PREP_50",
      "course_id": "ID_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "IL_PEVO_PREP": [
    {
      "id": "IL_PEVO_PREP_1",
      "course_id": "IL_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Illinois?",
      "option_a": "Hawaii DOT Highways Division",
      "option_b": "Kansas DOT Permitting",
      "option_c": "Minnesota DOT Permit Office",
      "option_d": "Illinois DOT Bureau of Permits",
      "correct_answer": "D",
      "explanation": "Per Illinois's current course data: Illinois DOT Bureau of Permits"
    },
    {
      "id": "IL_PEVO_PREP_2",
      "course_id": "IL_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Illinois require to legally operate as an escort vehicle operator?",
      "option_a": "PEVO Cert",
      "option_b": "State Specific",
      "option_c": "PPCA Required",
      "option_d": "8-State Uniform",
      "correct_answer": "B",
      "explanation": "Per Illinois's current course data: State Specific"
    },
    {
      "id": "IL_PEVO_PREP_3",
      "course_id": "IL_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Illinois?",
      "option_a": "OVERSIZE LOAD - yellow, black letters, standard",
      "option_b": "OVERSIZE LOAD - 96in x 12in, fluorescent yellow-green, black letters",
      "option_c": "OVERSIZE LOAD - yellow, standard federal spec",
      "option_d": "OVERSIZE LOAD - yellow, 5ft x 12in",
      "correct_answer": "B",
      "explanation": "Per Illinois's current course data: OVERSIZE LOAD - 96in x 12in, fluorescent yellow-green, black letters"
    },
    {
      "id": "IL_PEVO_PREP_4",
      "course_id": "IL_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Illinois?",
      "option_a": "SAE Class 1 amber, police-grade brightness",
      "option_b": "Class 1 amber strobe - must be visible 500 ft",
      "option_c": "SAE Class 1 amber front and rear",
      "option_d": "SAE Class 1 amber strobe",
      "correct_answer": "A",
      "explanation": "Per Illinois's current course data: SAE Class 1 amber, police-grade brightness"
    },
    {
      "id": "IL_PEVO_PREP_5",
      "course_id": "IL_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Illinois?",
      "option_a": "Paddle, 5 lb extinguisher, flares, cones",
      "option_b": "Paddle, 5 lb extinguisher, 3 road flares, safety vest",
      "option_c": "Paddle, extinguisher, 6 road flares",
      "option_d": "18-inch stop/slow paddle, 3 lb (2-A:10-B:C) fire extinguisher, orange safety vest",
      "correct_answer": "B",
      "explanation": "Per Illinois's current course data: Paddle, 5 lb extinguisher, 3 road flares, safety vest"
    },
    {
      "id": "IL_PEVO_PREP_6",
      "course_id": "IL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Illinois, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 14'0\"",
      "option_b": "Width over 9'0\" or height over 13'6\" triggers escort requirement",
      "option_c": "Loads exceeding 8'6\" width or 13'6\" height require licensed escort",
      "option_d": "Width over 12'0\" or height over 14'0\"",
      "correct_answer": "B",
      "explanation": "Per Illinois's current course data: Width over 9'0\" or height over 13'6\" triggers escort requirement"
    },
    {
      "id": "IL_PEVO_PREP_7",
      "course_id": "IL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Illinois?",
      "option_a": "16'0\"",
      "option_b": "14'6\"",
      "option_c": "14'0\"",
      "option_d": "12'0\"",
      "correct_answer": "B",
      "explanation": "Per Illinois's current course data: 14'6\""
    },
    {
      "id": "IL_PEVO_PREP_8",
      "course_id": "IL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Illinois?",
      "option_a": "15'6\"",
      "option_b": "14'6\"",
      "option_c": "13'6\"",
      "option_d": "15'0\"",
      "correct_answer": "D",
      "explanation": "Per Illinois's current course data: 15'0\""
    },
    {
      "id": "IL_PEVO_PREP_9",
      "course_id": "IL_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Illinois's night travel status for oversize permitted moves?",
      "option_a": "Always fully prohibited, no exceptions",
      "option_b": "Restricted",
      "option_c": "w/ lighting",
      "option_d": "Allowed",
      "correct_answer": "C",
      "explanation": "Per Illinois's current course data: w/ lighting"
    },
    {
      "id": "IL_PEVO_PREP_10",
      "course_id": "IL_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Illinois?",
      "option_a": "Same as standard minimum — no separate night-ops tier specified",
      "option_b": "$750K CSL minimum",
      "option_c": "$500K CSL minimum",
      "option_d": "$1M CSL minimum",
      "correct_answer": "D",
      "explanation": "Per Illinois's current course data: $1M CSL minimum"
    },
    {
      "id": "IL_PEVO_PREP_11",
      "course_id": "IL_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Illinois?",
      "option_a": "$1M CSL",
      "option_b": "$10,000 liability",
      "option_c": "$750K CSL",
      "option_d": "$500K CSL",
      "correct_answer": "A",
      "explanation": "Per Illinois's current course data: $1M CSL"
    },
    {
      "id": "IL_PEVO_PREP_12",
      "course_id": "IL_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Illinois belong to for escort operator requirements?",
      "option_a": "Remaining",
      "option_b": "Standalone",
      "option_c": "8-State",
      "option_d": "Stand-Alone",
      "correct_answer": "A",
      "explanation": "Per Illinois's current course data: Remaining"
    },
    {
      "id": "IL_PEVO_PREP_13",
      "course_id": "IL_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Illinois-specific rule or red flag operators must know?",
      "option_a": "Illinois requires $1M CSL insurance, higher than most states. Chicago metro has permit windows and bridge weight limits.",
      "option_b": "Hawaii has the narrowest width allowance at 12'0\". Island-specific routes and weight restrictions apply on all four major islands.",
      "option_c": "PEVO reciprocity state. PPCA cert accepted. Carry original cert plus trip permit at all times.",
      "option_d": "Iowa is in the 8-State group. Spring road restrictions (Feb-May) limit weights on paved roads annually.",
      "correct_answer": "A",
      "explanation": "Per Illinois's current course data: Illinois requires $1M CSL insurance, higher than most states. Chicago metro has permit windows and bridge weight limits."
    },
    {
      "id": "IL_PEVO_PREP_14",
      "course_id": "IL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Illinois?",
      "option_a": "6'0\"",
      "option_b": "10'0\"",
      "option_c": "There is no standard width threshold",
      "option_d": "8'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per Illinois's current course data: 8'6\" (standard)"
    },
    {
      "id": "IL_PEVO_PREP_15",
      "course_id": "IL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Illinois?",
      "option_a": "15'0\"",
      "option_b": "13'6\" (standard)",
      "option_c": "10'0\"",
      "option_d": "There is no standard height threshold",
      "correct_answer": "B",
      "explanation": "Per Illinois's current course data: 13'6\" (standard)"
    },
    {
      "id": "IL_PEVO_PREP_16",
      "course_id": "IL_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_17",
      "course_id": "IL_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_18",
      "course_id": "IL_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_19",
      "course_id": "IL_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_20",
      "course_id": "IL_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_21",
      "course_id": "IL_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_22",
      "course_id": "IL_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_23",
      "course_id": "IL_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_24",
      "course_id": "IL_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_25",
      "course_id": "IL_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_26",
      "course_id": "IL_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_27",
      "course_id": "IL_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_28",
      "course_id": "IL_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_29",
      "course_id": "IL_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_30",
      "course_id": "IL_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_31",
      "course_id": "IL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_32",
      "course_id": "IL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_33",
      "course_id": "IL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_34",
      "course_id": "IL_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_35",
      "course_id": "IL_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_36",
      "course_id": "IL_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_37",
      "course_id": "IL_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_38",
      "course_id": "IL_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_39",
      "course_id": "IL_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_40",
      "course_id": "IL_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_41",
      "course_id": "IL_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_42",
      "course_id": "IL_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_43",
      "course_id": "IL_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_44",
      "course_id": "IL_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_45",
      "course_id": "IL_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_46",
      "course_id": "IL_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_47",
      "course_id": "IL_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_48",
      "course_id": "IL_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_49",
      "course_id": "IL_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IL_PEVO_PREP_50",
      "course_id": "IL_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "IN_PEVO_PREP": [
    {
      "id": "IN_PEVO_PREP_1",
      "course_id": "IN_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Indiana?",
      "option_a": "Louisiana DOTD Oversize Permits",
      "option_b": "KY Transportation Cabinet Permits",
      "option_c": "Indiana DOT Permits",
      "option_d": "Ohio DOT Permit Office",
      "correct_answer": "C",
      "explanation": "Per Indiana's current course data: Indiana DOT Permits"
    },
    {
      "id": "IN_PEVO_PREP_2",
      "course_id": "IN_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Indiana require to legally operate as an escort vehicle operator?",
      "option_a": "State Specific",
      "option_b": "PPCA Required",
      "option_c": "8-State Uniform",
      "option_d": "NY Standalone ONLY",
      "correct_answer": "A",
      "explanation": "Per Indiana's current course data: State Specific"
    },
    {
      "id": "IN_PEVO_PREP_3",
      "course_id": "IN_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Indiana?",
      "option_a": "OVERSIZE LOAD - 5ft x 12in, yellow background",
      "option_b": "OVERSIZE LOAD - 5ft x 12in, yellow, black letters",
      "option_c": "OVERSIZE LOAD - yellow, 5ft x 12in, reflective",
      "option_d": "OVERSIZE LOAD - 5ft x 12in, yellow, black 8-inch letters",
      "correct_answer": "A",
      "explanation": "Per Indiana's current course data: OVERSIZE LOAD - 5ft x 12in, yellow background"
    },
    {
      "id": "IN_PEVO_PREP_4",
      "course_id": "IN_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Indiana?",
      "option_a": "Amber SAE Class 1, front and rear",
      "option_b": "Amber strobe Class 1",
      "option_c": "Amber Class 1 strobe, visible 1000 ft each direction",
      "option_d": "Amber SAE Class 1 strobe, front and rear",
      "correct_answer": "C",
      "explanation": "Per Indiana's current course data: Amber Class 1 strobe, visible 1000 ft each direction"
    },
    {
      "id": "IN_PEVO_PREP_5",
      "course_id": "IN_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Indiana?",
      "option_a": "18-inch paddle, 3 lb extinguisher",
      "option_b": "18-inch stop/slow paddle, 3 lb (2-A:10-B:C) fire extinguisher, orange safety vest",
      "option_c": "Paddle, fire extinguisher, safety vest",
      "option_d": "18-inch stop/slow paddle, 3 lb extinguisher, cones",
      "correct_answer": "A",
      "explanation": "Per Indiana's current course data: 18-inch paddle, 3 lb extinguisher"
    },
    {
      "id": "IN_PEVO_PREP_6",
      "course_id": "IN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Indiana, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\", height over 13'6\", or length over 65 ft",
      "option_b": "Width over 9'0\" or height over 13'6\" triggers escort requirement",
      "option_c": "Width over 8'6\" or height over 13'6\"",
      "option_d": "Width over 8'6\" or height over 13'0\"",
      "correct_answer": "C",
      "explanation": "Per Indiana's current course data: Width over 8'6\" or height over 13'6\""
    },
    {
      "id": "IN_PEVO_PREP_7",
      "course_id": "IN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Indiana?",
      "option_a": "16'0\"",
      "option_b": "14'6\"",
      "option_c": "12'0\"",
      "option_d": "14'0\"",
      "correct_answer": "B",
      "explanation": "Per Indiana's current course data: 14'6\""
    },
    {
      "id": "IN_PEVO_PREP_8",
      "course_id": "IN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Indiana?",
      "option_a": "15'6\"",
      "option_b": "16'0\"",
      "option_c": "14'6\"",
      "option_d": "15'0\"",
      "correct_answer": "C",
      "explanation": "Per Indiana's current course data: 14'6\""
    },
    {
      "id": "IN_PEVO_PREP_9",
      "course_id": "IN_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Indiana's night travel status for oversize permitted moves?",
      "option_a": "Allowed",
      "option_b": "Always fully prohibited, no exceptions",
      "option_c": "Restricted",
      "option_d": "w/ lighting",
      "correct_answer": "A",
      "explanation": "Per Indiana's current course data: Allowed"
    },
    {
      "id": "IN_PEVO_PREP_10",
      "course_id": "IN_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Indiana?",
      "option_a": "$750K CSL minimum",
      "option_b": "$1M CSL minimum",
      "option_c": "Same as standard minimum — no separate night-ops tier specified",
      "option_d": "$500K CSL minimum",
      "correct_answer": "A",
      "explanation": "Per Indiana's current course data: $750K CSL minimum"
    },
    {
      "id": "IN_PEVO_PREP_11",
      "course_id": "IN_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Indiana?",
      "option_a": "$500K CSL",
      "option_b": "$750K CSL",
      "option_c": "$1M CSL",
      "option_d": "$10,000 liability",
      "correct_answer": "B",
      "explanation": "Per Indiana's current course data: $750K CSL"
    },
    {
      "id": "IN_PEVO_PREP_12",
      "course_id": "IN_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Indiana belong to for escort operator requirements?",
      "option_a": "Remaining",
      "option_b": "8-State",
      "option_c": "NY Standalone",
      "option_d": "14 PEVO",
      "correct_answer": "A",
      "explanation": "Per Indiana's current course data: Remaining"
    },
    {
      "id": "IN_PEVO_PREP_13",
      "course_id": "IN_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Indiana-specific rule or red flag operators must know?",
      "option_a": "Idaho is part of the 8-State uniform equipment group. Mountain corridors US-95 and I-84 have seasonal restrictions.",
      "option_b": "Vermont spring thaw laws (Feb-April) severely restrict movements. Green Mountain routes have height clearance issues.",
      "option_c": "PEVO reciprocity. High seasonal agriculture move volume. Mississippi River crossing permits require advance coordination.",
      "option_d": "Indiana allows night travel with proper lighting. Indianapolis metro has restricted windows during sporting events.",
      "correct_answer": "D",
      "explanation": "Per Indiana's current course data: Indiana allows night travel with proper lighting. Indianapolis metro has restricted windows during sporting events."
    },
    {
      "id": "IN_PEVO_PREP_14",
      "course_id": "IN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Indiana?",
      "option_a": "6'0\"",
      "option_b": "8'6\" (standard)",
      "option_c": "There is no standard width threshold",
      "option_d": "10'0\"",
      "correct_answer": "B",
      "explanation": "Per Indiana's current course data: 8'6\" (standard)"
    },
    {
      "id": "IN_PEVO_PREP_15",
      "course_id": "IN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Indiana?",
      "option_a": "15'0\"",
      "option_b": "There is no standard height threshold",
      "option_c": "13'6\" (standard)",
      "option_d": "10'0\"",
      "correct_answer": "C",
      "explanation": "Per Indiana's current course data: 13'6\" (standard)"
    },
    {
      "id": "IN_PEVO_PREP_16",
      "course_id": "IN_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_17",
      "course_id": "IN_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_18",
      "course_id": "IN_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_19",
      "course_id": "IN_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_20",
      "course_id": "IN_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_21",
      "course_id": "IN_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_22",
      "course_id": "IN_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_23",
      "course_id": "IN_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_24",
      "course_id": "IN_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_25",
      "course_id": "IN_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_26",
      "course_id": "IN_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_27",
      "course_id": "IN_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_28",
      "course_id": "IN_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_29",
      "course_id": "IN_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_30",
      "course_id": "IN_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_31",
      "course_id": "IN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_32",
      "course_id": "IN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_33",
      "course_id": "IN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_34",
      "course_id": "IN_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_35",
      "course_id": "IN_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_36",
      "course_id": "IN_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_37",
      "course_id": "IN_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_38",
      "course_id": "IN_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_39",
      "course_id": "IN_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_40",
      "course_id": "IN_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_41",
      "course_id": "IN_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_42",
      "course_id": "IN_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_43",
      "course_id": "IN_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_44",
      "course_id": "IN_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_45",
      "course_id": "IN_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_46",
      "course_id": "IN_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_47",
      "course_id": "IN_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_48",
      "course_id": "IN_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_49",
      "course_id": "IN_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IN_PEVO_PREP_50",
      "course_id": "IN_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "IA_PEVO_PREP": [
    {
      "id": "IA_PEVO_PREP_1",
      "course_id": "IA_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Iowa?",
      "option_a": "Mississippi DOT Permits",
      "option_b": "Iowa DOT Office of Permitting",
      "option_c": "NH DOT Permit Office",
      "option_d": "SC DOT Oversize Permits",
      "correct_answer": "B",
      "explanation": "Per Iowa's current course data: Iowa DOT Office of Permitting"
    },
    {
      "id": "IA_PEVO_PREP_2",
      "course_id": "IA_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Iowa require to legally operate as an escort vehicle operator?",
      "option_a": "State Specific",
      "option_b": "NY Standalone ONLY",
      "option_c": "PEVO Cert",
      "option_d": "8-State Uniform",
      "correct_answer": "D",
      "explanation": "Per Iowa's current course data: 8-State Uniform"
    },
    {
      "id": "IA_PEVO_PREP_3",
      "course_id": "IA_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Iowa?",
      "option_a": "OVERSIZE LOAD - standard yellow, 5ft x 10in",
      "option_b": "OVERSIZE LOAD - yellow, standard federal spec",
      "option_c": "OVERSIZE LOAD - standard 5ft x 12in",
      "option_d": "OVERSIZE LOAD - 96in x 12in, fluorescent yellow-green, black letters",
      "correct_answer": "A",
      "explanation": "Per Iowa's current course data: OVERSIZE LOAD - standard yellow, 5ft x 10in"
    },
    {
      "id": "IA_PEVO_PREP_4",
      "course_id": "IA_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Iowa?",
      "option_a": "SAE Class 1 amber - 360 degree visibility required",
      "option_b": "Amber Class 1 strobe, visible from 500 ft",
      "option_c": "SAE Class 1 amber front and rear",
      "option_d": "Amber SAE Class 1 strobe visible from all sides",
      "correct_answer": "C",
      "explanation": "Per Iowa's current course data: SAE Class 1 amber front and rear"
    },
    {
      "id": "IA_PEVO_PREP_5",
      "course_id": "IA_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Iowa?",
      "option_a": "Paddle, extinguisher",
      "option_b": "Fire extinguisher, emergency flares, safety vest",
      "option_c": "Paddle, extinguisher, cones",
      "option_d": "18-inch stop/slow paddle, 3 lb (2-A:10-B:C) fire extinguisher, orange safety vest",
      "correct_answer": "C",
      "explanation": "Per Iowa's current course data: Paddle, extinguisher, cones"
    },
    {
      "id": "IA_PEVO_PREP_6",
      "course_id": "IA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Iowa, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 13'6\" requires escort",
      "option_b": "Width exceeding 8'6\" requires lead escort; height over 15'0\" requires height pole",
      "option_c": "Width over 8'6\" OR height over 14'0\" OR weight over 80,000 lbs",
      "option_d": "Any load over 8'6\" width or 14'0\" height on state highways",
      "correct_answer": "A",
      "explanation": "Per Iowa's current course data: Width over 8'6\" or height over 13'6\" requires escort"
    },
    {
      "id": "IA_PEVO_PREP_7",
      "course_id": "IA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Iowa?",
      "option_a": "14'6\"",
      "option_b": "14'0\"",
      "option_c": "16'0\"",
      "option_d": "12'0\"",
      "correct_answer": "A",
      "explanation": "Per Iowa's current course data: 14'6\""
    },
    {
      "id": "IA_PEVO_PREP_8",
      "course_id": "IA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Iowa?",
      "option_a": "14'6\"",
      "option_b": "16'0\"",
      "option_c": "15'0\"",
      "option_d": "15'6\"",
      "correct_answer": "A",
      "explanation": "Per Iowa's current course data: 14'6\""
    },
    {
      "id": "IA_PEVO_PREP_9",
      "course_id": "IA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Iowa's night travel status for oversize permitted moves?",
      "option_a": "w/ lighting",
      "option_b": "Allowed",
      "option_c": "Always fully prohibited, no exceptions",
      "option_d": "Restricted",
      "correct_answer": "A",
      "explanation": "Per Iowa's current course data: w/ lighting"
    },
    {
      "id": "IA_PEVO_PREP_10",
      "course_id": "IA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Iowa?",
      "option_a": "$500K CSL minimum",
      "option_b": "$1M CSL minimum",
      "option_c": "$750K CSL minimum",
      "option_d": "Same as standard minimum — no separate night-ops tier specified",
      "correct_answer": "C",
      "explanation": "Per Iowa's current course data: $750K CSL minimum"
    },
    {
      "id": "IA_PEVO_PREP_11",
      "course_id": "IA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Iowa?",
      "option_a": "$1M CSL",
      "option_b": "$500K CSL",
      "option_c": "$750K CSL",
      "option_d": "$10,000 liability",
      "correct_answer": "C",
      "explanation": "Per Iowa's current course data: $750K CSL"
    },
    {
      "id": "IA_PEVO_PREP_12",
      "course_id": "IA_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Iowa belong to for escort operator requirements?",
      "option_a": "Stand-Alone",
      "option_b": "8-State",
      "option_c": "14 PEVO",
      "option_d": "Standalone",
      "correct_answer": "B",
      "explanation": "Per Iowa's current course data: 8-State"
    },
    {
      "id": "IA_PEVO_PREP_13",
      "course_id": "IA_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Iowa-specific rule or red flag operators must know?",
      "option_a": "Iowa is in the 8-State group. Spring road restrictions (Feb-May) limit weights on paved roads annually.",
      "option_b": "Illinois requires $1M CSL insurance, higher than most states. Chicago metro has permit windows and bridge weight limits.",
      "option_c": "Connecticut restricts night moves on state routes. Permit office must pre-approve routes over bridges. Hartford metro restricted 7am-9am and 4pm-7pm.",
      "option_d": "Pennsylvania has numerous historic bridges with strict weight limits. Turnpike requires advance notification. Philadelphia metro has complex permit routing.",
      "correct_answer": "A",
      "explanation": "Per Iowa's current course data: Iowa is in the 8-State group. Spring road restrictions (Feb-May) limit weights on paved roads annually."
    },
    {
      "id": "IA_PEVO_PREP_14",
      "course_id": "IA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Iowa?",
      "option_a": "10'0\"",
      "option_b": "There is no standard width threshold",
      "option_c": "6'0\"",
      "option_d": "8'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per Iowa's current course data: 8'6\" (standard)"
    },
    {
      "id": "IA_PEVO_PREP_15",
      "course_id": "IA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Iowa?",
      "option_a": "There is no standard height threshold",
      "option_b": "10'0\"",
      "option_c": "15'0\"",
      "option_d": "13'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per Iowa's current course data: 13'6\" (standard)"
    },
    {
      "id": "IA_PEVO_PREP_16",
      "course_id": "IA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_17",
      "course_id": "IA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_18",
      "course_id": "IA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_19",
      "course_id": "IA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_20",
      "course_id": "IA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_21",
      "course_id": "IA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_22",
      "course_id": "IA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_23",
      "course_id": "IA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_24",
      "course_id": "IA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_25",
      "course_id": "IA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_26",
      "course_id": "IA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_27",
      "course_id": "IA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_28",
      "course_id": "IA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_29",
      "course_id": "IA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_30",
      "course_id": "IA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_31",
      "course_id": "IA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_32",
      "course_id": "IA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_33",
      "course_id": "IA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_34",
      "course_id": "IA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_35",
      "course_id": "IA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_36",
      "course_id": "IA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_37",
      "course_id": "IA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_38",
      "course_id": "IA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_39",
      "course_id": "IA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_40",
      "course_id": "IA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_41",
      "course_id": "IA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_42",
      "course_id": "IA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_43",
      "course_id": "IA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_44",
      "course_id": "IA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_45",
      "course_id": "IA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_46",
      "course_id": "IA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_47",
      "course_id": "IA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_48",
      "course_id": "IA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_49",
      "course_id": "IA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "IA_PEVO_PREP_50",
      "course_id": "IA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "KS_PEVO_PREP": [
    {
      "id": "KS_PEVO_PREP_1",
      "course_id": "KS_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Kansas?",
      "option_a": "TxDOT Oversize/Overweight Permits",
      "option_b": "Kansas DOT Permitting",
      "option_c": "Virginia DOT Oversize Permits",
      "option_d": "Missouri DOT Permit Center",
      "correct_answer": "B",
      "explanation": "Per Kansas's current course data: Kansas DOT Permitting"
    },
    {
      "id": "KS_PEVO_PREP_2",
      "course_id": "KS_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Kansas require to legally operate as an escort vehicle operator?",
      "option_a": "PPCA Required",
      "option_b": "PEVO Cert",
      "option_c": "8-State Uniform",
      "option_d": "State Specific",
      "correct_answer": "C",
      "explanation": "Per Kansas's current course data: 8-State Uniform"
    },
    {
      "id": "KS_PEVO_PREP_3",
      "course_id": "KS_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Kansas?",
      "option_a": "OVERSIZE LOAD - yellow, 5ft x 12in, reflective",
      "option_b": "OVERSIZE LOAD - 5ft x 10in yellow",
      "option_c": "OVERSIZE LOAD - 7ft x 18in, fluorescent yellow-orange, 10-inch black letters",
      "option_d": "OVERSIZE LOAD - standard 5ft x 12in",
      "correct_answer": "B",
      "explanation": "Per Kansas's current course data: OVERSIZE LOAD - 5ft x 10in yellow"
    },
    {
      "id": "KS_PEVO_PREP_4",
      "course_id": "KS_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Kansas?",
      "option_a": "SAE Class 1 amber - 360 degree visibility required",
      "option_b": "Amber strobe Class 1, visible from 500 ft",
      "option_c": "SAE Class 1 amber strobe, 360-degree visibility, minimum 35W",
      "option_d": "Amber Class 1 strobe, visible from 500 ft",
      "correct_answer": "D",
      "explanation": "Per Kansas's current course data: Amber Class 1 strobe, visible from 500 ft"
    },
    {
      "id": "KS_PEVO_PREP_5",
      "course_id": "KS_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Kansas?",
      "option_a": "Paddle, extinguisher, flares, emergency triangles",
      "option_b": "Paddle, extinguisher",
      "option_c": "Paddle, fire extinguisher, safety vest",
      "option_d": "18-inch stop/slow paddle, 5 lb fire extinguisher, 3 road flares, safety vest",
      "correct_answer": "B",
      "explanation": "Per Kansas's current course data: Paddle, extinguisher"
    },
    {
      "id": "KS_PEVO_PREP_6",
      "course_id": "KS_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Kansas, when is an escort legally REQUIRED?",
      "option_a": "Loads exceeding 8'6\" width or 13'6\" height require licensed escort",
      "option_b": "Any load exceeding 8'6\" width, 13'6\" height, or 80,000 lbs GVW",
      "option_c": "Any load over 8'6\" width or 13'6\" height",
      "option_d": "Width over 9'0\" or height over 14'0\"",
      "correct_answer": "C",
      "explanation": "Per Kansas's current course data: Any load over 8'6\" width or 13'6\" height"
    },
    {
      "id": "KS_PEVO_PREP_7",
      "course_id": "KS_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Kansas?",
      "option_a": "14'6\"",
      "option_b": "14'0\"",
      "option_c": "12'0\"",
      "option_d": "16'0\"",
      "correct_answer": "A",
      "explanation": "Per Kansas's current course data: 14'6\""
    },
    {
      "id": "KS_PEVO_PREP_8",
      "course_id": "KS_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Kansas?",
      "option_a": "15'6\"",
      "option_b": "13'6\"",
      "option_c": "16'0\"",
      "option_d": "14'6\"",
      "correct_answer": "D",
      "explanation": "Per Kansas's current course data: 14'6\""
    },
    {
      "id": "KS_PEVO_PREP_9",
      "course_id": "KS_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Kansas's night travel status for oversize permitted moves?",
      "option_a": "w/ lighting",
      "option_b": "Restricted",
      "option_c": "Allowed",
      "option_d": "Always fully prohibited, no exceptions",
      "correct_answer": "C",
      "explanation": "Per Kansas's current course data: Allowed"
    },
    {
      "id": "KS_PEVO_PREP_10",
      "course_id": "KS_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Kansas?",
      "option_a": "$1M CSL minimum",
      "option_b": "$750K CSL minimum",
      "option_c": "$500K CSL minimum",
      "option_d": "Same as standard minimum — no separate night-ops tier specified",
      "correct_answer": "B",
      "explanation": "Per Kansas's current course data: $750K CSL minimum"
    },
    {
      "id": "KS_PEVO_PREP_11",
      "course_id": "KS_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Kansas?",
      "option_a": "$1M CSL",
      "option_b": "$10,000 liability",
      "option_c": "$500K CSL",
      "option_d": "$750K CSL",
      "correct_answer": "D",
      "explanation": "Per Kansas's current course data: $750K CSL"
    },
    {
      "id": "KS_PEVO_PREP_12",
      "course_id": "KS_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Kansas belong to for escort operator requirements?",
      "option_a": "Stand-Alone",
      "option_b": "14 PEVO",
      "option_c": "Remaining",
      "option_d": "8-State",
      "correct_answer": "D",
      "explanation": "Per Kansas's current course data: 8-State"
    },
    {
      "id": "KS_PEVO_PREP_13",
      "course_id": "KS_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Kansas-specific rule or red flag operators must know?",
      "option_a": "Kansas is part of the 8-State uniform group. Flat terrain allows consistent escort patterns with few route restrictions.",
      "option_b": "Pennsylvania has numerous historic bridges with strict weight limits. Turnpike requires advance notification. Philadelphia metro has complex permit routing.",
      "option_c": "Vermont spring thaw laws (Feb-April) severely restrict movements. Green Mountain routes have height clearance issues.",
      "option_d": "Ohio does not participate in PEVO reciprocity. Own state cert required. Columbus and Cleveland metros have restricted hours.",
      "correct_answer": "A",
      "explanation": "Per Kansas's current course data: Kansas is part of the 8-State uniform group. Flat terrain allows consistent escort patterns with few route restrictions."
    },
    {
      "id": "KS_PEVO_PREP_14",
      "course_id": "KS_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Kansas?",
      "option_a": "10'0\"",
      "option_b": "8'6\" (standard)",
      "option_c": "There is no standard width threshold",
      "option_d": "6'0\"",
      "correct_answer": "B",
      "explanation": "Per Kansas's current course data: 8'6\" (standard)"
    },
    {
      "id": "KS_PEVO_PREP_15",
      "course_id": "KS_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Kansas?",
      "option_a": "15'0\"",
      "option_b": "13'6\" (standard)",
      "option_c": "10'0\"",
      "option_d": "There is no standard height threshold",
      "correct_answer": "B",
      "explanation": "Per Kansas's current course data: 13'6\" (standard)"
    },
    {
      "id": "KS_PEVO_PREP_16",
      "course_id": "KS_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_17",
      "course_id": "KS_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_18",
      "course_id": "KS_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_19",
      "course_id": "KS_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_20",
      "course_id": "KS_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_21",
      "course_id": "KS_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_22",
      "course_id": "KS_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_23",
      "course_id": "KS_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_24",
      "course_id": "KS_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_25",
      "course_id": "KS_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_26",
      "course_id": "KS_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_27",
      "course_id": "KS_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_28",
      "course_id": "KS_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_29",
      "course_id": "KS_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_30",
      "course_id": "KS_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_31",
      "course_id": "KS_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_32",
      "course_id": "KS_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_33",
      "course_id": "KS_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_34",
      "course_id": "KS_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_35",
      "course_id": "KS_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_36",
      "course_id": "KS_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_37",
      "course_id": "KS_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_38",
      "course_id": "KS_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_39",
      "course_id": "KS_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_40",
      "course_id": "KS_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_41",
      "course_id": "KS_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_42",
      "course_id": "KS_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_43",
      "course_id": "KS_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_44",
      "course_id": "KS_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_45",
      "course_id": "KS_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_46",
      "course_id": "KS_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_47",
      "course_id": "KS_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_48",
      "course_id": "KS_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_49",
      "course_id": "KS_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KS_PEVO_PREP_50",
      "course_id": "KS_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "KY_PEVO_PREP": [
    {
      "id": "KY_PEVO_PREP_1",
      "course_id": "KY_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Kentucky?",
      "option_a": "Iowa DOT Office of Permitting",
      "option_b": "KY Transportation Cabinet Permits",
      "option_c": "Arkansas DOT Oversize Permits",
      "option_d": "Vermont Agency of Transportation",
      "correct_answer": "B",
      "explanation": "Per Kentucky's current course data: KY Transportation Cabinet Permits"
    },
    {
      "id": "KY_PEVO_PREP_2",
      "course_id": "KY_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Kentucky require to legally operate as an escort vehicle operator?",
      "option_a": "PPCA Required",
      "option_b": "8-State Uniform",
      "option_c": "State Specific",
      "option_d": "PEVO Cert",
      "correct_answer": "D",
      "explanation": "Per Kentucky's current course data: PEVO Cert"
    },
    {
      "id": "KY_PEVO_PREP_3",
      "course_id": "KY_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Kentucky?",
      "option_a": "OVERSIZE LOAD - yellow, black letters, standard",
      "option_b": "OVERSIZE LOAD - fluorescent yellow, 5ft x 12in",
      "option_c": "OVERSIZE LOAD - 5ft x 12in, fluorescent yellow, reflective lettering",
      "option_d": "OVERSIZED LOAD - required on front and rear",
      "correct_answer": "B",
      "explanation": "Per Kentucky's current course data: OVERSIZE LOAD - fluorescent yellow, 5ft x 12in"
    },
    {
      "id": "KY_PEVO_PREP_4",
      "course_id": "KY_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Kentucky?",
      "option_a": "SAE Class 1 or 2 amber - mounted at highest visible point - 360 degree visibility",
      "option_b": "SAE Class 1 amber front and rear",
      "option_c": "Amber Class 1 strobe front and rear",
      "option_d": "SAE Class 1 amber AND rear-facing amber required",
      "correct_answer": "B",
      "explanation": "Per Kentucky's current course data: SAE Class 1 amber front and rear"
    },
    {
      "id": "KY_PEVO_PREP_5",
      "course_id": "KY_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Kentucky?",
      "option_a": "Paddle, extinguisher, cones",
      "option_b": "18-inch paddle, 3 lb extinguisher, cones",
      "option_c": "Paddle, 2.5 lb extinguisher, flares",
      "option_d": "Fire extinguisher, safety triangles, vest",
      "correct_answer": "B",
      "explanation": "Per Kentucky's current course data: 18-inch paddle, 3 lb extinguisher, cones"
    },
    {
      "id": "KY_PEVO_PREP_6",
      "course_id": "KY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Kentucky, when is an escort legally REQUIRED?",
      "option_a": "Width over 9'0\" or height over 15'0\"",
      "option_b": "Width over 8'6\" or height over 13'6\"",
      "option_c": "Any load over 8'6\" width or 13'6\" height",
      "option_d": "Width over 8'6\" or height over 14'0\"",
      "correct_answer": "B",
      "explanation": "Per Kentucky's current course data: Width over 8'6\" or height over 13'6\""
    },
    {
      "id": "KY_PEVO_PREP_7",
      "course_id": "KY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Kentucky?",
      "option_a": "14'6\"",
      "option_b": "14'0\"",
      "option_c": "12'0\"",
      "option_d": "16'0\"",
      "correct_answer": "B",
      "explanation": "Per Kentucky's current course data: 14'0\""
    },
    {
      "id": "KY_PEVO_PREP_8",
      "course_id": "KY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Kentucky?",
      "option_a": "14'6\"",
      "option_b": "13'6\"",
      "option_c": "18'0\"",
      "option_d": "14'0\"",
      "correct_answer": "D",
      "explanation": "Per Kentucky's current course data: 14'0\""
    },
    {
      "id": "KY_PEVO_PREP_9",
      "course_id": "KY_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Kentucky's night travel status for oversize permitted moves?",
      "option_a": "w/ lighting",
      "option_b": "Restricted",
      "option_c": "Always fully prohibited, no exceptions",
      "option_d": "Allowed",
      "correct_answer": "A",
      "explanation": "Per Kentucky's current course data: w/ lighting"
    },
    {
      "id": "KY_PEVO_PREP_10",
      "course_id": "KY_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Kentucky?",
      "option_a": "$1M CSL minimum",
      "option_b": "$750K CSL minimum",
      "option_c": "$500K CSL minimum",
      "option_d": "Same as standard minimum — no separate night-ops tier specified",
      "correct_answer": "B",
      "explanation": "Per Kentucky's current course data: $750K CSL minimum"
    },
    {
      "id": "KY_PEVO_PREP_11",
      "course_id": "KY_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Kentucky?",
      "option_a": "$500K CSL",
      "option_b": "$750K CSL",
      "option_c": "$1M CSL",
      "option_d": "$10,000 liability",
      "correct_answer": "B",
      "explanation": "Per Kentucky's current course data: $750K CSL"
    },
    {
      "id": "KY_PEVO_PREP_12",
      "course_id": "KY_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Kentucky belong to for escort operator requirements?",
      "option_a": "14 PEVO",
      "option_b": "8-State",
      "option_c": "Remaining",
      "option_d": "NY Standalone",
      "correct_answer": "A",
      "explanation": "Per Kentucky's current course data: 14 PEVO"
    },
    {
      "id": "KY_PEVO_PREP_13",
      "course_id": "KY_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Kentucky-specific rule or red flag operators must know?",
      "option_a": "Large agricultural equipment moves are common. Spring weight restrictions apply on all secondary roads.",
      "option_b": "NEW YORK HAS ZERO RECIPROCITY. No other cert is accepted. You MUST take the NY-specific course and pass the NY state exam. Thruway, bridges, and tunnels each require separate procedures.",
      "option_c": "PEVO reciprocity state. Appalachian mountain routes have additional permit requirements.",
      "option_d": "PEVO reciprocity. 15'0\" height allowance. Charlotte metro has permit windows and bridge restrictions.",
      "correct_answer": "C",
      "explanation": "Per Kentucky's current course data: PEVO reciprocity state. Appalachian mountain routes have additional permit requirements."
    },
    {
      "id": "KY_PEVO_PREP_14",
      "course_id": "KY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Kentucky?",
      "option_a": "8'6\" (standard)",
      "option_b": "There is no standard width threshold",
      "option_c": "6'0\"",
      "option_d": "10'0\"",
      "correct_answer": "A",
      "explanation": "Per Kentucky's current course data: 8'6\" (standard)"
    },
    {
      "id": "KY_PEVO_PREP_15",
      "course_id": "KY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Kentucky?",
      "option_a": "15'0\"",
      "option_b": "10'0\"",
      "option_c": "13'6\" (standard)",
      "option_d": "There is no standard height threshold",
      "correct_answer": "C",
      "explanation": "Per Kentucky's current course data: 13'6\" (standard)"
    },
    {
      "id": "KY_PEVO_PREP_16",
      "course_id": "KY_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_17",
      "course_id": "KY_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_18",
      "course_id": "KY_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_19",
      "course_id": "KY_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_20",
      "course_id": "KY_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_21",
      "course_id": "KY_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_22",
      "course_id": "KY_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_23",
      "course_id": "KY_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_24",
      "course_id": "KY_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_25",
      "course_id": "KY_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_26",
      "course_id": "KY_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_27",
      "course_id": "KY_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_28",
      "course_id": "KY_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_29",
      "course_id": "KY_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_30",
      "course_id": "KY_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_31",
      "course_id": "KY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_32",
      "course_id": "KY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_33",
      "course_id": "KY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_34",
      "course_id": "KY_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_35",
      "course_id": "KY_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_36",
      "course_id": "KY_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_37",
      "course_id": "KY_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_38",
      "course_id": "KY_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_39",
      "course_id": "KY_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_40",
      "course_id": "KY_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_41",
      "course_id": "KY_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_42",
      "course_id": "KY_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_43",
      "course_id": "KY_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_44",
      "course_id": "KY_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_45",
      "course_id": "KY_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_46",
      "course_id": "KY_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_47",
      "course_id": "KY_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_48",
      "course_id": "KY_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_49",
      "course_id": "KY_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "KY_PEVO_PREP_50",
      "course_id": "KY_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "LA_PEVO_PREP": [
    {
      "id": "LA_PEVO_PREP_1",
      "course_id": "LA_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Louisiana?",
      "option_a": "RI DOT Permit Office",
      "option_b": "Louisiana DOTD Oversize Permits",
      "option_c": "Maine DOT Permit Office",
      "option_d": "Delaware DOT Permit Office",
      "correct_answer": "B",
      "explanation": "Per Louisiana's current course data: Louisiana DOTD Oversize Permits"
    },
    {
      "id": "LA_PEVO_PREP_2",
      "course_id": "LA_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Louisiana require to legally operate as an escort vehicle operator?",
      "option_a": "State Specific",
      "option_b": "NY Standalone ONLY",
      "option_c": "PEVO Cert",
      "option_d": "8-State Uniform",
      "correct_answer": "C",
      "explanation": "Per Louisiana's current course data: PEVO Cert"
    },
    {
      "id": "LA_PEVO_PREP_3",
      "course_id": "LA_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Louisiana?",
      "option_a": "OVERSIZE LOAD - 96in x 12in, fluorescent yellow-green, black letters",
      "option_b": "OVERSIZE LOAD - yellow background, 6-inch black letters",
      "option_c": "OVERSIZE LOAD - fluorescent yellow, 5ft x 12in",
      "option_d": "OVERSIZE LOAD - 5ft x 12in, yellow, black letters",
      "correct_answer": "D",
      "explanation": "Per Louisiana's current course data: OVERSIZE LOAD - 5ft x 12in, yellow, black letters"
    },
    {
      "id": "LA_PEVO_PREP_4",
      "course_id": "LA_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Louisiana?",
      "option_a": "Amber Class 1 or Class 2, front and rear",
      "option_b": "Amber SAE Class 1, minimum 35W",
      "option_c": "Amber strobe, Class 1 rated, mounted highest point of vehicle",
      "option_d": "Amber Class 1 or 2 - front and rear required",
      "correct_answer": "A",
      "explanation": "Per Louisiana's current course data: Amber Class 1 or Class 2, front and rear"
    },
    {
      "id": "LA_PEVO_PREP_5",
      "course_id": "LA_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Louisiana?",
      "option_a": "Paddle, 3 lb extinguisher, cones",
      "option_b": "Fire extinguisher, emergency flares, safety vest",
      "option_c": "Paddle, extinguisher, safety triangles",
      "option_d": "Paddle, 2.5 lb extinguisher, flares",
      "correct_answer": "C",
      "explanation": "Per Louisiana's current course data: Paddle, extinguisher, safety triangles"
    },
    {
      "id": "LA_PEVO_PREP_6",
      "course_id": "LA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Louisiana, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 14'0\" triggers mandatory P/EVO escort",
      "option_b": "Loads exceeding 8'6\" width or 13'6\" height require licensed escort",
      "option_c": "Width over 8'6\" OR height over 14'0\" on most highways",
      "option_d": "Width over 8'6\" or height over 13'6\"",
      "correct_answer": "D",
      "explanation": "Per Louisiana's current course data: Width over 8'6\" or height over 13'6\""
    },
    {
      "id": "LA_PEVO_PREP_7",
      "course_id": "LA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Louisiana?",
      "option_a": "14'6\"",
      "option_b": "12'0\"",
      "option_c": "14'0\"",
      "option_d": "16'0\"",
      "correct_answer": "C",
      "explanation": "Per Louisiana's current course data: 14'0\""
    },
    {
      "id": "LA_PEVO_PREP_8",
      "course_id": "LA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Louisiana?",
      "option_a": "18'0\"",
      "option_b": "15'0\"",
      "option_c": "14'0\"",
      "option_d": "16'0\"",
      "correct_answer": "B",
      "explanation": "Per Louisiana's current course data: 15'0\""
    },
    {
      "id": "LA_PEVO_PREP_9",
      "course_id": "LA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Louisiana's night travel status for oversize permitted moves?",
      "option_a": "Always fully prohibited, no exceptions",
      "option_b": "Allowed",
      "option_c": "Restricted",
      "option_d": "w/ lighting",
      "correct_answer": "B",
      "explanation": "Per Louisiana's current course data: Allowed"
    },
    {
      "id": "LA_PEVO_PREP_10",
      "course_id": "LA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Louisiana?",
      "option_a": "Same as standard minimum — no separate night-ops tier specified",
      "option_b": "$1M CSL minimum",
      "option_c": "$750K CSL minimum",
      "option_d": "$500K CSL minimum",
      "correct_answer": "C",
      "explanation": "Per Louisiana's current course data: $750K CSL minimum"
    },
    {
      "id": "LA_PEVO_PREP_11",
      "course_id": "LA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Louisiana?",
      "option_a": "$10,000 liability",
      "option_b": "$750K CSL",
      "option_c": "$1M CSL",
      "option_d": "$500K CSL",
      "correct_answer": "B",
      "explanation": "Per Louisiana's current course data: $750K CSL"
    },
    {
      "id": "LA_PEVO_PREP_12",
      "course_id": "LA_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Louisiana belong to for escort operator requirements?",
      "option_a": "Remaining",
      "option_b": "14 PEVO",
      "option_c": "Stand-Alone",
      "option_d": "NY Standalone",
      "correct_answer": "B",
      "explanation": "Per Louisiana's current course data: 14 PEVO"
    },
    {
      "id": "LA_PEVO_PREP_13",
      "course_id": "LA_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Louisiana-specific rule or red flag operators must know?",
      "option_a": "Idaho is part of the 8-State uniform equipment group. Mountain corridors US-95 and I-84 have seasonal restrictions.",
      "option_b": "Louisiana has one of the highest height allowances at 15'0\". Bayou and river crossings require bridge clearance verification.",
      "option_c": "PEVO reciprocity. New Mexico allows night travel. High desert terrain has minimal bridge restrictions.",
      "option_d": "Tennessee does not participate in PEVO reciprocity. Nashville metro has restricted permit windows. Mountain routes require special permits.",
      "correct_answer": "B",
      "explanation": "Per Louisiana's current course data: Louisiana has one of the highest height allowances at 15'0\". Bayou and river crossings require bridge clearance verification."
    },
    {
      "id": "LA_PEVO_PREP_14",
      "course_id": "LA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Louisiana?",
      "option_a": "10'0\"",
      "option_b": "There is no standard width threshold",
      "option_c": "8'6\" (standard)",
      "option_d": "6'0\"",
      "correct_answer": "C",
      "explanation": "Per Louisiana's current course data: 8'6\" (standard)"
    },
    {
      "id": "LA_PEVO_PREP_15",
      "course_id": "LA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Louisiana?",
      "option_a": "15'0\"",
      "option_b": "10'0\"",
      "option_c": "There is no standard height threshold",
      "option_d": "13'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per Louisiana's current course data: 13'6\" (standard)"
    },
    {
      "id": "LA_PEVO_PREP_16",
      "course_id": "LA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_17",
      "course_id": "LA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_18",
      "course_id": "LA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_19",
      "course_id": "LA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_20",
      "course_id": "LA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_21",
      "course_id": "LA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_22",
      "course_id": "LA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_23",
      "course_id": "LA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_24",
      "course_id": "LA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_25",
      "course_id": "LA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_26",
      "course_id": "LA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_27",
      "course_id": "LA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_28",
      "course_id": "LA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_29",
      "course_id": "LA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_30",
      "course_id": "LA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_31",
      "course_id": "LA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_32",
      "course_id": "LA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_33",
      "course_id": "LA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_34",
      "course_id": "LA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_35",
      "course_id": "LA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_36",
      "course_id": "LA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_37",
      "course_id": "LA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_38",
      "course_id": "LA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_39",
      "course_id": "LA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_40",
      "course_id": "LA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_41",
      "course_id": "LA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_42",
      "course_id": "LA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_43",
      "course_id": "LA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_44",
      "course_id": "LA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_45",
      "course_id": "LA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_46",
      "course_id": "LA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_47",
      "course_id": "LA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_48",
      "course_id": "LA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_49",
      "course_id": "LA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "LA_PEVO_PREP_50",
      "course_id": "LA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "ME_PEVO_PREP": [
    {
      "id": "ME_PEVO_PREP_1",
      "course_id": "ME_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Maine?",
      "option_a": "RI DOT Permit Office",
      "option_b": "TxDOT Oversize/Overweight Permits",
      "option_c": "NJ DOT Oversize Permit Unit",
      "option_d": "Maine DOT Permit Office",
      "correct_answer": "D",
      "explanation": "Per Maine's current course data: Maine DOT Permit Office"
    },
    {
      "id": "ME_PEVO_PREP_2",
      "course_id": "ME_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Maine require to legally operate as an escort vehicle operator?",
      "option_a": "8-State Uniform",
      "option_b": "PPCA Required",
      "option_c": "NY Standalone ONLY",
      "option_d": "State Specific",
      "correct_answer": "D",
      "explanation": "Per Maine's current course data: State Specific"
    },
    {
      "id": "ME_PEVO_PREP_3",
      "course_id": "ME_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Maine?",
      "option_a": "OVERSIZE LOAD - 5ft x 12in, yellow, black letters",
      "option_b": "OVERSIZE LOAD - yellow, reflective, 5ft x 12in",
      "option_c": "OVERSIZE LOAD - yellow, standard federal spec",
      "option_d": "OVERSIZE LOAD - standard yellow spec",
      "correct_answer": "C",
      "explanation": "Per Maine's current course data: OVERSIZE LOAD - yellow, standard federal spec"
    },
    {
      "id": "ME_PEVO_PREP_4",
      "course_id": "ME_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Maine?",
      "option_a": "Amber Class 1 strobe - 360 visibility at 500 ft",
      "option_b": "Amber Class 1 strobe, visible 1000 ft each direction",
      "option_c": "Amber strobe Class 1, visible from 500 ft",
      "option_d": "Amber Class 1 strobe, front and rear",
      "correct_answer": "C",
      "explanation": "Per Maine's current course data: Amber strobe Class 1, visible from 500 ft"
    },
    {
      "id": "ME_PEVO_PREP_5",
      "course_id": "ME_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Maine?",
      "option_a": "Paddle, extinguisher, flares",
      "option_b": "Fire extinguisher, safety triangles, vest",
      "option_c": "18-inch stop/slow paddle, 3 lb fire extinguisher",
      "option_d": "Paddle, 3 lb extinguisher, cones",
      "correct_answer": "A",
      "explanation": "Per Maine's current course data: Paddle, extinguisher, flares"
    },
    {
      "id": "ME_PEVO_PREP_6",
      "course_id": "ME_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Maine, when is an escort legally REQUIRED?",
      "option_a": "Any load exceeding 8'6\" width, 13'6\" height, or 80,000 lbs GVW",
      "option_b": "Width over 12'0\" or height over 14'0\"",
      "option_c": "Width over 8'6\" or height over 13'6\"",
      "option_d": "Loads exceeding 8'6\" width or 13'6\" height require escort",
      "correct_answer": "C",
      "explanation": "Per Maine's current course data: Width over 8'6\" or height over 13'6\""
    },
    {
      "id": "ME_PEVO_PREP_7",
      "course_id": "ME_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Maine?",
      "option_a": "16'0\"",
      "option_b": "12'0\"",
      "option_c": "14'0\"",
      "option_d": "14'6\"",
      "correct_answer": "C",
      "explanation": "Per Maine's current course data: 14'0\""
    },
    {
      "id": "ME_PEVO_PREP_8",
      "course_id": "ME_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Maine?",
      "option_a": "14'0\"",
      "option_b": "15'0\"",
      "option_c": "13'6\"",
      "option_d": "15'6\"",
      "correct_answer": "C",
      "explanation": "Per Maine's current course data: 13'6\""
    },
    {
      "id": "ME_PEVO_PREP_9",
      "course_id": "ME_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Maine's night travel status for oversize permitted moves?",
      "option_a": "Allowed",
      "option_b": "Restricted",
      "option_c": "w/ lighting",
      "option_d": "Always fully prohibited, no exceptions",
      "correct_answer": "B",
      "explanation": "Per Maine's current course data: Restricted"
    },
    {
      "id": "ME_PEVO_PREP_10",
      "course_id": "ME_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Maine?",
      "option_a": "$750K CSL minimum",
      "option_b": "$1M CSL minimum",
      "option_c": "$500K CSL minimum",
      "option_d": "Same as standard minimum — no separate night-ops tier specified",
      "correct_answer": "A",
      "explanation": "Per Maine's current course data: $750K CSL minimum"
    },
    {
      "id": "ME_PEVO_PREP_11",
      "course_id": "ME_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Maine?",
      "option_a": "$500K CSL",
      "option_b": "$10,000 liability",
      "option_c": "$1M CSL",
      "option_d": "$750K CSL",
      "correct_answer": "D",
      "explanation": "Per Maine's current course data: $750K CSL"
    },
    {
      "id": "ME_PEVO_PREP_12",
      "course_id": "ME_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Maine belong to for escort operator requirements?",
      "option_a": "Remaining",
      "option_b": "8-State",
      "option_c": "Standalone",
      "option_d": "14 PEVO",
      "correct_answer": "A",
      "explanation": "Per Maine's current course data: Remaining"
    },
    {
      "id": "ME_PEVO_PREP_13",
      "course_id": "ME_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Maine-specific rule or red flag operators must know?",
      "option_a": "Large agricultural equipment moves are common. Spring weight restrictions apply on all secondary roads.",
      "option_b": "Maine restricts night travel. Spring frost laws limit movements March-May. Bridge weight limits are strictly enforced.",
      "option_c": "Alabama participates in the 14-state PEVO reciprocity group. One PPCA cert covers all PEVO states.",
      "option_d": "PEVO reciprocity. New Mexico allows night travel. High desert terrain has minimal bridge restrictions.",
      "correct_answer": "B",
      "explanation": "Per Maine's current course data: Maine restricts night travel. Spring frost laws limit movements March-May. Bridge weight limits are strictly enforced."
    },
    {
      "id": "ME_PEVO_PREP_14",
      "course_id": "ME_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Maine?",
      "option_a": "6'0\"",
      "option_b": "There is no standard width threshold",
      "option_c": "8'6\" (standard)",
      "option_d": "10'0\"",
      "correct_answer": "C",
      "explanation": "Per Maine's current course data: 8'6\" (standard)"
    },
    {
      "id": "ME_PEVO_PREP_15",
      "course_id": "ME_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Maine?",
      "option_a": "13'6\" (standard)",
      "option_b": "15'0\"",
      "option_c": "10'0\"",
      "option_d": "There is no standard height threshold",
      "correct_answer": "A",
      "explanation": "Per Maine's current course data: 13'6\" (standard)"
    },
    {
      "id": "ME_PEVO_PREP_16",
      "course_id": "ME_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_17",
      "course_id": "ME_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_18",
      "course_id": "ME_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_19",
      "course_id": "ME_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_20",
      "course_id": "ME_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_21",
      "course_id": "ME_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_22",
      "course_id": "ME_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_23",
      "course_id": "ME_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_24",
      "course_id": "ME_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_25",
      "course_id": "ME_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_26",
      "course_id": "ME_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_27",
      "course_id": "ME_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_28",
      "course_id": "ME_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_29",
      "course_id": "ME_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_30",
      "course_id": "ME_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_31",
      "course_id": "ME_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_32",
      "course_id": "ME_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_33",
      "course_id": "ME_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_34",
      "course_id": "ME_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_35",
      "course_id": "ME_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_36",
      "course_id": "ME_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_37",
      "course_id": "ME_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_38",
      "course_id": "ME_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_39",
      "course_id": "ME_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_40",
      "course_id": "ME_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_41",
      "course_id": "ME_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_42",
      "course_id": "ME_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_43",
      "course_id": "ME_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_44",
      "course_id": "ME_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_45",
      "course_id": "ME_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_46",
      "course_id": "ME_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_47",
      "course_id": "ME_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_48",
      "course_id": "ME_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_49",
      "course_id": "ME_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ME_PEVO_PREP_50",
      "course_id": "ME_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "MD_PEVO_PREP": [
    {
      "id": "MD_PEVO_PREP_1",
      "course_id": "MD_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Maryland?",
      "option_a": "Louisiana DOTD Oversize Permits",
      "option_b": "NY DOT Permit Bureau",
      "option_c": "Washington State DOT Permit Office",
      "option_d": "Maryland SHA Permit Office",
      "correct_answer": "D",
      "explanation": "Per Maryland's current course data: Maryland SHA Permit Office"
    },
    {
      "id": "MD_PEVO_PREP_2",
      "course_id": "MD_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Maryland require to legally operate as an escort vehicle operator?",
      "option_a": "State Specific",
      "option_b": "NY Standalone ONLY",
      "option_c": "PEVO Cert",
      "option_d": "8-State Uniform",
      "correct_answer": "A",
      "explanation": "Per Maryland's current course data: State Specific"
    },
    {
      "id": "MD_PEVO_PREP_3",
      "course_id": "MD_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Maryland?",
      "option_a": "OVERSIZE LOAD - 5ft x 10in, yellow, SAE spec",
      "option_b": "OVERSIZE LOAD - standard 5ft x 12in",
      "option_c": "OVERSIZE LOAD - 5ft x 12in yellow, reflective",
      "option_d": "OVERSIZE LOAD - 5ft wide x 10in high, yellow, black letters",
      "correct_answer": "B",
      "explanation": "Per Maryland's current course data: OVERSIZE LOAD - standard 5ft x 12in"
    },
    {
      "id": "MD_PEVO_PREP_4",
      "course_id": "MD_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Maryland?",
      "option_a": "SAE Class 1 amber AND rear-facing amber required",
      "option_b": "SAE Class 1 amber, front and rear required",
      "option_c": "SAE Class 1 amber strobe - front and rear - 360 degree visibility at 500 ft",
      "option_d": "SAE Class 1 amber, front and rear",
      "correct_answer": "D",
      "explanation": "Per Maryland's current course data: SAE Class 1 amber, front and rear"
    },
    {
      "id": "MD_PEVO_PREP_5",
      "course_id": "MD_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Maryland?",
      "option_a": "18-inch stop/slow paddle, 3 lb fire extinguisher",
      "option_b": "18-inch stop/slow paddle, 3 lb extinguisher, cones",
      "option_c": "Paddle, 3 lb extinguisher, vest",
      "option_d": "Paddle, 5 lb extinguisher, flares, cones",
      "correct_answer": "C",
      "explanation": "Per Maryland's current course data: Paddle, 3 lb extinguisher, vest"
    },
    {
      "id": "MD_PEVO_PREP_6",
      "course_id": "MD_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Maryland, when is an escort legally REQUIRED?",
      "option_a": "Any load over 8'6\" width or 13'6\" height",
      "option_b": "Width over 9'0\" or height over 13'6\" triggers escort requirement",
      "option_c": "Width over 8'6\", height over 13'6\", or length over 65 ft",
      "option_d": "Width over 8'6\" or height over 13'0\"",
      "correct_answer": "D",
      "explanation": "Per Maryland's current course data: Width over 8'6\" or height over 13'0\""
    },
    {
      "id": "MD_PEVO_PREP_7",
      "course_id": "MD_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Maryland?",
      "option_a": "14'0\"",
      "option_b": "16'0\"",
      "option_c": "14'6\"",
      "option_d": "12'0\"",
      "correct_answer": "A",
      "explanation": "Per Maryland's current course data: 14'0\""
    },
    {
      "id": "MD_PEVO_PREP_8",
      "course_id": "MD_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Maryland?",
      "option_a": "13'6\"",
      "option_b": "14'0\"",
      "option_c": "15'0\"",
      "option_d": "16'0\"",
      "correct_answer": "A",
      "explanation": "Per Maryland's current course data: 13'6\""
    },
    {
      "id": "MD_PEVO_PREP_9",
      "course_id": "MD_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Maryland's night travel status for oversize permitted moves?",
      "option_a": "w/ lighting",
      "option_b": "Always fully prohibited, no exceptions",
      "option_c": "Restricted",
      "option_d": "Allowed",
      "correct_answer": "A",
      "explanation": "Per Maryland's current course data: w/ lighting"
    },
    {
      "id": "MD_PEVO_PREP_10",
      "course_id": "MD_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Maryland?",
      "option_a": "$750K CSL minimum",
      "option_b": "$500K CSL minimum",
      "option_c": "$1M CSL minimum",
      "option_d": "Same as standard minimum — no separate night-ops tier specified",
      "correct_answer": "A",
      "explanation": "Per Maryland's current course data: $750K CSL minimum"
    },
    {
      "id": "MD_PEVO_PREP_11",
      "course_id": "MD_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Maryland?",
      "option_a": "$750K CSL",
      "option_b": "$10,000 liability",
      "option_c": "$1M CSL",
      "option_d": "$500K CSL",
      "correct_answer": "A",
      "explanation": "Per Maryland's current course data: $750K CSL"
    },
    {
      "id": "MD_PEVO_PREP_12",
      "course_id": "MD_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Maryland belong to for escort operator requirements?",
      "option_a": "Standalone",
      "option_b": "Remaining",
      "option_c": "14 PEVO",
      "option_d": "8-State",
      "correct_answer": "B",
      "explanation": "Per Maryland's current course data: Remaining"
    },
    {
      "id": "MD_PEVO_PREP_13",
      "course_id": "MD_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Maryland-specific rule or red flag operators must know?",
      "option_a": "Alaska has no reciprocity. Extreme weather rules apply Oct-Apr. Daylight-only travel required Nov-Feb.",
      "option_b": "Kansas is part of the 8-State uniform group. Flat terrain allows consistent escort patterns with few route restrictions.",
      "option_c": "Illinois requires $1M CSL insurance, higher than most states. Chicago metro has permit windows and bridge weight limits.",
      "option_d": "Baltimore metro and Chesapeake Bay Bridge have special permit procedures. Bay Bridge requires advance notice of 48 hours.",
      "correct_answer": "D",
      "explanation": "Per Maryland's current course data: Baltimore metro and Chesapeake Bay Bridge have special permit procedures. Bay Bridge requires advance notice of 48 hours."
    },
    {
      "id": "MD_PEVO_PREP_14",
      "course_id": "MD_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Maryland?",
      "option_a": "10'0\"",
      "option_b": "8'6\" (standard)",
      "option_c": "There is no standard width threshold",
      "option_d": "6'0\"",
      "correct_answer": "B",
      "explanation": "Per Maryland's current course data: 8'6\" (standard)"
    },
    {
      "id": "MD_PEVO_PREP_15",
      "course_id": "MD_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Maryland?",
      "option_a": "15'0\"",
      "option_b": "There is no standard height threshold",
      "option_c": "13'6\" (standard)",
      "option_d": "10'0\"",
      "correct_answer": "C",
      "explanation": "Per Maryland's current course data: 13'6\" (standard)"
    },
    {
      "id": "MD_PEVO_PREP_16",
      "course_id": "MD_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_17",
      "course_id": "MD_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_18",
      "course_id": "MD_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_19",
      "course_id": "MD_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_20",
      "course_id": "MD_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_21",
      "course_id": "MD_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_22",
      "course_id": "MD_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_23",
      "course_id": "MD_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_24",
      "course_id": "MD_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_25",
      "course_id": "MD_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_26",
      "course_id": "MD_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_27",
      "course_id": "MD_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_28",
      "course_id": "MD_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_29",
      "course_id": "MD_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_30",
      "course_id": "MD_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_31",
      "course_id": "MD_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_32",
      "course_id": "MD_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_33",
      "course_id": "MD_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_34",
      "course_id": "MD_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_35",
      "course_id": "MD_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_36",
      "course_id": "MD_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_37",
      "course_id": "MD_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_38",
      "course_id": "MD_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_39",
      "course_id": "MD_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_40",
      "course_id": "MD_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_41",
      "course_id": "MD_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_42",
      "course_id": "MD_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_43",
      "course_id": "MD_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_44",
      "course_id": "MD_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_45",
      "course_id": "MD_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_46",
      "course_id": "MD_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_47",
      "course_id": "MD_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_48",
      "course_id": "MD_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_49",
      "course_id": "MD_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MD_PEVO_PREP_50",
      "course_id": "MD_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "MA_PEVO_PREP": [
    {
      "id": "MA_PEVO_PREP_1",
      "course_id": "MA_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Massachusetts?",
      "option_a": "Virginia DOT Oversize Permits",
      "option_b": "California DOT Permit Office",
      "option_c": "MA DOT Permit Office",
      "option_d": "TxDOT Oversize/Overweight Permits",
      "correct_answer": "C",
      "explanation": "Per Massachusetts's current course data: MA DOT Permit Office"
    },
    {
      "id": "MA_PEVO_PREP_2",
      "course_id": "MA_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Massachusetts require to legally operate as an escort vehicle operator?",
      "option_a": "PEVO Cert",
      "option_b": "PPCA Required",
      "option_c": "NY Standalone ONLY",
      "option_d": "State Specific",
      "correct_answer": "D",
      "explanation": "Per Massachusetts's current course data: State Specific"
    },
    {
      "id": "MA_PEVO_PREP_3",
      "course_id": "MA_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Massachusetts?",
      "option_a": "OVERSIZE LOAD - fluorescent yellow, 5ft x 12in",
      "option_b": "OVERSIZE LOAD - standard yellow spec",
      "option_c": "OVERSIZE LOAD - 5ft x 12in, fluorescent yellow-green, black reflective letters",
      "option_d": "OVERSIZE LOAD - yellow, 5ft x 12in",
      "correct_answer": "D",
      "explanation": "Per Massachusetts's current course data: OVERSIZE LOAD - yellow, 5ft x 12in"
    },
    {
      "id": "MA_PEVO_PREP_4",
      "course_id": "MA_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Massachusetts?",
      "option_a": "Amber Class 1 strobe, visible from 500 ft",
      "option_b": "SAE Class 1 amber, 360-degree visibility, minimum 35W output",
      "option_c": "Amber Class 1, front and rear",
      "option_d": "Amber Class 1 strobe, front and rear",
      "correct_answer": "C",
      "explanation": "Per Massachusetts's current course data: Amber Class 1, front and rear"
    },
    {
      "id": "MA_PEVO_PREP_5",
      "course_id": "MA_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Massachusetts?",
      "option_a": "Paddle, fire extinguisher, safety vest",
      "option_b": "Paddle, 5 lb extinguisher, flares, safety vest",
      "option_c": "Paddle, extinguisher, 6 flares",
      "option_d": "Paddle, 5 lb extinguisher, 3 road flares, safety vest",
      "correct_answer": "C",
      "explanation": "Per Massachusetts's current course data: Paddle, extinguisher, 6 flares"
    },
    {
      "id": "MA_PEVO_PREP_6",
      "course_id": "MA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Massachusetts, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 13'0\"",
      "option_b": "Any load exceeding 8'0\" width or 13'6\" height",
      "option_c": "Loads exceeding 8'6\" width or 13'6\" height require licensed escort",
      "option_d": "Width over 12'0\" or height over 14'0\"",
      "correct_answer": "A",
      "explanation": "Per Massachusetts's current course data: Width over 8'6\" or height over 13'0\""
    },
    {
      "id": "MA_PEVO_PREP_7",
      "course_id": "MA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Massachusetts?",
      "option_a": "12'0\"",
      "option_b": "14'6\"",
      "option_c": "16'0\"",
      "option_d": "14'0\"",
      "correct_answer": "D",
      "explanation": "Per Massachusetts's current course data: 14'0\""
    },
    {
      "id": "MA_PEVO_PREP_8",
      "course_id": "MA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Massachusetts?",
      "option_a": "16'0\"",
      "option_b": "13'6\"",
      "option_c": "14'0\"",
      "option_d": "15'6\"",
      "correct_answer": "B",
      "explanation": "Per Massachusetts's current course data: 13'6\""
    },
    {
      "id": "MA_PEVO_PREP_9",
      "course_id": "MA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Massachusetts's night travel status for oversize permitted moves?",
      "option_a": "Allowed",
      "option_b": "Always fully prohibited, no exceptions",
      "option_c": "Restricted",
      "option_d": "w/ lighting",
      "correct_answer": "C",
      "explanation": "Per Massachusetts's current course data: Restricted"
    },
    {
      "id": "MA_PEVO_PREP_10",
      "course_id": "MA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Massachusetts?",
      "option_a": "$750K CSL minimum",
      "option_b": "$500K CSL minimum",
      "option_c": "Same as standard minimum — no separate night-ops tier specified",
      "option_d": "$1M CSL minimum",
      "correct_answer": "A",
      "explanation": "Per Massachusetts's current course data: $750K CSL minimum"
    },
    {
      "id": "MA_PEVO_PREP_11",
      "course_id": "MA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Massachusetts?",
      "option_a": "$750K CSL",
      "option_b": "$10,000 liability",
      "option_c": "$500K CSL",
      "option_d": "$1M CSL",
      "correct_answer": "A",
      "explanation": "Per Massachusetts's current course data: $750K CSL"
    },
    {
      "id": "MA_PEVO_PREP_12",
      "course_id": "MA_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Massachusetts belong to for escort operator requirements?",
      "option_a": "8-State",
      "option_b": "Standalone",
      "option_c": "Remaining",
      "option_d": "Stand-Alone",
      "correct_answer": "C",
      "explanation": "Per Massachusetts's current course data: Remaining"
    },
    {
      "id": "MA_PEVO_PREP_13",
      "course_id": "MA_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Massachusetts-specific rule or red flag operators must know?",
      "option_a": "High wind and blizzard conditions common Oct-April. Wind farm equipment moves are a major market in SD.",
      "option_b": "PEVO reciprocity state. Appalachian mountain routes have additional permit requirements.",
      "option_c": "Boston metro has extremely restricted permit windows. Night travel banned without special variance. Many local roads require city permit in addition to state permit.",
      "option_d": "Connecticut restricts night moves on state routes. Permit office must pre-approve routes over bridges. Hartford metro restricted 7am-9am and 4pm-7pm.",
      "correct_answer": "C",
      "explanation": "Per Massachusetts's current course data: Boston metro has extremely restricted permit windows. Night travel banned without special variance. Many local roads require city permit in addition to state permit."
    },
    {
      "id": "MA_PEVO_PREP_14",
      "course_id": "MA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Massachusetts?",
      "option_a": "6'0\"",
      "option_b": "There is no standard width threshold",
      "option_c": "10'0\"",
      "option_d": "8'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per Massachusetts's current course data: 8'6\" (standard)"
    },
    {
      "id": "MA_PEVO_PREP_15",
      "course_id": "MA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Massachusetts?",
      "option_a": "There is no standard height threshold",
      "option_b": "13'6\" (standard)",
      "option_c": "15'0\"",
      "option_d": "10'0\"",
      "correct_answer": "B",
      "explanation": "Per Massachusetts's current course data: 13'6\" (standard)"
    },
    {
      "id": "MA_PEVO_PREP_16",
      "course_id": "MA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_17",
      "course_id": "MA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_18",
      "course_id": "MA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_19",
      "course_id": "MA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_20",
      "course_id": "MA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_21",
      "course_id": "MA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_22",
      "course_id": "MA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_23",
      "course_id": "MA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_24",
      "course_id": "MA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_25",
      "course_id": "MA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_26",
      "course_id": "MA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_27",
      "course_id": "MA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_28",
      "course_id": "MA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_29",
      "course_id": "MA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_30",
      "course_id": "MA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_31",
      "course_id": "MA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_32",
      "course_id": "MA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_33",
      "course_id": "MA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_34",
      "course_id": "MA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_35",
      "course_id": "MA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_36",
      "course_id": "MA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_37",
      "course_id": "MA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_38",
      "course_id": "MA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_39",
      "course_id": "MA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_40",
      "course_id": "MA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_41",
      "course_id": "MA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_42",
      "course_id": "MA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_43",
      "course_id": "MA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_44",
      "course_id": "MA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_45",
      "course_id": "MA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_46",
      "course_id": "MA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_47",
      "course_id": "MA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_48",
      "course_id": "MA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_49",
      "course_id": "MA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MA_PEVO_PREP_50",
      "course_id": "MA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "MI_PEVO_PREP": [
    {
      "id": "MI_PEVO_PREP_1",
      "course_id": "MI_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Michigan?",
      "option_a": "Michigan DOT Permit Office",
      "option_b": "WV DOT Permit Office",
      "option_c": "Delaware DOT Permit Office",
      "option_d": "Wyoming DOT Oversize Permits",
      "correct_answer": "A",
      "explanation": "Per Michigan's current course data: Michigan DOT Permit Office"
    },
    {
      "id": "MI_PEVO_PREP_2",
      "course_id": "MI_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Michigan require to legally operate as an escort vehicle operator?",
      "option_a": "State Specific",
      "option_b": "PPCA Required",
      "option_c": "PEVO Cert",
      "option_d": "8-State Uniform",
      "correct_answer": "C",
      "explanation": "Per Michigan's current course data: PEVO Cert"
    },
    {
      "id": "MI_PEVO_PREP_3",
      "course_id": "MI_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Michigan?",
      "option_a": "OVERSIZE LOAD - yellow, black letters, standard spec",
      "option_b": "OVERSIZE LOAD - 5ft x 12in, yellow",
      "option_c": "OVERSIZE LOAD - yellow, 5ft x 10in",
      "option_d": "OVERSIZE LOAD - must be removed when not actively escorting",
      "correct_answer": "B",
      "explanation": "Per Michigan's current course data: OVERSIZE LOAD - 5ft x 12in, yellow"
    },
    {
      "id": "MI_PEVO_PREP_4",
      "course_id": "MI_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Michigan?",
      "option_a": "Amber SAE Class 1 strobe, front and rear",
      "option_b": "SAE Class 1 amber, 360 visibility",
      "option_c": "SAE Class 1 amber strobe - front and rear - 360 degree visibility at 500 ft",
      "option_d": "Amber strobe - front and rear mandatory",
      "correct_answer": "B",
      "explanation": "Per Michigan's current course data: SAE Class 1 amber, 360 visibility"
    },
    {
      "id": "MI_PEVO_PREP_5",
      "course_id": "MI_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Michigan?",
      "option_a": "18-inch stop/slow paddle, 3 lb fire extinguisher",
      "option_b": "Paddle, extinguisher, 6 flares",
      "option_c": "18-inch paddle, 3 lb extinguisher",
      "option_d": "18-inch paddle, 3 lb extinguisher, cones",
      "correct_answer": "C",
      "explanation": "Per Michigan's current course data: 18-inch paddle, 3 lb extinguisher"
    },
    {
      "id": "MI_PEVO_PREP_6",
      "course_id": "MI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Michigan, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 14'0\"",
      "option_b": "Width over 8'6\" or height over 13'6\"",
      "option_c": "Width over 8'6\" or height over 13'0\"",
      "option_d": "Width over 9'0\" or height over 13'6\" triggers escort requirement",
      "correct_answer": "B",
      "explanation": "Per Michigan's current course data: Width over 8'6\" or height over 13'6\""
    },
    {
      "id": "MI_PEVO_PREP_7",
      "course_id": "MI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Michigan?",
      "option_a": "14'0\"",
      "option_b": "14'6\"",
      "option_c": "16'0\"",
      "option_d": "12'0\"",
      "correct_answer": "B",
      "explanation": "Per Michigan's current course data: 14'6\""
    },
    {
      "id": "MI_PEVO_PREP_8",
      "course_id": "MI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Michigan?",
      "option_a": "13'6\"",
      "option_b": "15'0\"",
      "option_c": "16'0\"",
      "option_d": "14'6\"",
      "correct_answer": "A",
      "explanation": "Per Michigan's current course data: 13'6\""
    },
    {
      "id": "MI_PEVO_PREP_9",
      "course_id": "MI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Michigan's night travel status for oversize permitted moves?",
      "option_a": "Always fully prohibited, no exceptions",
      "option_b": "Restricted",
      "option_c": "Allowed",
      "option_d": "w/ lighting",
      "correct_answer": "B",
      "explanation": "Per Michigan's current course data: Restricted"
    },
    {
      "id": "MI_PEVO_PREP_10",
      "course_id": "MI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Michigan?",
      "option_a": "Same as standard minimum — no separate night-ops tier specified",
      "option_b": "$500K CSL minimum",
      "option_c": "$750K CSL minimum",
      "option_d": "$1M CSL minimum",
      "correct_answer": "C",
      "explanation": "Per Michigan's current course data: $750K CSL minimum"
    },
    {
      "id": "MI_PEVO_PREP_11",
      "course_id": "MI_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Michigan?",
      "option_a": "$1M CSL",
      "option_b": "$750K CSL",
      "option_c": "$10,000 liability",
      "option_d": "$500K CSL",
      "correct_answer": "B",
      "explanation": "Per Michigan's current course data: $750K CSL"
    },
    {
      "id": "MI_PEVO_PREP_12",
      "course_id": "MI_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Michigan belong to for escort operator requirements?",
      "option_a": "Stand-Alone",
      "option_b": "NY Standalone",
      "option_c": "14 PEVO",
      "option_d": "Remaining",
      "correct_answer": "C",
      "explanation": "Per Michigan's current course data: 14 PEVO"
    },
    {
      "id": "MI_PEVO_PREP_13",
      "course_id": "MI_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Michigan-specific rule or red flag operators must know?",
      "option_a": "Vermont spring thaw laws (Feb-April) severely restrict movements. Green Mountain routes have height clearance issues.",
      "option_b": "Michigan has extensive bridge restrictions due to aging infrastructure. Upper Peninsula routes have seasonal weight limits.",
      "option_c": "Texas has one of the highest height allowances at 18'0\". Texas requires state-specific certification (no PEVO reciprocity). TxDMV handles permit issuance. Super loads over 20' wide require Texas DPS escort. Houston, Dallas, and Austin metros have restricted windows. Oversize signs must be 7ft wide — larger than most states.",
      "option_d": "PEVO reciprocity. New Mexico allows night travel. High desert terrain has minimal bridge restrictions.",
      "correct_answer": "B",
      "explanation": "Per Michigan's current course data: Michigan has extensive bridge restrictions due to aging infrastructure. Upper Peninsula routes have seasonal weight limits."
    },
    {
      "id": "MI_PEVO_PREP_14",
      "course_id": "MI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Michigan?",
      "option_a": "There is no standard width threshold",
      "option_b": "8'6\" (standard)",
      "option_c": "10'0\"",
      "option_d": "6'0\"",
      "correct_answer": "B",
      "explanation": "Per Michigan's current course data: 8'6\" (standard)"
    },
    {
      "id": "MI_PEVO_PREP_15",
      "course_id": "MI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Michigan?",
      "option_a": "15'0\"",
      "option_b": "10'0\"",
      "option_c": "13'6\" (standard)",
      "option_d": "There is no standard height threshold",
      "correct_answer": "C",
      "explanation": "Per Michigan's current course data: 13'6\" (standard)"
    },
    {
      "id": "MI_PEVO_PREP_16",
      "course_id": "MI_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_17",
      "course_id": "MI_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_18",
      "course_id": "MI_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_19",
      "course_id": "MI_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_20",
      "course_id": "MI_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_21",
      "course_id": "MI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_22",
      "course_id": "MI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_23",
      "course_id": "MI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_24",
      "course_id": "MI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_25",
      "course_id": "MI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_26",
      "course_id": "MI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_27",
      "course_id": "MI_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_28",
      "course_id": "MI_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_29",
      "course_id": "MI_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_30",
      "course_id": "MI_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_31",
      "course_id": "MI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_32",
      "course_id": "MI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_33",
      "course_id": "MI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_34",
      "course_id": "MI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_35",
      "course_id": "MI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_36",
      "course_id": "MI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_37",
      "course_id": "MI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_38",
      "course_id": "MI_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_39",
      "course_id": "MI_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_40",
      "course_id": "MI_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_41",
      "course_id": "MI_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_42",
      "course_id": "MI_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_43",
      "course_id": "MI_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_44",
      "course_id": "MI_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_45",
      "course_id": "MI_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_46",
      "course_id": "MI_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_47",
      "course_id": "MI_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_48",
      "course_id": "MI_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_49",
      "course_id": "MI_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MI_PEVO_PREP_50",
      "course_id": "MI_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "MN_PEVO_PREP": [
    {
      "id": "MN_PEVO_PREP_1",
      "course_id": "MN_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Minnesota?",
      "option_a": "NJ DOT Oversize Permit Unit",
      "option_b": "Florida DOT State Permit Office",
      "option_c": "Arizona DOT Permit Office",
      "option_d": "Minnesota DOT Permit Office",
      "correct_answer": "D",
      "explanation": "Per Minnesota's current course data: Minnesota DOT Permit Office"
    },
    {
      "id": "MN_PEVO_PREP_2",
      "course_id": "MN_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Minnesota require to legally operate as an escort vehicle operator?",
      "option_a": "PEVO Cert",
      "option_b": "State Specific",
      "option_c": "PPCA Required",
      "option_d": "NY Standalone ONLY",
      "correct_answer": "B",
      "explanation": "Per Minnesota's current course data: State Specific"
    },
    {
      "id": "MN_PEVO_PREP_3",
      "course_id": "MN_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Minnesota?",
      "option_a": "OVERSIZE LOAD - yellow, standard federal spec",
      "option_b": "OVERSIZE LOAD - yellow, black letters, standard spec",
      "option_c": "OVERSIZE LOAD - 5ft x 12in, yellow background",
      "option_d": "OVERSIZE LOAD - must be removed when not actively escorting",
      "correct_answer": "B",
      "explanation": "Per Minnesota's current course data: OVERSIZE LOAD - yellow, black letters, standard spec"
    },
    {
      "id": "MN_PEVO_PREP_4",
      "course_id": "MN_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Minnesota?",
      "option_a": "Amber Class 1 strobe required",
      "option_b": "SAE Class 1 amber, 360 visibility",
      "option_c": "Amber strobe - front and rear mandatory",
      "option_d": "Amber Class 1 or 2 strobe",
      "correct_answer": "D",
      "explanation": "Per Minnesota's current course data: Amber Class 1 or 2 strobe"
    },
    {
      "id": "MN_PEVO_PREP_5",
      "course_id": "MN_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Minnesota?",
      "option_a": "18-inch stop/slow paddle, 3 lb 2-A:10-B:C fire extinguisher, safety cones",
      "option_b": "18-inch paddle, 3 lb extinguisher, cones",
      "option_c": "Paddle, extinguisher, cones",
      "option_d": "Paddle, 2.5 lb extinguisher, flares",
      "correct_answer": "C",
      "explanation": "Per Minnesota's current course data: Paddle, extinguisher, cones"
    },
    {
      "id": "MN_PEVO_PREP_6",
      "course_id": "MN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Minnesota, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 14'0\"",
      "option_b": "Width over 8'6\" or height over 13'6\"",
      "option_c": "Width exceeding 8'6\" requires lead escort; height over 15'0\" requires height pole",
      "option_d": "Any load over 8'6\" width or 14'0\" height on state highways",
      "correct_answer": "B",
      "explanation": "Per Minnesota's current course data: Width over 8'6\" or height over 13'6\""
    },
    {
      "id": "MN_PEVO_PREP_7",
      "course_id": "MN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Minnesota?",
      "option_a": "14'6\"",
      "option_b": "16'0\"",
      "option_c": "12'0\"",
      "option_d": "14'0\"",
      "correct_answer": "A",
      "explanation": "Per Minnesota's current course data: 14'6\""
    },
    {
      "id": "MN_PEVO_PREP_8",
      "course_id": "MN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Minnesota?",
      "option_a": "15'6\"",
      "option_b": "15'0\"",
      "option_c": "14'6\"",
      "option_d": "16'0\"",
      "correct_answer": "B",
      "explanation": "Per Minnesota's current course data: 15'0\""
    },
    {
      "id": "MN_PEVO_PREP_9",
      "course_id": "MN_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Minnesota's night travel status for oversize permitted moves?",
      "option_a": "Restricted",
      "option_b": "w/ lighting",
      "option_c": "Allowed",
      "option_d": "Always fully prohibited, no exceptions",
      "correct_answer": "C",
      "explanation": "Per Minnesota's current course data: Allowed"
    },
    {
      "id": "MN_PEVO_PREP_10",
      "course_id": "MN_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Minnesota?",
      "option_a": "$750K CSL minimum",
      "option_b": "Same as standard minimum — no separate night-ops tier specified",
      "option_c": "$500K CSL minimum",
      "option_d": "$1M CSL minimum",
      "correct_answer": "A",
      "explanation": "Per Minnesota's current course data: $750K CSL minimum"
    },
    {
      "id": "MN_PEVO_PREP_11",
      "course_id": "MN_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Minnesota?",
      "option_a": "$10,000 liability",
      "option_b": "$1M CSL",
      "option_c": "$750K CSL",
      "option_d": "$500K CSL",
      "correct_answer": "C",
      "explanation": "Per Minnesota's current course data: $750K CSL"
    },
    {
      "id": "MN_PEVO_PREP_12",
      "course_id": "MN_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Minnesota belong to for escort operator requirements?",
      "option_a": "Remaining",
      "option_b": "14 PEVO",
      "option_c": "8-State",
      "option_d": "Standalone",
      "correct_answer": "A",
      "explanation": "Per Minnesota's current course data: Remaining"
    },
    {
      "id": "MN_PEVO_PREP_13",
      "course_id": "MN_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Minnesota-specific rule or red flag operators must know?",
      "option_a": "Minnesota allows 15'0\" height clearance. Spring weight restrictions apply March-May on all state and county roads.",
      "option_b": "Baltimore metro and Chesapeake Bay Bridge have special permit procedures. Bay Bridge requires advance notice of 48 hours.",
      "option_c": "PEVO reciprocity state. Appalachian mountain routes have additional permit requirements.",
      "option_d": "8-State group. Mountain canyon routes (I-15, US-89) have seasonal restrictions. Salt Lake metro restricted during major events.",
      "correct_answer": "A",
      "explanation": "Per Minnesota's current course data: Minnesota allows 15'0\" height clearance. Spring weight restrictions apply March-May on all state and county roads."
    },
    {
      "id": "MN_PEVO_PREP_14",
      "course_id": "MN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Minnesota?",
      "option_a": "8'6\" (standard)",
      "option_b": "10'0\"",
      "option_c": "6'0\"",
      "option_d": "There is no standard width threshold",
      "correct_answer": "A",
      "explanation": "Per Minnesota's current course data: 8'6\" (standard)"
    },
    {
      "id": "MN_PEVO_PREP_15",
      "course_id": "MN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Minnesota?",
      "option_a": "There is no standard height threshold",
      "option_b": "10'0\"",
      "option_c": "15'0\"",
      "option_d": "13'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per Minnesota's current course data: 13'6\" (standard)"
    },
    {
      "id": "MN_PEVO_PREP_16",
      "course_id": "MN_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_17",
      "course_id": "MN_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_18",
      "course_id": "MN_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_19",
      "course_id": "MN_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_20",
      "course_id": "MN_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_21",
      "course_id": "MN_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_22",
      "course_id": "MN_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_23",
      "course_id": "MN_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_24",
      "course_id": "MN_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_25",
      "course_id": "MN_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_26",
      "course_id": "MN_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_27",
      "course_id": "MN_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_28",
      "course_id": "MN_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_29",
      "course_id": "MN_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_30",
      "course_id": "MN_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_31",
      "course_id": "MN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_32",
      "course_id": "MN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_33",
      "course_id": "MN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_34",
      "course_id": "MN_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_35",
      "course_id": "MN_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_36",
      "course_id": "MN_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_37",
      "course_id": "MN_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_38",
      "course_id": "MN_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_39",
      "course_id": "MN_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_40",
      "course_id": "MN_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_41",
      "course_id": "MN_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_42",
      "course_id": "MN_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_43",
      "course_id": "MN_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_44",
      "course_id": "MN_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_45",
      "course_id": "MN_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_46",
      "course_id": "MN_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_47",
      "course_id": "MN_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_48",
      "course_id": "MN_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_49",
      "course_id": "MN_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MN_PEVO_PREP_50",
      "course_id": "MN_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "MS_PEVO_PREP": [
    {
      "id": "MS_PEVO_PREP_1",
      "course_id": "MS_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Mississippi?",
      "option_a": "Montana DOT Permit Office",
      "option_b": "Maryland SHA Permit Office",
      "option_c": "Mississippi DOT Permits",
      "option_d": "Alabama DOT Permit Office",
      "correct_answer": "C",
      "explanation": "Per Mississippi's current course data: Mississippi DOT Permits"
    },
    {
      "id": "MS_PEVO_PREP_2",
      "course_id": "MS_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Mississippi require to legally operate as an escort vehicle operator?",
      "option_a": "PEVO Cert",
      "option_b": "State Specific",
      "option_c": "8-State Uniform",
      "option_d": "PPCA Required",
      "correct_answer": "A",
      "explanation": "Per Mississippi's current course data: PEVO Cert"
    },
    {
      "id": "MS_PEVO_PREP_3",
      "course_id": "MS_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Mississippi?",
      "option_a": "OVERSIZE LOAD - yellow, standard federal spec",
      "option_b": "OVERSIZE LOAD - yellow, standard 5ft x 12in",
      "option_c": "OVERSIZE LOAD - yellow background, 6-inch black letters",
      "option_d": "OVERSIZE LOAD - yellow, black letters, 5ft x 12in",
      "correct_answer": "B",
      "explanation": "Per Mississippi's current course data: OVERSIZE LOAD - yellow, standard 5ft x 12in"
    },
    {
      "id": "MS_PEVO_PREP_4",
      "course_id": "MS_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Mississippi?",
      "option_a": "SAE Class 1 or 2 amber - mounted at highest visible point - 360 degree visibility",
      "option_b": "SAE Class 1 amber, police-grade brightness",
      "option_c": "Amber Class 1 front and rear",
      "option_d": "Amber Class 1 strobe",
      "correct_answer": "D",
      "explanation": "Per Mississippi's current course data: Amber Class 1 strobe"
    },
    {
      "id": "MS_PEVO_PREP_5",
      "course_id": "MS_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Mississippi?",
      "option_a": "Paddle, extinguisher",
      "option_b": "Paddle, extinguisher, flares",
      "option_c": "18-inch stop/slow paddle, 3 lb fire extinguisher",
      "option_d": "Paddle, 5 lb extinguisher, flares, safety vest",
      "correct_answer": "A",
      "explanation": "Per Mississippi's current course data: Paddle, extinguisher"
    },
    {
      "id": "MS_PEVO_PREP_6",
      "course_id": "MS_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Mississippi, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 13'0\" requires escort",
      "option_b": "Width over 8'6\" or height over 13'6\"",
      "option_c": "Width exceeding 8'6\" requires lead escort; height over 15'0\" requires height pole",
      "option_d": "Width over 8'6\", height over 13'6\", or length over 65 ft",
      "correct_answer": "B",
      "explanation": "Per Mississippi's current course data: Width over 8'6\" or height over 13'6\""
    },
    {
      "id": "MS_PEVO_PREP_7",
      "course_id": "MS_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Mississippi?",
      "option_a": "16'0\"",
      "option_b": "14'0\"",
      "option_c": "14'6\"",
      "option_d": "12'0\"",
      "correct_answer": "B",
      "explanation": "Per Mississippi's current course data: 14'0\""
    },
    {
      "id": "MS_PEVO_PREP_8",
      "course_id": "MS_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Mississippi?",
      "option_a": "15'6\"",
      "option_b": "14'0\"",
      "option_c": "15'0\"",
      "option_d": "16'0\"",
      "correct_answer": "C",
      "explanation": "Per Mississippi's current course data: 15'0\""
    },
    {
      "id": "MS_PEVO_PREP_9",
      "course_id": "MS_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Mississippi's night travel status for oversize permitted moves?",
      "option_a": "Always fully prohibited, no exceptions",
      "option_b": "Restricted",
      "option_c": "w/ lighting",
      "option_d": "Allowed",
      "correct_answer": "D",
      "explanation": "Per Mississippi's current course data: Allowed"
    },
    {
      "id": "MS_PEVO_PREP_10",
      "course_id": "MS_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Mississippi?",
      "option_a": "$500K CSL minimum",
      "option_b": "$1M CSL minimum",
      "option_c": "Same as standard minimum — no separate night-ops tier specified",
      "option_d": "$750K CSL minimum",
      "correct_answer": "D",
      "explanation": "Per Mississippi's current course data: $750K CSL minimum"
    },
    {
      "id": "MS_PEVO_PREP_11",
      "course_id": "MS_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Mississippi?",
      "option_a": "$750K CSL",
      "option_b": "$10,000 liability",
      "option_c": "$1M CSL",
      "option_d": "$500K CSL",
      "correct_answer": "A",
      "explanation": "Per Mississippi's current course data: $750K CSL"
    },
    {
      "id": "MS_PEVO_PREP_12",
      "course_id": "MS_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Mississippi belong to for escort operator requirements?",
      "option_a": "Standalone",
      "option_b": "Remaining",
      "option_c": "14 PEVO",
      "option_d": "8-State",
      "correct_answer": "C",
      "explanation": "Per Mississippi's current course data: 14 PEVO"
    },
    {
      "id": "MS_PEVO_PREP_13",
      "course_id": "MS_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Mississippi-specific rule or red flag operators must know?",
      "option_a": "8-State group. St. Louis metro has bridge restrictions. I-70 corridor has high volume oversize move traffic.",
      "option_b": "PEVO reciprocity. High seasonal agriculture move volume. Mississippi River crossing permits require advance coordination.",
      "option_c": "Large agricultural equipment moves are common. Spring weight restrictions apply on all secondary roads.",
      "option_d": "Montana has the highest height limit at 16'0\". Wide load allowances up to 14'6\" without escort on rural highways.",
      "correct_answer": "B",
      "explanation": "Per Mississippi's current course data: PEVO reciprocity. High seasonal agriculture move volume. Mississippi River crossing permits require advance coordination."
    },
    {
      "id": "MS_PEVO_PREP_14",
      "course_id": "MS_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Mississippi?",
      "option_a": "8'6\" (standard)",
      "option_b": "10'0\"",
      "option_c": "There is no standard width threshold",
      "option_d": "6'0\"",
      "correct_answer": "A",
      "explanation": "Per Mississippi's current course data: 8'6\" (standard)"
    },
    {
      "id": "MS_PEVO_PREP_15",
      "course_id": "MS_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Mississippi?",
      "option_a": "There is no standard height threshold",
      "option_b": "13'6\" (standard)",
      "option_c": "15'0\"",
      "option_d": "10'0\"",
      "correct_answer": "B",
      "explanation": "Per Mississippi's current course data: 13'6\" (standard)"
    },
    {
      "id": "MS_PEVO_PREP_16",
      "course_id": "MS_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_17",
      "course_id": "MS_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_18",
      "course_id": "MS_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_19",
      "course_id": "MS_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_20",
      "course_id": "MS_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_21",
      "course_id": "MS_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_22",
      "course_id": "MS_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_23",
      "course_id": "MS_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_24",
      "course_id": "MS_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_25",
      "course_id": "MS_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_26",
      "course_id": "MS_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_27",
      "course_id": "MS_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_28",
      "course_id": "MS_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_29",
      "course_id": "MS_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_30",
      "course_id": "MS_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_31",
      "course_id": "MS_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_32",
      "course_id": "MS_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_33",
      "course_id": "MS_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_34",
      "course_id": "MS_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_35",
      "course_id": "MS_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_36",
      "course_id": "MS_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_37",
      "course_id": "MS_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_38",
      "course_id": "MS_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_39",
      "course_id": "MS_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_40",
      "course_id": "MS_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_41",
      "course_id": "MS_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_42",
      "course_id": "MS_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_43",
      "course_id": "MS_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_44",
      "course_id": "MS_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_45",
      "course_id": "MS_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_46",
      "course_id": "MS_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_47",
      "course_id": "MS_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_48",
      "course_id": "MS_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_49",
      "course_id": "MS_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MS_PEVO_PREP_50",
      "course_id": "MS_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "MO_PEVO_PREP": [
    {
      "id": "MO_PEVO_PREP_1",
      "course_id": "MO_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Missouri?",
      "option_a": "Arkansas DOT Oversize Permits",
      "option_b": "Missouri DOT Permit Center",
      "option_c": "Colorado DOT Oversize Permits",
      "option_d": "Hawaii DOT Highways Division",
      "correct_answer": "B",
      "explanation": "Per Missouri's current course data: Missouri DOT Permit Center"
    },
    {
      "id": "MO_PEVO_PREP_2",
      "course_id": "MO_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Missouri require to legally operate as an escort vehicle operator?",
      "option_a": "8-State Uniform",
      "option_b": "PPCA Required",
      "option_c": "PEVO Cert",
      "option_d": "State Specific",
      "correct_answer": "A",
      "explanation": "Per Missouri's current course data: 8-State Uniform"
    },
    {
      "id": "MO_PEVO_PREP_3",
      "course_id": "MO_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Missouri?",
      "option_a": "OVERSIZE LOAD - yellow, 5ft x 10in",
      "option_b": "OVERSIZE LOAD - yellow, 5ft x 12in",
      "option_c": "OVERSIZE LOAD - standard 5ft x 12in yellow sign",
      "option_d": "OVERSIZE LOAD - yellow, reflective, 5ft x 12in",
      "correct_answer": "A",
      "explanation": "Per Missouri's current course data: OVERSIZE LOAD - yellow, 5ft x 10in"
    },
    {
      "id": "MO_PEVO_PREP_4",
      "course_id": "MO_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Missouri?",
      "option_a": "Amber Class 1 strobe - 360 visibility at 500 ft",
      "option_b": "SAE Class 1 amber strobe, 360-degree visibility, minimum 35W",
      "option_c": "SAE Class 1 amber - 360 degree visibility required",
      "option_d": "Amber SAE Class 1, front and rear",
      "correct_answer": "D",
      "explanation": "Per Missouri's current course data: Amber SAE Class 1, front and rear"
    },
    {
      "id": "MO_PEVO_PREP_5",
      "course_id": "MO_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Missouri?",
      "option_a": "Paddle, extinguisher, flares",
      "option_b": "Paddle, 3 lb extinguisher, flares",
      "option_c": "18-inch stop/slow paddle, 3 lb 2-A:10-B:C fire extinguisher, safety cones",
      "option_d": "18-inch stop/slow paddle, fire extinguisher",
      "correct_answer": "A",
      "explanation": "Per Missouri's current course data: Paddle, extinguisher, flares"
    },
    {
      "id": "MO_PEVO_PREP_6",
      "course_id": "MO_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Missouri, when is an escort legally REQUIRED?",
      "option_a": "ANY load over 8'6\" width or 13'6\" height - ZERO tolerance",
      "option_b": "Width over 8'6\" or height over 13'0\"",
      "option_c": "Width over 8'6\" or height over 13'6\"",
      "option_d": "Width over 8'6\", height over 13'6\", or length over 65 ft",
      "correct_answer": "C",
      "explanation": "Per Missouri's current course data: Width over 8'6\" or height over 13'6\""
    },
    {
      "id": "MO_PEVO_PREP_7",
      "course_id": "MO_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Missouri?",
      "option_a": "12'0\"",
      "option_b": "16'0\"",
      "option_c": "14'0\"",
      "option_d": "14'6\"",
      "correct_answer": "D",
      "explanation": "Per Missouri's current course data: 14'6\""
    },
    {
      "id": "MO_PEVO_PREP_8",
      "course_id": "MO_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Missouri?",
      "option_a": "14'6\"",
      "option_b": "15'0\"",
      "option_c": "16'0\"",
      "option_d": "18'0\"",
      "correct_answer": "A",
      "explanation": "Per Missouri's current course data: 14'6\""
    },
    {
      "id": "MO_PEVO_PREP_9",
      "course_id": "MO_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Missouri's night travel status for oversize permitted moves?",
      "option_a": "Allowed",
      "option_b": "w/ lighting",
      "option_c": "Restricted",
      "option_d": "Always fully prohibited, no exceptions",
      "correct_answer": "B",
      "explanation": "Per Missouri's current course data: w/ lighting"
    },
    {
      "id": "MO_PEVO_PREP_10",
      "course_id": "MO_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Missouri?",
      "option_a": "Same as standard minimum — no separate night-ops tier specified",
      "option_b": "$500K CSL minimum",
      "option_c": "$750K CSL minimum",
      "option_d": "$1M CSL minimum",
      "correct_answer": "C",
      "explanation": "Per Missouri's current course data: $750K CSL minimum"
    },
    {
      "id": "MO_PEVO_PREP_11",
      "course_id": "MO_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Missouri?",
      "option_a": "$1M CSL",
      "option_b": "$750K CSL",
      "option_c": "$500K CSL",
      "option_d": "$10,000 liability",
      "correct_answer": "B",
      "explanation": "Per Missouri's current course data: $750K CSL"
    },
    {
      "id": "MO_PEVO_PREP_12",
      "course_id": "MO_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Missouri belong to for escort operator requirements?",
      "option_a": "14 PEVO",
      "option_b": "Remaining",
      "option_c": "Stand-Alone",
      "option_d": "8-State",
      "correct_answer": "D",
      "explanation": "Per Missouri's current course data: 8-State"
    },
    {
      "id": "MO_PEVO_PREP_13",
      "course_id": "MO_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Missouri-specific rule or red flag operators must know?",
      "option_a": "Iowa is in the 8-State group. Spring road restrictions (Feb-May) limit weights on paved roads annually.",
      "option_b": "8-State group. St. Louis metro has bridge restrictions. I-70 corridor has high volume oversize move traffic.",
      "option_c": "Pennsylvania has numerous historic bridges with strict weight limits. Turnpike requires advance notification. Philadelphia metro has complex permit routing.",
      "option_d": "PEVO reciprocity state. Appalachian mountain routes have additional permit requirements.",
      "correct_answer": "B",
      "explanation": "Per Missouri's current course data: 8-State group. St. Louis metro has bridge restrictions. I-70 corridor has high volume oversize move traffic."
    },
    {
      "id": "MO_PEVO_PREP_14",
      "course_id": "MO_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Missouri?",
      "option_a": "8'6\" (standard)",
      "option_b": "6'0\"",
      "option_c": "10'0\"",
      "option_d": "There is no standard width threshold",
      "correct_answer": "A",
      "explanation": "Per Missouri's current course data: 8'6\" (standard)"
    },
    {
      "id": "MO_PEVO_PREP_15",
      "course_id": "MO_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Missouri?",
      "option_a": "15'0\"",
      "option_b": "There is no standard height threshold",
      "option_c": "10'0\"",
      "option_d": "13'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per Missouri's current course data: 13'6\" (standard)"
    },
    {
      "id": "MO_PEVO_PREP_16",
      "course_id": "MO_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_17",
      "course_id": "MO_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_18",
      "course_id": "MO_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_19",
      "course_id": "MO_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_20",
      "course_id": "MO_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_21",
      "course_id": "MO_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_22",
      "course_id": "MO_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_23",
      "course_id": "MO_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_24",
      "course_id": "MO_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_25",
      "course_id": "MO_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_26",
      "course_id": "MO_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_27",
      "course_id": "MO_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_28",
      "course_id": "MO_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_29",
      "course_id": "MO_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_30",
      "course_id": "MO_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_31",
      "course_id": "MO_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_32",
      "course_id": "MO_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_33",
      "course_id": "MO_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_34",
      "course_id": "MO_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_35",
      "course_id": "MO_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_36",
      "course_id": "MO_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_37",
      "course_id": "MO_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_38",
      "course_id": "MO_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_39",
      "course_id": "MO_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_40",
      "course_id": "MO_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_41",
      "course_id": "MO_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_42",
      "course_id": "MO_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_43",
      "course_id": "MO_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_44",
      "course_id": "MO_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_45",
      "course_id": "MO_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_46",
      "course_id": "MO_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_47",
      "course_id": "MO_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_48",
      "course_id": "MO_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_49",
      "course_id": "MO_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MO_PEVO_PREP_50",
      "course_id": "MO_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "MT_PEVO_PREP": [
    {
      "id": "MT_PEVO_PREP_1",
      "course_id": "MT_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Montana?",
      "option_a": "Montana DOT Permit Office",
      "option_b": "Indiana DOT Permits",
      "option_c": "Kansas DOT Permitting",
      "option_d": "Nebraska Dept of Roads Permits",
      "correct_answer": "A",
      "explanation": "Per Montana's current course data: Montana DOT Permit Office"
    },
    {
      "id": "MT_PEVO_PREP_2",
      "course_id": "MT_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Montana require to legally operate as an escort vehicle operator?",
      "option_a": "PPCA Required",
      "option_b": "8-State Uniform",
      "option_c": "NY Standalone ONLY",
      "option_d": "State Specific",
      "correct_answer": "D",
      "explanation": "Per Montana's current course data: State Specific"
    },
    {
      "id": "MT_PEVO_PREP_3",
      "course_id": "MT_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Montana?",
      "option_a": "OVERSIZE LOAD - 5ft x 12in, bright yellow, 8-inch black letters, 1-inch brush stroke",
      "option_b": "OVERSIZE LOAD - yellow, standard spec",
      "option_c": "OVERSIZE LOAD - yellow, black letters, standard",
      "option_d": "OVERSIZE LOAD - standard yellow spec",
      "correct_answer": "C",
      "explanation": "Per Montana's current course data: OVERSIZE LOAD - yellow, black letters, standard"
    },
    {
      "id": "MT_PEVO_PREP_4",
      "course_id": "MT_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Montana?",
      "option_a": "Amber strobe - front and rear mandatory",
      "option_b": "Amber Class 1 strobe - 360 visibility at 500 ft",
      "option_c": "SAE Class 1 amber, police-grade brightness",
      "option_d": "Amber Class 1 strobe required",
      "correct_answer": "D",
      "explanation": "Per Montana's current course data: Amber Class 1 strobe required"
    },
    {
      "id": "MT_PEVO_PREP_5",
      "course_id": "MT_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Montana?",
      "option_a": "Fire extinguisher, emergency flares, safety vest",
      "option_b": "Paddle, extinguisher, flares, emergency triangles",
      "option_c": "Paddle, 3 lb extinguisher, flares",
      "option_d": "18-inch stop/slow paddle, 3 lb fire extinguisher",
      "correct_answer": "B",
      "explanation": "Per Montana's current course data: Paddle, extinguisher, flares, emergency triangles"
    },
    {
      "id": "MT_PEVO_PREP_6",
      "course_id": "MT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Montana, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 13'6\" requires escort",
      "option_b": "Width over 9'0\" or height over 15'0\"",
      "option_c": "Width over 8'6\" or height over 13'0\" requires escort",
      "option_d": "Width over 8'6\" or height over 14'0\" triggers mandatory escort",
      "correct_answer": "B",
      "explanation": "Per Montana's current course data: Width over 9'0\" or height over 15'0\""
    },
    {
      "id": "MT_PEVO_PREP_7",
      "course_id": "MT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Montana?",
      "option_a": "16'0\"",
      "option_b": "12'0\"",
      "option_c": "14'0\"",
      "option_d": "14'6\"",
      "correct_answer": "D",
      "explanation": "Per Montana's current course data: 14'6\""
    },
    {
      "id": "MT_PEVO_PREP_8",
      "course_id": "MT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Montana?",
      "option_a": "13'6\"",
      "option_b": "18'0\"",
      "option_c": "16'0\"",
      "option_d": "15'6\"",
      "correct_answer": "C",
      "explanation": "Per Montana's current course data: 16'0\""
    },
    {
      "id": "MT_PEVO_PREP_9",
      "course_id": "MT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Montana's night travel status for oversize permitted moves?",
      "option_a": "Always fully prohibited, no exceptions",
      "option_b": "w/ lighting",
      "option_c": "Restricted",
      "option_d": "Allowed",
      "correct_answer": "C",
      "explanation": "Per Montana's current course data: Restricted"
    },
    {
      "id": "MT_PEVO_PREP_10",
      "course_id": "MT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Montana?",
      "option_a": "Same as standard minimum — no separate night-ops tier specified",
      "option_b": "$1M CSL minimum",
      "option_c": "$500K CSL minimum",
      "option_d": "$750K CSL minimum",
      "correct_answer": "D",
      "explanation": "Per Montana's current course data: $750K CSL minimum"
    },
    {
      "id": "MT_PEVO_PREP_11",
      "course_id": "MT_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Montana?",
      "option_a": "$750K CSL",
      "option_b": "$500K CSL",
      "option_c": "$1M CSL",
      "option_d": "$10,000 liability",
      "correct_answer": "A",
      "explanation": "Per Montana's current course data: $750K CSL"
    },
    {
      "id": "MT_PEVO_PREP_12",
      "course_id": "MT_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Montana belong to for escort operator requirements?",
      "option_a": "Remaining",
      "option_b": "Stand-Alone",
      "option_c": "8-State",
      "option_d": "14 PEVO",
      "correct_answer": "A",
      "explanation": "Per Montana's current course data: Remaining"
    },
    {
      "id": "MT_PEVO_PREP_13",
      "course_id": "MT_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Montana-specific rule or red flag operators must know?",
      "option_a": "Wisconsin allows 15'0\" height. Spring weight restrictions apply March-May. Wind energy equipment moves are a growing market.",
      "option_b": "Illinois requires $1M CSL insurance, higher than most states. Chicago metro has permit windows and bridge weight limits.",
      "option_c": "NEW YORK HAS ZERO RECIPROCITY. No other cert is accepted. You MUST take the NY-specific course and pass the NY state exam. Thruway, bridges, and tunnels each require separate procedures.",
      "option_d": "Montana has the highest height limit at 16'0\". Wide load allowances up to 14'6\" without escort on rural highways.",
      "correct_answer": "D",
      "explanation": "Per Montana's current course data: Montana has the highest height limit at 16'0\". Wide load allowances up to 14'6\" without escort on rural highways."
    },
    {
      "id": "MT_PEVO_PREP_14",
      "course_id": "MT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Montana?",
      "option_a": "10'0\"",
      "option_b": "8'6\" (standard)",
      "option_c": "There is no standard width threshold",
      "option_d": "6'0\"",
      "correct_answer": "B",
      "explanation": "Per Montana's current course data: 8'6\" (standard)"
    },
    {
      "id": "MT_PEVO_PREP_15",
      "course_id": "MT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Montana?",
      "option_a": "10'0\"",
      "option_b": "13'6\" (standard)",
      "option_c": "15'0\"",
      "option_d": "There is no standard height threshold",
      "correct_answer": "B",
      "explanation": "Per Montana's current course data: 13'6\" (standard)"
    },
    {
      "id": "MT_PEVO_PREP_16",
      "course_id": "MT_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_17",
      "course_id": "MT_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_18",
      "course_id": "MT_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_19",
      "course_id": "MT_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_20",
      "course_id": "MT_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_21",
      "course_id": "MT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_22",
      "course_id": "MT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_23",
      "course_id": "MT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_24",
      "course_id": "MT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_25",
      "course_id": "MT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_26",
      "course_id": "MT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_27",
      "course_id": "MT_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_28",
      "course_id": "MT_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_29",
      "course_id": "MT_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_30",
      "course_id": "MT_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_31",
      "course_id": "MT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_32",
      "course_id": "MT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_33",
      "course_id": "MT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_34",
      "course_id": "MT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_35",
      "course_id": "MT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_36",
      "course_id": "MT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_37",
      "course_id": "MT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_38",
      "course_id": "MT_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_39",
      "course_id": "MT_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_40",
      "course_id": "MT_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_41",
      "course_id": "MT_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_42",
      "course_id": "MT_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_43",
      "course_id": "MT_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_44",
      "course_id": "MT_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_45",
      "course_id": "MT_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_46",
      "course_id": "MT_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_47",
      "course_id": "MT_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_48",
      "course_id": "MT_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_49",
      "course_id": "MT_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "MT_PEVO_PREP_50",
      "course_id": "MT_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "NE_PEVO_PREP": [
    {
      "id": "NE_PEVO_PREP_1",
      "course_id": "NE_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Nebraska?",
      "option_a": "Vermont Agency of Transportation",
      "option_b": "Hawaii DOT Highways Division",
      "option_c": "Michigan DOT Permit Office",
      "option_d": "Nebraska Dept of Roads Permits",
      "correct_answer": "D",
      "explanation": "Per Nebraska's current course data: Nebraska Dept of Roads Permits"
    },
    {
      "id": "NE_PEVO_PREP_2",
      "course_id": "NE_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Nebraska require to legally operate as an escort vehicle operator?",
      "option_a": "State Specific",
      "option_b": "8-State Uniform",
      "option_c": "PPCA Required",
      "option_d": "PEVO Cert",
      "correct_answer": "B",
      "explanation": "Per Nebraska's current course data: 8-State Uniform"
    },
    {
      "id": "NE_PEVO_PREP_3",
      "course_id": "NE_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Nebraska?",
      "option_a": "OVERSIZE LOAD - yellow, 5ft x 12in",
      "option_b": "OVERSIZE LOAD - 96in x 12in, fluorescent yellow-green, black letters",
      "option_c": "OVERSIZE LOAD - 5ft x 10in, yellow, SAE spec",
      "option_d": "OVERSIZE LOAD - standard yellow, 5ft x 10in",
      "correct_answer": "D",
      "explanation": "Per Nebraska's current course data: OVERSIZE LOAD - standard yellow, 5ft x 10in"
    },
    {
      "id": "NE_PEVO_PREP_4",
      "course_id": "NE_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Nebraska?",
      "option_a": "SAE Class 1 amber strobe - front and rear - 360 degree visibility at 500 ft",
      "option_b": "SAE Class 1 amber strobe, 360-degree visibility, minimum 35W",
      "option_c": "Amber Class 1, front and rear",
      "option_d": "SAE Class 1 amber front and rear",
      "correct_answer": "C",
      "explanation": "Per Nebraska's current course data: Amber Class 1, front and rear"
    },
    {
      "id": "NE_PEVO_PREP_5",
      "course_id": "NE_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Nebraska?",
      "option_a": "Paddle, 3 lb extinguisher, flares",
      "option_b": "18-inch stop/slow paddle, 3 lb fire extinguisher",
      "option_c": "Paddle, extinguisher, flares, emergency triangles",
      "option_d": "Paddle, extinguisher",
      "correct_answer": "D",
      "explanation": "Per Nebraska's current course data: Paddle, extinguisher"
    },
    {
      "id": "NE_PEVO_PREP_6",
      "course_id": "NE_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Nebraska, when is an escort legally REQUIRED?",
      "option_a": "Any load exceeding 8'6\" width, 13'6\" height, or 80,000 lbs GVW",
      "option_b": "Width over 8'6\" or height over 14'0\"",
      "option_c": "Width over 8'6\" or height over 14'0\" triggers mandatory P/EVO escort",
      "option_d": "Width over 8'6\" or height over 13'6\"",
      "correct_answer": "D",
      "explanation": "Per Nebraska's current course data: Width over 8'6\" or height over 13'6\""
    },
    {
      "id": "NE_PEVO_PREP_7",
      "course_id": "NE_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Nebraska?",
      "option_a": "14'6\"",
      "option_b": "16'0\"",
      "option_c": "14'0\"",
      "option_d": "12'0\"",
      "correct_answer": "A",
      "explanation": "Per Nebraska's current course data: 14'6\""
    },
    {
      "id": "NE_PEVO_PREP_8",
      "course_id": "NE_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Nebraska?",
      "option_a": "15'0\"",
      "option_b": "14'6\"",
      "option_c": "16'0\"",
      "option_d": "15'6\"",
      "correct_answer": "B",
      "explanation": "Per Nebraska's current course data: 14'6\""
    },
    {
      "id": "NE_PEVO_PREP_9",
      "course_id": "NE_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Nebraska's night travel status for oversize permitted moves?",
      "option_a": "Allowed",
      "option_b": "Always fully prohibited, no exceptions",
      "option_c": "Restricted",
      "option_d": "w/ lighting",
      "correct_answer": "A",
      "explanation": "Per Nebraska's current course data: Allowed"
    },
    {
      "id": "NE_PEVO_PREP_10",
      "course_id": "NE_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Nebraska?",
      "option_a": "$500K CSL minimum",
      "option_b": "Same as standard minimum — no separate night-ops tier specified",
      "option_c": "$750K CSL minimum",
      "option_d": "$1M CSL minimum",
      "correct_answer": "C",
      "explanation": "Per Nebraska's current course data: $750K CSL minimum"
    },
    {
      "id": "NE_PEVO_PREP_11",
      "course_id": "NE_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Nebraska?",
      "option_a": "$750K CSL",
      "option_b": "$500K CSL",
      "option_c": "$10,000 liability",
      "option_d": "$1M CSL",
      "correct_answer": "A",
      "explanation": "Per Nebraska's current course data: $750K CSL"
    },
    {
      "id": "NE_PEVO_PREP_12",
      "course_id": "NE_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Nebraska belong to for escort operator requirements?",
      "option_a": "Remaining",
      "option_b": "Standalone",
      "option_c": "14 PEVO",
      "option_d": "8-State",
      "correct_answer": "D",
      "explanation": "Per Nebraska's current course data: 8-State"
    },
    {
      "id": "NE_PEVO_PREP_13",
      "course_id": "NE_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Nebraska-specific rule or red flag operators must know?",
      "option_a": "Nevada is in the 8-State group. Las Vegas metro has restricted permit windows for casino and convention events.",
      "option_b": "Ohio does not participate in PEVO reciprocity. Own state cert required. Columbus and Cleveland metros have restricted hours.",
      "option_c": "Nebraska is in the 8-State group. Flat terrain and minimal bridge restrictions make this a straightforward escort state.",
      "option_d": "NEW YORK HAS ZERO RECIPROCITY. No other cert is accepted. You MUST take the NY-specific course and pass the NY state exam. Thruway, bridges, and tunnels each require separate procedures.",
      "correct_answer": "C",
      "explanation": "Per Nebraska's current course data: Nebraska is in the 8-State group. Flat terrain and minimal bridge restrictions make this a straightforward escort state."
    },
    {
      "id": "NE_PEVO_PREP_14",
      "course_id": "NE_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Nebraska?",
      "option_a": "10'0\"",
      "option_b": "6'0\"",
      "option_c": "8'6\" (standard)",
      "option_d": "There is no standard width threshold",
      "correct_answer": "C",
      "explanation": "Per Nebraska's current course data: 8'6\" (standard)"
    },
    {
      "id": "NE_PEVO_PREP_15",
      "course_id": "NE_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Nebraska?",
      "option_a": "10'0\"",
      "option_b": "13'6\" (standard)",
      "option_c": "15'0\"",
      "option_d": "There is no standard height threshold",
      "correct_answer": "B",
      "explanation": "Per Nebraska's current course data: 13'6\" (standard)"
    },
    {
      "id": "NE_PEVO_PREP_16",
      "course_id": "NE_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_17",
      "course_id": "NE_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_18",
      "course_id": "NE_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_19",
      "course_id": "NE_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_20",
      "course_id": "NE_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_21",
      "course_id": "NE_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_22",
      "course_id": "NE_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_23",
      "course_id": "NE_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_24",
      "course_id": "NE_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_25",
      "course_id": "NE_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_26",
      "course_id": "NE_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_27",
      "course_id": "NE_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_28",
      "course_id": "NE_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_29",
      "course_id": "NE_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_30",
      "course_id": "NE_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_31",
      "course_id": "NE_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_32",
      "course_id": "NE_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_33",
      "course_id": "NE_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_34",
      "course_id": "NE_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_35",
      "course_id": "NE_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_36",
      "course_id": "NE_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_37",
      "course_id": "NE_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_38",
      "course_id": "NE_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_39",
      "course_id": "NE_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_40",
      "course_id": "NE_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_41",
      "course_id": "NE_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_42",
      "course_id": "NE_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_43",
      "course_id": "NE_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_44",
      "course_id": "NE_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_45",
      "course_id": "NE_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_46",
      "course_id": "NE_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_47",
      "course_id": "NE_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_48",
      "course_id": "NE_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_49",
      "course_id": "NE_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NE_PEVO_PREP_50",
      "course_id": "NE_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "NV_PEVO_PREP": [
    {
      "id": "NV_PEVO_PREP_1",
      "course_id": "NV_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Nevada?",
      "option_a": "Nevada DOT Permit Office",
      "option_b": "Arkansas DOT Oversize Permits",
      "option_c": "SC DOT Oversize Permits",
      "option_d": "Illinois DOT Bureau of Permits",
      "correct_answer": "A",
      "explanation": "Per Nevada's current course data: Nevada DOT Permit Office"
    },
    {
      "id": "NV_PEVO_PREP_2",
      "course_id": "NV_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Nevada require to legally operate as an escort vehicle operator?",
      "option_a": "State Specific",
      "option_b": "8-State Uniform",
      "option_c": "NY Standalone ONLY",
      "option_d": "PPCA Required",
      "correct_answer": "B",
      "explanation": "Per Nevada's current course data: 8-State Uniform"
    },
    {
      "id": "NV_PEVO_PREP_3",
      "course_id": "NV_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Nevada?",
      "option_a": "OVERSIZE LOAD - yellow, 5ft x 12in",
      "option_b": "OVERSIZED LOAD - required on front and rear",
      "option_c": "OVERSIZE LOAD - yellow, SAE spec",
      "option_d": "OVERSIZE LOAD - 5ft x 10in yellow",
      "correct_answer": "C",
      "explanation": "Per Nevada's current course data: OVERSIZE LOAD - yellow, SAE spec"
    },
    {
      "id": "NV_PEVO_PREP_4",
      "course_id": "NV_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Nevada?",
      "option_a": "Amber SAE Class 1 strobe visible from all sides",
      "option_b": "Amber Class 1 strobe front and rear",
      "option_c": "Amber Class 1 or Class 2, front and rear",
      "option_d": "Amber strobe - front and rear mandatory",
      "correct_answer": "B",
      "explanation": "Per Nevada's current course data: Amber Class 1 strobe front and rear"
    },
    {
      "id": "NV_PEVO_PREP_5",
      "course_id": "NV_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Nevada?",
      "option_a": "Paddle, extinguisher",
      "option_b": "18-inch paddle, 3 lb extinguisher",
      "option_c": "Paddle, extinguisher, 6 flares",
      "option_d": "Paddle, fire extinguisher, safety vest",
      "correct_answer": "A",
      "explanation": "Per Nevada's current course data: Paddle, extinguisher"
    },
    {
      "id": "NV_PEVO_PREP_6",
      "course_id": "NV_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Nevada, when is an escort legally REQUIRED?",
      "option_a": "Any load over 8'6\" width or 14'0\" height on state highways",
      "option_b": "Any load over 8'6\" width or 13'6\" height",
      "option_c": "Width over 8'6\" or height over 13'6\"",
      "option_d": "Width over 8'6\" OR height over 14'0\" on most highways",
      "correct_answer": "C",
      "explanation": "Per Nevada's current course data: Width over 8'6\" or height over 13'6\""
    },
    {
      "id": "NV_PEVO_PREP_7",
      "course_id": "NV_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Nevada?",
      "option_a": "14'0\"",
      "option_b": "16'0\"",
      "option_c": "14'6\"",
      "option_d": "12'0\"",
      "correct_answer": "C",
      "explanation": "Per Nevada's current course data: 14'6\""
    },
    {
      "id": "NV_PEVO_PREP_8",
      "course_id": "NV_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Nevada?",
      "option_a": "18'0\"",
      "option_b": "15'0\"",
      "option_c": "13'6\"",
      "option_d": "14'6\"",
      "correct_answer": "D",
      "explanation": "Per Nevada's current course data: 14'6\""
    },
    {
      "id": "NV_PEVO_PREP_9",
      "course_id": "NV_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Nevada's night travel status for oversize permitted moves?",
      "option_a": "Always fully prohibited, no exceptions",
      "option_b": "w/ lighting",
      "option_c": "Allowed",
      "option_d": "Restricted",
      "correct_answer": "C",
      "explanation": "Per Nevada's current course data: Allowed"
    },
    {
      "id": "NV_PEVO_PREP_10",
      "course_id": "NV_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Nevada?",
      "option_a": "Same as standard minimum — no separate night-ops tier specified",
      "option_b": "$750K CSL minimum",
      "option_c": "$1M CSL minimum",
      "option_d": "$500K CSL minimum",
      "correct_answer": "B",
      "explanation": "Per Nevada's current course data: $750K CSL minimum"
    },
    {
      "id": "NV_PEVO_PREP_11",
      "course_id": "NV_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Nevada?",
      "option_a": "$10,000 liability",
      "option_b": "$750K CSL",
      "option_c": "$1M CSL",
      "option_d": "$500K CSL",
      "correct_answer": "B",
      "explanation": "Per Nevada's current course data: $750K CSL"
    },
    {
      "id": "NV_PEVO_PREP_12",
      "course_id": "NV_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Nevada belong to for escort operator requirements?",
      "option_a": "Remaining",
      "option_b": "8-State",
      "option_c": "14 PEVO",
      "option_d": "Stand-Alone",
      "correct_answer": "B",
      "explanation": "Per Nevada's current course data: 8-State"
    },
    {
      "id": "NV_PEVO_PREP_13",
      "course_id": "NV_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Nevada-specific rule or red flag operators must know?",
      "option_a": "Indiana allows night travel with proper lighting. Indianapolis metro has restricted windows during sporting events.",
      "option_b": "Nevada is in the 8-State group. Las Vegas metro has restricted permit windows for casino and convention events.",
      "option_c": "PEVO reciprocity. 15'0\" height allowance. Charlotte metro has permit windows and bridge restrictions.",
      "option_d": "High wind and blizzard conditions common Oct-April. Wind farm equipment moves are a major market in SD.",
      "correct_answer": "B",
      "explanation": "Per Nevada's current course data: Nevada is in the 8-State group. Las Vegas metro has restricted permit windows for casino and convention events."
    },
    {
      "id": "NV_PEVO_PREP_14",
      "course_id": "NV_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Nevada?",
      "option_a": "10'0\"",
      "option_b": "6'0\"",
      "option_c": "There is no standard width threshold",
      "option_d": "8'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per Nevada's current course data: 8'6\" (standard)"
    },
    {
      "id": "NV_PEVO_PREP_15",
      "course_id": "NV_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Nevada?",
      "option_a": "There is no standard height threshold",
      "option_b": "10'0\"",
      "option_c": "15'0\"",
      "option_d": "13'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per Nevada's current course data: 13'6\" (standard)"
    },
    {
      "id": "NV_PEVO_PREP_16",
      "course_id": "NV_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_17",
      "course_id": "NV_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_18",
      "course_id": "NV_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_19",
      "course_id": "NV_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_20",
      "course_id": "NV_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_21",
      "course_id": "NV_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_22",
      "course_id": "NV_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_23",
      "course_id": "NV_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_24",
      "course_id": "NV_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_25",
      "course_id": "NV_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_26",
      "course_id": "NV_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_27",
      "course_id": "NV_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_28",
      "course_id": "NV_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_29",
      "course_id": "NV_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_30",
      "course_id": "NV_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_31",
      "course_id": "NV_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_32",
      "course_id": "NV_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_33",
      "course_id": "NV_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_34",
      "course_id": "NV_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_35",
      "course_id": "NV_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_36",
      "course_id": "NV_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_37",
      "course_id": "NV_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_38",
      "course_id": "NV_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_39",
      "course_id": "NV_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_40",
      "course_id": "NV_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_41",
      "course_id": "NV_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_42",
      "course_id": "NV_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_43",
      "course_id": "NV_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_44",
      "course_id": "NV_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_45",
      "course_id": "NV_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_46",
      "course_id": "NV_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_47",
      "course_id": "NV_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_48",
      "course_id": "NV_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_49",
      "course_id": "NV_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NV_PEVO_PREP_50",
      "course_id": "NV_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "NH_PEVO_PREP": [
    {
      "id": "NH_PEVO_PREP_1",
      "course_id": "NH_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in New Hampshire?",
      "option_a": "NH DOT Permit Office",
      "option_b": "Mississippi DOT Permits",
      "option_c": "Arizona DOT Permit Office",
      "option_d": "Illinois DOT Bureau of Permits",
      "correct_answer": "A",
      "explanation": "Per New Hampshire's current course data: NH DOT Permit Office"
    },
    {
      "id": "NH_PEVO_PREP_2",
      "course_id": "NH_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does New Hampshire require to legally operate as an escort vehicle operator?",
      "option_a": "PEVO Cert",
      "option_b": "NY Standalone ONLY",
      "option_c": "State Specific",
      "option_d": "PPCA Required",
      "correct_answer": "C",
      "explanation": "Per New Hampshire's current course data: State Specific"
    },
    {
      "id": "NH_PEVO_PREP_3",
      "course_id": "NH_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in New Hampshire?",
      "option_a": "OVERSIZE LOAD - standard yellow spec",
      "option_b": "OVERSIZE LOAD - yellow, reflective, 5ft x 12in",
      "option_c": "OVERSIZE LOAD - yellow, standard spec",
      "option_d": "OVERSIZE LOAD - 5ft x 12in, yellow",
      "correct_answer": "C",
      "explanation": "Per New Hampshire's current course data: OVERSIZE LOAD - yellow, standard spec"
    },
    {
      "id": "NH_PEVO_PREP_4",
      "course_id": "NH_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in New Hampshire?",
      "option_a": "SAE Class 1 amber, 360 visibility",
      "option_b": "SAE Class 1 amber - 360 degree visibility required",
      "option_c": "Amber strobe, Class 1 rated, mounted highest point of vehicle",
      "option_d": "Amber Class 1, front and rear",
      "correct_answer": "D",
      "explanation": "Per New Hampshire's current course data: Amber Class 1, front and rear"
    },
    {
      "id": "NH_PEVO_PREP_5",
      "course_id": "NH_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in New Hampshire?",
      "option_a": "18-inch stop/slow paddle, fire extinguisher",
      "option_b": "Paddle, extinguisher, flares",
      "option_c": "Paddle, 3 lb extinguisher, flares",
      "option_d": "Paddle, extinguisher, flares, emergency triangles",
      "correct_answer": "B",
      "explanation": "Per New Hampshire's current course data: Paddle, extinguisher, flares"
    },
    {
      "id": "NH_PEVO_PREP_6",
      "course_id": "NH_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In New Hampshire, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\", height over 13'6\", or length over 65 ft",
      "option_b": "Width over 8'6\" or height over 13'0\"",
      "option_c": "Width over 9'0\" or height over 13'6\" triggers escort requirement",
      "option_d": "Width exceeding 8'6\" requires lead escort; height over 15'0\" requires height pole",
      "correct_answer": "B",
      "explanation": "Per New Hampshire's current course data: Width over 8'6\" or height over 13'0\""
    },
    {
      "id": "NH_PEVO_PREP_7",
      "course_id": "NH_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in New Hampshire?",
      "option_a": "14'6\"",
      "option_b": "16'0\"",
      "option_c": "14'0\"",
      "option_d": "12'0\"",
      "correct_answer": "C",
      "explanation": "Per New Hampshire's current course data: 14'0\""
    },
    {
      "id": "NH_PEVO_PREP_8",
      "course_id": "NH_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in New Hampshire?",
      "option_a": "16'0\"",
      "option_b": "13'6\"",
      "option_c": "18'0\"",
      "option_d": "15'6\"",
      "correct_answer": "B",
      "explanation": "Per New Hampshire's current course data: 13'6\""
    },
    {
      "id": "NH_PEVO_PREP_9",
      "course_id": "NH_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is New Hampshire's night travel status for oversize permitted moves?",
      "option_a": "Restricted",
      "option_b": "Allowed",
      "option_c": "w/ lighting",
      "option_d": "Always fully prohibited, no exceptions",
      "correct_answer": "A",
      "explanation": "Per New Hampshire's current course data: Restricted"
    },
    {
      "id": "NH_PEVO_PREP_10",
      "course_id": "NH_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in New Hampshire?",
      "option_a": "Same as standard minimum — no separate night-ops tier specified",
      "option_b": "$500K CSL minimum",
      "option_c": "$1M CSL minimum",
      "option_d": "$750K CSL minimum",
      "correct_answer": "D",
      "explanation": "Per New Hampshire's current course data: $750K CSL minimum"
    },
    {
      "id": "NH_PEVO_PREP_11",
      "course_id": "NH_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in New Hampshire?",
      "option_a": "$500K CSL",
      "option_b": "$1M CSL",
      "option_c": "$10,000 liability",
      "option_d": "$750K CSL",
      "correct_answer": "D",
      "explanation": "Per New Hampshire's current course data: $750K CSL"
    },
    {
      "id": "NH_PEVO_PREP_12",
      "course_id": "NH_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does New Hampshire belong to for escort operator requirements?",
      "option_a": "Remaining",
      "option_b": "NY Standalone",
      "option_c": "Stand-Alone",
      "option_d": "14 PEVO",
      "correct_answer": "A",
      "explanation": "Per New Hampshire's current course data: Remaining"
    },
    {
      "id": "NH_PEVO_PREP_13",
      "course_id": "NH_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a New Hampshire-specific rule or red flag operators must know?",
      "option_a": "Mountain routes require additional permits. I-70 mountain corridor has weight and escort restrictions year-round.",
      "option_b": "Tennessee does not participate in PEVO reciprocity. Nashville metro has restricted permit windows. Mountain routes require special permits.",
      "option_c": "Baltimore metro and Chesapeake Bay Bridge have special permit procedures. Bay Bridge requires advance notice of 48 hours.",
      "option_d": "Night travel prohibited without variance. White Mountain routes have seasonal weight restrictions and bridge limits.",
      "correct_answer": "D",
      "explanation": "Per New Hampshire's current course data: Night travel prohibited without variance. White Mountain routes have seasonal weight restrictions and bridge limits."
    },
    {
      "id": "NH_PEVO_PREP_14",
      "course_id": "NH_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in New Hampshire?",
      "option_a": "10'0\"",
      "option_b": "There is no standard width threshold",
      "option_c": "8'6\" (standard)",
      "option_d": "6'0\"",
      "correct_answer": "C",
      "explanation": "Per New Hampshire's current course data: 8'6\" (standard)"
    },
    {
      "id": "NH_PEVO_PREP_15",
      "course_id": "NH_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in New Hampshire?",
      "option_a": "13'6\" (standard)",
      "option_b": "15'0\"",
      "option_c": "10'0\"",
      "option_d": "There is no standard height threshold",
      "correct_answer": "A",
      "explanation": "Per New Hampshire's current course data: 13'6\" (standard)"
    },
    {
      "id": "NH_PEVO_PREP_16",
      "course_id": "NH_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_17",
      "course_id": "NH_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_18",
      "course_id": "NH_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_19",
      "course_id": "NH_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_20",
      "course_id": "NH_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_21",
      "course_id": "NH_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_22",
      "course_id": "NH_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_23",
      "course_id": "NH_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_24",
      "course_id": "NH_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_25",
      "course_id": "NH_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_26",
      "course_id": "NH_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_27",
      "course_id": "NH_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_28",
      "course_id": "NH_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_29",
      "course_id": "NH_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_30",
      "course_id": "NH_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_31",
      "course_id": "NH_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_32",
      "course_id": "NH_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_33",
      "course_id": "NH_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_34",
      "course_id": "NH_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_35",
      "course_id": "NH_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_36",
      "course_id": "NH_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_37",
      "course_id": "NH_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_38",
      "course_id": "NH_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_39",
      "course_id": "NH_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_40",
      "course_id": "NH_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_41",
      "course_id": "NH_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_42",
      "course_id": "NH_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_43",
      "course_id": "NH_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_44",
      "course_id": "NH_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_45",
      "course_id": "NH_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_46",
      "course_id": "NH_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_47",
      "course_id": "NH_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_48",
      "course_id": "NH_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_49",
      "course_id": "NH_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NH_PEVO_PREP_50",
      "course_id": "NH_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "NJ_PEVO_PREP": [
    {
      "id": "NJ_PEVO_PREP_1",
      "course_id": "NJ_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in New Jersey?",
      "option_a": "Maine DOT Permit Office",
      "option_b": "Vermont Agency of Transportation",
      "option_c": "NJ DOT Oversize Permit Unit",
      "option_d": "NY DOT Permit Bureau",
      "correct_answer": "C",
      "explanation": "Per New Jersey's current course data: NJ DOT Oversize Permit Unit"
    },
    {
      "id": "NJ_PEVO_PREP_2",
      "course_id": "NJ_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does New Jersey require to legally operate as an escort vehicle operator?",
      "option_a": "NY Standalone ONLY",
      "option_b": "PEVO Cert",
      "option_c": "8-State Uniform",
      "option_d": "PPCA Required",
      "correct_answer": "D",
      "explanation": "Per New Jersey's current course data: PPCA Required"
    },
    {
      "id": "NJ_PEVO_PREP_3",
      "course_id": "NJ_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in New Jersey?",
      "option_a": "OVERSIZE LOAD - 5ft x 12in, bright yellow, 8-inch black letters, 1-inch brush stroke",
      "option_b": "OVERSIZE LOAD - 5ft x 12in yellow, reflective",
      "option_c": "OVERSIZE LOAD - standard yellow, 5ft x 10in",
      "option_d": "OVERSIZE LOAD - 96in x 12in, fluorescent yellow-green, black letters",
      "correct_answer": "B",
      "explanation": "Per New Jersey's current course data: OVERSIZE LOAD - 5ft x 12in yellow, reflective"
    },
    {
      "id": "NJ_PEVO_PREP_4",
      "course_id": "NJ_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in New Jersey?",
      "option_a": "SAE Class 1 amber - 360 degree visibility required",
      "option_b": "SAE Class 1 amber strobe",
      "option_c": "SAE Class 1 amber, front and rear",
      "option_d": "Amber SAE Class 1, minimum 35W",
      "correct_answer": "C",
      "explanation": "Per New Jersey's current course data: SAE Class 1 amber, front and rear"
    },
    {
      "id": "NJ_PEVO_PREP_5",
      "course_id": "NJ_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in New Jersey?",
      "option_a": "18-inch stop/slow paddle, 3 lb extinguisher, cones",
      "option_b": "Paddle, extinguisher, flares",
      "option_c": "Paddle, 5 lb extinguisher, flares, cones",
      "option_d": "Paddle, extinguisher, 6 road flares",
      "correct_answer": "C",
      "explanation": "Per New Jersey's current course data: Paddle, 5 lb extinguisher, flares, cones"
    },
    {
      "id": "NJ_PEVO_PREP_6",
      "course_id": "NJ_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In New Jersey, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 14'0\"",
      "option_b": "Width over 8'6\" or height over 13'0\"",
      "option_c": "Any load exceeding 8'0\" width or 13'6\" height",
      "option_d": "Width over 8'6\" OR height over 14'0\" OR weight over 80,000 lbs",
      "correct_answer": "B",
      "explanation": "Per New Jersey's current course data: Width over 8'6\" or height over 13'0\""
    },
    {
      "id": "NJ_PEVO_PREP_7",
      "course_id": "NJ_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in New Jersey?",
      "option_a": "12'0\"",
      "option_b": "16'0\"",
      "option_c": "14'0\"",
      "option_d": "14'6\"",
      "correct_answer": "C",
      "explanation": "Per New Jersey's current course data: 14'0\""
    },
    {
      "id": "NJ_PEVO_PREP_8",
      "course_id": "NJ_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in New Jersey?",
      "option_a": "14'0\"",
      "option_b": "18'0\"",
      "option_c": "14'6\"",
      "option_d": "13'6\"",
      "correct_answer": "D",
      "explanation": "Per New Jersey's current course data: 13'6\""
    },
    {
      "id": "NJ_PEVO_PREP_9",
      "course_id": "NJ_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is New Jersey's night travel status for oversize permitted moves?",
      "option_a": "Allowed",
      "option_b": "Restricted",
      "option_c": "w/ lighting",
      "option_d": "Always fully prohibited, no exceptions",
      "correct_answer": "B",
      "explanation": "Per New Jersey's current course data: Restricted"
    },
    {
      "id": "NJ_PEVO_PREP_10",
      "course_id": "NJ_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in New Jersey?",
      "option_a": "$500K CSL minimum",
      "option_b": "Same as standard minimum — no separate night-ops tier specified",
      "option_c": "$750K CSL minimum",
      "option_d": "$1M CSL minimum",
      "correct_answer": "D",
      "explanation": "Per New Jersey's current course data: $1M CSL minimum"
    },
    {
      "id": "NJ_PEVO_PREP_11",
      "course_id": "NJ_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in New Jersey?",
      "option_a": "$1M CSL",
      "option_b": "$500K CSL",
      "option_c": "$10,000 liability",
      "option_d": "$750K CSL",
      "correct_answer": "A",
      "explanation": "Per New Jersey's current course data: $1M CSL"
    },
    {
      "id": "NJ_PEVO_PREP_12",
      "course_id": "NJ_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does New Jersey belong to for escort operator requirements?",
      "option_a": "Remaining",
      "option_b": "Stand-Alone",
      "option_c": "NY Standalone",
      "option_d": "8-State",
      "correct_answer": "B",
      "explanation": "Per New Jersey's current course data: Stand-Alone"
    },
    {
      "id": "NJ_PEVO_PREP_13",
      "course_id": "NJ_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a New Jersey-specific rule or red flag operators must know?",
      "option_a": "Rhode Island is the smallest state. Most routes pass through Providence metro. Night travel restricted to midnight-5am only with variance.",
      "option_b": "Vermont spring thaw laws (Feb-April) severely restrict movements. Green Mountain routes have height clearance issues.",
      "option_c": "Delaware is a small state with high bridge density. Bridge strike liability is strictly enforced under state code.",
      "option_d": "NJ requires $1M insurance. NJ Turnpike and Garden State Parkway have separate permit procedures. Path and Lincoln tunnel approaches have height restrictions.",
      "correct_answer": "D",
      "explanation": "Per New Jersey's current course data: NJ requires $1M insurance. NJ Turnpike and Garden State Parkway have separate permit procedures. Path and Lincoln tunnel approaches have height restrictions."
    },
    {
      "id": "NJ_PEVO_PREP_14",
      "course_id": "NJ_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in New Jersey?",
      "option_a": "10'0\"",
      "option_b": "There is no standard width threshold",
      "option_c": "8'6\" (standard)",
      "option_d": "6'0\"",
      "correct_answer": "C",
      "explanation": "Per New Jersey's current course data: 8'6\" (standard)"
    },
    {
      "id": "NJ_PEVO_PREP_15",
      "course_id": "NJ_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in New Jersey?",
      "option_a": "15'0\"",
      "option_b": "13'6\" (standard)",
      "option_c": "10'0\"",
      "option_d": "There is no standard height threshold",
      "correct_answer": "B",
      "explanation": "Per New Jersey's current course data: 13'6\" (standard)"
    },
    {
      "id": "NJ_PEVO_PREP_16",
      "course_id": "NJ_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_17",
      "course_id": "NJ_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_18",
      "course_id": "NJ_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_19",
      "course_id": "NJ_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_20",
      "course_id": "NJ_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_21",
      "course_id": "NJ_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_22",
      "course_id": "NJ_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_23",
      "course_id": "NJ_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_24",
      "course_id": "NJ_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_25",
      "course_id": "NJ_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_26",
      "course_id": "NJ_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_27",
      "course_id": "NJ_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_28",
      "course_id": "NJ_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_29",
      "course_id": "NJ_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_30",
      "course_id": "NJ_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_31",
      "course_id": "NJ_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_32",
      "course_id": "NJ_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_33",
      "course_id": "NJ_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_34",
      "course_id": "NJ_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_35",
      "course_id": "NJ_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_36",
      "course_id": "NJ_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_37",
      "course_id": "NJ_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_38",
      "course_id": "NJ_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_39",
      "course_id": "NJ_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_40",
      "course_id": "NJ_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_41",
      "course_id": "NJ_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_42",
      "course_id": "NJ_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_43",
      "course_id": "NJ_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_44",
      "course_id": "NJ_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_45",
      "course_id": "NJ_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_46",
      "course_id": "NJ_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_47",
      "course_id": "NJ_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_48",
      "course_id": "NJ_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_49",
      "course_id": "NJ_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NJ_PEVO_PREP_50",
      "course_id": "NJ_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "NM_PEVO_PREP": [
    {
      "id": "NM_PEVO_PREP_1",
      "course_id": "NM_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in New Mexico?",
      "option_a": "Maryland SHA Permit Office",
      "option_b": "SC DOT Oversize Permits",
      "option_c": "NM DOT Permits Office",
      "option_d": "Utah DOT Permit Office",
      "correct_answer": "C",
      "explanation": "Per New Mexico's current course data: NM DOT Permits Office"
    },
    {
      "id": "NM_PEVO_PREP_2",
      "course_id": "NM_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does New Mexico require to legally operate as an escort vehicle operator?",
      "option_a": "PEVO Cert",
      "option_b": "8-State Uniform",
      "option_c": "NY Standalone ONLY",
      "option_d": "State Specific",
      "correct_answer": "A",
      "explanation": "Per New Mexico's current course data: PEVO Cert"
    },
    {
      "id": "NM_PEVO_PREP_3",
      "course_id": "NM_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in New Mexico?",
      "option_a": "OVERSIZE LOAD - standard 5ft x 12in yellow sign",
      "option_b": "OVERSIZE LOAD - yellow, standard spec",
      "option_c": "OVERSIZE LOAD - standard yellow, 5ft x 10in",
      "option_d": "OVERSIZE LOAD - yellow, black letters, 5ft x 12in",
      "correct_answer": "D",
      "explanation": "Per New Mexico's current course data: OVERSIZE LOAD - yellow, black letters, 5ft x 12in"
    },
    {
      "id": "NM_PEVO_PREP_4",
      "course_id": "NM_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in New Mexico?",
      "option_a": "SAE Class 1 amber strobe, 360-degree visibility, minimum 35W",
      "option_b": "SAE Class 1 or 2 amber - mounted at highest visible point - 360 degree visibility",
      "option_c": "SAE Class 1 amber front and rear",
      "option_d": "Amber Class 1 strobe",
      "correct_answer": "D",
      "explanation": "Per New Mexico's current course data: Amber Class 1 strobe"
    },
    {
      "id": "NM_PEVO_PREP_5",
      "course_id": "NM_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in New Mexico?",
      "option_a": "Paddle, extinguisher",
      "option_b": "18-inch paddle, 3 lb extinguisher",
      "option_c": "Paddle, 3 lb extinguisher",
      "option_d": "18-inch stop/slow paddle, 3 lb fire extinguisher",
      "correct_answer": "A",
      "explanation": "Per New Mexico's current course data: Paddle, extinguisher"
    },
    {
      "id": "NM_PEVO_PREP_6",
      "course_id": "NM_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In New Mexico, when is an escort legally REQUIRED?",
      "option_a": "Width over 9'0\" or height over 14'0\"",
      "option_b": "Width over 8'6\" or height over 13'0\"",
      "option_c": "Width over 12'0\" or height over 14'0\"",
      "option_d": "Width over 8'6\" or height over 14'0\"",
      "correct_answer": "D",
      "explanation": "Per New Mexico's current course data: Width over 8'6\" or height over 14'0\""
    },
    {
      "id": "NM_PEVO_PREP_7",
      "course_id": "NM_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in New Mexico?",
      "option_a": "16'0\"",
      "option_b": "12'0\"",
      "option_c": "14'6\"",
      "option_d": "14'0\"",
      "correct_answer": "D",
      "explanation": "Per New Mexico's current course data: 14'0\""
    },
    {
      "id": "NM_PEVO_PREP_8",
      "course_id": "NM_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in New Mexico?",
      "option_a": "16'0\"",
      "option_b": "15'6\"",
      "option_c": "14'6\"",
      "option_d": "18'0\"",
      "correct_answer": "C",
      "explanation": "Per New Mexico's current course data: 14'6\""
    },
    {
      "id": "NM_PEVO_PREP_9",
      "course_id": "NM_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is New Mexico's night travel status for oversize permitted moves?",
      "option_a": "Restricted",
      "option_b": "Allowed",
      "option_c": "Always fully prohibited, no exceptions",
      "option_d": "w/ lighting",
      "correct_answer": "B",
      "explanation": "Per New Mexico's current course data: Allowed"
    },
    {
      "id": "NM_PEVO_PREP_10",
      "course_id": "NM_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in New Mexico?",
      "option_a": "$1M CSL minimum",
      "option_b": "Same as standard minimum — no separate night-ops tier specified",
      "option_c": "$750K CSL minimum",
      "option_d": "$500K CSL minimum",
      "correct_answer": "C",
      "explanation": "Per New Mexico's current course data: $750K CSL minimum"
    },
    {
      "id": "NM_PEVO_PREP_11",
      "course_id": "NM_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in New Mexico?",
      "option_a": "$1M CSL",
      "option_b": "$10,000 liability",
      "option_c": "$500K CSL",
      "option_d": "$750K CSL",
      "correct_answer": "D",
      "explanation": "Per New Mexico's current course data: $750K CSL"
    },
    {
      "id": "NM_PEVO_PREP_12",
      "course_id": "NM_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does New Mexico belong to for escort operator requirements?",
      "option_a": "Remaining",
      "option_b": "8-State",
      "option_c": "14 PEVO",
      "option_d": "Standalone",
      "correct_answer": "C",
      "explanation": "Per New Mexico's current course data: 14 PEVO"
    },
    {
      "id": "NM_PEVO_PREP_13",
      "course_id": "NM_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a New Mexico-specific rule or red flag operators must know?",
      "option_a": "Nebraska is in the 8-State group. Flat terrain and minimal bridge restrictions make this a straightforward escort state.",
      "option_b": "PEVO reciprocity. New Mexico allows night travel. High desert terrain has minimal bridge restrictions.",
      "option_c": "Michigan has extensive bridge restrictions due to aging infrastructure. Upper Peninsula routes have seasonal weight limits.",
      "option_d": "Baltimore metro and Chesapeake Bay Bridge have special permit procedures. Bay Bridge requires advance notice of 48 hours.",
      "correct_answer": "B",
      "explanation": "Per New Mexico's current course data: PEVO reciprocity. New Mexico allows night travel. High desert terrain has minimal bridge restrictions."
    },
    {
      "id": "NM_PEVO_PREP_14",
      "course_id": "NM_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in New Mexico?",
      "option_a": "There is no standard width threshold",
      "option_b": "10'0\"",
      "option_c": "6'0\"",
      "option_d": "8'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per New Mexico's current course data: 8'6\" (standard)"
    },
    {
      "id": "NM_PEVO_PREP_15",
      "course_id": "NM_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in New Mexico?",
      "option_a": "15'0\"",
      "option_b": "There is no standard height threshold",
      "option_c": "13'6\" (standard)",
      "option_d": "10'0\"",
      "correct_answer": "C",
      "explanation": "Per New Mexico's current course data: 13'6\" (standard)"
    },
    {
      "id": "NM_PEVO_PREP_16",
      "course_id": "NM_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_17",
      "course_id": "NM_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_18",
      "course_id": "NM_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_19",
      "course_id": "NM_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_20",
      "course_id": "NM_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_21",
      "course_id": "NM_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_22",
      "course_id": "NM_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_23",
      "course_id": "NM_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_24",
      "course_id": "NM_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_25",
      "course_id": "NM_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_26",
      "course_id": "NM_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_27",
      "course_id": "NM_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_28",
      "course_id": "NM_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_29",
      "course_id": "NM_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_30",
      "course_id": "NM_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_31",
      "course_id": "NM_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_32",
      "course_id": "NM_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_33",
      "course_id": "NM_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_34",
      "course_id": "NM_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_35",
      "course_id": "NM_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_36",
      "course_id": "NM_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_37",
      "course_id": "NM_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_38",
      "course_id": "NM_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_39",
      "course_id": "NM_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_40",
      "course_id": "NM_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_41",
      "course_id": "NM_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_42",
      "course_id": "NM_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_43",
      "course_id": "NM_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_44",
      "course_id": "NM_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_45",
      "course_id": "NM_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_46",
      "course_id": "NM_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_47",
      "course_id": "NM_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_48",
      "course_id": "NM_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_49",
      "course_id": "NM_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NM_PEVO_PREP_50",
      "course_id": "NM_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "NY_PEVO_PREP": [
    {
      "id": "NY_PEVO_PREP_1",
      "course_id": "NY_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in New York?",
      "option_a": "Nevada DOT Permit Office",
      "option_b": "NY DOT Permit Bureau",
      "option_c": "Maryland SHA Permit Office",
      "option_d": "Hawaii DOT Highways Division",
      "correct_answer": "B",
      "explanation": "Per New York's current course data: NY DOT Permit Bureau"
    },
    {
      "id": "NY_PEVO_PREP_2",
      "course_id": "NY_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does New York require to legally operate as an escort vehicle operator?",
      "option_a": "PEVO Cert",
      "option_b": "NY Standalone ONLY",
      "option_c": "8-State Uniform",
      "option_d": "PPCA Required",
      "correct_answer": "B",
      "explanation": "Per New York's current course data: NY Standalone ONLY"
    },
    {
      "id": "NY_PEVO_PREP_3",
      "course_id": "NY_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in New York?",
      "option_a": "OVERSIZE LOAD - 5ft x 12in, fluorescent yellow-green, black reflective letters",
      "option_b": "OVERSIZE LOAD - must be removed when not actively escorting",
      "option_c": "OVERSIZE LOAD - yellow, black letters",
      "option_d": "OVERSIZE LOAD - 7ft x 18in, fluorescent yellow-orange, 10-inch black letters",
      "correct_answer": "B",
      "explanation": "Per New York's current course data: OVERSIZE LOAD - must be removed when not actively escorting"
    },
    {
      "id": "NY_PEVO_PREP_4",
      "course_id": "NY_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in New York?",
      "option_a": "SAE Class 1 amber AND rear-facing amber required",
      "option_b": "SAE Class 1 or 2 amber - mounted at highest visible point - 360 degree visibility",
      "option_c": "Amber Class 1 strobe, front and rear",
      "option_d": "Amber strobe, Class 1 or 2",
      "correct_answer": "A",
      "explanation": "Per New York's current course data: SAE Class 1 amber AND rear-facing amber required"
    },
    {
      "id": "NY_PEVO_PREP_5",
      "course_id": "NY_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in New York?",
      "option_a": "Paddle, 5 lb extinguisher, flares, cones, first aid kit",
      "option_b": "Paddle, fire extinguisher, safety vest",
      "option_c": "Paddle, 3 lb extinguisher, vest",
      "option_d": "Paddle, 2.5 lb extinguisher, flares",
      "correct_answer": "A",
      "explanation": "Per New York's current course data: Paddle, 5 lb extinguisher, flares, cones, first aid kit"
    },
    {
      "id": "NY_PEVO_PREP_6",
      "course_id": "NY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In New York, when is an escort legally REQUIRED?",
      "option_a": "Loads exceeding 8'6\" width or 13'6\" height require licensed escort",
      "option_b": "ANY load over 8'6\" width or 13'6\" height - ZERO tolerance",
      "option_c": "Width over 8'6\" or height over 14'0\"",
      "option_d": "Width over 8'6\" or height over 13'0\" requires escort",
      "correct_answer": "B",
      "explanation": "Per New York's current course data: ANY load over 8'6\" width or 13'6\" height - ZERO tolerance"
    },
    {
      "id": "NY_PEVO_PREP_7",
      "course_id": "NY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in New York?",
      "option_a": "12'0\"",
      "option_b": "14'0\"",
      "option_c": "16'0\"",
      "option_d": "14'6\"",
      "correct_answer": "B",
      "explanation": "Per New York's current course data: 14'0\""
    },
    {
      "id": "NY_PEVO_PREP_8",
      "course_id": "NY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in New York?",
      "option_a": "13'6\"",
      "option_b": "18'0\"",
      "option_c": "14'0\"",
      "option_d": "15'0\"",
      "correct_answer": "C",
      "explanation": "Per New York's current course data: 14'0\""
    },
    {
      "id": "NY_PEVO_PREP_9",
      "course_id": "NY_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is New York's night travel status for oversize permitted moves?",
      "option_a": "w/ lighting",
      "option_b": "Allowed",
      "option_c": "Restricted",
      "option_d": "Always fully prohibited, no exceptions",
      "correct_answer": "C",
      "explanation": "Per New York's current course data: Restricted"
    },
    {
      "id": "NY_PEVO_PREP_10",
      "course_id": "NY_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in New York?",
      "option_a": "$1M CSL minimum",
      "option_b": "$750K CSL minimum",
      "option_c": "$500K CSL minimum",
      "option_d": "Same as standard minimum — no separate night-ops tier specified",
      "correct_answer": "A",
      "explanation": "Per New York's current course data: $1M CSL minimum"
    },
    {
      "id": "NY_PEVO_PREP_11",
      "course_id": "NY_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in New York?",
      "option_a": "$1M CSL",
      "option_b": "$500K CSL",
      "option_c": "$10,000 liability",
      "option_d": "$750K CSL",
      "correct_answer": "A",
      "explanation": "Per New York's current course data: $1M CSL"
    },
    {
      "id": "NY_PEVO_PREP_12",
      "course_id": "NY_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does New York belong to for escort operator requirements?",
      "option_a": "Remaining",
      "option_b": "NY Standalone",
      "option_c": "14 PEVO",
      "option_d": "Standalone",
      "correct_answer": "B",
      "explanation": "Per New York's current course data: NY Standalone"
    },
    {
      "id": "NY_PEVO_PREP_13",
      "course_id": "NY_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a New York-specific rule or red flag operators must know?",
      "option_a": "NEW YORK HAS ZERO RECIPROCITY. No other cert is accepted. You MUST take the NY-specific course and pass the NY state exam. Thruway, bridges, and tunnels each require separate procedures.",
      "option_b": "Indiana allows night travel with proper lighting. Indianapolis metro has restricted windows during sporting events.",
      "option_c": "Oklahoma has high wind conditions on open highways. Tornado season (April-June) may result in permit holds.",
      "option_d": "High wind and blizzard conditions common Oct-April. Wind farm equipment moves are a major market in SD.",
      "correct_answer": "A",
      "explanation": "Per New York's current course data: NEW YORK HAS ZERO RECIPROCITY. No other cert is accepted. You MUST take the NY-specific course and pass the NY state exam. Thruway, bridges, and tunnels each require separate procedures."
    },
    {
      "id": "NY_PEVO_PREP_14",
      "course_id": "NY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in New York?",
      "option_a": "6'0\"",
      "option_b": "8'6\" (standard)",
      "option_c": "10'0\"",
      "option_d": "There is no standard width threshold",
      "correct_answer": "B",
      "explanation": "Per New York's current course data: 8'6\" (standard)"
    },
    {
      "id": "NY_PEVO_PREP_15",
      "course_id": "NY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in New York?",
      "option_a": "15'0\"",
      "option_b": "There is no standard height threshold",
      "option_c": "10'0\"",
      "option_d": "13'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per New York's current course data: 13'6\" (standard)"
    },
    {
      "id": "NY_PEVO_PREP_16",
      "course_id": "NY_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_17",
      "course_id": "NY_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_18",
      "course_id": "NY_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_19",
      "course_id": "NY_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_20",
      "course_id": "NY_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_21",
      "course_id": "NY_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_22",
      "course_id": "NY_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_23",
      "course_id": "NY_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_24",
      "course_id": "NY_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_25",
      "course_id": "NY_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_26",
      "course_id": "NY_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_27",
      "course_id": "NY_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_28",
      "course_id": "NY_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_29",
      "course_id": "NY_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_30",
      "course_id": "NY_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_31",
      "course_id": "NY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_32",
      "course_id": "NY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_33",
      "course_id": "NY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_34",
      "course_id": "NY_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_35",
      "course_id": "NY_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_36",
      "course_id": "NY_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_37",
      "course_id": "NY_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_38",
      "course_id": "NY_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_39",
      "course_id": "NY_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_40",
      "course_id": "NY_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_41",
      "course_id": "NY_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_42",
      "course_id": "NY_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_43",
      "course_id": "NY_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_44",
      "course_id": "NY_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_45",
      "course_id": "NY_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_46",
      "course_id": "NY_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_47",
      "course_id": "NY_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_48",
      "course_id": "NY_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_49",
      "course_id": "NY_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NY_PEVO_PREP_50",
      "course_id": "NY_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "NC_PEVO_PREP": [
    {
      "id": "NC_PEVO_PREP_1",
      "course_id": "NC_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in North Carolina?",
      "option_a": "Alaska DOT Permit Section",
      "option_b": "Idaho Transportation Dept Permits",
      "option_c": "NH DOT Permit Office",
      "option_d": "NC DOT Oversize Permits",
      "correct_answer": "D",
      "explanation": "Per North Carolina's current course data: NC DOT Oversize Permits"
    },
    {
      "id": "NC_PEVO_PREP_2",
      "course_id": "NC_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does North Carolina require to legally operate as an escort vehicle operator?",
      "option_a": "NY Standalone ONLY",
      "option_b": "8-State Uniform",
      "option_c": "PEVO Cert",
      "option_d": "State Specific",
      "correct_answer": "C",
      "explanation": "Per North Carolina's current course data: PEVO Cert"
    },
    {
      "id": "NC_PEVO_PREP_3",
      "course_id": "NC_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in North Carolina?",
      "option_a": "OVERSIZE LOAD - yellow, 5ft x 12in, reflective",
      "option_b": "OVERSIZE LOAD - 5ft x 12in, fluorescent yellow, reflective lettering",
      "option_c": "OVERSIZE LOAD - yellow, 5ft x 12in",
      "option_d": "OVERSIZE LOAD - fluorescent yellow, 5ft x 12in",
      "correct_answer": "C",
      "explanation": "Per North Carolina's current course data: OVERSIZE LOAD - yellow, 5ft x 12in"
    },
    {
      "id": "NC_PEVO_PREP_4",
      "course_id": "NC_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in North Carolina?",
      "option_a": "Amber SAE Class 1, minimum 35W",
      "option_b": "Amber Class 1 strobe front and rear",
      "option_c": "SAE Class 1 amber strobe - front and rear",
      "option_d": "Amber SAE Class 1 strobe, front and rear",
      "correct_answer": "D",
      "explanation": "Per North Carolina's current course data: Amber SAE Class 1 strobe, front and rear"
    },
    {
      "id": "NC_PEVO_PREP_5",
      "course_id": "NC_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in North Carolina?",
      "option_a": "18-inch paddle, 3 lb extinguisher",
      "option_b": "18-inch stop/slow paddle, fire extinguisher",
      "option_c": "Fire extinguisher, emergency flares, safety vest",
      "option_d": "Paddle, 3 lb extinguisher",
      "correct_answer": "A",
      "explanation": "Per North Carolina's current course data: 18-inch paddle, 3 lb extinguisher"
    },
    {
      "id": "NC_PEVO_PREP_6",
      "course_id": "NC_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In North Carolina, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 13'6\"",
      "option_b": "Width over 9'0\" or height over 15'0\"",
      "option_c": "Width over 9'0\" or height over 13'6\" triggers escort requirement",
      "option_d": "Width over 8'6\" or height over 13'0\" requires escort",
      "correct_answer": "A",
      "explanation": "Per North Carolina's current course data: Width over 8'6\" or height over 13'6\""
    },
    {
      "id": "NC_PEVO_PREP_7",
      "course_id": "NC_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in North Carolina?",
      "option_a": "12'0\"",
      "option_b": "14'6\"",
      "option_c": "14'0\"",
      "option_d": "16'0\"",
      "correct_answer": "C",
      "explanation": "Per North Carolina's current course data: 14'0\""
    },
    {
      "id": "NC_PEVO_PREP_8",
      "course_id": "NC_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in North Carolina?",
      "option_a": "16'0\"",
      "option_b": "18'0\"",
      "option_c": "13'6\"",
      "option_d": "15'0\"",
      "correct_answer": "D",
      "explanation": "Per North Carolina's current course data: 15'0\""
    },
    {
      "id": "NC_PEVO_PREP_9",
      "course_id": "NC_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is North Carolina's night travel status for oversize permitted moves?",
      "option_a": "w/ lighting",
      "option_b": "Allowed",
      "option_c": "Always fully prohibited, no exceptions",
      "option_d": "Restricted",
      "correct_answer": "A",
      "explanation": "Per North Carolina's current course data: w/ lighting"
    },
    {
      "id": "NC_PEVO_PREP_10",
      "course_id": "NC_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in North Carolina?",
      "option_a": "$750K CSL minimum",
      "option_b": "$1M CSL minimum",
      "option_c": "Same as standard minimum — no separate night-ops tier specified",
      "option_d": "$500K CSL minimum",
      "correct_answer": "A",
      "explanation": "Per North Carolina's current course data: $750K CSL minimum"
    },
    {
      "id": "NC_PEVO_PREP_11",
      "course_id": "NC_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in North Carolina?",
      "option_a": "$10,000 liability",
      "option_b": "$500K CSL",
      "option_c": "$750K CSL",
      "option_d": "$1M CSL",
      "correct_answer": "C",
      "explanation": "Per North Carolina's current course data: $750K CSL"
    },
    {
      "id": "NC_PEVO_PREP_12",
      "course_id": "NC_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does North Carolina belong to for escort operator requirements?",
      "option_a": "Standalone",
      "option_b": "8-State",
      "option_c": "14 PEVO",
      "option_d": "NY Standalone",
      "correct_answer": "C",
      "explanation": "Per North Carolina's current course data: 14 PEVO"
    },
    {
      "id": "NC_PEVO_PREP_13",
      "course_id": "NC_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a North Carolina-specific rule or red flag operators must know?",
      "option_a": "8-State group. Mountain canyon routes (I-15, US-89) have seasonal restrictions. Salt Lake metro restricted during major events.",
      "option_b": "Large agricultural equipment moves are common. Spring weight restrictions apply on all secondary roads.",
      "option_c": "Wisconsin allows 15'0\" height. Spring weight restrictions apply March-May. Wind energy equipment moves are a growing market.",
      "option_d": "PEVO reciprocity. 15'0\" height allowance. Charlotte metro has permit windows and bridge restrictions.",
      "correct_answer": "D",
      "explanation": "Per North Carolina's current course data: PEVO reciprocity. 15'0\" height allowance. Charlotte metro has permit windows and bridge restrictions."
    },
    {
      "id": "NC_PEVO_PREP_14",
      "course_id": "NC_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in North Carolina?",
      "option_a": "8'6\" (standard)",
      "option_b": "There is no standard width threshold",
      "option_c": "6'0\"",
      "option_d": "10'0\"",
      "correct_answer": "A",
      "explanation": "Per North Carolina's current course data: 8'6\" (standard)"
    },
    {
      "id": "NC_PEVO_PREP_15",
      "course_id": "NC_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in North Carolina?",
      "option_a": "15'0\"",
      "option_b": "13'6\" (standard)",
      "option_c": "There is no standard height threshold",
      "option_d": "10'0\"",
      "correct_answer": "B",
      "explanation": "Per North Carolina's current course data: 13'6\" (standard)"
    },
    {
      "id": "NC_PEVO_PREP_16",
      "course_id": "NC_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_17",
      "course_id": "NC_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_18",
      "course_id": "NC_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_19",
      "course_id": "NC_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_20",
      "course_id": "NC_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_21",
      "course_id": "NC_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_22",
      "course_id": "NC_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_23",
      "course_id": "NC_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_24",
      "course_id": "NC_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_25",
      "course_id": "NC_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_26",
      "course_id": "NC_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_27",
      "course_id": "NC_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_28",
      "course_id": "NC_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_29",
      "course_id": "NC_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_30",
      "course_id": "NC_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_31",
      "course_id": "NC_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_32",
      "course_id": "NC_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_33",
      "course_id": "NC_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_34",
      "course_id": "NC_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_35",
      "course_id": "NC_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_36",
      "course_id": "NC_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_37",
      "course_id": "NC_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_38",
      "course_id": "NC_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_39",
      "course_id": "NC_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_40",
      "course_id": "NC_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_41",
      "course_id": "NC_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_42",
      "course_id": "NC_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_43",
      "course_id": "NC_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_44",
      "course_id": "NC_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_45",
      "course_id": "NC_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_46",
      "course_id": "NC_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_47",
      "course_id": "NC_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_48",
      "course_id": "NC_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_49",
      "course_id": "NC_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "NC_PEVO_PREP_50",
      "course_id": "NC_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "ND_PEVO_PREP": [
    {
      "id": "ND_PEVO_PREP_1",
      "course_id": "ND_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in North Dakota?",
      "option_a": "ND DOT Motor Carrier Services",
      "option_b": "PennDOT Oversize Permits",
      "option_c": "RI DOT Permit Office",
      "option_d": "Montana DOT Permit Office",
      "correct_answer": "A",
      "explanation": "Per North Dakota's current course data: ND DOT Motor Carrier Services"
    },
    {
      "id": "ND_PEVO_PREP_2",
      "course_id": "ND_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does North Dakota require to legally operate as an escort vehicle operator?",
      "option_a": "PPCA Required",
      "option_b": "State Specific",
      "option_c": "PEVO Cert",
      "option_d": "NY Standalone ONLY",
      "correct_answer": "B",
      "explanation": "Per North Dakota's current course data: State Specific"
    },
    {
      "id": "ND_PEVO_PREP_3",
      "course_id": "ND_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in North Dakota?",
      "option_a": "OVERSIZE LOAD - yellow, 5ft x 12in, reflective",
      "option_b": "OVERSIZE LOAD - yellow, black letters",
      "option_c": "OVERSIZE LOAD - 5ft x 12in, fluorescent yellow, reflective lettering",
      "option_d": "OVERSIZE LOAD - 7ft x 18in, fluorescent yellow-orange, 10-inch black letters",
      "correct_answer": "B",
      "explanation": "Per North Dakota's current course data: OVERSIZE LOAD - yellow, black letters"
    },
    {
      "id": "ND_PEVO_PREP_4",
      "course_id": "ND_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in North Dakota?",
      "option_a": "Amber Class 1 or 2 - front and rear required",
      "option_b": "Amber Class 1 strobe",
      "option_c": "Amber Class 1 strobe - 360 visibility at 500 ft",
      "option_d": "Amber SAE Class 1, minimum 35W",
      "correct_answer": "B",
      "explanation": "Per North Dakota's current course data: Amber Class 1 strobe"
    },
    {
      "id": "ND_PEVO_PREP_5",
      "course_id": "ND_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in North Dakota?",
      "option_a": "Paddle, extinguisher, safety triangles",
      "option_b": "Paddle, 3 lb extinguisher",
      "option_c": "Stop/slow paddle min 18in, 3 lb fire extinguisher, orange cones",
      "option_d": "Paddle, extinguisher",
      "correct_answer": "D",
      "explanation": "Per North Dakota's current course data: Paddle, extinguisher"
    },
    {
      "id": "ND_PEVO_PREP_6",
      "course_id": "ND_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In North Dakota, when is an escort legally REQUIRED?",
      "option_a": "Width over 9'0\" or height over 13'6\" triggers escort requirement",
      "option_b": "Width over 8'6\", height over 13'6\", or length over 65 ft",
      "option_c": "Width over 9'0\" or height over 14'0\"",
      "option_d": "Width over 8'6\" or height over 13'0\" requires escort",
      "correct_answer": "C",
      "explanation": "Per North Dakota's current course data: Width over 9'0\" or height over 14'0\""
    },
    {
      "id": "ND_PEVO_PREP_7",
      "course_id": "ND_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in North Dakota?",
      "option_a": "16'0\"",
      "option_b": "14'6\"",
      "option_c": "14'0\"",
      "option_d": "12'0\"",
      "correct_answer": "B",
      "explanation": "Per North Dakota's current course data: 14'6\""
    },
    {
      "id": "ND_PEVO_PREP_8",
      "course_id": "ND_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in North Dakota?",
      "option_a": "18'0\"",
      "option_b": "14'0\"",
      "option_c": "15'0\"",
      "option_d": "13'6\"",
      "correct_answer": "C",
      "explanation": "Per North Dakota's current course data: 15'0\""
    },
    {
      "id": "ND_PEVO_PREP_9",
      "course_id": "ND_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is North Dakota's night travel status for oversize permitted moves?",
      "option_a": "w/ lighting",
      "option_b": "Restricted",
      "option_c": "Allowed",
      "option_d": "Always fully prohibited, no exceptions",
      "correct_answer": "C",
      "explanation": "Per North Dakota's current course data: Allowed"
    },
    {
      "id": "ND_PEVO_PREP_10",
      "course_id": "ND_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in North Dakota?",
      "option_a": "$1M CSL minimum",
      "option_b": "Same as standard minimum — no separate night-ops tier specified",
      "option_c": "$500K CSL minimum",
      "option_d": "$750K CSL minimum",
      "correct_answer": "D",
      "explanation": "Per North Dakota's current course data: $750K CSL minimum"
    },
    {
      "id": "ND_PEVO_PREP_11",
      "course_id": "ND_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in North Dakota?",
      "option_a": "$1M CSL",
      "option_b": "$10,000 liability",
      "option_c": "$750K CSL",
      "option_d": "$500K CSL",
      "correct_answer": "C",
      "explanation": "Per North Dakota's current course data: $750K CSL"
    },
    {
      "id": "ND_PEVO_PREP_12",
      "course_id": "ND_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does North Dakota belong to for escort operator requirements?",
      "option_a": "8-State",
      "option_b": "Remaining",
      "option_c": "Standalone",
      "option_d": "Stand-Alone",
      "correct_answer": "B",
      "explanation": "Per North Dakota's current course data: Remaining"
    },
    {
      "id": "ND_PEVO_PREP_13",
      "course_id": "ND_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a North Dakota-specific rule or red flag operators must know?",
      "option_a": "Mountain routes require additional permits. I-70 mountain corridor has weight and escort restrictions year-round.",
      "option_b": "Indiana allows night travel with proper lighting. Indianapolis metro has restricted windows during sporting events.",
      "option_c": "Alaska has no reciprocity. Extreme weather rules apply Oct-Apr. Daylight-only travel required Nov-Feb.",
      "option_d": "Large agricultural equipment moves are common. Spring weight restrictions apply on all secondary roads.",
      "correct_answer": "D",
      "explanation": "Per North Dakota's current course data: Large agricultural equipment moves are common. Spring weight restrictions apply on all secondary roads."
    },
    {
      "id": "ND_PEVO_PREP_14",
      "course_id": "ND_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in North Dakota?",
      "option_a": "6'0\"",
      "option_b": "There is no standard width threshold",
      "option_c": "8'6\" (standard)",
      "option_d": "10'0\"",
      "correct_answer": "C",
      "explanation": "Per North Dakota's current course data: 8'6\" (standard)"
    },
    {
      "id": "ND_PEVO_PREP_15",
      "course_id": "ND_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in North Dakota?",
      "option_a": "15'0\"",
      "option_b": "There is no standard height threshold",
      "option_c": "10'0\"",
      "option_d": "13'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per North Dakota's current course data: 13'6\" (standard)"
    },
    {
      "id": "ND_PEVO_PREP_16",
      "course_id": "ND_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_17",
      "course_id": "ND_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_18",
      "course_id": "ND_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_19",
      "course_id": "ND_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_20",
      "course_id": "ND_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_21",
      "course_id": "ND_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_22",
      "course_id": "ND_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_23",
      "course_id": "ND_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_24",
      "course_id": "ND_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_25",
      "course_id": "ND_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_26",
      "course_id": "ND_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_27",
      "course_id": "ND_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_28",
      "course_id": "ND_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_29",
      "course_id": "ND_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_30",
      "course_id": "ND_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_31",
      "course_id": "ND_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_32",
      "course_id": "ND_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_33",
      "course_id": "ND_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_34",
      "course_id": "ND_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_35",
      "course_id": "ND_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_36",
      "course_id": "ND_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_37",
      "course_id": "ND_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_38",
      "course_id": "ND_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_39",
      "course_id": "ND_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_40",
      "course_id": "ND_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_41",
      "course_id": "ND_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_42",
      "course_id": "ND_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_43",
      "course_id": "ND_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_44",
      "course_id": "ND_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_45",
      "course_id": "ND_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_46",
      "course_id": "ND_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_47",
      "course_id": "ND_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_48",
      "course_id": "ND_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_49",
      "course_id": "ND_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "ND_PEVO_PREP_50",
      "course_id": "ND_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "OH_PEVO_PREP": [
    {
      "id": "OH_PEVO_PREP_1",
      "course_id": "OH_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Ohio?",
      "option_a": "Utah DOT Permit Office",
      "option_b": "NH DOT Permit Office",
      "option_c": "Ohio DOT Permit Office",
      "option_d": "Colorado DOT Oversize Permits",
      "correct_answer": "C",
      "explanation": "Per Ohio's current course data: Ohio DOT Permit Office"
    },
    {
      "id": "OH_PEVO_PREP_2",
      "course_id": "OH_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Ohio require to legally operate as an escort vehicle operator?",
      "option_a": "8-State Uniform",
      "option_b": "NY Standalone ONLY",
      "option_c": "State Specific",
      "option_d": "PPCA Required",
      "correct_answer": "C",
      "explanation": "Per Ohio's current course data: State Specific"
    },
    {
      "id": "OH_PEVO_PREP_3",
      "course_id": "OH_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Ohio?",
      "option_a": "OVERSIZE LOAD - yellow, standard federal spec",
      "option_b": "OVERSIZE LOAD - 5ft x 12in, yellow",
      "option_c": "OVERSIZE LOAD - standard yellow spec",
      "option_d": "OVERSIZE LOAD - yellow, standard 5ft x 12in",
      "correct_answer": "B",
      "explanation": "Per Ohio's current course data: OVERSIZE LOAD - 5ft x 12in, yellow"
    },
    {
      "id": "OH_PEVO_PREP_4",
      "course_id": "OH_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Ohio?",
      "option_a": "Amber SAE Class 1, minimum 35W",
      "option_b": "Amber SAE Class 1 strobe, front and rear",
      "option_c": "Amber strobe, Class 1 rated, mounted highest point of vehicle",
      "option_d": "Amber Class 1 strobe front and rear",
      "correct_answer": "A",
      "explanation": "Per Ohio's current course data: Amber SAE Class 1, minimum 35W"
    },
    {
      "id": "OH_PEVO_PREP_5",
      "course_id": "OH_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Ohio?",
      "option_a": "Paddle, fire extinguisher, safety vest",
      "option_b": "Paddle, 3 lb extinguisher, cones",
      "option_c": "Paddle, 3 lb extinguisher, vest",
      "option_d": "Paddle, extinguisher",
      "correct_answer": "B",
      "explanation": "Per Ohio's current course data: Paddle, 3 lb extinguisher, cones"
    },
    {
      "id": "OH_PEVO_PREP_6",
      "course_id": "OH_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Ohio, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\", height over 13'6\", or length over 65 ft",
      "option_b": "Width over 8'6\" OR height over 14'0\" on most highways",
      "option_c": "Width over 8'6\" or height over 13'6\"",
      "option_d": "Width over 8'6\" or height over 14'0\"",
      "correct_answer": "C",
      "explanation": "Per Ohio's current course data: Width over 8'6\" or height over 13'6\""
    },
    {
      "id": "OH_PEVO_PREP_7",
      "course_id": "OH_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Ohio?",
      "option_a": "16'0\"",
      "option_b": "12'0\"",
      "option_c": "14'6\"",
      "option_d": "14'0\"",
      "correct_answer": "C",
      "explanation": "Per Ohio's current course data: 14'6\""
    },
    {
      "id": "OH_PEVO_PREP_8",
      "course_id": "OH_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Ohio?",
      "option_a": "15'6\"",
      "option_b": "14'6\"",
      "option_c": "13'6\"",
      "option_d": "18'0\"",
      "correct_answer": "B",
      "explanation": "Per Ohio's current course data: 14'6\""
    },
    {
      "id": "OH_PEVO_PREP_9",
      "course_id": "OH_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Ohio's night travel status for oversize permitted moves?",
      "option_a": "Restricted",
      "option_b": "Always fully prohibited, no exceptions",
      "option_c": "w/ lighting",
      "option_d": "Allowed",
      "correct_answer": "D",
      "explanation": "Per Ohio's current course data: Allowed"
    },
    {
      "id": "OH_PEVO_PREP_10",
      "course_id": "OH_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Ohio?",
      "option_a": "Same as standard minimum — no separate night-ops tier specified",
      "option_b": "$500K CSL minimum",
      "option_c": "$1M CSL minimum",
      "option_d": "$750K CSL minimum",
      "correct_answer": "D",
      "explanation": "Per Ohio's current course data: $750K CSL minimum"
    },
    {
      "id": "OH_PEVO_PREP_11",
      "course_id": "OH_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Ohio?",
      "option_a": "$1M CSL",
      "option_b": "$10,000 liability",
      "option_c": "$500K CSL",
      "option_d": "$750K CSL",
      "correct_answer": "D",
      "explanation": "Per Ohio's current course data: $750K CSL"
    },
    {
      "id": "OH_PEVO_PREP_12",
      "course_id": "OH_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Ohio belong to for escort operator requirements?",
      "option_a": "Stand-Alone",
      "option_b": "Standalone",
      "option_c": "Remaining",
      "option_d": "8-State",
      "correct_answer": "C",
      "explanation": "Per Ohio's current course data: Remaining"
    },
    {
      "id": "OH_PEVO_PREP_13",
      "course_id": "OH_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Ohio-specific rule or red flag operators must know?",
      "option_a": "Large agricultural equipment moves are common. Spring weight restrictions apply on all secondary roads.",
      "option_b": "Ohio does not participate in PEVO reciprocity. Own state cert required. Columbus and Cleveland metros have restricted hours.",
      "option_c": "Mountain routes require additional permits. I-70 mountain corridor has weight and escort restrictions year-round.",
      "option_d": "8-State group. Mountain canyon routes (I-15, US-89) have seasonal restrictions. Salt Lake metro restricted during major events.",
      "correct_answer": "B",
      "explanation": "Per Ohio's current course data: Ohio does not participate in PEVO reciprocity. Own state cert required. Columbus and Cleveland metros have restricted hours."
    },
    {
      "id": "OH_PEVO_PREP_14",
      "course_id": "OH_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Ohio?",
      "option_a": "10'0\"",
      "option_b": "8'6\" (standard)",
      "option_c": "6'0\"",
      "option_d": "There is no standard width threshold",
      "correct_answer": "B",
      "explanation": "Per Ohio's current course data: 8'6\" (standard)"
    },
    {
      "id": "OH_PEVO_PREP_15",
      "course_id": "OH_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Ohio?",
      "option_a": "13'6\" (standard)",
      "option_b": "There is no standard height threshold",
      "option_c": "15'0\"",
      "option_d": "10'0\"",
      "correct_answer": "A",
      "explanation": "Per Ohio's current course data: 13'6\" (standard)"
    },
    {
      "id": "OH_PEVO_PREP_16",
      "course_id": "OH_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_17",
      "course_id": "OH_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_18",
      "course_id": "OH_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_19",
      "course_id": "OH_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_20",
      "course_id": "OH_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_21",
      "course_id": "OH_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_22",
      "course_id": "OH_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_23",
      "course_id": "OH_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_24",
      "course_id": "OH_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_25",
      "course_id": "OH_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_26",
      "course_id": "OH_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_27",
      "course_id": "OH_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_28",
      "course_id": "OH_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_29",
      "course_id": "OH_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_30",
      "course_id": "OH_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_31",
      "course_id": "OH_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_32",
      "course_id": "OH_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_33",
      "course_id": "OH_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_34",
      "course_id": "OH_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_35",
      "course_id": "OH_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_36",
      "course_id": "OH_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_37",
      "course_id": "OH_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_38",
      "course_id": "OH_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_39",
      "course_id": "OH_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_40",
      "course_id": "OH_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_41",
      "course_id": "OH_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_42",
      "course_id": "OH_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_43",
      "course_id": "OH_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_44",
      "course_id": "OH_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_45",
      "course_id": "OH_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_46",
      "course_id": "OH_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_47",
      "course_id": "OH_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_48",
      "course_id": "OH_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_49",
      "course_id": "OH_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OH_PEVO_PREP_50",
      "course_id": "OH_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "OK_PEVO_PREP": [
    {
      "id": "OK_PEVO_PREP_1",
      "course_id": "OK_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Oklahoma?",
      "option_a": "ND DOT Motor Carrier Services",
      "option_b": "Utah DOT Permit Office",
      "option_c": "Alabama DOT Permit Office",
      "option_d": "Oklahoma DOT Permits",
      "correct_answer": "D",
      "explanation": "Per Oklahoma's current course data: Oklahoma DOT Permits"
    },
    {
      "id": "OK_PEVO_PREP_2",
      "course_id": "OK_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Oklahoma require to legally operate as an escort vehicle operator?",
      "option_a": "PPCA Required",
      "option_b": "NY Standalone ONLY",
      "option_c": "State Specific",
      "option_d": "8-State Uniform",
      "correct_answer": "C",
      "explanation": "Per Oklahoma's current course data: State Specific"
    },
    {
      "id": "OK_PEVO_PREP_3",
      "course_id": "OK_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Oklahoma?",
      "option_a": "OVERSIZE LOAD - yellow, 5ft x 12in",
      "option_b": "OVERSIZE LOAD - yellow, 5ft x 10in",
      "option_c": "OVERSIZE LOAD - yellow, reflective, 5ft x 12in",
      "option_d": "OVERSIZE LOAD - yellow, standard spec",
      "correct_answer": "D",
      "explanation": "Per Oklahoma's current course data: OVERSIZE LOAD - yellow, standard spec"
    },
    {
      "id": "OK_PEVO_PREP_4",
      "course_id": "OK_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Oklahoma?",
      "option_a": "Amber Class 1 or 2 - front and rear required",
      "option_b": "SAE Class 1 amber 360-degree strobe, plus headlights on",
      "option_c": "Amber Class 1 strobe",
      "option_d": "Amber Class 1",
      "correct_answer": "C",
      "explanation": "Per Oklahoma's current course data: Amber Class 1 strobe"
    },
    {
      "id": "OK_PEVO_PREP_5",
      "course_id": "OK_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Oklahoma?",
      "option_a": "Paddle, extinguisher",
      "option_b": "Paddle, 2.5 lb extinguisher, flares",
      "option_c": "Paddle, 3 lb extinguisher, cones",
      "option_d": "Paddle, 5 lb extinguisher, flares, safety vest",
      "correct_answer": "A",
      "explanation": "Per Oklahoma's current course data: Paddle, extinguisher"
    },
    {
      "id": "OK_PEVO_PREP_6",
      "course_id": "OK_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Oklahoma, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 13'0\" requires escort",
      "option_b": "Width over 8'6\" or height over 14'0\" triggers mandatory escort",
      "option_c": "Width over 8'6\" or height over 13'6\"",
      "option_d": "Width over 9'0\" or height over 15'0\"",
      "correct_answer": "C",
      "explanation": "Per Oklahoma's current course data: Width over 8'6\" or height over 13'6\""
    },
    {
      "id": "OK_PEVO_PREP_7",
      "course_id": "OK_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Oklahoma?",
      "option_a": "14'6\"",
      "option_b": "14'0\"",
      "option_c": "12'0\"",
      "option_d": "16'0\"",
      "correct_answer": "A",
      "explanation": "Per Oklahoma's current course data: 14'6\""
    },
    {
      "id": "OK_PEVO_PREP_8",
      "course_id": "OK_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Oklahoma?",
      "option_a": "15'6\"",
      "option_b": "14'6\"",
      "option_c": "16'0\"",
      "option_d": "14'0\"",
      "correct_answer": "B",
      "explanation": "Per Oklahoma's current course data: 14'6\""
    },
    {
      "id": "OK_PEVO_PREP_9",
      "course_id": "OK_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Oklahoma's night travel status for oversize permitted moves?",
      "option_a": "Always fully prohibited, no exceptions",
      "option_b": "Allowed",
      "option_c": "Restricted",
      "option_d": "w/ lighting",
      "correct_answer": "B",
      "explanation": "Per Oklahoma's current course data: Allowed"
    },
    {
      "id": "OK_PEVO_PREP_10",
      "course_id": "OK_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Oklahoma?",
      "option_a": "$1M CSL minimum",
      "option_b": "Same as standard minimum — no separate night-ops tier specified",
      "option_c": "$500K CSL minimum",
      "option_d": "$750K CSL minimum",
      "correct_answer": "D",
      "explanation": "Per Oklahoma's current course data: $750K CSL minimum"
    },
    {
      "id": "OK_PEVO_PREP_11",
      "course_id": "OK_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Oklahoma?",
      "option_a": "$500K CSL",
      "option_b": "$1M CSL",
      "option_c": "$10,000 liability",
      "option_d": "$750K CSL",
      "correct_answer": "D",
      "explanation": "Per Oklahoma's current course data: $750K CSL"
    },
    {
      "id": "OK_PEVO_PREP_12",
      "course_id": "OK_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Oklahoma belong to for escort operator requirements?",
      "option_a": "Remaining",
      "option_b": "Stand-Alone",
      "option_c": "14 PEVO",
      "option_d": "NY Standalone",
      "correct_answer": "A",
      "explanation": "Per Oklahoma's current course data: Remaining"
    },
    {
      "id": "OK_PEVO_PREP_13",
      "course_id": "OK_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Oklahoma-specific rule or red flag operators must know?",
      "option_a": "Baltimore metro and Chesapeake Bay Bridge have special permit procedures. Bay Bridge requires advance notice of 48 hours.",
      "option_b": "NJ requires $1M insurance. NJ Turnpike and Garden State Parkway have separate permit procedures. Path and Lincoln tunnel approaches have height restrictions.",
      "option_c": "Oklahoma has high wind conditions on open highways. Tornado season (April-June) may result in permit holds.",
      "option_d": "Rhode Island is the smallest state. Most routes pass through Providence metro. Night travel restricted to midnight-5am only with variance.",
      "correct_answer": "C",
      "explanation": "Per Oklahoma's current course data: Oklahoma has high wind conditions on open highways. Tornado season (April-June) may result in permit holds."
    },
    {
      "id": "OK_PEVO_PREP_14",
      "course_id": "OK_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Oklahoma?",
      "option_a": "10'0\"",
      "option_b": "8'6\" (standard)",
      "option_c": "6'0\"",
      "option_d": "There is no standard width threshold",
      "correct_answer": "B",
      "explanation": "Per Oklahoma's current course data: 8'6\" (standard)"
    },
    {
      "id": "OK_PEVO_PREP_15",
      "course_id": "OK_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Oklahoma?",
      "option_a": "There is no standard height threshold",
      "option_b": "10'0\"",
      "option_c": "13'6\" (standard)",
      "option_d": "15'0\"",
      "correct_answer": "C",
      "explanation": "Per Oklahoma's current course data: 13'6\" (standard)"
    },
    {
      "id": "OK_PEVO_PREP_16",
      "course_id": "OK_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_17",
      "course_id": "OK_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_18",
      "course_id": "OK_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_19",
      "course_id": "OK_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_20",
      "course_id": "OK_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_21",
      "course_id": "OK_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_22",
      "course_id": "OK_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_23",
      "course_id": "OK_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_24",
      "course_id": "OK_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_25",
      "course_id": "OK_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_26",
      "course_id": "OK_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_27",
      "course_id": "OK_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_28",
      "course_id": "OK_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_29",
      "course_id": "OK_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_30",
      "course_id": "OK_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_31",
      "course_id": "OK_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_32",
      "course_id": "OK_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_33",
      "course_id": "OK_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_34",
      "course_id": "OK_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_35",
      "course_id": "OK_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_36",
      "course_id": "OK_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_37",
      "course_id": "OK_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_38",
      "course_id": "OK_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_39",
      "course_id": "OK_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_40",
      "course_id": "OK_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_41",
      "course_id": "OK_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_42",
      "course_id": "OK_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_43",
      "course_id": "OK_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_44",
      "course_id": "OK_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_45",
      "course_id": "OK_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_46",
      "course_id": "OK_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_47",
      "course_id": "OK_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_48",
      "course_id": "OK_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_49",
      "course_id": "OK_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OK_PEVO_PREP_50",
      "course_id": "OK_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "OR_PEVO_PREP": [
    {
      "id": "OR_PEVO_PREP_1",
      "course_id": "OR_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Oregon?",
      "option_a": "Nebraska Dept of Roads Permits",
      "option_b": "Mississippi DOT Permits",
      "option_c": "Kansas DOT Permitting",
      "option_d": "Oregon DOT Permits Unit",
      "correct_answer": "D",
      "explanation": "Per Oregon's current course data: Oregon DOT Permits Unit"
    },
    {
      "id": "OR_PEVO_PREP_2",
      "course_id": "OR_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Oregon require to legally operate as an escort vehicle operator?",
      "option_a": "PPCA Required",
      "option_b": "State Specific",
      "option_c": "8-State Uniform",
      "option_d": "PEVO Cert",
      "correct_answer": "A",
      "explanation": "Per Oregon's current course data: PPCA Required"
    },
    {
      "id": "OR_PEVO_PREP_3",
      "course_id": "OR_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Oregon?",
      "option_a": "OVERSIZE LOAD - 5ft x 10in, reflective yellow, black letters",
      "option_b": "OVERSIZE LOAD - yellow, reflective, 5ft x 12in",
      "option_c": "OVERSIZE LOAD - 5ft x 12in, bright yellow, 8-inch black letters, 1-inch brush stroke",
      "option_d": "OVERSIZE LOAD - 5ft x 12in, yellow, black 8-inch letters",
      "correct_answer": "B",
      "explanation": "Per Oregon's current course data: OVERSIZE LOAD - yellow, reflective, 5ft x 12in"
    },
    {
      "id": "OR_PEVO_PREP_4",
      "course_id": "OR_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Oregon?",
      "option_a": "Amber Class 1, front and rear",
      "option_b": "SAE Class 1 amber, front and rear required",
      "option_c": "Amber strobe Class 1, visible from 500 ft",
      "option_d": "Amber Class 1",
      "correct_answer": "B",
      "explanation": "Per Oregon's current course data: SAE Class 1 amber, front and rear required"
    },
    {
      "id": "OR_PEVO_PREP_5",
      "course_id": "OR_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Oregon?",
      "option_a": "18-inch paddle, 3 lb extinguisher, cones",
      "option_b": "Paddle, extinguisher, safety triangles",
      "option_c": "Paddle, 3 lb extinguisher, cones",
      "option_d": "Paddle, 5 lb extinguisher, flares, safety vest",
      "correct_answer": "D",
      "explanation": "Per Oregon's current course data: Paddle, 5 lb extinguisher, flares, safety vest"
    },
    {
      "id": "OR_PEVO_PREP_6",
      "course_id": "OR_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Oregon, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 13'0\"",
      "option_b": "Width over 8'6\" or height over 14'0\" triggers mandatory escort",
      "option_c": "Width over 8'6\" or height over 14'0\"",
      "option_d": "Width over 8'6\" or height over 13'6\" requires escort",
      "correct_answer": "C",
      "explanation": "Per Oregon's current course data: Width over 8'6\" or height over 14'0\""
    },
    {
      "id": "OR_PEVO_PREP_7",
      "course_id": "OR_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Oregon?",
      "option_a": "14'0\"",
      "option_b": "14'6\"",
      "option_c": "12'0\"",
      "option_d": "16'0\"",
      "correct_answer": "B",
      "explanation": "Per Oregon's current course data: 14'6\""
    },
    {
      "id": "OR_PEVO_PREP_8",
      "course_id": "OR_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Oregon?",
      "option_a": "15'6\"",
      "option_b": "14'0\"",
      "option_c": "15'0\"",
      "option_d": "14'6\"",
      "correct_answer": "A",
      "explanation": "Per Oregon's current course data: 15'6\""
    },
    {
      "id": "OR_PEVO_PREP_9",
      "course_id": "OR_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Oregon's night travel status for oversize permitted moves?",
      "option_a": "Restricted",
      "option_b": "w/ lighting",
      "option_c": "Always fully prohibited, no exceptions",
      "option_d": "Allowed",
      "correct_answer": "A",
      "explanation": "Per Oregon's current course data: Restricted"
    },
    {
      "id": "OR_PEVO_PREP_10",
      "course_id": "OR_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Oregon?",
      "option_a": "$1M CSL minimum",
      "option_b": "Same as standard minimum — no separate night-ops tier specified",
      "option_c": "$750K CSL minimum",
      "option_d": "$500K CSL minimum",
      "correct_answer": "A",
      "explanation": "Per Oregon's current course data: $1M CSL minimum"
    },
    {
      "id": "OR_PEVO_PREP_11",
      "course_id": "OR_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Oregon?",
      "option_a": "$1M CSL",
      "option_b": "$750K CSL",
      "option_c": "$10,000 liability",
      "option_d": "$500K CSL",
      "correct_answer": "A",
      "explanation": "Per Oregon's current course data: $1M CSL"
    },
    {
      "id": "OR_PEVO_PREP_12",
      "course_id": "OR_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Oregon belong to for escort operator requirements?",
      "option_a": "Remaining",
      "option_b": "8-State",
      "option_c": "Stand-Alone",
      "option_d": "14 PEVO",
      "correct_answer": "C",
      "explanation": "Per Oregon's current course data: Stand-Alone"
    },
    {
      "id": "OR_PEVO_PREP_13",
      "course_id": "OR_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Oregon-specific rule or red flag operators must know?",
      "option_a": "Oregon requires state-specific cert AND $1M insurance. Portland metro restricted windows. Coast routes have severe weather seasonal restrictions Oct-Mar.",
      "option_b": "High wind and blizzard conditions common Oct-April. Wind farm equipment moves are a major market in SD.",
      "option_c": "Delaware is a small state with high bridge density. Bridge strike liability is strictly enforced under state code.",
      "option_d": "PEVO reciprocity state. PPCA cert accepted. Carry original cert plus trip permit at all times.",
      "correct_answer": "A",
      "explanation": "Per Oregon's current course data: Oregon requires state-specific cert AND $1M insurance. Portland metro restricted windows. Coast routes have severe weather seasonal restrictions Oct-Mar."
    },
    {
      "id": "OR_PEVO_PREP_14",
      "course_id": "OR_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Oregon?",
      "option_a": "There is no standard width threshold",
      "option_b": "10'0\"",
      "option_c": "8'6\" (standard)",
      "option_d": "6'0\"",
      "correct_answer": "C",
      "explanation": "Per Oregon's current course data: 8'6\" (standard)"
    },
    {
      "id": "OR_PEVO_PREP_15",
      "course_id": "OR_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Oregon?",
      "option_a": "15'0\"",
      "option_b": "There is no standard height threshold",
      "option_c": "13'6\" (standard)",
      "option_d": "10'0\"",
      "correct_answer": "C",
      "explanation": "Per Oregon's current course data: 13'6\" (standard)"
    },
    {
      "id": "OR_PEVO_PREP_16",
      "course_id": "OR_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_17",
      "course_id": "OR_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_18",
      "course_id": "OR_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_19",
      "course_id": "OR_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_20",
      "course_id": "OR_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_21",
      "course_id": "OR_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_22",
      "course_id": "OR_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_23",
      "course_id": "OR_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_24",
      "course_id": "OR_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_25",
      "course_id": "OR_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_26",
      "course_id": "OR_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_27",
      "course_id": "OR_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_28",
      "course_id": "OR_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_29",
      "course_id": "OR_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_30",
      "course_id": "OR_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_31",
      "course_id": "OR_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_32",
      "course_id": "OR_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_33",
      "course_id": "OR_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_34",
      "course_id": "OR_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_35",
      "course_id": "OR_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_36",
      "course_id": "OR_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_37",
      "course_id": "OR_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_38",
      "course_id": "OR_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_39",
      "course_id": "OR_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_40",
      "course_id": "OR_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_41",
      "course_id": "OR_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_42",
      "course_id": "OR_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_43",
      "course_id": "OR_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_44",
      "course_id": "OR_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_45",
      "course_id": "OR_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_46",
      "course_id": "OR_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_47",
      "course_id": "OR_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_48",
      "course_id": "OR_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_49",
      "course_id": "OR_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "OR_PEVO_PREP_50",
      "course_id": "OR_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "PA_PEVO_PREP": [
    {
      "id": "PA_PEVO_PREP_1",
      "course_id": "PA_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Pennsylvania?",
      "option_a": "PennDOT Oversize Permits",
      "option_b": "Colorado DOT Oversize Permits",
      "option_c": "Illinois DOT Bureau of Permits",
      "option_d": "Oklahoma DOT Permits",
      "correct_answer": "A",
      "explanation": "Per Pennsylvania's current course data: PennDOT Oversize Permits"
    },
    {
      "id": "PA_PEVO_PREP_2",
      "course_id": "PA_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Pennsylvania require to legally operate as an escort vehicle operator?",
      "option_a": "State Specific",
      "option_b": "PPCA Required",
      "option_c": "8-State Uniform",
      "option_d": "PEVO Cert",
      "correct_answer": "A",
      "explanation": "Per Pennsylvania's current course data: State Specific"
    },
    {
      "id": "PA_PEVO_PREP_3",
      "course_id": "PA_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Pennsylvania?",
      "option_a": "OVERSIZE LOAD - 5ft x 12in, yellow, black letters",
      "option_b": "OVERSIZE LOAD - fluorescent yellow, 5ft x 12in",
      "option_c": "OVERSIZE LOAD - yellow, 5ft x 12in, reflective",
      "option_d": "OVERSIZE LOAD - 5ft x 12in yellow, reflective",
      "correct_answer": "C",
      "explanation": "Per Pennsylvania's current course data: OVERSIZE LOAD - yellow, 5ft x 12in, reflective"
    },
    {
      "id": "PA_PEVO_PREP_4",
      "course_id": "PA_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Pennsylvania?",
      "option_a": "SAE Class 1 amber 360-degree strobe, plus headlights on",
      "option_b": "Amber Class 1 strobe, front and rear",
      "option_c": "SAE Class 1 amber, front and rear required",
      "option_d": "SAE Class 1 amber, 360-degree visibility, minimum 35W output",
      "correct_answer": "B",
      "explanation": "Per Pennsylvania's current course data: Amber Class 1 strobe, front and rear"
    },
    {
      "id": "PA_PEVO_PREP_5",
      "course_id": "PA_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Pennsylvania?",
      "option_a": "Paddle, 5 lb extinguisher, flares, cones, first aid kit",
      "option_b": "Paddle, 3 lb extinguisher, flares",
      "option_c": "18-inch stop/slow paddle, fire extinguisher",
      "option_d": "Paddle, 5 lb extinguisher, 3 road flares, safety vest",
      "correct_answer": "B",
      "explanation": "Per Pennsylvania's current course data: Paddle, 3 lb extinguisher, flares"
    },
    {
      "id": "PA_PEVO_PREP_6",
      "course_id": "PA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Pennsylvania, when is an escort legally REQUIRED?",
      "option_a": "Any load exceeding 8'6\" width, 13'6\" height, or 80,000 lbs GVW",
      "option_b": "Width over 12'0\" or height over 14'0\"",
      "option_c": "Width over 8'6\" or height over 13'0\"",
      "option_d": "Width exceeding 8'6\" requires lead escort; height over 15'0\" requires height pole",
      "correct_answer": "C",
      "explanation": "Per Pennsylvania's current course data: Width over 8'6\" or height over 13'0\""
    },
    {
      "id": "PA_PEVO_PREP_7",
      "course_id": "PA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Pennsylvania?",
      "option_a": "14'0\"",
      "option_b": "14'6\"",
      "option_c": "16'0\"",
      "option_d": "12'0\"",
      "correct_answer": "A",
      "explanation": "Per Pennsylvania's current course data: 14'0\""
    },
    {
      "id": "PA_PEVO_PREP_8",
      "course_id": "PA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Pennsylvania?",
      "option_a": "14'0\"",
      "option_b": "14'6\"",
      "option_c": "15'6\"",
      "option_d": "13'6\"",
      "correct_answer": "D",
      "explanation": "Per Pennsylvania's current course data: 13'6\""
    },
    {
      "id": "PA_PEVO_PREP_9",
      "course_id": "PA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Pennsylvania's night travel status for oversize permitted moves?",
      "option_a": "Restricted",
      "option_b": "Allowed",
      "option_c": "w/ lighting",
      "option_d": "Always fully prohibited, no exceptions",
      "correct_answer": "A",
      "explanation": "Per Pennsylvania's current course data: Restricted"
    },
    {
      "id": "PA_PEVO_PREP_10",
      "course_id": "PA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Pennsylvania?",
      "option_a": "Same as standard minimum — no separate night-ops tier specified",
      "option_b": "$750K CSL minimum",
      "option_c": "$500K CSL minimum",
      "option_d": "$1M CSL minimum",
      "correct_answer": "B",
      "explanation": "Per Pennsylvania's current course data: $750K CSL minimum"
    },
    {
      "id": "PA_PEVO_PREP_11",
      "course_id": "PA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Pennsylvania?",
      "option_a": "$1M CSL",
      "option_b": "$10,000 liability",
      "option_c": "$750K CSL",
      "option_d": "$500K CSL",
      "correct_answer": "C",
      "explanation": "Per Pennsylvania's current course data: $750K CSL"
    },
    {
      "id": "PA_PEVO_PREP_12",
      "course_id": "PA_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Pennsylvania belong to for escort operator requirements?",
      "option_a": "Remaining",
      "option_b": "14 PEVO",
      "option_c": "NY Standalone",
      "option_d": "Stand-Alone",
      "correct_answer": "A",
      "explanation": "Per Pennsylvania's current course data: Remaining"
    },
    {
      "id": "PA_PEVO_PREP_13",
      "course_id": "PA_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Pennsylvania-specific rule or red flag operators must know?",
      "option_a": "Tennessee does not participate in PEVO reciprocity. Nashville metro has restricted permit windows. Mountain routes require special permits.",
      "option_b": "PEVO reciprocity. 15'0\" height limit. Port of Charleston generates high oversize move volume.",
      "option_c": "Pennsylvania has numerous historic bridges with strict weight limits. Turnpike requires advance notification. Philadelphia metro has complex permit routing.",
      "option_d": "Iowa is in the 8-State group. Spring road restrictions (Feb-May) limit weights on paved roads annually.",
      "correct_answer": "C",
      "explanation": "Per Pennsylvania's current course data: Pennsylvania has numerous historic bridges with strict weight limits. Turnpike requires advance notification. Philadelphia metro has complex permit routing."
    },
    {
      "id": "PA_PEVO_PREP_14",
      "course_id": "PA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Pennsylvania?",
      "option_a": "There is no standard width threshold",
      "option_b": "10'0\"",
      "option_c": "6'0\"",
      "option_d": "8'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per Pennsylvania's current course data: 8'6\" (standard)"
    },
    {
      "id": "PA_PEVO_PREP_15",
      "course_id": "PA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Pennsylvania?",
      "option_a": "15'0\"",
      "option_b": "There is no standard height threshold",
      "option_c": "13'6\" (standard)",
      "option_d": "10'0\"",
      "correct_answer": "C",
      "explanation": "Per Pennsylvania's current course data: 13'6\" (standard)"
    },
    {
      "id": "PA_PEVO_PREP_16",
      "course_id": "PA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_17",
      "course_id": "PA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_18",
      "course_id": "PA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_19",
      "course_id": "PA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_20",
      "course_id": "PA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_21",
      "course_id": "PA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_22",
      "course_id": "PA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_23",
      "course_id": "PA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_24",
      "course_id": "PA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_25",
      "course_id": "PA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_26",
      "course_id": "PA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_27",
      "course_id": "PA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_28",
      "course_id": "PA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_29",
      "course_id": "PA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_30",
      "course_id": "PA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_31",
      "course_id": "PA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_32",
      "course_id": "PA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_33",
      "course_id": "PA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_34",
      "course_id": "PA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_35",
      "course_id": "PA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_36",
      "course_id": "PA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_37",
      "course_id": "PA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_38",
      "course_id": "PA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_39",
      "course_id": "PA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_40",
      "course_id": "PA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_41",
      "course_id": "PA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_42",
      "course_id": "PA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_43",
      "course_id": "PA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_44",
      "course_id": "PA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_45",
      "course_id": "PA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_46",
      "course_id": "PA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_47",
      "course_id": "PA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_48",
      "course_id": "PA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_49",
      "course_id": "PA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "PA_PEVO_PREP_50",
      "course_id": "PA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "RI_PEVO_PREP": [
    {
      "id": "RI_PEVO_PREP_1",
      "course_id": "RI_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Rhode Island?",
      "option_a": "RI DOT Permit Office",
      "option_b": "Kansas DOT Permitting",
      "option_c": "Alaska DOT Permit Section",
      "option_d": "California DOT Permit Office",
      "correct_answer": "A",
      "explanation": "Per Rhode Island's current course data: RI DOT Permit Office"
    },
    {
      "id": "RI_PEVO_PREP_2",
      "course_id": "RI_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Rhode Island require to legally operate as an escort vehicle operator?",
      "option_a": "8-State Uniform",
      "option_b": "State Specific",
      "option_c": "PEVO Cert",
      "option_d": "NY Standalone ONLY",
      "correct_answer": "B",
      "explanation": "Per Rhode Island's current course data: State Specific"
    },
    {
      "id": "RI_PEVO_PREP_3",
      "course_id": "RI_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Rhode Island?",
      "option_a": "OVERSIZE LOAD - 7ft x 18in, fluorescent yellow-orange, 10-inch black letters",
      "option_b": "OVERSIZE LOAD - 5ft x 12in, yellow",
      "option_c": "OVERSIZE LOAD - standard yellow spec",
      "option_d": "OVERSIZE LOAD - 5ft x 10in, reflective yellow, black letters",
      "correct_answer": "C",
      "explanation": "Per Rhode Island's current course data: OVERSIZE LOAD - standard yellow spec"
    },
    {
      "id": "RI_PEVO_PREP_4",
      "course_id": "RI_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Rhode Island?",
      "option_a": "Amber strobe, Class 1 or 2",
      "option_b": "Amber Class 1 strobe - 360 visibility at 500 ft",
      "option_c": "Amber Class 1",
      "option_d": "Amber Class 1, front and rear",
      "correct_answer": "C",
      "explanation": "Per Rhode Island's current course data: Amber Class 1"
    },
    {
      "id": "RI_PEVO_PREP_5",
      "course_id": "RI_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Rhode Island?",
      "option_a": "Paddle, 5 lb extinguisher, flares, cones, first aid kit",
      "option_b": "Paddle, extinguisher, safety triangles",
      "option_c": "Stop/slow paddle min 18in, 3 lb fire extinguisher, orange cones",
      "option_d": "Paddle, extinguisher",
      "correct_answer": "D",
      "explanation": "Per Rhode Island's current course data: Paddle, extinguisher"
    },
    {
      "id": "RI_PEVO_PREP_6",
      "course_id": "RI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Rhode Island, when is an escort legally REQUIRED?",
      "option_a": "Loads exceeding 8'6\" width or 13'6\" height require escort",
      "option_b": "Width over 8'6\", height over 13'6\", or length over 65 ft",
      "option_c": "Width over 8'6\" or height over 13'0\"",
      "option_d": "Width over 9'0\" or height over 13'6\" triggers escort requirement",
      "correct_answer": "C",
      "explanation": "Per Rhode Island's current course data: Width over 8'6\" or height over 13'0\""
    },
    {
      "id": "RI_PEVO_PREP_7",
      "course_id": "RI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Rhode Island?",
      "option_a": "14'6\"",
      "option_b": "14'0\"",
      "option_c": "16'0\"",
      "option_d": "12'0\"",
      "correct_answer": "B",
      "explanation": "Per Rhode Island's current course data: 14'0\""
    },
    {
      "id": "RI_PEVO_PREP_8",
      "course_id": "RI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Rhode Island?",
      "option_a": "18'0\"",
      "option_b": "13'6\"",
      "option_c": "14'0\"",
      "option_d": "16'0\"",
      "correct_answer": "B",
      "explanation": "Per Rhode Island's current course data: 13'6\""
    },
    {
      "id": "RI_PEVO_PREP_9",
      "course_id": "RI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Rhode Island's night travel status for oversize permitted moves?",
      "option_a": "Restricted",
      "option_b": "Allowed",
      "option_c": "w/ lighting",
      "option_d": "Always fully prohibited, no exceptions",
      "correct_answer": "A",
      "explanation": "Per Rhode Island's current course data: Restricted"
    },
    {
      "id": "RI_PEVO_PREP_10",
      "course_id": "RI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Rhode Island?",
      "option_a": "Same as standard minimum — no separate night-ops tier specified",
      "option_b": "$750K CSL minimum",
      "option_c": "$1M CSL minimum",
      "option_d": "$500K CSL minimum",
      "correct_answer": "B",
      "explanation": "Per Rhode Island's current course data: $750K CSL minimum"
    },
    {
      "id": "RI_PEVO_PREP_11",
      "course_id": "RI_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Rhode Island?",
      "option_a": "$1M CSL",
      "option_b": "$500K CSL",
      "option_c": "$10,000 liability",
      "option_d": "$750K CSL",
      "correct_answer": "D",
      "explanation": "Per Rhode Island's current course data: $750K CSL"
    },
    {
      "id": "RI_PEVO_PREP_12",
      "course_id": "RI_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Rhode Island belong to for escort operator requirements?",
      "option_a": "Stand-Alone",
      "option_b": "Standalone",
      "option_c": "Remaining",
      "option_d": "8-State",
      "correct_answer": "C",
      "explanation": "Per Rhode Island's current course data: Remaining"
    },
    {
      "id": "RI_PEVO_PREP_13",
      "course_id": "RI_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Rhode Island-specific rule or red flag operators must know?",
      "option_a": "8-State group. Mountain canyon routes (I-15, US-89) have seasonal restrictions. Salt Lake metro restricted during major events.",
      "option_b": "Florida is a PEVO reciprocity state. PPCA cert accepted. Florida requires PEVO + Defensive Driving certification for operators. Florida has significant bridge height restrictions due to coastal infrastructure. Summer thunderstorm season (June-September) frequently halts permitted moves.",
      "option_c": "Michigan has extensive bridge restrictions due to aging infrastructure. Upper Peninsula routes have seasonal weight limits.",
      "option_d": "Rhode Island is the smallest state. Most routes pass through Providence metro. Night travel restricted to midnight-5am only with variance.",
      "correct_answer": "D",
      "explanation": "Per Rhode Island's current course data: Rhode Island is the smallest state. Most routes pass through Providence metro. Night travel restricted to midnight-5am only with variance."
    },
    {
      "id": "RI_PEVO_PREP_14",
      "course_id": "RI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Rhode Island?",
      "option_a": "10'0\"",
      "option_b": "6'0\"",
      "option_c": "8'6\" (standard)",
      "option_d": "There is no standard width threshold",
      "correct_answer": "C",
      "explanation": "Per Rhode Island's current course data: 8'6\" (standard)"
    },
    {
      "id": "RI_PEVO_PREP_15",
      "course_id": "RI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Rhode Island?",
      "option_a": "15'0\"",
      "option_b": "There is no standard height threshold",
      "option_c": "13'6\" (standard)",
      "option_d": "10'0\"",
      "correct_answer": "C",
      "explanation": "Per Rhode Island's current course data: 13'6\" (standard)"
    },
    {
      "id": "RI_PEVO_PREP_16",
      "course_id": "RI_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_17",
      "course_id": "RI_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_18",
      "course_id": "RI_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_19",
      "course_id": "RI_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_20",
      "course_id": "RI_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_21",
      "course_id": "RI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_22",
      "course_id": "RI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_23",
      "course_id": "RI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_24",
      "course_id": "RI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_25",
      "course_id": "RI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_26",
      "course_id": "RI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_27",
      "course_id": "RI_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_28",
      "course_id": "RI_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_29",
      "course_id": "RI_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_30",
      "course_id": "RI_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_31",
      "course_id": "RI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_32",
      "course_id": "RI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_33",
      "course_id": "RI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_34",
      "course_id": "RI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_35",
      "course_id": "RI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_36",
      "course_id": "RI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_37",
      "course_id": "RI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_38",
      "course_id": "RI_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_39",
      "course_id": "RI_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_40",
      "course_id": "RI_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_41",
      "course_id": "RI_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_42",
      "course_id": "RI_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_43",
      "course_id": "RI_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_44",
      "course_id": "RI_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_45",
      "course_id": "RI_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_46",
      "course_id": "RI_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_47",
      "course_id": "RI_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_48",
      "course_id": "RI_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_49",
      "course_id": "RI_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "RI_PEVO_PREP_50",
      "course_id": "RI_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "SC_PEVO_PREP": [
    {
      "id": "SC_PEVO_PREP_1",
      "course_id": "SC_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in South Carolina?",
      "option_a": "KY Transportation Cabinet Permits",
      "option_b": "Montana DOT Permit Office",
      "option_c": "ND DOT Motor Carrier Services",
      "option_d": "SC DOT Oversize Permits",
      "correct_answer": "D",
      "explanation": "Per South Carolina's current course data: SC DOT Oversize Permits"
    },
    {
      "id": "SC_PEVO_PREP_2",
      "course_id": "SC_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does South Carolina require to legally operate as an escort vehicle operator?",
      "option_a": "8-State Uniform",
      "option_b": "PPCA Required",
      "option_c": "NY Standalone ONLY",
      "option_d": "PEVO Cert",
      "correct_answer": "D",
      "explanation": "Per South Carolina's current course data: PEVO Cert"
    },
    {
      "id": "SC_PEVO_PREP_3",
      "course_id": "SC_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in South Carolina?",
      "option_a": "OVERSIZE LOAD - yellow, 5ft x 12in",
      "option_b": "OVERSIZE LOAD - 5ft x 12in, fluorescent yellow, reflective lettering",
      "option_c": "OVERSIZE LOAD - 5ft x 12in, fluorescent yellow, 8-inch black reflective letters",
      "option_d": "OVERSIZE LOAD - 5ft x 10in, yellow, SAE spec",
      "correct_answer": "A",
      "explanation": "Per South Carolina's current course data: OVERSIZE LOAD - yellow, 5ft x 12in"
    },
    {
      "id": "SC_PEVO_PREP_4",
      "course_id": "SC_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in South Carolina?",
      "option_a": "SAE Class 1 amber strobe",
      "option_b": "Class 1 amber strobe - must be visible 500 ft",
      "option_c": "Amber strobe, Class 1 or 2",
      "option_d": "SAE Class 1 amber, 360-degree visibility, minimum 35W output",
      "correct_answer": "A",
      "explanation": "Per South Carolina's current course data: SAE Class 1 amber strobe"
    },
    {
      "id": "SC_PEVO_PREP_5",
      "course_id": "SC_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in South Carolina?",
      "option_a": "Paddle, extinguisher",
      "option_b": "Paddle, 5 lb extinguisher, 3 road flares, safety vest",
      "option_c": "18-inch stop/slow paddle, 3 lb fire extinguisher",
      "option_d": "Paddle, 5 lb extinguisher, flares, cones",
      "correct_answer": "A",
      "explanation": "Per South Carolina's current course data: Paddle, extinguisher"
    },
    {
      "id": "SC_PEVO_PREP_6",
      "course_id": "SC_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In South Carolina, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 13'6\" requires escort",
      "option_b": "Width over 8'6\" or height over 13'6\"",
      "option_c": "Width over 9'0\" or height over 13'6\" triggers escort requirement",
      "option_d": "Width over 8'6\" or height over 14'0\"",
      "correct_answer": "B",
      "explanation": "Per South Carolina's current course data: Width over 8'6\" or height over 13'6\""
    },
    {
      "id": "SC_PEVO_PREP_7",
      "course_id": "SC_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in South Carolina?",
      "option_a": "14'6\"",
      "option_b": "16'0\"",
      "option_c": "14'0\"",
      "option_d": "12'0\"",
      "correct_answer": "C",
      "explanation": "Per South Carolina's current course data: 14'0\""
    },
    {
      "id": "SC_PEVO_PREP_8",
      "course_id": "SC_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in South Carolina?",
      "option_a": "16'0\"",
      "option_b": "14'0\"",
      "option_c": "14'6\"",
      "option_d": "15'0\"",
      "correct_answer": "D",
      "explanation": "Per South Carolina's current course data: 15'0\""
    },
    {
      "id": "SC_PEVO_PREP_9",
      "course_id": "SC_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is South Carolina's night travel status for oversize permitted moves?",
      "option_a": "Always fully prohibited, no exceptions",
      "option_b": "w/ lighting",
      "option_c": "Allowed",
      "option_d": "Restricted",
      "correct_answer": "B",
      "explanation": "Per South Carolina's current course data: w/ lighting"
    },
    {
      "id": "SC_PEVO_PREP_10",
      "course_id": "SC_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in South Carolina?",
      "option_a": "$500K CSL minimum",
      "option_b": "Same as standard minimum — no separate night-ops tier specified",
      "option_c": "$750K CSL minimum",
      "option_d": "$1M CSL minimum",
      "correct_answer": "C",
      "explanation": "Per South Carolina's current course data: $750K CSL minimum"
    },
    {
      "id": "SC_PEVO_PREP_11",
      "course_id": "SC_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in South Carolina?",
      "option_a": "$750K CSL",
      "option_b": "$1M CSL",
      "option_c": "$10,000 liability",
      "option_d": "$500K CSL",
      "correct_answer": "A",
      "explanation": "Per South Carolina's current course data: $750K CSL"
    },
    {
      "id": "SC_PEVO_PREP_12",
      "course_id": "SC_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does South Carolina belong to for escort operator requirements?",
      "option_a": "Stand-Alone",
      "option_b": "8-State",
      "option_c": "14 PEVO",
      "option_d": "Standalone",
      "correct_answer": "C",
      "explanation": "Per South Carolina's current course data: 14 PEVO"
    },
    {
      "id": "SC_PEVO_PREP_13",
      "course_id": "SC_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a South Carolina-specific rule or red flag operators must know?",
      "option_a": "PEVO reciprocity. 15'0\" height limit. Port of Charleston generates high oversize move volume.",
      "option_b": "Baltimore metro and Chesapeake Bay Bridge have special permit procedures. Bay Bridge requires advance notice of 48 hours.",
      "option_c": "Wyoming has the most permissive limits — 16'0\" width and 16'0\" height. High wind is the primary hazard. I-80 has frequent wind-related permit holds.",
      "option_d": "Kansas is part of the 8-State uniform group. Flat terrain allows consistent escort patterns with few route restrictions.",
      "correct_answer": "A",
      "explanation": "Per South Carolina's current course data: PEVO reciprocity. 15'0\" height limit. Port of Charleston generates high oversize move volume."
    },
    {
      "id": "SC_PEVO_PREP_14",
      "course_id": "SC_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in South Carolina?",
      "option_a": "There is no standard width threshold",
      "option_b": "6'0\"",
      "option_c": "10'0\"",
      "option_d": "8'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per South Carolina's current course data: 8'6\" (standard)"
    },
    {
      "id": "SC_PEVO_PREP_15",
      "course_id": "SC_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in South Carolina?",
      "option_a": "10'0\"",
      "option_b": "13'6\" (standard)",
      "option_c": "15'0\"",
      "option_d": "There is no standard height threshold",
      "correct_answer": "B",
      "explanation": "Per South Carolina's current course data: 13'6\" (standard)"
    },
    {
      "id": "SC_PEVO_PREP_16",
      "course_id": "SC_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_17",
      "course_id": "SC_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_18",
      "course_id": "SC_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_19",
      "course_id": "SC_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_20",
      "course_id": "SC_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_21",
      "course_id": "SC_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_22",
      "course_id": "SC_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_23",
      "course_id": "SC_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_24",
      "course_id": "SC_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_25",
      "course_id": "SC_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_26",
      "course_id": "SC_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_27",
      "course_id": "SC_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_28",
      "course_id": "SC_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_29",
      "course_id": "SC_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_30",
      "course_id": "SC_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_31",
      "course_id": "SC_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_32",
      "course_id": "SC_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_33",
      "course_id": "SC_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_34",
      "course_id": "SC_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_35",
      "course_id": "SC_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_36",
      "course_id": "SC_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_37",
      "course_id": "SC_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_38",
      "course_id": "SC_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_39",
      "course_id": "SC_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_40",
      "course_id": "SC_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_41",
      "course_id": "SC_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_42",
      "course_id": "SC_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_43",
      "course_id": "SC_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_44",
      "course_id": "SC_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_45",
      "course_id": "SC_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_46",
      "course_id": "SC_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_47",
      "course_id": "SC_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_48",
      "course_id": "SC_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_49",
      "course_id": "SC_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SC_PEVO_PREP_50",
      "course_id": "SC_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "SD_PEVO_PREP": [
    {
      "id": "SD_PEVO_PREP_1",
      "course_id": "SD_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in South Dakota?",
      "option_a": "Wyoming DOT Oversize Permits",
      "option_b": "Illinois DOT Bureau of Permits",
      "option_c": "SD DOT Permit Office",
      "option_d": "KY Transportation Cabinet Permits",
      "correct_answer": "C",
      "explanation": "Per South Dakota's current course data: SD DOT Permit Office"
    },
    {
      "id": "SD_PEVO_PREP_2",
      "course_id": "SD_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does South Dakota require to legally operate as an escort vehicle operator?",
      "option_a": "PEVO Cert",
      "option_b": "PPCA Required",
      "option_c": "State Specific",
      "option_d": "NY Standalone ONLY",
      "correct_answer": "C",
      "explanation": "Per South Dakota's current course data: State Specific"
    },
    {
      "id": "SD_PEVO_PREP_3",
      "course_id": "SD_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in South Dakota?",
      "option_a": "OVERSIZE LOAD - yellow, standard spec",
      "option_b": "OVERSIZE LOAD - 5ft x 10in, yellow, SAE spec",
      "option_c": "OVERSIZE LOAD - yellow, black letters",
      "option_d": "OVERSIZE LOAD - yellow, 5ft x 12in, reflective",
      "correct_answer": "C",
      "explanation": "Per South Dakota's current course data: OVERSIZE LOAD - yellow, black letters"
    },
    {
      "id": "SD_PEVO_PREP_4",
      "course_id": "SD_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in South Dakota?",
      "option_a": "SAE Class 1 amber strobe - front and rear",
      "option_b": "Amber strobe Class 1",
      "option_c": "SAE Class 1 amber, front and rear required",
      "option_d": "SAE Class 1 amber strobe",
      "correct_answer": "B",
      "explanation": "Per South Dakota's current course data: Amber strobe Class 1"
    },
    {
      "id": "SD_PEVO_PREP_5",
      "course_id": "SD_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in South Dakota?",
      "option_a": "Paddle, extinguisher",
      "option_b": "Stop/slow paddle min 18in, 3 lb fire extinguisher, orange cones",
      "option_c": "18-inch stop/slow paddle, 5 lb fire extinguisher, 3 road flares, safety vest",
      "option_d": "18-inch paddle, 3 lb extinguisher, cones",
      "correct_answer": "A",
      "explanation": "Per South Dakota's current course data: Paddle, extinguisher"
    },
    {
      "id": "SD_PEVO_PREP_6",
      "course_id": "SD_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In South Dakota, when is an escort legally REQUIRED?",
      "option_a": "Any load over 8'6\" width or 14'0\" height on state highways",
      "option_b": "Width over 8'6\" or height over 13'6\"",
      "option_c": "ANY load over 8'6\" width or 13'6\" height - ZERO tolerance",
      "option_d": "Width over 9'0\" or height over 14'0\"",
      "correct_answer": "D",
      "explanation": "Per South Dakota's current course data: Width over 9'0\" or height over 14'0\""
    },
    {
      "id": "SD_PEVO_PREP_7",
      "course_id": "SD_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in South Dakota?",
      "option_a": "14'0\"",
      "option_b": "16'0\"",
      "option_c": "12'0\"",
      "option_d": "14'6\"",
      "correct_answer": "D",
      "explanation": "Per South Dakota's current course data: 14'6\""
    },
    {
      "id": "SD_PEVO_PREP_8",
      "course_id": "SD_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in South Dakota?",
      "option_a": "15'0\"",
      "option_b": "18'0\"",
      "option_c": "14'0\"",
      "option_d": "14'6\"",
      "correct_answer": "A",
      "explanation": "Per South Dakota's current course data: 15'0\""
    },
    {
      "id": "SD_PEVO_PREP_9",
      "course_id": "SD_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is South Dakota's night travel status for oversize permitted moves?",
      "option_a": "Always fully prohibited, no exceptions",
      "option_b": "Allowed",
      "option_c": "Restricted",
      "option_d": "w/ lighting",
      "correct_answer": "B",
      "explanation": "Per South Dakota's current course data: Allowed"
    },
    {
      "id": "SD_PEVO_PREP_10",
      "course_id": "SD_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in South Dakota?",
      "option_a": "$500K CSL minimum",
      "option_b": "$1M CSL minimum",
      "option_c": "$750K CSL minimum",
      "option_d": "Same as standard minimum — no separate night-ops tier specified",
      "correct_answer": "C",
      "explanation": "Per South Dakota's current course data: $750K CSL minimum"
    },
    {
      "id": "SD_PEVO_PREP_11",
      "course_id": "SD_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in South Dakota?",
      "option_a": "$500K CSL",
      "option_b": "$10,000 liability",
      "option_c": "$750K CSL",
      "option_d": "$1M CSL",
      "correct_answer": "C",
      "explanation": "Per South Dakota's current course data: $750K CSL"
    },
    {
      "id": "SD_PEVO_PREP_12",
      "course_id": "SD_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does South Dakota belong to for escort operator requirements?",
      "option_a": "Remaining",
      "option_b": "Stand-Alone",
      "option_c": "Standalone",
      "option_d": "8-State",
      "correct_answer": "A",
      "explanation": "Per South Dakota's current course data: Remaining"
    },
    {
      "id": "SD_PEVO_PREP_13",
      "course_id": "SD_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a South Dakota-specific rule or red flag operators must know?",
      "option_a": "Iowa is in the 8-State group. Spring road restrictions (Feb-May) limit weights on paved roads annually.",
      "option_b": "High wind and blizzard conditions common Oct-April. Wind farm equipment moves are a major market in SD.",
      "option_c": "Maine restricts night travel. Spring frost laws limit movements March-May. Bridge weight limits are strictly enforced.",
      "option_d": "West Virginia has highly mountainous terrain with severe height and weight restrictions on secondary roads. Coal and timber equipment moves are common.",
      "correct_answer": "B",
      "explanation": "Per South Dakota's current course data: High wind and blizzard conditions common Oct-April. Wind farm equipment moves are a major market in SD."
    },
    {
      "id": "SD_PEVO_PREP_14",
      "course_id": "SD_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in South Dakota?",
      "option_a": "10'0\"",
      "option_b": "6'0\"",
      "option_c": "There is no standard width threshold",
      "option_d": "8'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per South Dakota's current course data: 8'6\" (standard)"
    },
    {
      "id": "SD_PEVO_PREP_15",
      "course_id": "SD_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in South Dakota?",
      "option_a": "13'6\" (standard)",
      "option_b": "10'0\"",
      "option_c": "15'0\"",
      "option_d": "There is no standard height threshold",
      "correct_answer": "A",
      "explanation": "Per South Dakota's current course data: 13'6\" (standard)"
    },
    {
      "id": "SD_PEVO_PREP_16",
      "course_id": "SD_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_17",
      "course_id": "SD_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_18",
      "course_id": "SD_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_19",
      "course_id": "SD_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_20",
      "course_id": "SD_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_21",
      "course_id": "SD_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_22",
      "course_id": "SD_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_23",
      "course_id": "SD_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_24",
      "course_id": "SD_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_25",
      "course_id": "SD_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_26",
      "course_id": "SD_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_27",
      "course_id": "SD_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_28",
      "course_id": "SD_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_29",
      "course_id": "SD_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_30",
      "course_id": "SD_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_31",
      "course_id": "SD_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_32",
      "course_id": "SD_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_33",
      "course_id": "SD_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_34",
      "course_id": "SD_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_35",
      "course_id": "SD_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_36",
      "course_id": "SD_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_37",
      "course_id": "SD_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_38",
      "course_id": "SD_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_39",
      "course_id": "SD_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_40",
      "course_id": "SD_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_41",
      "course_id": "SD_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_42",
      "course_id": "SD_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_43",
      "course_id": "SD_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_44",
      "course_id": "SD_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_45",
      "course_id": "SD_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_46",
      "course_id": "SD_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_47",
      "course_id": "SD_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_48",
      "course_id": "SD_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_49",
      "course_id": "SD_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "SD_PEVO_PREP_50",
      "course_id": "SD_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "TN_PEVO_PREP": [
    {
      "id": "TN_PEVO_PREP_1",
      "course_id": "TN_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Tennessee?",
      "option_a": "Wyoming DOT Oversize Permits",
      "option_b": "Michigan DOT Permit Office",
      "option_c": "NC DOT Oversize Permits",
      "option_d": "Tennessee DOT Permits",
      "correct_answer": "D",
      "explanation": "Per Tennessee's current course data: Tennessee DOT Permits"
    },
    {
      "id": "TN_PEVO_PREP_2",
      "course_id": "TN_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Tennessee require to legally operate as an escort vehicle operator?",
      "option_a": "PPCA Required",
      "option_b": "8-State Uniform",
      "option_c": "NY Standalone ONLY",
      "option_d": "State Specific",
      "correct_answer": "D",
      "explanation": "Per Tennessee's current course data: State Specific"
    },
    {
      "id": "TN_PEVO_PREP_3",
      "course_id": "TN_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Tennessee?",
      "option_a": "OVERSIZE LOAD - 5ft x 10in yellow",
      "option_b": "OVERSIZE LOAD - yellow, black letters, 5ft x 12in",
      "option_c": "OVERSIZE LOAD - yellow, 5ft x 12in",
      "option_d": "OVERSIZE LOAD - 5ft x 12in, yellow",
      "correct_answer": "C",
      "explanation": "Per Tennessee's current course data: OVERSIZE LOAD - yellow, 5ft x 12in"
    },
    {
      "id": "TN_PEVO_PREP_4",
      "course_id": "TN_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Tennessee?",
      "option_a": "Amber Class 1, front and rear",
      "option_b": "Amber SAE Class 1 strobe, front and rear",
      "option_c": "SAE Class 1 amber - 360 degree visibility required",
      "option_d": "Amber Class 1",
      "correct_answer": "A",
      "explanation": "Per Tennessee's current course data: Amber Class 1, front and rear"
    },
    {
      "id": "TN_PEVO_PREP_5",
      "course_id": "TN_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Tennessee?",
      "option_a": "Paddle, 3 lb extinguisher",
      "option_b": "18-inch stop/slow paddle, 5 lb fire extinguisher, road flares, orange safety vest",
      "option_c": "Stop/slow paddle, 2.5 lb fire extinguisher, flares",
      "option_d": "18-inch paddle, 3 lb extinguisher",
      "correct_answer": "A",
      "explanation": "Per Tennessee's current course data: Paddle, 3 lb extinguisher"
    },
    {
      "id": "TN_PEVO_PREP_6",
      "course_id": "TN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Tennessee, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 13'6\"",
      "option_b": "Width over 9'0\" or height over 15'0\"",
      "option_c": "Width over 8'6\" or height over 13'0\"",
      "option_d": "Width over 8'6\" or height over 14'0\"",
      "correct_answer": "A",
      "explanation": "Per Tennessee's current course data: Width over 8'6\" or height over 13'6\""
    },
    {
      "id": "TN_PEVO_PREP_7",
      "course_id": "TN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Tennessee?",
      "option_a": "14'0\"",
      "option_b": "12'0\"",
      "option_c": "14'6\"",
      "option_d": "16'0\"",
      "correct_answer": "C",
      "explanation": "Per Tennessee's current course data: 14'6\""
    },
    {
      "id": "TN_PEVO_PREP_8",
      "course_id": "TN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Tennessee?",
      "option_a": "15'0\"",
      "option_b": "14'0\"",
      "option_c": "16'0\"",
      "option_d": "13'6\"",
      "correct_answer": "A",
      "explanation": "Per Tennessee's current course data: 15'0\""
    },
    {
      "id": "TN_PEVO_PREP_9",
      "course_id": "TN_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Tennessee's night travel status for oversize permitted moves?",
      "option_a": "Restricted",
      "option_b": "w/ lighting",
      "option_c": "Allowed",
      "option_d": "Always fully prohibited, no exceptions",
      "correct_answer": "B",
      "explanation": "Per Tennessee's current course data: w/ lighting"
    },
    {
      "id": "TN_PEVO_PREP_10",
      "course_id": "TN_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Tennessee?",
      "option_a": "$1M CSL minimum",
      "option_b": "$500K CSL minimum",
      "option_c": "Same as standard minimum — no separate night-ops tier specified",
      "option_d": "$750K CSL minimum",
      "correct_answer": "D",
      "explanation": "Per Tennessee's current course data: $750K CSL minimum"
    },
    {
      "id": "TN_PEVO_PREP_11",
      "course_id": "TN_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Tennessee?",
      "option_a": "$10,000 liability",
      "option_b": "$1M CSL",
      "option_c": "$500K CSL",
      "option_d": "$750K CSL",
      "correct_answer": "D",
      "explanation": "Per Tennessee's current course data: $750K CSL"
    },
    {
      "id": "TN_PEVO_PREP_12",
      "course_id": "TN_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Tennessee belong to for escort operator requirements?",
      "option_a": "Standalone",
      "option_b": "Remaining",
      "option_c": "NY Standalone",
      "option_d": "Stand-Alone",
      "correct_answer": "B",
      "explanation": "Per Tennessee's current course data: Remaining"
    },
    {
      "id": "TN_PEVO_PREP_13",
      "course_id": "TN_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Tennessee-specific rule or red flag operators must know?",
      "option_a": "Tennessee does not participate in PEVO reciprocity. Nashville metro has restricted permit windows. Mountain routes require special permits.",
      "option_b": "Michigan has extensive bridge restrictions due to aging infrastructure. Upper Peninsula routes have seasonal weight limits.",
      "option_c": "PEVO reciprocity. New Mexico allows night travel. High desert terrain has minimal bridge restrictions.",
      "option_d": "Ohio does not participate in PEVO reciprocity. Own state cert required. Columbus and Cleveland metros have restricted hours.",
      "correct_answer": "A",
      "explanation": "Per Tennessee's current course data: Tennessee does not participate in PEVO reciprocity. Nashville metro has restricted permit windows. Mountain routes require special permits."
    },
    {
      "id": "TN_PEVO_PREP_14",
      "course_id": "TN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Tennessee?",
      "option_a": "6'0\"",
      "option_b": "8'6\" (standard)",
      "option_c": "10'0\"",
      "option_d": "There is no standard width threshold",
      "correct_answer": "B",
      "explanation": "Per Tennessee's current course data: 8'6\" (standard)"
    },
    {
      "id": "TN_PEVO_PREP_15",
      "course_id": "TN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Tennessee?",
      "option_a": "There is no standard height threshold",
      "option_b": "13'6\" (standard)",
      "option_c": "10'0\"",
      "option_d": "15'0\"",
      "correct_answer": "B",
      "explanation": "Per Tennessee's current course data: 13'6\" (standard)"
    },
    {
      "id": "TN_PEVO_PREP_16",
      "course_id": "TN_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_17",
      "course_id": "TN_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_18",
      "course_id": "TN_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_19",
      "course_id": "TN_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_20",
      "course_id": "TN_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_21",
      "course_id": "TN_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_22",
      "course_id": "TN_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_23",
      "course_id": "TN_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_24",
      "course_id": "TN_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_25",
      "course_id": "TN_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_26",
      "course_id": "TN_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_27",
      "course_id": "TN_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_28",
      "course_id": "TN_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_29",
      "course_id": "TN_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_30",
      "course_id": "TN_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_31",
      "course_id": "TN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_32",
      "course_id": "TN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_33",
      "course_id": "TN_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_34",
      "course_id": "TN_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_35",
      "course_id": "TN_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_36",
      "course_id": "TN_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_37",
      "course_id": "TN_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_38",
      "course_id": "TN_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_39",
      "course_id": "TN_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_40",
      "course_id": "TN_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_41",
      "course_id": "TN_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_42",
      "course_id": "TN_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_43",
      "course_id": "TN_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_44",
      "course_id": "TN_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_45",
      "course_id": "TN_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_46",
      "course_id": "TN_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_47",
      "course_id": "TN_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_48",
      "course_id": "TN_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_49",
      "course_id": "TN_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TN_PEVO_PREP_50",
      "course_id": "TN_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "UT_PEVO_PREP": [
    {
      "id": "UT_PEVO_PREP_1",
      "course_id": "UT_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Utah?",
      "option_a": "Tennessee DOT Permits",
      "option_b": "Utah DOT Permit Office",
      "option_c": "Nebraska Dept of Roads Permits",
      "option_d": "Alaska DOT Permit Section",
      "correct_answer": "B",
      "explanation": "Per Utah's current course data: Utah DOT Permit Office"
    },
    {
      "id": "UT_PEVO_PREP_2",
      "course_id": "UT_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Utah require to legally operate as an escort vehicle operator?",
      "option_a": "State Specific",
      "option_b": "PEVO Cert",
      "option_c": "NY Standalone ONLY",
      "option_d": "8-State Uniform",
      "correct_answer": "D",
      "explanation": "Per Utah's current course data: 8-State Uniform"
    },
    {
      "id": "UT_PEVO_PREP_3",
      "course_id": "UT_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Utah?",
      "option_a": "OVERSIZE LOAD - yellow, SAE spec",
      "option_b": "OVERSIZE LOAD - 5ft x 12in, yellow, black 8-inch letters",
      "option_c": "OVERSIZE LOAD - yellow, 5ft x 10in",
      "option_d": "OVERSIZE LOAD - 96in x 12in, fluorescent yellow-green, black letters",
      "correct_answer": "A",
      "explanation": "Per Utah's current course data: OVERSIZE LOAD - yellow, SAE spec"
    },
    {
      "id": "UT_PEVO_PREP_4",
      "course_id": "UT_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Utah?",
      "option_a": "SAE Class 1 amber front and rear",
      "option_b": "Amber Class 1 strobe",
      "option_c": "Amber SAE Class 1, front and rear",
      "option_d": "Amber Class 1 front and rear",
      "correct_answer": "B",
      "explanation": "Per Utah's current course data: Amber Class 1 strobe"
    },
    {
      "id": "UT_PEVO_PREP_5",
      "course_id": "UT_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Utah?",
      "option_a": "Paddle, extinguisher",
      "option_b": "Paddle, 3 lb extinguisher",
      "option_c": "Paddle, 3 lb extinguisher, cones",
      "option_d": "Paddle, 3 lb extinguisher, flares",
      "correct_answer": "A",
      "explanation": "Per Utah's current course data: Paddle, extinguisher"
    },
    {
      "id": "UT_PEVO_PREP_6",
      "course_id": "UT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Utah, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 14'0\" triggers mandatory P/EVO escort",
      "option_b": "Any load over 8'6\" width or 14'0\" height on state highways",
      "option_c": "Width over 8'6\" or height over 13'6\"",
      "option_d": "ANY load over 8'6\" width or 13'6\" height - ZERO tolerance",
      "correct_answer": "C",
      "explanation": "Per Utah's current course data: Width over 8'6\" or height over 13'6\""
    },
    {
      "id": "UT_PEVO_PREP_7",
      "course_id": "UT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Utah?",
      "option_a": "14'6\"",
      "option_b": "12'0\"",
      "option_c": "14'0\"",
      "option_d": "16'0\"",
      "correct_answer": "A",
      "explanation": "Per Utah's current course data: 14'6\""
    },
    {
      "id": "UT_PEVO_PREP_8",
      "course_id": "UT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Utah?",
      "option_a": "18'0\"",
      "option_b": "13'6\"",
      "option_c": "14'6\"",
      "option_d": "15'6\"",
      "correct_answer": "C",
      "explanation": "Per Utah's current course data: 14'6\""
    },
    {
      "id": "UT_PEVO_PREP_9",
      "course_id": "UT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Utah's night travel status for oversize permitted moves?",
      "option_a": "Allowed",
      "option_b": "Always fully prohibited, no exceptions",
      "option_c": "w/ lighting",
      "option_d": "Restricted",
      "correct_answer": "C",
      "explanation": "Per Utah's current course data: w/ lighting"
    },
    {
      "id": "UT_PEVO_PREP_10",
      "course_id": "UT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Utah?",
      "option_a": "Same as standard minimum — no separate night-ops tier specified",
      "option_b": "$1M CSL minimum",
      "option_c": "$500K CSL minimum",
      "option_d": "$750K CSL minimum",
      "correct_answer": "D",
      "explanation": "Per Utah's current course data: $750K CSL minimum"
    },
    {
      "id": "UT_PEVO_PREP_11",
      "course_id": "UT_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Utah?",
      "option_a": "$500K CSL",
      "option_b": "$10,000 liability",
      "option_c": "$750K CSL",
      "option_d": "$1M CSL",
      "correct_answer": "C",
      "explanation": "Per Utah's current course data: $750K CSL"
    },
    {
      "id": "UT_PEVO_PREP_12",
      "course_id": "UT_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Utah belong to for escort operator requirements?",
      "option_a": "Standalone",
      "option_b": "8-State",
      "option_c": "Remaining",
      "option_d": "NY Standalone",
      "correct_answer": "B",
      "explanation": "Per Utah's current course data: 8-State"
    },
    {
      "id": "UT_PEVO_PREP_13",
      "course_id": "UT_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Utah-specific rule or red flag operators must know?",
      "option_a": "8-State group. Mountain canyon routes (I-15, US-89) have seasonal restrictions. Salt Lake metro restricted during major events.",
      "option_b": "Minnesota allows 15'0\" height clearance. Spring weight restrictions apply March-May on all state and county roads.",
      "option_c": "Oklahoma has high wind conditions on open highways. Tornado season (April-June) may result in permit holds.",
      "option_d": "Hawaii has the narrowest width allowance at 12'0\". Island-specific routes and weight restrictions apply on all four major islands.",
      "correct_answer": "A",
      "explanation": "Per Utah's current course data: 8-State group. Mountain canyon routes (I-15, US-89) have seasonal restrictions. Salt Lake metro restricted during major events."
    },
    {
      "id": "UT_PEVO_PREP_14",
      "course_id": "UT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Utah?",
      "option_a": "10'0\"",
      "option_b": "6'0\"",
      "option_c": "There is no standard width threshold",
      "option_d": "8'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per Utah's current course data: 8'6\" (standard)"
    },
    {
      "id": "UT_PEVO_PREP_15",
      "course_id": "UT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Utah?",
      "option_a": "15'0\"",
      "option_b": "There is no standard height threshold",
      "option_c": "10'0\"",
      "option_d": "13'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per Utah's current course data: 13'6\" (standard)"
    },
    {
      "id": "UT_PEVO_PREP_16",
      "course_id": "UT_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_17",
      "course_id": "UT_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_18",
      "course_id": "UT_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_19",
      "course_id": "UT_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_20",
      "course_id": "UT_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_21",
      "course_id": "UT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_22",
      "course_id": "UT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_23",
      "course_id": "UT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_24",
      "course_id": "UT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_25",
      "course_id": "UT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_26",
      "course_id": "UT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_27",
      "course_id": "UT_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_28",
      "course_id": "UT_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_29",
      "course_id": "UT_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_30",
      "course_id": "UT_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_31",
      "course_id": "UT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_32",
      "course_id": "UT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_33",
      "course_id": "UT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_34",
      "course_id": "UT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_35",
      "course_id": "UT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_36",
      "course_id": "UT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_37",
      "course_id": "UT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_38",
      "course_id": "UT_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_39",
      "course_id": "UT_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_40",
      "course_id": "UT_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_41",
      "course_id": "UT_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_42",
      "course_id": "UT_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_43",
      "course_id": "UT_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_44",
      "course_id": "UT_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_45",
      "course_id": "UT_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_46",
      "course_id": "UT_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_47",
      "course_id": "UT_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_48",
      "course_id": "UT_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_49",
      "course_id": "UT_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "UT_PEVO_PREP_50",
      "course_id": "UT_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "VT_PEVO_PREP": [
    {
      "id": "VT_PEVO_PREP_1",
      "course_id": "VT_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Vermont?",
      "option_a": "Arkansas DOT Oversize Permits",
      "option_b": "NJ DOT Oversize Permit Unit",
      "option_c": "Idaho Transportation Dept Permits",
      "option_d": "Vermont Agency of Transportation",
      "correct_answer": "D",
      "explanation": "Per Vermont's current course data: Vermont Agency of Transportation"
    },
    {
      "id": "VT_PEVO_PREP_2",
      "course_id": "VT_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Vermont require to legally operate as an escort vehicle operator?",
      "option_a": "State Specific",
      "option_b": "NY Standalone ONLY",
      "option_c": "PPCA Required",
      "option_d": "PEVO Cert",
      "correct_answer": "A",
      "explanation": "Per Vermont's current course data: State Specific"
    },
    {
      "id": "VT_PEVO_PREP_3",
      "course_id": "VT_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Vermont?",
      "option_a": "OVERSIZE LOAD - standard yellow spec",
      "option_b": "OVERSIZE LOAD - 5ft x 12in, yellow background",
      "option_c": "OVERSIZE LOAD - 5ft x 12in, fluorescent yellow, 8-inch black reflective letters",
      "option_d": "OVERSIZE LOAD - yellow, 5ft x 12in",
      "correct_answer": "A",
      "explanation": "Per Vermont's current course data: OVERSIZE LOAD - standard yellow spec"
    },
    {
      "id": "VT_PEVO_PREP_4",
      "course_id": "VT_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Vermont?",
      "option_a": "Amber Class 1, front and rear",
      "option_b": "Amber Class 1 front and rear",
      "option_c": "SAE Class 1 amber strobe, 360-degree visibility, minimum 35W",
      "option_d": "Amber strobe, Class 1 rated, mounted highest point of vehicle",
      "correct_answer": "B",
      "explanation": "Per Vermont's current course data: Amber Class 1 front and rear"
    },
    {
      "id": "VT_PEVO_PREP_5",
      "course_id": "VT_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Vermont?",
      "option_a": "Paddle, extinguisher, emergency kit",
      "option_b": "18-inch stop/slow paddle, fire extinguisher",
      "option_c": "Paddle, extinguisher, flares",
      "option_d": "18-inch stop/slow paddle, 3 lb extinguisher, cones",
      "correct_answer": "C",
      "explanation": "Per Vermont's current course data: Paddle, extinguisher, flares"
    },
    {
      "id": "VT_PEVO_PREP_6",
      "course_id": "VT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Vermont, when is an escort legally REQUIRED?",
      "option_a": "Width over 9'0\" or height over 15'0\"",
      "option_b": "Width over 8'6\" or height over 13'6\"",
      "option_c": "Width over 8'6\" or height over 13'0\"",
      "option_d": "Width over 8'6\", height over 13'6\", or length over 65 ft",
      "correct_answer": "C",
      "explanation": "Per Vermont's current course data: Width over 8'6\" or height over 13'0\""
    },
    {
      "id": "VT_PEVO_PREP_7",
      "course_id": "VT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Vermont?",
      "option_a": "14'6\"",
      "option_b": "16'0\"",
      "option_c": "12'0\"",
      "option_d": "14'0\"",
      "correct_answer": "D",
      "explanation": "Per Vermont's current course data: 14'0\""
    },
    {
      "id": "VT_PEVO_PREP_8",
      "course_id": "VT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Vermont?",
      "option_a": "15'6\"",
      "option_b": "13'6\"",
      "option_c": "14'6\"",
      "option_d": "14'0\"",
      "correct_answer": "B",
      "explanation": "Per Vermont's current course data: 13'6\""
    },
    {
      "id": "VT_PEVO_PREP_9",
      "course_id": "VT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Vermont's night travel status for oversize permitted moves?",
      "option_a": "w/ lighting",
      "option_b": "Allowed",
      "option_c": "Restricted",
      "option_d": "Always fully prohibited, no exceptions",
      "correct_answer": "C",
      "explanation": "Per Vermont's current course data: Restricted"
    },
    {
      "id": "VT_PEVO_PREP_10",
      "course_id": "VT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Vermont?",
      "option_a": "$750K CSL minimum",
      "option_b": "Same as standard minimum — no separate night-ops tier specified",
      "option_c": "$1M CSL minimum",
      "option_d": "$500K CSL minimum",
      "correct_answer": "A",
      "explanation": "Per Vermont's current course data: $750K CSL minimum"
    },
    {
      "id": "VT_PEVO_PREP_11",
      "course_id": "VT_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Vermont?",
      "option_a": "$10,000 liability",
      "option_b": "$750K CSL",
      "option_c": "$1M CSL",
      "option_d": "$500K CSL",
      "correct_answer": "B",
      "explanation": "Per Vermont's current course data: $750K CSL"
    },
    {
      "id": "VT_PEVO_PREP_12",
      "course_id": "VT_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Vermont belong to for escort operator requirements?",
      "option_a": "14 PEVO",
      "option_b": "8-State",
      "option_c": "Remaining",
      "option_d": "Standalone",
      "correct_answer": "C",
      "explanation": "Per Vermont's current course data: Remaining"
    },
    {
      "id": "VT_PEVO_PREP_13",
      "course_id": "VT_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Vermont-specific rule or red flag operators must know?",
      "option_a": "Nebraska is in the 8-State group. Flat terrain and minimal bridge restrictions make this a straightforward escort state.",
      "option_b": "Indiana allows night travel with proper lighting. Indianapolis metro has restricted windows during sporting events.",
      "option_c": "Vermont spring thaw laws (Feb-April) severely restrict movements. Green Mountain routes have height clearance issues.",
      "option_d": "Wisconsin allows 15'0\" height. Spring weight restrictions apply March-May. Wind energy equipment moves are a growing market.",
      "correct_answer": "C",
      "explanation": "Per Vermont's current course data: Vermont spring thaw laws (Feb-April) severely restrict movements. Green Mountain routes have height clearance issues."
    },
    {
      "id": "VT_PEVO_PREP_14",
      "course_id": "VT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Vermont?",
      "option_a": "8'6\" (standard)",
      "option_b": "10'0\"",
      "option_c": "There is no standard width threshold",
      "option_d": "6'0\"",
      "correct_answer": "A",
      "explanation": "Per Vermont's current course data: 8'6\" (standard)"
    },
    {
      "id": "VT_PEVO_PREP_15",
      "course_id": "VT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Vermont?",
      "option_a": "10'0\"",
      "option_b": "There is no standard height threshold",
      "option_c": "15'0\"",
      "option_d": "13'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per Vermont's current course data: 13'6\" (standard)"
    },
    {
      "id": "VT_PEVO_PREP_16",
      "course_id": "VT_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_17",
      "course_id": "VT_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_18",
      "course_id": "VT_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_19",
      "course_id": "VT_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_20",
      "course_id": "VT_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_21",
      "course_id": "VT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_22",
      "course_id": "VT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_23",
      "course_id": "VT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_24",
      "course_id": "VT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_25",
      "course_id": "VT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_26",
      "course_id": "VT_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_27",
      "course_id": "VT_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_28",
      "course_id": "VT_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_29",
      "course_id": "VT_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_30",
      "course_id": "VT_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_31",
      "course_id": "VT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_32",
      "course_id": "VT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_33",
      "course_id": "VT_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_34",
      "course_id": "VT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_35",
      "course_id": "VT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_36",
      "course_id": "VT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_37",
      "course_id": "VT_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_38",
      "course_id": "VT_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_39",
      "course_id": "VT_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_40",
      "course_id": "VT_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_41",
      "course_id": "VT_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_42",
      "course_id": "VT_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_43",
      "course_id": "VT_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_44",
      "course_id": "VT_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_45",
      "course_id": "VT_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_46",
      "course_id": "VT_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_47",
      "course_id": "VT_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_48",
      "course_id": "VT_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_49",
      "course_id": "VT_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VT_PEVO_PREP_50",
      "course_id": "VT_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "VA_PEVO_PREP": [
    {
      "id": "VA_PEVO_PREP_1",
      "course_id": "VA_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Virginia?",
      "option_a": "California DOT Permit Office",
      "option_b": "Montana DOT Permit Office",
      "option_c": "Wyoming DOT Oversize Permits",
      "option_d": "Virginia DOT Oversize Permits",
      "correct_answer": "D",
      "explanation": "Per Virginia's current course data: Virginia DOT Oversize Permits"
    },
    {
      "id": "VA_PEVO_PREP_2",
      "course_id": "VA_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Virginia require to legally operate as an escort vehicle operator?",
      "option_a": "PPCA Required",
      "option_b": "8-State Uniform",
      "option_c": "State Specific",
      "option_d": "PEVO Cert",
      "correct_answer": "C",
      "explanation": "Per Virginia's current course data: State Specific"
    },
    {
      "id": "VA_PEVO_PREP_3",
      "course_id": "VA_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Virginia?",
      "option_a": "OVERSIZE LOAD - yellow, 5ft x 12in, reflective",
      "option_b": "OVERSIZE LOAD - 5ft x 12in, yellow, black letters",
      "option_c": "OVERSIZE LOAD - yellow, 5ft x 10in",
      "option_d": "OVERSIZE LOAD - yellow, 5ft x 12in, 8-inch letters",
      "correct_answer": "A",
      "explanation": "Per Virginia's current course data: OVERSIZE LOAD - yellow, 5ft x 12in, reflective"
    },
    {
      "id": "VA_PEVO_PREP_4",
      "course_id": "VA_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Virginia?",
      "option_a": "Amber SAE Class 1, minimum 35W",
      "option_b": "SAE Class 1 amber, 360 visibility",
      "option_c": "SAE Class 1 amber, front and rear",
      "option_d": "SAE Class 1 amber 360-degree strobe, plus headlights on",
      "correct_answer": "C",
      "explanation": "Per Virginia's current course data: SAE Class 1 amber, front and rear"
    },
    {
      "id": "VA_PEVO_PREP_5",
      "course_id": "VA_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Virginia?",
      "option_a": "Paddle, extinguisher",
      "option_b": "Paddle, 3 lb extinguisher, cones",
      "option_c": "Paddle, extinguisher, cones",
      "option_d": "Paddle, 3 lb extinguisher, flares",
      "correct_answer": "B",
      "explanation": "Per Virginia's current course data: Paddle, 3 lb extinguisher, cones"
    },
    {
      "id": "VA_PEVO_PREP_6",
      "course_id": "VA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Virginia, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 13'6\"",
      "option_b": "Any load exceeding 8'6\" width, 13'6\" height, or 80,000 lbs GVW",
      "option_c": "ANY load over 8'6\" width or 13'6\" height - ZERO tolerance",
      "option_d": "Width over 8'6\" or height over 13'0\" requires escort",
      "correct_answer": "A",
      "explanation": "Per Virginia's current course data: Width over 8'6\" or height over 13'6\""
    },
    {
      "id": "VA_PEVO_PREP_7",
      "course_id": "VA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Virginia?",
      "option_a": "12'0\"",
      "option_b": "14'6\"",
      "option_c": "16'0\"",
      "option_d": "14'0\"",
      "correct_answer": "B",
      "explanation": "Per Virginia's current course data: 14'6\""
    },
    {
      "id": "VA_PEVO_PREP_8",
      "course_id": "VA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Virginia?",
      "option_a": "13'6\"",
      "option_b": "14'6\"",
      "option_c": "18'0\"",
      "option_d": "15'0\"",
      "correct_answer": "B",
      "explanation": "Per Virginia's current course data: 14'6\""
    },
    {
      "id": "VA_PEVO_PREP_9",
      "course_id": "VA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Virginia's night travel status for oversize permitted moves?",
      "option_a": "w/ lighting",
      "option_b": "Restricted",
      "option_c": "Always fully prohibited, no exceptions",
      "option_d": "Allowed",
      "correct_answer": "A",
      "explanation": "Per Virginia's current course data: w/ lighting"
    },
    {
      "id": "VA_PEVO_PREP_10",
      "course_id": "VA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Virginia?",
      "option_a": "$1M CSL minimum",
      "option_b": "$500K CSL minimum",
      "option_c": "$750K CSL minimum",
      "option_d": "Same as standard minimum — no separate night-ops tier specified",
      "correct_answer": "C",
      "explanation": "Per Virginia's current course data: $750K CSL minimum"
    },
    {
      "id": "VA_PEVO_PREP_11",
      "course_id": "VA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Virginia?",
      "option_a": "$500K CSL",
      "option_b": "$10,000 liability",
      "option_c": "$1M CSL",
      "option_d": "$750K CSL",
      "correct_answer": "D",
      "explanation": "Per Virginia's current course data: $750K CSL"
    },
    {
      "id": "VA_PEVO_PREP_12",
      "course_id": "VA_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Virginia belong to for escort operator requirements?",
      "option_a": "Standalone",
      "option_b": "8-State",
      "option_c": "Remaining",
      "option_d": "Stand-Alone",
      "correct_answer": "C",
      "explanation": "Per Virginia's current course data: Remaining"
    },
    {
      "id": "VA_PEVO_PREP_13",
      "course_id": "VA_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Virginia-specific rule or red flag operators must know?",
      "option_a": "8-State group. St. Louis metro has bridge restrictions. I-70 corridor has high volume oversize move traffic.",
      "option_b": "Michigan has extensive bridge restrictions due to aging infrastructure. Upper Peninsula routes have seasonal weight limits.",
      "option_c": "Alaska has no reciprocity. Extreme weather rules apply Oct-Apr. Daylight-only travel required Nov-Feb.",
      "option_d": "Northern Virginia (NOVA) has some of the most restrictive permit windows in the country. I-95 and I-66 corridors are heavily managed.",
      "correct_answer": "D",
      "explanation": "Per Virginia's current course data: Northern Virginia (NOVA) has some of the most restrictive permit windows in the country. I-95 and I-66 corridors are heavily managed."
    },
    {
      "id": "VA_PEVO_PREP_14",
      "course_id": "VA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Virginia?",
      "option_a": "6'0\"",
      "option_b": "10'0\"",
      "option_c": "There is no standard width threshold",
      "option_d": "8'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per Virginia's current course data: 8'6\" (standard)"
    },
    {
      "id": "VA_PEVO_PREP_15",
      "course_id": "VA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Virginia?",
      "option_a": "15'0\"",
      "option_b": "10'0\"",
      "option_c": "There is no standard height threshold",
      "option_d": "13'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per Virginia's current course data: 13'6\" (standard)"
    },
    {
      "id": "VA_PEVO_PREP_16",
      "course_id": "VA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_17",
      "course_id": "VA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_18",
      "course_id": "VA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_19",
      "course_id": "VA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_20",
      "course_id": "VA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_21",
      "course_id": "VA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_22",
      "course_id": "VA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_23",
      "course_id": "VA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_24",
      "course_id": "VA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_25",
      "course_id": "VA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_26",
      "course_id": "VA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_27",
      "course_id": "VA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_28",
      "course_id": "VA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_29",
      "course_id": "VA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_30",
      "course_id": "VA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_31",
      "course_id": "VA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_32",
      "course_id": "VA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_33",
      "course_id": "VA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_34",
      "course_id": "VA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_35",
      "course_id": "VA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_36",
      "course_id": "VA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_37",
      "course_id": "VA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_38",
      "course_id": "VA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_39",
      "course_id": "VA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_40",
      "course_id": "VA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_41",
      "course_id": "VA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_42",
      "course_id": "VA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_43",
      "course_id": "VA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_44",
      "course_id": "VA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_45",
      "course_id": "VA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_46",
      "course_id": "VA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_47",
      "course_id": "VA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_48",
      "course_id": "VA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_49",
      "course_id": "VA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "VA_PEVO_PREP_50",
      "course_id": "VA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "WV_PEVO_PREP": [
    {
      "id": "WV_PEVO_PREP_1",
      "course_id": "WV_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in West Virginia?",
      "option_a": "Utah DOT Permit Office",
      "option_b": "Maryland SHA Permit Office",
      "option_c": "SD DOT Permit Office",
      "option_d": "WV DOT Permit Office",
      "correct_answer": "D",
      "explanation": "Per West Virginia's current course data: WV DOT Permit Office"
    },
    {
      "id": "WV_PEVO_PREP_2",
      "course_id": "WV_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does West Virginia require to legally operate as an escort vehicle operator?",
      "option_a": "PPCA Required",
      "option_b": "State Specific",
      "option_c": "8-State Uniform",
      "option_d": "NY Standalone ONLY",
      "correct_answer": "B",
      "explanation": "Per West Virginia's current course data: State Specific"
    },
    {
      "id": "WV_PEVO_PREP_3",
      "course_id": "WV_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in West Virginia?",
      "option_a": "OVERSIZE LOAD - yellow background, 6-inch black letters",
      "option_b": "OVERSIZE LOAD - 5ft x 12in, fluorescent yellow, 8-inch black reflective letters",
      "option_c": "OVERSIZE LOAD - standard 5ft x 12in",
      "option_d": "OVERSIZE LOAD - yellow, standard spec",
      "correct_answer": "D",
      "explanation": "Per West Virginia's current course data: OVERSIZE LOAD - yellow, standard spec"
    },
    {
      "id": "WV_PEVO_PREP_4",
      "course_id": "WV_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in West Virginia?",
      "option_a": "Amber Class 1",
      "option_b": "SAE Class 1 amber strobe",
      "option_c": "Amber Class 1 front and rear",
      "option_d": "Amber Class 1, front and rear",
      "correct_answer": "A",
      "explanation": "Per West Virginia's current course data: Amber Class 1"
    },
    {
      "id": "WV_PEVO_PREP_5",
      "course_id": "WV_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in West Virginia?",
      "option_a": "Fire extinguisher, safety triangles, vest",
      "option_b": "Paddle, extinguisher, cones",
      "option_c": "Paddle, 5 lb extinguisher, flares, cones",
      "option_d": "Paddle, extinguisher, flares",
      "correct_answer": "D",
      "explanation": "Per West Virginia's current course data: Paddle, extinguisher, flares"
    },
    {
      "id": "WV_PEVO_PREP_6",
      "course_id": "WV_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In West Virginia, when is an escort legally REQUIRED?",
      "option_a": "Any load exceeding 8'0\" width or 13'6\" height",
      "option_b": "Any load exceeding 8'6\" width, 13'6\" height, or 80,000 lbs GVW",
      "option_c": "Width over 8'6\" or height over 13'0\"",
      "option_d": "Width over 8'6\" or height over 13'6\" requires escort",
      "correct_answer": "C",
      "explanation": "Per West Virginia's current course data: Width over 8'6\" or height over 13'0\""
    },
    {
      "id": "WV_PEVO_PREP_7",
      "course_id": "WV_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in West Virginia?",
      "option_a": "16'0\"",
      "option_b": "14'0\"",
      "option_c": "12'0\"",
      "option_d": "14'6\"",
      "correct_answer": "B",
      "explanation": "Per West Virginia's current course data: 14'0\""
    },
    {
      "id": "WV_PEVO_PREP_8",
      "course_id": "WV_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in West Virginia?",
      "option_a": "14'6\"",
      "option_b": "18'0\"",
      "option_c": "13'6\"",
      "option_d": "14'0\"",
      "correct_answer": "C",
      "explanation": "Per West Virginia's current course data: 13'6\""
    },
    {
      "id": "WV_PEVO_PREP_9",
      "course_id": "WV_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is West Virginia's night travel status for oversize permitted moves?",
      "option_a": "Always fully prohibited, no exceptions",
      "option_b": "Allowed",
      "option_c": "w/ lighting",
      "option_d": "Restricted",
      "correct_answer": "D",
      "explanation": "Per West Virginia's current course data: Restricted"
    },
    {
      "id": "WV_PEVO_PREP_10",
      "course_id": "WV_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in West Virginia?",
      "option_a": "$1M CSL minimum",
      "option_b": "$500K CSL minimum",
      "option_c": "Same as standard minimum — no separate night-ops tier specified",
      "option_d": "$750K CSL minimum",
      "correct_answer": "D",
      "explanation": "Per West Virginia's current course data: $750K CSL minimum"
    },
    {
      "id": "WV_PEVO_PREP_11",
      "course_id": "WV_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in West Virginia?",
      "option_a": "$1M CSL",
      "option_b": "$10,000 liability",
      "option_c": "$500K CSL",
      "option_d": "$750K CSL",
      "correct_answer": "D",
      "explanation": "Per West Virginia's current course data: $750K CSL"
    },
    {
      "id": "WV_PEVO_PREP_12",
      "course_id": "WV_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does West Virginia belong to for escort operator requirements?",
      "option_a": "14 PEVO",
      "option_b": "Stand-Alone",
      "option_c": "Remaining",
      "option_d": "8-State",
      "correct_answer": "C",
      "explanation": "Per West Virginia's current course data: Remaining"
    },
    {
      "id": "WV_PEVO_PREP_13",
      "course_id": "WV_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a West Virginia-specific rule or red flag operators must know?",
      "option_a": "West Virginia has highly mountainous terrain with severe height and weight restrictions on secondary roads. Coal and timber equipment moves are common.",
      "option_b": "Hawaii has the narrowest width allowance at 12'0\". Island-specific routes and weight restrictions apply on all four major islands.",
      "option_c": "High wind and blizzard conditions common Oct-April. Wind farm equipment moves are a major market in SD.",
      "option_d": "Louisiana has one of the highest height allowances at 15'0\". Bayou and river crossings require bridge clearance verification.",
      "correct_answer": "A",
      "explanation": "Per West Virginia's current course data: West Virginia has highly mountainous terrain with severe height and weight restrictions on secondary roads. Coal and timber equipment moves are common."
    },
    {
      "id": "WV_PEVO_PREP_14",
      "course_id": "WV_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in West Virginia?",
      "option_a": "There is no standard width threshold",
      "option_b": "8'6\" (standard)",
      "option_c": "10'0\"",
      "option_d": "6'0\"",
      "correct_answer": "B",
      "explanation": "Per West Virginia's current course data: 8'6\" (standard)"
    },
    {
      "id": "WV_PEVO_PREP_15",
      "course_id": "WV_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in West Virginia?",
      "option_a": "13'6\" (standard)",
      "option_b": "15'0\"",
      "option_c": "There is no standard height threshold",
      "option_d": "10'0\"",
      "correct_answer": "A",
      "explanation": "Per West Virginia's current course data: 13'6\" (standard)"
    },
    {
      "id": "WV_PEVO_PREP_16",
      "course_id": "WV_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_17",
      "course_id": "WV_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_18",
      "course_id": "WV_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_19",
      "course_id": "WV_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_20",
      "course_id": "WV_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_21",
      "course_id": "WV_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_22",
      "course_id": "WV_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_23",
      "course_id": "WV_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_24",
      "course_id": "WV_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_25",
      "course_id": "WV_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_26",
      "course_id": "WV_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_27",
      "course_id": "WV_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_28",
      "course_id": "WV_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_29",
      "course_id": "WV_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_30",
      "course_id": "WV_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_31",
      "course_id": "WV_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_32",
      "course_id": "WV_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_33",
      "course_id": "WV_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_34",
      "course_id": "WV_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_35",
      "course_id": "WV_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_36",
      "course_id": "WV_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_37",
      "course_id": "WV_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_38",
      "course_id": "WV_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_39",
      "course_id": "WV_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_40",
      "course_id": "WV_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_41",
      "course_id": "WV_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_42",
      "course_id": "WV_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_43",
      "course_id": "WV_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_44",
      "course_id": "WV_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_45",
      "course_id": "WV_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_46",
      "course_id": "WV_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_47",
      "course_id": "WV_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_48",
      "course_id": "WV_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_49",
      "course_id": "WV_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WV_PEVO_PREP_50",
      "course_id": "WV_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "WI_PEVO_PREP": [
    {
      "id": "WI_PEVO_PREP_1",
      "course_id": "WI_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Wisconsin?",
      "option_a": "Wisconsin DOT Permit Office",
      "option_b": "Louisiana DOTD Oversize Permits",
      "option_c": "NM DOT Permits Office",
      "option_d": "Oklahoma DOT Permits",
      "correct_answer": "A",
      "explanation": "Per Wisconsin's current course data: Wisconsin DOT Permit Office"
    },
    {
      "id": "WI_PEVO_PREP_2",
      "course_id": "WI_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Wisconsin require to legally operate as an escort vehicle operator?",
      "option_a": "State Specific",
      "option_b": "NY Standalone ONLY",
      "option_c": "8-State Uniform",
      "option_d": "PEVO Cert",
      "correct_answer": "A",
      "explanation": "Per Wisconsin's current course data: State Specific"
    },
    {
      "id": "WI_PEVO_PREP_3",
      "course_id": "WI_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Wisconsin?",
      "option_a": "OVERSIZE LOAD - yellow, standard 5ft x 12in",
      "option_b": "OVERSIZE LOAD - yellow, 5ft x 10in",
      "option_c": "OVERSIZE LOAD - 5ft x 12in yellow, reflective",
      "option_d": "OVERSIZE LOAD - yellow, standard spec",
      "correct_answer": "D",
      "explanation": "Per Wisconsin's current course data: OVERSIZE LOAD - yellow, standard spec"
    },
    {
      "id": "WI_PEVO_PREP_4",
      "course_id": "WI_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Wisconsin?",
      "option_a": "SAE Class 1 amber - 360 degree visibility required",
      "option_b": "Amber Class 1 strobe required",
      "option_c": "Amber Class 1 or 2 strobe",
      "option_d": "Amber Class 1 strobe",
      "correct_answer": "D",
      "explanation": "Per Wisconsin's current course data: Amber Class 1 strobe"
    },
    {
      "id": "WI_PEVO_PREP_5",
      "course_id": "WI_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Wisconsin?",
      "option_a": "Paddle, 3 lb extinguisher, vest",
      "option_b": "Paddle, extinguisher",
      "option_c": "Paddle, extinguisher, 6 flares",
      "option_d": "Stop/slow paddle min 18in, 3 lb fire extinguisher, orange cones",
      "correct_answer": "B",
      "explanation": "Per Wisconsin's current course data: Paddle, extinguisher"
    },
    {
      "id": "WI_PEVO_PREP_6",
      "course_id": "WI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Wisconsin, when is an escort legally REQUIRED?",
      "option_a": "Width over 9'0\" or height over 15'0\"",
      "option_b": "Width exceeding 8'6\" requires lead escort; height over 15'0\" requires height pole",
      "option_c": "Width over 8'6\" or height over 13'6\"",
      "option_d": "Any load exceeding 8'0\" width or 13'6\" height",
      "correct_answer": "C",
      "explanation": "Per Wisconsin's current course data: Width over 8'6\" or height over 13'6\""
    },
    {
      "id": "WI_PEVO_PREP_7",
      "course_id": "WI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Wisconsin?",
      "option_a": "12'0\"",
      "option_b": "14'6\"",
      "option_c": "14'0\"",
      "option_d": "16'0\"",
      "correct_answer": "B",
      "explanation": "Per Wisconsin's current course data: 14'6\""
    },
    {
      "id": "WI_PEVO_PREP_8",
      "course_id": "WI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Wisconsin?",
      "option_a": "15'6\"",
      "option_b": "14'6\"",
      "option_c": "15'0\"",
      "option_d": "18'0\"",
      "correct_answer": "C",
      "explanation": "Per Wisconsin's current course data: 15'0\""
    },
    {
      "id": "WI_PEVO_PREP_9",
      "course_id": "WI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Wisconsin's night travel status for oversize permitted moves?",
      "option_a": "w/ lighting",
      "option_b": "Always fully prohibited, no exceptions",
      "option_c": "Restricted",
      "option_d": "Allowed",
      "correct_answer": "D",
      "explanation": "Per Wisconsin's current course data: Allowed"
    },
    {
      "id": "WI_PEVO_PREP_10",
      "course_id": "WI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Wisconsin?",
      "option_a": "$1M CSL minimum",
      "option_b": "Same as standard minimum — no separate night-ops tier specified",
      "option_c": "$500K CSL minimum",
      "option_d": "$750K CSL minimum",
      "correct_answer": "D",
      "explanation": "Per Wisconsin's current course data: $750K CSL minimum"
    },
    {
      "id": "WI_PEVO_PREP_11",
      "course_id": "WI_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Wisconsin?",
      "option_a": "$1M CSL",
      "option_b": "$500K CSL",
      "option_c": "$10,000 liability",
      "option_d": "$750K CSL",
      "correct_answer": "D",
      "explanation": "Per Wisconsin's current course data: $750K CSL"
    },
    {
      "id": "WI_PEVO_PREP_12",
      "course_id": "WI_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Wisconsin belong to for escort operator requirements?",
      "option_a": "8-State",
      "option_b": "Standalone",
      "option_c": "14 PEVO",
      "option_d": "Remaining",
      "correct_answer": "D",
      "explanation": "Per Wisconsin's current course data: Remaining"
    },
    {
      "id": "WI_PEVO_PREP_13",
      "course_id": "WI_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Wisconsin-specific rule or red flag operators must know?",
      "option_a": "Texas has one of the highest height allowances at 18'0\". Texas requires state-specific certification (no PEVO reciprocity). TxDMV handles permit issuance. Super loads over 20' wide require Texas DPS escort. Houston, Dallas, and Austin metros have restricted windows. Oversize signs must be 7ft wide — larger than most states.",
      "option_b": "Wisconsin allows 15'0\" height. Spring weight restrictions apply March-May. Wind energy equipment moves are a growing market.",
      "option_c": "NJ requires $1M insurance. NJ Turnpike and Garden State Parkway have separate permit procedures. Path and Lincoln tunnel approaches have height restrictions.",
      "option_d": "Florida is a PEVO reciprocity state. PPCA cert accepted. Florida requires PEVO + Defensive Driving certification for operators. Florida has significant bridge height restrictions due to coastal infrastructure. Summer thunderstorm season (June-September) frequently halts permitted moves.",
      "correct_answer": "B",
      "explanation": "Per Wisconsin's current course data: Wisconsin allows 15'0\" height. Spring weight restrictions apply March-May. Wind energy equipment moves are a growing market."
    },
    {
      "id": "WI_PEVO_PREP_14",
      "course_id": "WI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Wisconsin?",
      "option_a": "10'0\"",
      "option_b": "6'0\"",
      "option_c": "8'6\" (standard)",
      "option_d": "There is no standard width threshold",
      "correct_answer": "C",
      "explanation": "Per Wisconsin's current course data: 8'6\" (standard)"
    },
    {
      "id": "WI_PEVO_PREP_15",
      "course_id": "WI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Wisconsin?",
      "option_a": "13'6\" (standard)",
      "option_b": "There is no standard height threshold",
      "option_c": "15'0\"",
      "option_d": "10'0\"",
      "correct_answer": "A",
      "explanation": "Per Wisconsin's current course data: 13'6\" (standard)"
    },
    {
      "id": "WI_PEVO_PREP_16",
      "course_id": "WI_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_17",
      "course_id": "WI_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_18",
      "course_id": "WI_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_19",
      "course_id": "WI_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_20",
      "course_id": "WI_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_21",
      "course_id": "WI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_22",
      "course_id": "WI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_23",
      "course_id": "WI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_24",
      "course_id": "WI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_25",
      "course_id": "WI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_26",
      "course_id": "WI_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_27",
      "course_id": "WI_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_28",
      "course_id": "WI_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_29",
      "course_id": "WI_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_30",
      "course_id": "WI_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_31",
      "course_id": "WI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_32",
      "course_id": "WI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_33",
      "course_id": "WI_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_34",
      "course_id": "WI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_35",
      "course_id": "WI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_36",
      "course_id": "WI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_37",
      "course_id": "WI_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_38",
      "course_id": "WI_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_39",
      "course_id": "WI_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_40",
      "course_id": "WI_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_41",
      "course_id": "WI_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_42",
      "course_id": "WI_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_43",
      "course_id": "WI_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_44",
      "course_id": "WI_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_45",
      "course_id": "WI_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_46",
      "course_id": "WI_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_47",
      "course_id": "WI_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_48",
      "course_id": "WI_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_49",
      "course_id": "WI_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WI_PEVO_PREP_50",
      "course_id": "WI_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "WY_PEVO_PREP": [
    {
      "id": "WY_PEVO_PREP_1",
      "course_id": "WY_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Wyoming?",
      "option_a": "SD DOT Permit Office",
      "option_b": "California DOT Permit Office",
      "option_c": "Wyoming DOT Oversize Permits",
      "option_d": "Maine DOT Permit Office",
      "correct_answer": "C",
      "explanation": "Per Wyoming's current course data: Wyoming DOT Oversize Permits"
    },
    {
      "id": "WY_PEVO_PREP_2",
      "course_id": "WY_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Wyoming require to legally operate as an escort vehicle operator?",
      "option_a": "PEVO Cert",
      "option_b": "PPCA Required",
      "option_c": "State Specific",
      "option_d": "8-State Uniform",
      "correct_answer": "C",
      "explanation": "Per Wyoming's current course data: State Specific"
    },
    {
      "id": "WY_PEVO_PREP_3",
      "course_id": "WY_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Wyoming?",
      "option_a": "OVERSIZE LOAD - standard 5ft x 12in",
      "option_b": "OVERSIZE LOAD - standard 5ft x 12in yellow sign",
      "option_c": "OVERSIZE LOAD - yellow, standard federal spec",
      "option_d": "OVERSIZE LOAD - standard yellow spec",
      "correct_answer": "C",
      "explanation": "Per Wyoming's current course data: OVERSIZE LOAD - yellow, standard federal spec"
    },
    {
      "id": "WY_PEVO_PREP_4",
      "course_id": "WY_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Wyoming?",
      "option_a": "SAE Class 1 amber, front and rear required",
      "option_b": "Amber SAE Class 1 strobe visible from all sides",
      "option_c": "Amber Class 1 strobe front and rear",
      "option_d": "Amber strobe, Class 1 or 2",
      "correct_answer": "D",
      "explanation": "Per Wyoming's current course data: Amber strobe, Class 1 or 2"
    },
    {
      "id": "WY_PEVO_PREP_5",
      "course_id": "WY_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Wyoming?",
      "option_a": "Paddle, extinguisher, emergency kit",
      "option_b": "Paddle, extinguisher, 6 flares",
      "option_c": "18-inch stop/slow paddle, 3 lb fire extinguisher",
      "option_d": "18-inch paddle, 3 lb extinguisher",
      "correct_answer": "A",
      "explanation": "Per Wyoming's current course data: Paddle, extinguisher, emergency kit"
    },
    {
      "id": "WY_PEVO_PREP_6",
      "course_id": "WY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Wyoming, when is an escort legally REQUIRED?",
      "option_a": "Any load over 8'6\" width or 13'6\" height",
      "option_b": "Any load exceeding 8'6\" width, 13'6\" height, or 80,000 lbs GVW",
      "option_c": "ANY load over 8'6\" width or 13'6\" height - ZERO tolerance",
      "option_d": "Width over 12'0\" or height over 14'0\"",
      "correct_answer": "D",
      "explanation": "Per Wyoming's current course data: Width over 12'0\" or height over 14'0\""
    },
    {
      "id": "WY_PEVO_PREP_7",
      "course_id": "WY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Wyoming?",
      "option_a": "12'0\"",
      "option_b": "14'0\"",
      "option_c": "16'0\"",
      "option_d": "14'6\"",
      "correct_answer": "C",
      "explanation": "Per Wyoming's current course data: 16'0\""
    },
    {
      "id": "WY_PEVO_PREP_8",
      "course_id": "WY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Wyoming?",
      "option_a": "18'0\"",
      "option_b": "14'6\"",
      "option_c": "16'0\"",
      "option_d": "15'6\"",
      "correct_answer": "C",
      "explanation": "Per Wyoming's current course data: 16'0\""
    },
    {
      "id": "WY_PEVO_PREP_9",
      "course_id": "WY_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Wyoming's night travel status for oversize permitted moves?",
      "option_a": "Restricted",
      "option_b": "w/ lighting",
      "option_c": "Allowed",
      "option_d": "Always fully prohibited, no exceptions",
      "correct_answer": "C",
      "explanation": "Per Wyoming's current course data: Allowed"
    },
    {
      "id": "WY_PEVO_PREP_10",
      "course_id": "WY_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Wyoming?",
      "option_a": "$750K CSL minimum",
      "option_b": "$1M CSL minimum",
      "option_c": "Same as standard minimum — no separate night-ops tier specified",
      "option_d": "$500K CSL minimum",
      "correct_answer": "A",
      "explanation": "Per Wyoming's current course data: $750K CSL minimum"
    },
    {
      "id": "WY_PEVO_PREP_11",
      "course_id": "WY_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Wyoming?",
      "option_a": "$1M CSL",
      "option_b": "$750K CSL",
      "option_c": "$500K CSL",
      "option_d": "$10,000 liability",
      "correct_answer": "B",
      "explanation": "Per Wyoming's current course data: $750K CSL"
    },
    {
      "id": "WY_PEVO_PREP_12",
      "course_id": "WY_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Wyoming belong to for escort operator requirements?",
      "option_a": "8-State",
      "option_b": "Remaining",
      "option_c": "Stand-Alone",
      "option_d": "Standalone",
      "correct_answer": "B",
      "explanation": "Per Wyoming's current course data: Remaining"
    },
    {
      "id": "WY_PEVO_PREP_13",
      "course_id": "WY_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Wyoming-specific rule or red flag operators must know?",
      "option_a": "Wyoming has the most permissive limits — 16'0\" width and 16'0\" height. High wind is the primary hazard. I-80 has frequent wind-related permit holds.",
      "option_b": "Oregon requires state-specific cert AND $1M insurance. Portland metro restricted windows. Coast routes have severe weather seasonal restrictions Oct-Mar.",
      "option_c": "Maine restricts night travel. Spring frost laws limit movements March-May. Bridge weight limits are strictly enforced.",
      "option_d": "Large agricultural equipment moves are common. Spring weight restrictions apply on all secondary roads.",
      "correct_answer": "A",
      "explanation": "Per Wyoming's current course data: Wyoming has the most permissive limits — 16'0\" width and 16'0\" height. High wind is the primary hazard. I-80 has frequent wind-related permit holds."
    },
    {
      "id": "WY_PEVO_PREP_14",
      "course_id": "WY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Wyoming?",
      "option_a": "8'6\" (standard)",
      "option_b": "6'0\"",
      "option_c": "10'0\"",
      "option_d": "There is no standard width threshold",
      "correct_answer": "A",
      "explanation": "Per Wyoming's current course data: 8'6\" (standard)"
    },
    {
      "id": "WY_PEVO_PREP_15",
      "course_id": "WY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Wyoming?",
      "option_a": "10'0\"",
      "option_b": "There is no standard height threshold",
      "option_c": "15'0\"",
      "option_d": "13'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per Wyoming's current course data: 13'6\" (standard)"
    },
    {
      "id": "WY_PEVO_PREP_16",
      "course_id": "WY_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_17",
      "course_id": "WY_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_18",
      "course_id": "WY_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_19",
      "course_id": "WY_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_20",
      "course_id": "WY_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_21",
      "course_id": "WY_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_22",
      "course_id": "WY_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_23",
      "course_id": "WY_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_24",
      "course_id": "WY_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_25",
      "course_id": "WY_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_26",
      "course_id": "WY_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_27",
      "course_id": "WY_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_28",
      "course_id": "WY_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_29",
      "course_id": "WY_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_30",
      "course_id": "WY_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_31",
      "course_id": "WY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_32",
      "course_id": "WY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_33",
      "course_id": "WY_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_34",
      "course_id": "WY_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_35",
      "course_id": "WY_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_36",
      "course_id": "WY_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_37",
      "course_id": "WY_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_38",
      "course_id": "WY_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_39",
      "course_id": "WY_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_40",
      "course_id": "WY_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_41",
      "course_id": "WY_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_42",
      "course_id": "WY_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_43",
      "course_id": "WY_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_44",
      "course_id": "WY_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_45",
      "course_id": "WY_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_46",
      "course_id": "WY_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_47",
      "course_id": "WY_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_48",
      "course_id": "WY_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_49",
      "course_id": "WY_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WY_PEVO_PREP_50",
      "course_id": "WY_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "CA_PEVO_PREP": [
    {
      "id": "CA_PEVO_PREP_1",
      "course_id": "CA_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in California?",
      "option_a": "Wyoming DOT Oversize Permits",
      "option_b": "Montana DOT Permit Office",
      "option_c": "Illinois DOT Bureau of Permits",
      "option_d": "California DOT Permit Office",
      "correct_answer": "D",
      "explanation": "Per California's current course data: California DOT Permit Office"
    },
    {
      "id": "CA_PEVO_PREP_2",
      "course_id": "CA_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does California require to legally operate as an escort vehicle operator?",
      "option_a": "PPCA Required",
      "option_b": "NY Standalone ONLY",
      "option_c": "PEVO Cert",
      "option_d": "8-State Uniform",
      "correct_answer": "A",
      "explanation": "Per California's current course data: PPCA Required"
    },
    {
      "id": "CA_PEVO_PREP_3",
      "course_id": "CA_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in California?",
      "option_a": "OVERSIZE LOAD - 5ft x 12in, fluorescent yellow, reflective lettering",
      "option_b": "OVERSIZE LOAD - yellow, standard federal spec",
      "option_c": "OVERSIZE LOAD - 5ft x 12in, fluorescent yellow, 8-inch black reflective letters",
      "option_d": "OVERSIZE LOAD - 5ft x 12in yellow, reflective",
      "correct_answer": "C",
      "explanation": "Per California's current course data: OVERSIZE LOAD - 5ft x 12in, fluorescent yellow, 8-inch black reflective letters"
    },
    {
      "id": "CA_PEVO_PREP_4",
      "course_id": "CA_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in California?",
      "option_a": "Amber Class 1",
      "option_b": "SAE Class 1 amber, front and rear required",
      "option_c": "SAE Class 1 amber strobe - front and rear - 360 degree visibility at 500 ft",
      "option_d": "SAE Class 1 amber strobe",
      "correct_answer": "C",
      "explanation": "Per California's current course data: SAE Class 1 amber strobe - front and rear - 360 degree visibility at 500 ft"
    },
    {
      "id": "CA_PEVO_PREP_5",
      "course_id": "CA_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in California?",
      "option_a": "18-inch stop/slow paddle, 3 lb 2-A:10-B:C fire extinguisher, safety cones",
      "option_b": "18-inch stop/slow paddle, 5 lb fire extinguisher, road flares, orange safety vest",
      "option_c": "Stop/slow paddle min 18in, 3 lb fire extinguisher, orange cones",
      "option_d": "Paddle, extinguisher",
      "correct_answer": "B",
      "explanation": "Per California's current course data: 18-inch stop/slow paddle, 5 lb fire extinguisher, road flares, orange safety vest"
    },
    {
      "id": "CA_PEVO_PREP_6",
      "course_id": "CA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In California, when is an escort legally REQUIRED?",
      "option_a": "Width exceeding 8'6\" requires lead escort; height over 15'0\" requires height pole",
      "option_b": "Width over 8'6\" OR height over 14'0\" OR weight over 80,000 lbs",
      "option_c": "Any load exceeding 8'6\" width, 13'6\" height, or 80,000 lbs GVW",
      "option_d": "Width over 9'0\" or height over 14'0\"",
      "correct_answer": "B",
      "explanation": "Per California's current course data: Width over 8'6\" OR height over 14'0\" OR weight over 80,000 lbs"
    },
    {
      "id": "CA_PEVO_PREP_7",
      "course_id": "CA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in California?",
      "option_a": "14'0\"",
      "option_b": "14'6\"",
      "option_c": "16'0\"",
      "option_d": "12'0\"",
      "correct_answer": "A",
      "explanation": "Per California's current course data: 14'0\""
    },
    {
      "id": "CA_PEVO_PREP_8",
      "course_id": "CA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in California?",
      "option_a": "15'6\"",
      "option_b": "16'0\"",
      "option_c": "14'6\"",
      "option_d": "13'6\"",
      "correct_answer": "B",
      "explanation": "Per California's current course data: 16'0\""
    },
    {
      "id": "CA_PEVO_PREP_9",
      "course_id": "CA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is California's night travel status for oversize permitted moves?",
      "option_a": "Always fully prohibited, no exceptions",
      "option_b": "w/ lighting",
      "option_c": "Restricted",
      "option_d": "Allowed",
      "correct_answer": "C",
      "explanation": "Per California's current course data: Restricted"
    },
    {
      "id": "CA_PEVO_PREP_10",
      "course_id": "CA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in California?",
      "option_a": "$500K CSL minimum",
      "option_b": "$1M CSL minimum",
      "option_c": "Same as standard minimum — no separate night-ops tier specified",
      "option_d": "$750K CSL minimum",
      "correct_answer": "C",
      "explanation": "Per California's current course data: Same as standard minimum — no separate night-ops tier specified"
    },
    {
      "id": "CA_PEVO_PREP_11",
      "course_id": "CA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in California?",
      "option_a": "$750K CSL",
      "option_b": "$1M CSL",
      "option_c": "$500K CSL",
      "option_d": "$10,000 liability",
      "correct_answer": "B",
      "explanation": "Per California's current course data: $1M CSL"
    },
    {
      "id": "CA_PEVO_PREP_12",
      "course_id": "CA_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does California belong to for escort operator requirements?",
      "option_a": "NY Standalone",
      "option_b": "8-State",
      "option_c": "Stand-Alone",
      "option_d": "Remaining",
      "correct_answer": "C",
      "explanation": "Per California's current course data: Stand-Alone"
    },
    {
      "id": "CA_PEVO_PREP_13",
      "course_id": "CA_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a California-specific rule or red flag operators must know?",
      "option_a": "Alaska has no reciprocity. Extreme weather rules apply Oct-Apr. Daylight-only travel required Nov-Feb.",
      "option_b": "NEW YORK HAS ZERO RECIPROCITY. No other cert is accepted. You MUST take the NY-specific course and pass the NY state exam. Thruway, bridges, and tunnels each require separate procedures.",
      "option_c": "Oregon requires state-specific cert AND $1M insurance. Portland metro restricted windows. Coast routes have severe weather seasonal restrictions Oct-Mar.",
      "option_d": "California requires its own state-specific certification — NO reciprocity accepted. Caltrans has 15 district offices with different route procedures. SR-99 and I-5 corridors have strict permit windows. Bay Area and LA metro have rush-hour bans 7am-9am and 4pm-7pm.",
      "correct_answer": "D",
      "explanation": "Per California's current course data: California requires its own state-specific certification — NO reciprocity accepted. Caltrans has 15 district offices with different route procedures. SR-99 and I-5 corridors have strict permit windows. Bay Area and LA metro have rush-hour bans 7am-9am and 4pm-7pm."
    },
    {
      "id": "CA_PEVO_PREP_14",
      "course_id": "CA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in California?",
      "option_a": "6'0\"",
      "option_b": "10'0\"",
      "option_c": "8'6\" (standard)",
      "option_d": "There is no standard width threshold",
      "correct_answer": "C",
      "explanation": "Per California's current course data: 8'6\" (standard)"
    },
    {
      "id": "CA_PEVO_PREP_15",
      "course_id": "CA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in California?",
      "option_a": "15'0\"",
      "option_b": "13'6\" (standard)",
      "option_c": "There is no standard height threshold",
      "option_d": "10'0\"",
      "correct_answer": "B",
      "explanation": "Per California's current course data: 13'6\" (standard)"
    },
    {
      "id": "CA_PEVO_PREP_16",
      "course_id": "CA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_17",
      "course_id": "CA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_18",
      "course_id": "CA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_19",
      "course_id": "CA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_20",
      "course_id": "CA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_21",
      "course_id": "CA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_22",
      "course_id": "CA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_23",
      "course_id": "CA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_24",
      "course_id": "CA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_25",
      "course_id": "CA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_26",
      "course_id": "CA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_27",
      "course_id": "CA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_28",
      "course_id": "CA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_29",
      "course_id": "CA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_30",
      "course_id": "CA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_31",
      "course_id": "CA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_32",
      "course_id": "CA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_33",
      "course_id": "CA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_34",
      "course_id": "CA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_35",
      "course_id": "CA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_36",
      "course_id": "CA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_37",
      "course_id": "CA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_38",
      "course_id": "CA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_39",
      "course_id": "CA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_40",
      "course_id": "CA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_41",
      "course_id": "CA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_42",
      "course_id": "CA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_43",
      "course_id": "CA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_44",
      "course_id": "CA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_45",
      "course_id": "CA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_46",
      "course_id": "CA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_47",
      "course_id": "CA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_48",
      "course_id": "CA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_49",
      "course_id": "CA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "CA_PEVO_PREP_50",
      "course_id": "CA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "FL_PEVO_PREP": [
    {
      "id": "FL_PEVO_PREP_1",
      "course_id": "FL_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Florida?",
      "option_a": "SD DOT Permit Office",
      "option_b": "Iowa DOT Office of Permitting",
      "option_c": "Florida DOT State Permit Office",
      "option_d": "Indiana DOT Permits",
      "correct_answer": "C",
      "explanation": "Per Florida's current course data: Florida DOT State Permit Office"
    },
    {
      "id": "FL_PEVO_PREP_2",
      "course_id": "FL_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Florida require to legally operate as an escort vehicle operator?",
      "option_a": "NY Standalone ONLY",
      "option_b": "PPCA Required",
      "option_c": "State Specific",
      "option_d": "PEVO Cert",
      "correct_answer": "D",
      "explanation": "Per Florida's current course data: PEVO Cert"
    },
    {
      "id": "FL_PEVO_PREP_3",
      "course_id": "FL_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Florida?",
      "option_a": "OVERSIZE LOAD - yellow, reflective, 5ft x 12in",
      "option_b": "OVERSIZE LOAD - yellow, standard spec",
      "option_c": "OVERSIZE LOAD - 5ft x 12in, fluorescent yellow-green, black reflective letters",
      "option_d": "OVERSIZE LOAD - standard yellow spec",
      "correct_answer": "C",
      "explanation": "Per Florida's current course data: OVERSIZE LOAD - 5ft x 12in, fluorescent yellow-green, black reflective letters"
    },
    {
      "id": "FL_PEVO_PREP_4",
      "course_id": "FL_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Florida?",
      "option_a": "Amber SAE Class 1, front and rear",
      "option_b": "SAE Class 1 amber, 360-degree visibility, minimum 35W output",
      "option_c": "SAE Class 1 amber 360-degree strobe, plus headlights on",
      "option_d": "SAE Class 1 amber strobe, 360-degree visibility, minimum 35W",
      "correct_answer": "B",
      "explanation": "Per Florida's current course data: SAE Class 1 amber, 360-degree visibility, minimum 35W output"
    },
    {
      "id": "FL_PEVO_PREP_5",
      "course_id": "FL_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Florida?",
      "option_a": "18-inch stop/slow paddle, 3 lb 2-A:10-B:C fire extinguisher, safety cones",
      "option_b": "Paddle, 3 lb extinguisher",
      "option_c": "Stop/slow paddle, 2.5 lb fire extinguisher, flares",
      "option_d": "Paddle, extinguisher, flares",
      "correct_answer": "A",
      "explanation": "Per Florida's current course data: 18-inch stop/slow paddle, 3 lb 2-A:10-B:C fire extinguisher, safety cones"
    },
    {
      "id": "FL_PEVO_PREP_6",
      "course_id": "FL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Florida, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\", height over 13'6\", or length over 65 ft",
      "option_b": "Width over 8'6\" or height over 13'6\"",
      "option_c": "Any load exceeding 8'0\" width or 13'6\" height",
      "option_d": "Width over 9'0\" or height over 15'0\"",
      "correct_answer": "B",
      "explanation": "Per Florida's current course data: Width over 8'6\" or height over 13'6\""
    },
    {
      "id": "FL_PEVO_PREP_7",
      "course_id": "FL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Florida?",
      "option_a": "12'0\"",
      "option_b": "16'0\"",
      "option_c": "14'6\"",
      "option_d": "14'0\"",
      "correct_answer": "C",
      "explanation": "Per Florida's current course data: 14'6\""
    },
    {
      "id": "FL_PEVO_PREP_8",
      "course_id": "FL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Florida?",
      "option_a": "14'0\"",
      "option_b": "16'0\"",
      "option_c": "13'6\"",
      "option_d": "14'6\"",
      "correct_answer": "D",
      "explanation": "Per Florida's current course data: 14'6\""
    },
    {
      "id": "FL_PEVO_PREP_9",
      "course_id": "FL_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Florida's night travel status for oversize permitted moves?",
      "option_a": "w/ lighting",
      "option_b": "Allowed",
      "option_c": "Always fully prohibited, no exceptions",
      "option_d": "Restricted",
      "correct_answer": "B",
      "explanation": "Per Florida's current course data: Allowed"
    },
    {
      "id": "FL_PEVO_PREP_10",
      "course_id": "FL_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Florida?",
      "option_a": "Same as standard minimum — no separate night-ops tier specified",
      "option_b": "$500K CSL minimum",
      "option_c": "$750K CSL minimum",
      "option_d": "$1M CSL minimum",
      "correct_answer": "A",
      "explanation": "Per Florida's current course data: Same as standard minimum — no separate night-ops tier specified"
    },
    {
      "id": "FL_PEVO_PREP_11",
      "course_id": "FL_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Florida?",
      "option_a": "$10,000 liability",
      "option_b": "$750K CSL",
      "option_c": "$500K CSL",
      "option_d": "$1M CSL",
      "correct_answer": "B",
      "explanation": "Per Florida's current course data: $750K CSL"
    },
    {
      "id": "FL_PEVO_PREP_12",
      "course_id": "FL_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Florida belong to for escort operator requirements?",
      "option_a": "Standalone",
      "option_b": "14 PEVO",
      "option_c": "Stand-Alone",
      "option_d": "Remaining",
      "correct_answer": "B",
      "explanation": "Per Florida's current course data: 14 PEVO"
    },
    {
      "id": "FL_PEVO_PREP_13",
      "course_id": "FL_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Florida-specific rule or red flag operators must know?",
      "option_a": "PEVO reciprocity state. Appalachian mountain routes have additional permit requirements.",
      "option_b": "California requires its own state-specific certification — NO reciprocity accepted. Caltrans has 15 district offices with different route procedures. SR-99 and I-5 corridors have strict permit windows. Bay Area and LA metro have rush-hour bans 7am-9am and 4pm-7pm.",
      "option_c": "Florida is a PEVO reciprocity state. PPCA cert accepted. Florida requires PEVO + Defensive Driving certification for operators. Florida has significant bridge height restrictions due to coastal infrastructure. Summer thunderstorm season (June-September) frequently halts permitted moves.",
      "option_d": "Illinois requires $1M CSL insurance, higher than most states. Chicago metro has permit windows and bridge weight limits.",
      "correct_answer": "C",
      "explanation": "Per Florida's current course data: Florida is a PEVO reciprocity state. PPCA cert accepted. Florida requires PEVO + Defensive Driving certification for operators. Florida has significant bridge height restrictions due to coastal infrastructure. Summer thunderstorm season (June-September) frequently halts permitted moves."
    },
    {
      "id": "FL_PEVO_PREP_14",
      "course_id": "FL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Florida?",
      "option_a": "10'0\"",
      "option_b": "There is no standard width threshold",
      "option_c": "8'6\" (standard)",
      "option_d": "6'0\"",
      "correct_answer": "C",
      "explanation": "Per Florida's current course data: 8'6\" (standard)"
    },
    {
      "id": "FL_PEVO_PREP_15",
      "course_id": "FL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Florida?",
      "option_a": "There is no standard height threshold",
      "option_b": "10'0\"",
      "option_c": "13'6\" (standard)",
      "option_d": "15'0\"",
      "correct_answer": "C",
      "explanation": "Per Florida's current course data: 13'6\" (standard)"
    },
    {
      "id": "FL_PEVO_PREP_16",
      "course_id": "FL_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_17",
      "course_id": "FL_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_18",
      "course_id": "FL_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_19",
      "course_id": "FL_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_20",
      "course_id": "FL_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_21",
      "course_id": "FL_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_22",
      "course_id": "FL_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_23",
      "course_id": "FL_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_24",
      "course_id": "FL_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_25",
      "course_id": "FL_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_26",
      "course_id": "FL_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_27",
      "course_id": "FL_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_28",
      "course_id": "FL_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_29",
      "course_id": "FL_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_30",
      "course_id": "FL_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_31",
      "course_id": "FL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_32",
      "course_id": "FL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_33",
      "course_id": "FL_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_34",
      "course_id": "FL_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_35",
      "course_id": "FL_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_36",
      "course_id": "FL_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_37",
      "course_id": "FL_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_38",
      "course_id": "FL_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_39",
      "course_id": "FL_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_40",
      "course_id": "FL_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_41",
      "course_id": "FL_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_42",
      "course_id": "FL_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_43",
      "course_id": "FL_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_44",
      "course_id": "FL_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_45",
      "course_id": "FL_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_46",
      "course_id": "FL_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_47",
      "course_id": "FL_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_48",
      "course_id": "FL_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_49",
      "course_id": "FL_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "FL_PEVO_PREP_50",
      "course_id": "FL_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "TX_PEVO_PREP": [
    {
      "id": "TX_PEVO_PREP_1",
      "course_id": "TX_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Texas?",
      "option_a": "Indiana DOT Permits",
      "option_b": "NH DOT Permit Office",
      "option_c": "TxDOT Oversize/Overweight Permits",
      "option_d": "Delaware DOT Permit Office",
      "correct_answer": "C",
      "explanation": "Per Texas's current course data: TxDOT Oversize/Overweight Permits"
    },
    {
      "id": "TX_PEVO_PREP_2",
      "course_id": "TX_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Texas require to legally operate as an escort vehicle operator?",
      "option_a": "8-State Uniform",
      "option_b": "PEVO Cert",
      "option_c": "PPCA Required",
      "option_d": "State Specific",
      "correct_answer": "C",
      "explanation": "Per Texas's current course data: PPCA Required"
    },
    {
      "id": "TX_PEVO_PREP_3",
      "course_id": "TX_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Texas?",
      "option_a": "OVERSIZE LOAD - yellow background, 6-inch black letters",
      "option_b": "OVERSIZE LOAD - 7ft x 18in, fluorescent yellow-orange, 10-inch black letters",
      "option_c": "OVERSIZE LOAD - must be removed when not actively escorting",
      "option_d": "OVERSIZE LOAD - yellow, standard spec",
      "correct_answer": "B",
      "explanation": "Per Texas's current course data: OVERSIZE LOAD - 7ft x 18in, fluorescent yellow-orange, 10-inch black letters"
    },
    {
      "id": "TX_PEVO_PREP_4",
      "course_id": "TX_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Texas?",
      "option_a": "SAE Class 1 amber strobe",
      "option_b": "Amber strobe, Class 1 rated, mounted highest point of vehicle",
      "option_c": "SAE Class 1 amber 360-degree strobe, plus headlights on",
      "option_d": "SAE Class 1 amber strobe - front and rear",
      "correct_answer": "D",
      "explanation": "Per Texas's current course data: SAE Class 1 amber strobe - front and rear"
    },
    {
      "id": "TX_PEVO_PREP_5",
      "course_id": "TX_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Texas?",
      "option_a": "Paddle, extinguisher, flares",
      "option_b": "Paddle, 2.5 lb extinguisher, flares",
      "option_c": "18-inch stop/slow paddle, 3 lb fire extinguisher",
      "option_d": "18-inch stop/slow paddle, 5 lb fire extinguisher, 3 road flares, safety vest",
      "correct_answer": "D",
      "explanation": "Per Texas's current course data: 18-inch stop/slow paddle, 5 lb fire extinguisher, 3 road flares, safety vest"
    },
    {
      "id": "TX_PEVO_PREP_6",
      "course_id": "TX_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Texas, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" OR height over 14'0\" on most highways",
      "option_b": "Width over 8'6\", height over 13'6\", or length over 65 ft",
      "option_c": "Width over 8'6\" or height over 14'0\" triggers mandatory escort",
      "option_d": "Width over 8'6\" or height over 13'0\"",
      "correct_answer": "A",
      "explanation": "Per Texas's current course data: Width over 8'6\" OR height over 14'0\" on most highways"
    },
    {
      "id": "TX_PEVO_PREP_7",
      "course_id": "TX_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Texas?",
      "option_a": "14'0\"",
      "option_b": "14'6\"",
      "option_c": "12'0\"",
      "option_d": "16'0\"",
      "correct_answer": "A",
      "explanation": "Per Texas's current course data: 14'0\""
    },
    {
      "id": "TX_PEVO_PREP_8",
      "course_id": "TX_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Texas?",
      "option_a": "18'0\"",
      "option_b": "14'0\"",
      "option_c": "15'0\"",
      "option_d": "14'6\"",
      "correct_answer": "A",
      "explanation": "Per Texas's current course data: 18'0\""
    },
    {
      "id": "TX_PEVO_PREP_9",
      "course_id": "TX_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Texas's night travel status for oversize permitted moves?",
      "option_a": "Allowed",
      "option_b": "w/ lighting",
      "option_c": "Always fully prohibited, no exceptions",
      "option_d": "Restricted",
      "correct_answer": "A",
      "explanation": "Per Texas's current course data: Allowed"
    },
    {
      "id": "TX_PEVO_PREP_10",
      "course_id": "TX_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Texas?",
      "option_a": "$1M CSL minimum",
      "option_b": "Same as standard minimum — no separate night-ops tier specified",
      "option_c": "$500K CSL minimum",
      "option_d": "$750K CSL minimum",
      "correct_answer": "B",
      "explanation": "Per Texas's current course data: Same as standard minimum — no separate night-ops tier specified"
    },
    {
      "id": "TX_PEVO_PREP_11",
      "course_id": "TX_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Texas?",
      "option_a": "$500K CSL",
      "option_b": "$1M CSL",
      "option_c": "$750K CSL",
      "option_d": "$10,000 liability",
      "correct_answer": "A",
      "explanation": "Per Texas's current course data: $500K CSL"
    },
    {
      "id": "TX_PEVO_PREP_12",
      "course_id": "TX_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Texas belong to for escort operator requirements?",
      "option_a": "8-State",
      "option_b": "Remaining",
      "option_c": "NY Standalone",
      "option_d": "Stand-Alone",
      "correct_answer": "D",
      "explanation": "Per Texas's current course data: Stand-Alone"
    },
    {
      "id": "TX_PEVO_PREP_13",
      "course_id": "TX_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Texas-specific rule or red flag operators must know?",
      "option_a": "Alaska has no reciprocity. Extreme weather rules apply Oct-Apr. Daylight-only travel required Nov-Feb.",
      "option_b": "Texas has one of the highest height allowances at 18'0\". Texas requires state-specific certification (no PEVO reciprocity). TxDMV handles permit issuance. Super loads over 20' wide require Texas DPS escort. Houston, Dallas, and Austin metros have restricted windows. Oversize signs must be 7ft wide — larger than most states.",
      "option_c": "High wind and blizzard conditions common Oct-April. Wind farm equipment moves are a major market in SD.",
      "option_d": "PEVO reciprocity. High seasonal agriculture move volume. Mississippi River crossing permits require advance coordination.",
      "correct_answer": "B",
      "explanation": "Per Texas's current course data: Texas has one of the highest height allowances at 18'0\". Texas requires state-specific certification (no PEVO reciprocity). TxDMV handles permit issuance. Super loads over 20' wide require Texas DPS escort. Houston, Dallas, and Austin metros have restricted windows. Oversize signs must be 7ft wide — larger than most states."
    },
    {
      "id": "TX_PEVO_PREP_14",
      "course_id": "TX_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Texas?",
      "option_a": "6'0\"",
      "option_b": "There is no standard width threshold",
      "option_c": "8'6\" (standard)",
      "option_d": "10'0\"",
      "correct_answer": "C",
      "explanation": "Per Texas's current course data: 8'6\" (standard)"
    },
    {
      "id": "TX_PEVO_PREP_15",
      "course_id": "TX_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Texas?",
      "option_a": "13'6\" (standard)",
      "option_b": "10'0\"",
      "option_c": "15'0\"",
      "option_d": "There is no standard height threshold",
      "correct_answer": "A",
      "explanation": "Per Texas's current course data: 13'6\" (standard)"
    },
    {
      "id": "TX_PEVO_PREP_16",
      "course_id": "TX_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_17",
      "course_id": "TX_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_18",
      "course_id": "TX_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_19",
      "course_id": "TX_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_20",
      "course_id": "TX_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_21",
      "course_id": "TX_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_22",
      "course_id": "TX_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_23",
      "course_id": "TX_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_24",
      "course_id": "TX_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_25",
      "course_id": "TX_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_26",
      "course_id": "TX_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_27",
      "course_id": "TX_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_28",
      "course_id": "TX_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_29",
      "course_id": "TX_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_30",
      "course_id": "TX_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_31",
      "course_id": "TX_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_32",
      "course_id": "TX_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_33",
      "course_id": "TX_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_34",
      "course_id": "TX_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_35",
      "course_id": "TX_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_36",
      "course_id": "TX_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_37",
      "course_id": "TX_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_38",
      "course_id": "TX_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_39",
      "course_id": "TX_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_40",
      "course_id": "TX_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_41",
      "course_id": "TX_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_42",
      "course_id": "TX_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_43",
      "course_id": "TX_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_44",
      "course_id": "TX_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_45",
      "course_id": "TX_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_46",
      "course_id": "TX_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_47",
      "course_id": "TX_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_48",
      "course_id": "TX_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_49",
      "course_id": "TX_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "TX_PEVO_PREP_50",
      "course_id": "TX_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ],
  "WA_PEVO_PREP": [
    {
      "id": "WA_PEVO_PREP_1",
      "course_id": "WA_PEVO_PREP",
      "category": "State Authority",
      "question_text": "Which agency regulates Pilot/Escort Vehicle Operators in Washington?",
      "option_a": "Arizona DOT Permit Office",
      "option_b": "Delaware DOT Permit Office",
      "option_c": "Washington State DOT Permit Office",
      "option_d": "Alabama DOT Permit Office",
      "correct_answer": "C",
      "explanation": "Per Washington's current course data: Washington State DOT Permit Office"
    },
    {
      "id": "WA_PEVO_PREP_2",
      "course_id": "WA_PEVO_PREP",
      "category": "State Certification",
      "question_text": "What certification does Washington require to legally operate as an escort vehicle operator?",
      "option_a": "State Specific",
      "option_b": "PPCA Required",
      "option_c": "NY Standalone ONLY",
      "option_d": "PEVO Cert",
      "correct_answer": "D",
      "explanation": "Per Washington's current course data: PEVO Cert"
    },
    {
      "id": "WA_PEVO_PREP_3",
      "course_id": "WA_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is the required OVERSIZE LOAD signage standard in Washington?",
      "option_a": "OVERSIZE LOAD - standard 5ft x 12in",
      "option_b": "OVERSIZE LOAD - 5ft x 12in, bright yellow, 8-inch black letters, 1-inch brush stroke",
      "option_c": "OVERSIZE LOAD - 5ft x 12in, yellow background",
      "option_d": "OVERSIZE LOAD - yellow, standard spec",
      "correct_answer": "B",
      "explanation": "Per Washington's current course data: OVERSIZE LOAD - 5ft x 12in, bright yellow, 8-inch black letters, 1-inch brush stroke"
    },
    {
      "id": "WA_PEVO_PREP_4",
      "course_id": "WA_PEVO_PREP",
      "category": "State Lighting",
      "question_text": "What is the required lighting standard for escort vehicles in Washington?",
      "option_a": "Amber Class 1 front and rear",
      "option_b": "SAE Class 1 amber 360-degree strobe, plus headlights on",
      "option_c": "Amber Class 1 or 2 - front and rear required",
      "option_d": "SAE Class 1 or 2 amber - mounted at highest visible point - 360 degree visibility",
      "correct_answer": "D",
      "explanation": "Per Washington's current course data: SAE Class 1 or 2 amber - mounted at highest visible point - 360 degree visibility"
    },
    {
      "id": "WA_PEVO_PREP_5",
      "course_id": "WA_PEVO_PREP",
      "category": "State Equipment",
      "question_text": "What is a mandatory safety kit item required for escort vehicles in Washington?",
      "option_a": "Paddle, extinguisher",
      "option_b": "18-inch stop/slow paddle, 3 lb fire extinguisher",
      "option_c": "18-inch stop/slow paddle, 3 lb (2-A:10-B:C) fire extinguisher, orange safety vest",
      "option_d": "18-inch stop/slow paddle, 3 lb 2-A:10-B:C fire extinguisher, safety cones",
      "correct_answer": "C",
      "explanation": "Per Washington's current course data: 18-inch stop/slow paddle, 3 lb (2-A:10-B:C) fire extinguisher, orange safety vest"
    },
    {
      "id": "WA_PEVO_PREP_6",
      "course_id": "WA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "In Washington, when is an escort legally REQUIRED?",
      "option_a": "Width over 8'6\" or height over 14'0\" triggers mandatory P/EVO escort",
      "option_b": "Width over 9'0\" or height over 15'0\"",
      "option_c": "Width over 8'6\" or height over 13'6\" requires escort",
      "option_d": "Any load exceeding 8'0\" width or 13'6\" height",
      "correct_answer": "A",
      "explanation": "Per Washington's current course data: Width over 8'6\" or height over 14'0\" triggers mandatory P/EVO escort"
    },
    {
      "id": "WA_PEVO_PREP_7",
      "course_id": "WA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted width WITH an escort in Washington?",
      "option_a": "16'0\"",
      "option_b": "14'0\"",
      "option_c": "12'0\"",
      "option_d": "14'6\"",
      "correct_answer": "D",
      "explanation": "Per Washington's current course data: 14'6\""
    },
    {
      "id": "WA_PEVO_PREP_8",
      "course_id": "WA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the maximum permitted height WITH an escort in Washington?",
      "option_a": "16'0\"",
      "option_b": "13'6\"",
      "option_c": "14'6\"",
      "option_d": "15'6\"",
      "correct_answer": "C",
      "explanation": "Per Washington's current course data: 14'6\""
    },
    {
      "id": "WA_PEVO_PREP_9",
      "course_id": "WA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is Washington's night travel status for oversize permitted moves?",
      "option_a": "Restricted",
      "option_b": "Allowed",
      "option_c": "w/ lighting",
      "option_d": "Always fully prohibited, no exceptions",
      "correct_answer": "A",
      "explanation": "Per Washington's current course data: Restricted"
    },
    {
      "id": "WA_PEVO_PREP_10",
      "course_id": "WA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is the insurance requirement during night operations in Washington?",
      "option_a": "$1M CSL minimum",
      "option_b": "$500K CSL minimum",
      "option_c": "Same as standard minimum — no separate night-ops tier specified",
      "option_d": "$750K CSL minimum",
      "correct_answer": "C",
      "explanation": "Per Washington's current course data: Same as standard minimum — no separate night-ops tier specified"
    },
    {
      "id": "WA_PEVO_PREP_11",
      "course_id": "WA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is the minimum required liability insurance coverage for escort vehicles in Washington?",
      "option_a": "$10,000 liability",
      "option_b": "$500K CSL",
      "option_c": "$1M CSL",
      "option_d": "$750K CSL",
      "correct_answer": "D",
      "explanation": "Per Washington's current course data: $750K CSL"
    },
    {
      "id": "WA_PEVO_PREP_12",
      "course_id": "WA_PEVO_PREP",
      "category": "Compliance Group",
      "question_text": "Which compliance group does Washington belong to for escort operator requirements?",
      "option_a": "NY Standalone",
      "option_b": "8-State",
      "option_c": "Stand-Alone",
      "option_d": "14 PEVO",
      "correct_answer": "D",
      "explanation": "Per Washington's current course data: 14 PEVO"
    },
    {
      "id": "WA_PEVO_PREP_13",
      "course_id": "WA_PEVO_PREP",
      "category": "State-Specific Rules",
      "question_text": "Which of the following is a Washington-specific rule or red flag operators must know?",
      "option_a": "PEVO reciprocity. 15'0\" height limit. Port of Charleston generates high oversize move volume.",
      "option_b": "PEVO reciprocity state. PPCA cert accepted. Carry original cert plus trip permit at all times.",
      "option_c": "Washington requires physical hard-copy certification — digital copies may not be accepted by WSP. PEVO reciprocity state. I-90 mountain passes and Cascade crossings have seasonal restrictions. Washington is a Joint and Several Liability state for bridge strikes — costs can exceed $1,000,000.",
      "option_d": "Night travel prohibited without variance. White Mountain routes have seasonal weight restrictions and bridge limits.",
      "correct_answer": "C",
      "explanation": "Per Washington's current course data: Washington requires physical hard-copy certification — digital copies may not be accepted by WSP. PEVO reciprocity state. I-90 mountain passes and Cascade crossings have seasonal restrictions. Washington is a Joint and Several Liability state for bridge strikes — costs can exceed $1,000,000."
    },
    {
      "id": "WA_PEVO_PREP_14",
      "course_id": "WA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal width WITHOUT an escort in Washington?",
      "option_a": "6'0\"",
      "option_b": "There is no standard width threshold",
      "option_c": "10'0\"",
      "option_d": "8'6\" (standard)",
      "correct_answer": "D",
      "explanation": "Per Washington's current course data: 8'6\" (standard)"
    },
    {
      "id": "WA_PEVO_PREP_15",
      "course_id": "WA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What is the standard maximum legal height WITHOUT an escort in Washington?",
      "option_a": "15'0\"",
      "option_b": "10'0\"",
      "option_c": "13'6\" (standard)",
      "option_d": "There is no standard height threshold",
      "correct_answer": "C",
      "explanation": "Per Washington's current course data: 13'6\" (standard)"
    },
    {
      "id": "WA_PEVO_PREP_16",
      "course_id": "WA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What document is the supreme legal authority during an oversize move?",
      "option_a": "The pilot car operator's certification",
      "option_b": "The oversize transport permit",
      "option_c": "The carrier's DOT registration",
      "option_d": "The escort company's insurance policy",
      "correct_answer": "B",
      "explanation": "The oversize transport permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_17",
      "course_id": "WA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "Must a PEVO certification be carried physically during a move?",
      "option_a": "No, a digital photo is always sufficient",
      "option_b": "Yes, physical certification is required at all times",
      "option_c": "Only if requested 24 hours in advance",
      "option_d": "Only on interstate highways",
      "correct_answer": "B",
      "explanation": "Yes, physical certification is required at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_18",
      "course_id": "WA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is a pilot/escort vehicle operator's role during a move?",
      "option_a": "A passive observer with no legal authority",
      "option_b": "A Traffic Control Agent with legal authority to stop loads for safety",
      "option_c": "An employee who cannot make independent safety decisions",
      "option_d": "A person who only follows the truck driver's instructions",
      "correct_answer": "B",
      "explanation": "A Traffic Control Agent with legal authority to stop loads for safety is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_19",
      "course_id": "WA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "What is the policy on impairment while operating an escort vehicle?",
      "option_a": "Zero tolerance for impairment of any kind",
      "option_b": "Permitted below the standard legal driving limit",
      "option_c": "Allowed only during daytime moves",
      "option_d": "Permitted if disclosed to the carrier",
      "correct_answer": "A",
      "explanation": "Zero tolerance for impairment of any kind is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_20",
      "course_id": "WA_PEVO_PREP",
      "category": "Legal Authority",
      "question_text": "If a permit's instructions conflict with a carrier's request, which governs?",
      "option_a": "The carrier's request always wins",
      "option_b": "The permit governs — it is the supreme legal document",
      "option_c": "Whichever was communicated most recently",
      "option_d": "The pilot car operator's personal judgment alone",
      "correct_answer": "B",
      "explanation": "The permit governs — it is the supreme legal document is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_21",
      "course_id": "WA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What is the standard OVERSIZE LOAD sign color and lettering?",
      "option_a": "Yellow background with black letters",
      "option_b": "Red background with white letters",
      "option_c": "Blue background with yellow letters",
      "option_d": "White background with red letters",
      "correct_answer": "A",
      "explanation": "Yellow background with black letters is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_22",
      "course_id": "WA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Where must OVERSIZE LOAD signage be mounted?",
      "option_a": "Only on the escorted truck itself",
      "option_b": "Front of lead escorts and rear of tail escorts",
      "option_c": "Only visible from directly overhead",
      "option_d": "On the driver's side window only",
      "correct_answer": "B",
      "explanation": "Front of lead escorts and rear of tail escorts is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_23",
      "course_id": "WA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "When should OVERSIZE LOAD signs be covered or removed?",
      "option_a": "Never — they must always remain visible",
      "option_b": "When not actively escorting a load",
      "option_c": "Only on weekends",
      "option_d": "Only when parked at a rest stop",
      "correct_answer": "B",
      "explanation": "When not actively escorting a load is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_24",
      "course_id": "WA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "How often should escort equipment be inspected?",
      "option_a": "Once per year",
      "option_b": "Before every move/departure",
      "option_c": "Only after an incident",
      "option_d": "Every 90 days regardless of use",
      "correct_answer": "B",
      "explanation": "Before every move/departure is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_25",
      "course_id": "WA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "Is a safety vest required during on-road escort operations?",
      "option_a": "No, it is optional",
      "option_b": "Yes, it must be worn during all on-road operations",
      "option_c": "Only required at night",
      "option_d": "Only required in construction zones",
      "correct_answer": "B",
      "explanation": "Yes, it must be worn during all on-road operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_26",
      "course_id": "WA_PEVO_PREP",
      "category": "Equipment & Signage",
      "question_text": "What happens if signage is non-compliant during an inspection?",
      "option_a": "A verbal warning with no further action",
      "option_b": "Grounds for immediate Out of Service",
      "option_c": "A small fine paid later by mail",
      "option_d": "Nothing, as long as the truck itself is compliant",
      "correct_answer": "B",
      "explanation": "Grounds for immediate Out of Service is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_27",
      "course_id": "WA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "When must required escort lighting be active?",
      "option_a": "Only after sunset",
      "option_b": "From the moment the load is picked up until delivery is complete",
      "option_c": "Only when passing through a city",
      "option_d": "Only when requested by law enforcement",
      "correct_answer": "B",
      "explanation": "From the moment the load is picked up until delivery is complete is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_28",
      "course_id": "WA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Why is 360-degree visibility often required for strobes?",
      "option_a": "It looks more professional",
      "option_b": "So the escort is visible to traffic approaching from any direction",
      "option_c": "It is a cosmetic preference of most carriers",
      "option_d": "It reduces glare for the escort driver",
      "correct_answer": "B",
      "explanation": "So the escort is visible to traffic approaching from any direction is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_29",
      "course_id": "WA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "What should a PEVO do if their strobe light fails mid-route?",
      "option_a": "Continue the move without lighting",
      "option_b": "Stop safely and address the equipment failure before continuing",
      "option_c": "Ignore it if the sun is still up",
      "option_d": "Ask the truck driver to use hazard lights instead",
      "correct_answer": "B",
      "explanation": "Stop safely and address the equipment failure before continuing is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_30",
      "course_id": "WA_PEVO_PREP",
      "category": "Lighting",
      "question_text": "Are headlights typically required to be on during an escorted move?",
      "option_a": "No, only strobes are needed",
      "option_b": "Yes, in many states headlights on is part of the lighting standard",
      "option_c": "Only during a documented storm",
      "option_d": "Only if the load exceeds 20,000 lbs",
      "correct_answer": "B",
      "explanation": "Yes, in many states headlights on is part of the lighting standard is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_31",
      "course_id": "WA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "Why must dimension thresholds be memorized precisely?",
      "option_a": "They are rarely tested on certification exams",
      "option_b": "Examiners test them precisely and they determine legal escort requirements",
      "option_c": "They change every single day",
      "option_d": "They only matter for weight, not size",
      "correct_answer": "B",
      "explanation": "Examiners test them precisely and they determine legal escort requirements is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_32",
      "course_id": "WA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "What determines whether a load needs one escort or two?",
      "option_a": "The color of the load",
      "option_b": "The permit, based on width, height, length, and route",
      "option_c": "The time of day only",
      "option_d": "The driver's personal preference",
      "correct_answer": "B",
      "explanation": "The permit, based on width, height, length, and route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_33",
      "course_id": "WA_PEVO_PREP",
      "category": "Dimensions & Triggers",
      "question_text": "A load measuring 9'0\" wide most likely requires what?",
      "option_a": "No escort at all",
      "option_b": "At least one escort, since it exceeds the standard 8'6\" threshold",
      "option_c": "Only a police escort",
      "option_d": "A reduced speed limit but no escort",
      "correct_answer": "B",
      "explanation": "At least one escort, since it exceeds the standard 8'6\" threshold is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_34",
      "course_id": "WA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What is generally true about night travel curfews for oversize loads?",
      "option_a": "They never apply on state highways",
      "option_b": "Curfew violations are automatic permit voids",
      "option_c": "Curfews only apply to loads under 10,000 lbs",
      "option_d": "Night travel is always fully prohibited nationwide",
      "correct_answer": "B",
      "explanation": "Curfew violations are automatic permit voids is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_35",
      "course_id": "WA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What must be true before an escort may travel outside daylight hours?",
      "option_a": "Nothing extra is needed if the truck has headlights",
      "option_b": "A specific night permit window must be granted by the permit authority",
      "option_c": "Only the carrier's approval is needed",
      "option_d": "Any escort may decide independently to travel at night",
      "correct_answer": "B",
      "explanation": "A specific night permit window must be granted by the permit authority is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_36",
      "course_id": "WA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "What can void a permit related to travel timing?",
      "option_a": "Arriving early to the pickup site",
      "option_b": "Operating outside of permitted travel hours",
      "option_c": "Taking a lunch break mid-route",
      "option_d": "Using a different color escort vehicle",
      "correct_answer": "B",
      "explanation": "Operating outside of permitted travel hours is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_37",
      "course_id": "WA_PEVO_PREP",
      "category": "Night Travel",
      "question_text": "Who may need to be notified before night travel begins?",
      "option_a": "No one — night travel requires no notification",
      "option_b": "Highway patrol or local law enforcement, depending on the permit",
      "option_c": "Only the escort's personal insurance agent",
      "option_d": "The load's manufacturer",
      "correct_answer": "B",
      "explanation": "Highway patrol or local law enforcement, depending on the permit is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_38",
      "course_id": "WA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Where must proof of insurance be kept during operations?",
      "option_a": "At the escort company's home office only",
      "option_b": "In the vehicle during all operations",
      "option_c": "It is not required to be carried",
      "option_d": "Only in digital form on a personal phone",
      "correct_answer": "B",
      "explanation": "In the vehicle during all operations is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_39",
      "course_id": "WA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "Who can be held jointly liable in a bridge strike incident?",
      "option_a": "Only the truck driver",
      "option_b": "The carrier, driver, and pilot car operator can all be held liable",
      "option_c": "Only the load's owner",
      "option_d": "No one — bridge strikes are a state cost",
      "correct_answer": "B",
      "explanation": "The carrier, driver, and pilot car operator can all be held liable is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_40",
      "course_id": "WA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What is a potential financial exposure from a bridge strike incident?",
      "option_a": "A small fixed fine under $500",
      "option_b": "Costs that can exceed $1,000,000 plus criminal charges",
      "option_c": "No financial exposure to the escort operator",
      "option_d": "Only a temporary suspension with no monetary cost",
      "correct_answer": "B",
      "explanation": "Costs that can exceed $1,000,000 plus criminal charges is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_41",
      "course_id": "WA_PEVO_PREP",
      "category": "Insurance & Liability",
      "question_text": "What should a PEVO do if their insurance is about to lapse mid-contract?",
      "option_a": "Continue operating and renew later",
      "option_b": "Address it before continuing any operations, since proof must be valid at all times",
      "option_c": "Ignore it unless stopped by police",
      "option_d": "Ask the carrier to cover the gap silently",
      "correct_answer": "B",
      "explanation": "Address it before continuing any operations, since proof must be valid at all times is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_42",
      "course_id": "WA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "When is a functioning, calibrated high-pole typically required?",
      "option_a": "On every move regardless of height",
      "option_b": "When a load approaches the maximum permitted height",
      "option_c": "Only for loads under 10 feet tall",
      "option_d": "Never — high-poles are optional accessories",
      "correct_answer": "B",
      "explanation": "When a load approaches the maximum permitted height is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_43",
      "course_id": "WA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "Where is the high-pole typically mounted?",
      "option_a": "On the rear escort vehicle only",
      "option_b": "On the lead escort vehicle",
      "option_c": "On the transported load itself",
      "option_d": "On a trailing police vehicle",
      "correct_answer": "B",
      "explanation": "On the lead escort vehicle is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_44",
      "course_id": "WA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "How should a high-pole be set relative to load height?",
      "option_a": "Exactly at the load height with no margin",
      "option_b": "At the actual load height plus a safety margin per permit instructions",
      "option_c": "Below the load height to save clearance",
      "option_d": "At a fixed height regardless of the load",
      "correct_answer": "B",
      "explanation": "At the actual load height plus a safety margin per permit instructions is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_45",
      "course_id": "WA_PEVO_PREP",
      "category": "High-Pole Operations",
      "question_text": "What should a PEVO do if the high-pole contacts an obstruction?",
      "option_a": "Continue and note it in a report afterward",
      "option_b": "Stop the convoy immediately and reassess the route",
      "option_c": "Speed up to clear the obstruction quickly",
      "option_d": "Disable the pole and continue without it",
      "correct_answer": "B",
      "explanation": "Stop the convoy immediately and reassess the route is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_46",
      "course_id": "WA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should a PEVO do before every move regarding equipment?",
      "option_a": "Skip inspection if the last move went smoothly",
      "option_b": "Inspect and verify all required equipment is functional",
      "option_c": "Only inspect equipment once per month",
      "option_d": "Rely on the carrier to inspect the escort vehicle",
      "correct_answer": "B",
      "explanation": "Inspect and verify all required equipment is functional is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_47",
      "course_id": "WA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "How should a PEVO communicate hazards to the truck driver?",
      "option_a": "Using clear, consistent radio communication protocols",
      "option_b": "By flashing headlights only, with no radio use",
      "option_c": "By waiting until the next scheduled stop",
      "option_d": "Hazards should never be communicated mid-route",
      "correct_answer": "A",
      "explanation": "Using clear, consistent radio communication protocols is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_48",
      "course_id": "WA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What is the correct response if regulations seem to have changed since last year?",
      "option_a": "Assume last year's rules still apply",
      "option_b": "Always verify current requirements with the permit authority before the move",
      "option_c": "Use whichever rule is more convenient",
      "option_d": "Ask another driver on the CB radio for a final answer",
      "correct_answer": "B",
      "explanation": "Always verify current requirements with the permit authority before the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_49",
      "course_id": "WA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What best describes the relationship between the permit and route restrictions?",
      "option_a": "Route restrictions are only suggestions",
      "option_b": "The permit defines legally authorized routes, times, and conditions for the move",
      "option_c": "Routes may be changed freely without updating the permit",
      "option_d": "Permits do not specify routes, only dimensions",
      "correct_answer": "B",
      "explanation": "The permit defines legally authorized routes, times, and conditions for the move is correct per standard PEVO/escort operating practice."
    },
    {
      "id": "WA_PEVO_PREP_50",
      "course_id": "WA_PEVO_PREP",
      "category": "Professional Conduct",
      "question_text": "What should happen if a PEVO is asked to falsify an equipment inspection?",
      "option_a": "Comply to keep the schedule on time",
      "option_b": "Refuse — accurate inspections are a core safety and legal obligation",
      "option_c": "Falsify it only for short local moves",
      "option_d": "Delegate the decision to the truck driver",
      "correct_answer": "B",
      "explanation": "Refuse — accurate inspections are a core safety and legal obligation is correct per standard PEVO/escort operating practice."
    }
  ]
};

export default FINAL_EXAM_BANK;
